import React, { useRef, useState, useEffect, useReducer, useCallback, useMemo, forwardRef, useImperativeHandle, Fragment, lazy, Suspense, PureComponent, Component } from 'react';
import PropTypes from 'prop-types';
import Button, { Size } from '@leafygreen-ui/button';
import DropdownMenu from 'react-dd-menu';
import classNames from 'classnames';
import { confirmable, createConfirmation } from 'react-confirm';
import Checkbox from '@leafygreen-ui/checkbox';
import Modal from '@leafygreen-ui/modal';
import { H3, Subtitle, Body, Label, H2, Link } from '@leafygreen-ui/typography';
import FontAwesome from 'react-fontawesome';
import { CSSTransition } from 'react-transition-group';
import ConfirmationModal from '@leafygreen-ui/confirmation-modal';
import TextInput, { State } from '@leafygreen-ui/text-input';
import Banner, { Variant as Variant$1 } from '@leafygreen-ui/banner';
import Icon, { createIconComponent } from '@leafygreen-ui/icon';
import { palette } from '@leafygreen-ui/palette';
import Code from '@leafygreen-ui/code';
import XIcon from '@leafygreen-ui/icon/dist/X';
import IconButton from '@leafygreen-ui/icon-button';
import { Select, OptionGroup, Option } from '@leafygreen-ui/select';
import Badge from '@leafygreen-ui/badge';
import PlusIcon from '@leafygreen-ui/icon/dist/Plus';
import moment from 'moment';
import Copyable from '@leafygreen-ui/copyable';
import ReactTooltip from 'react-tooltip';
import Toast, { Variant as Variant$2 } from '@leafygreen-ui/toast';
import { InstallationStatus, EventProcessorType, MeasurementName, MeasurementUnit } from 'baas-admin-sdk';
import { RadioBoxGroup, RadioBox } from '@leafygreen-ui/radio-box-group';
import CronParser from 'cron-parser';
import Select$1 from 'react-select';
import Toggle from '@leafygreen-ui/toggle';
import Tooltip from '@leafygreen-ui/tooltip';
import semverCoerce from 'semver/functions/coerce';
import semverGte from 'semver/functions/gte';
import Card from '@leafygreen-ui/card';
import { createAgent, throughArea } from 'react-through';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator$1(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read$1(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$D = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n/* Not really sure why, but the inverse version has a bigger gap */\n.dd-menu {\n  display: inline-block;\n  position: relative;\n}\n.dd-menu.dd-menu-center .dd-menu-items {\n  left: 50%;\n  transform: translateX(-50%);\n}\n.dd-menu.dd-menu-left .dd-menu-items {\n  left: 0;\n}\n.dd-menu.dd-menu-left .dd-menu-items [class^='nested-']:not(.nested-reverse) > span {\n  'left': 100%;\n  padding-'left': 0.5em;\n}\n.dd-menu.dd-menu-left .dd-menu-items .nested-reverse > span {\n  left: 100%;\n  padding-left: 0.5em;\n}\n.dd-menu.dd-menu-left.dd-menu-inverse .dd-menu-items [class^='nested-']:not(.nested-reverse) > span {\n  'left': 100%;\n  padding-'left': 0.3em;\n}\n.dd-menu.dd-menu-left.dd-menu-inverse .dd-menu-items .nested-reverse > span {\n  left: 100%;\n  padding-left: 0.3em;\n}\n.dd-menu.dd-menu-right .dd-menu-items {\n  right: 0;\n}\n.dd-menu.dd-menu-right .dd-menu-items [class^='nested-']:not(.nested-reverse) > span {\n  'left': 100%;\n  padding-'left': 0.5em;\n}\n.dd-menu.dd-menu-right .dd-menu-items .nested-reverse > span {\n  right: 100%;\n  padding-right: 0.5em;\n}\n.dd-menu.dd-menu-right.dd-menu-inverse .dd-menu-items [class^='nested-']:not(.nested-reverse) > span {\n  'left': 100%;\n  padding-'left': 0.3em;\n}\n.dd-menu.dd-menu-right.dd-menu-inverse .dd-menu-items .nested-reverse > span {\n  right: 100%;\n  padding-right: 0.3em;\n}\n.dd-menu .dd-menu-items {\n  position: absolute;\n  z-index: 1011;\n  margin: 0 0 0 0;\n}\n.dd-menu .dd-menu-items.dd-items-upwards {\n  bottom: 100%;\n  margin: 0 0 0;\n}\n.dd-menu .dd-menu-items ul,\n.dd-menu .dd-menu-items ol {\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 2px;\n  list-style: none;\n  padding: 5px 0;\n  margin: 0;\n  min-width: 160px;\n  color: #303434;\n  background-color: #fefefe;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n}\n.dd-menu .dd-menu-items ul.dd-items-right li > *,\n.dd-menu .dd-menu-items ol.dd-items-right li > * {\n  text-align: left;\n}\n.dd-menu .dd-menu-items ul.dd-items-left li > *,\n.dd-menu .dd-menu-items ol.dd-items-left li > * {\n  text-align: left;\n}\n.dd-menu .dd-menu-items ul.dd-items-center li > *,\n.dd-menu .dd-menu-items ol.dd-items-center li > * {\n  text-align: center;\n}\n.dd-menu .dd-menu-items ul li,\n.dd-menu .dd-menu-items ol li {\n  cursor: pointer;\n  font-size: 13px;\n  line-height: 1.42857143;\n  list-style: none;\n}\n.dd-menu .dd-menu-items ul li.dd-item-ignore,\n.dd-menu .dd-menu-items ol li.dd-item-ignore {\n  color: #a09f9e;\n}\n.dd-menu .dd-menu-items ul li:hover:not([role='separator']):not(.separator):not(.dd-item-ignore),\n.dd-menu .dd-menu-items ol li:hover:not([role='separator']):not(.separator):not(.dd-item-ignore),\n.dd-menu .dd-menu-items ul li > *:focus,\n.dd-menu .dd-menu-items ol li > *:focus {\n  color: #303434;\n  background-color: #e6e6e6;\n  outline: none;\n}\n.dd-menu .dd-menu-items ul li > *:not(.dd-item-ignore),\n.dd-menu .dd-menu-items ol li > *:not(.dd-item-ignore) {\n  display: block;\n  width: auto;\n  min-width: 100%;\n  padding: 6px 10px;\n  font-family: 'Akzidenz', sans-serif;\n  white-space: pre;\n  color: inherit;\n  text-decoration: none;\n  font-size: inherit;\n}\n.dd-menu .dd-menu-items ul li > button,\n.dd-menu .dd-menu-items ol li > button {\n  border: none;\n  background: transparent;\n}\n.dd-menu.dd-menu-inverse .dd-menu-items ul,\n.dd-menu.dd-menu-inverse .dd-menu-items ol {\n  color: #fff;\n  background-color: #2c3e50;\n}\n.dd-menu.dd-menu-inverse .dd-menu-items ul li:hover:not([role='separator']):not(.separator),\n.dd-menu.dd-menu-inverse .dd-menu-items ol li:hover:not([role='separator']):not(.separator),\n.dd-menu.dd-menu-inverse .dd-menu-items ul li > *:focus,\n.dd-menu.dd-menu-inverse .dd-menu-items ol li > *:focus {\n  color: #fff;\n  background-color: #34495e;\n}\n.dd-menu.dd-menu-inverse [role='separator'],\n.dd-menu.dd-menu-inverse .separator {\n  background-color: #45595e;\n}\n.dd-menu [role='separator'],\n.dd-menu .separator {\n  content: '';\n  display: block;\n  height: 2px;\n  background-color: rgba(0, 0, 0, 0.15);\n  margin: 0.5em 0 0.5em 0;\n}\n.dd-menu .dd-items-upwards li.nested-dd-menu > span {\n  bottom: 0;\n  top: initial;\n}\n.dd-menu li.nested-dd-menu {\n  position: relative;\n}\n.dd-menu li.nested-dd-menu > span {\n  position: absolute;\n  top: 0;\n}\n";
styleInject(css_248z$D);

// Returns an event handler function which calls the given argument (a function)
// if the event is an "enter" keypress.
// The optional second argument is a function that will get called if the
// user presses Escape.
var enterPressedCaller = function (func, escFunc) { return function (e) {
    if (e.key === 'Enter') {
        func();
    }
    if (typeof escFunc === 'function' && e.key === 'Escape') {
        escFunc();
    }
}; };
// stopPropagation returns an event handler that stops propagation (if the event is defined)
// before calling f.
var stopPropagation = function (f) { return function (e) {
    if (e && e.stopPropagation) {
        e.stopPropagation();
    }
    return f();
}; };
/**
 * Creates a simple stateless functional component that activates a given set of CSS classes
 * when certain corresponding props are specified.
 *
 * @param {Record<string, any>} propsMapping - A mapping of prop names to CSS class names.
 * @param {string} displayName - The display name for the React component
 * @param {string=} className - A classname that is *always* applied to instances of the component.
 */
var basicComponent = function (propsMapping, displayName, className) {
    if (className === void 0) { className = ''; }
    /* eslint-disable react/prop-types */
    var result = function (props) {
        var componentClassName = classNames(className, props.className, Object.keys(propsMapping).reduce(function (obj, k) {
            var _a;
            return (__assign(__assign({}, obj), (_a = {}, _a[propsMapping[k]] = props[k], _a)));
        }, {}));
        var newProps = __assign(__assign({}, props), { className: componentClassName });
        Object.keys(propsMapping).forEach(function (k) { return delete newProps[k]; });
        return React.createElement("div", __assign({}, newProps));
    };
    /* eslint-enable react/prop-types */
    result.displayName = displayName;
    return result;
};
// Makes a DOM Event of the given name. Use this in place of the
// normal Event constructor for browser compatibility.
function makeDOMEvent(name, eventInit) {
    if (eventInit === void 0) { eventInit = { bubbles: false, cancelable: false }; }
    if (typeof Event === 'function') {
        return new Event(name, eventInit);
    }
    // IE11 support
    var event = document.createEvent('Event');
    event.initEvent(name, eventInit.bubbles, eventInit.cancelable);
    return event;
}
// filter out props so that only data-* props get passed through
var passThroughProps = function (props) {
    return Object.keys(props).reduce(function (obj, key) {
        if (key.startsWith('data-')) {
            obj[key] = props[key];
        }
        return obj;
    }, {});
};
function usePoller() {
    var interval = useRef();
    var _a = __read$1(useState(false), 2), isPolling = _a[0], setIsPolling = _a[1];
    React.useEffect(function () {
        return function () {
            window.clearInterval(interval.current);
        };
    }, [interval]);
    return {
        isPolling: isPolling,
        start: function (action, timeout) {
            action();
            interval.current = window.setInterval(action, timeout);
            setIsPolling(true);
        },
        stop: function () {
            clearInterval(interval.current);
            setIsPolling(false);
        },
    };
}
function usePrevious(value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
}

var util = /*#__PURE__*/Object.freeze({
    __proto__: null,
    enterPressedCaller: enterPressedCaller,
    stopPropagation: stopPropagation,
    basicComponent: basicComponent,
    makeDOMEvent: makeDOMEvent,
    passThroughProps: passThroughProps,
    usePoller: usePoller,
    usePrevious: usePrevious
});

var dropdownDefaultProps = {
    align: 'right',
    children: null,
    toggle: (React.createElement(Button, { size: "xsmall", className: "dropdown-toggle", name: "options" },
        React.createElement("i", { className: "mms-icon-ellipsis" }))),
    startOpen: false,
    closeOnInsideClick: true,
    toggleProps: {},
};
var Dropdown = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(Dropdown, _super);
            function Dropdown(props) {
                var _this = _super.call(this, props) || this;
                _this.state = {
                    isOpen: !!_this.props.startOpen,
                };
                _this.onToggle = function (e) {
                    if (e) {
                        e.stopPropagation();
                    }
                    if (_this.mounted) {
                        _this.setState(function (_a) {
                            var isOpen = _a.isOpen;
                            return ({ isOpen: !isOpen });
                        });
                    }
                };
                _this.onClose = function () {
                    if (_this.mounted) {
                        _this.setState(function () { return ({ isOpen: false }); });
                    }
                };
                _this.mounted = false;
                return _this;
            }
            Dropdown.prototype.componentDidMount = function () {
                // react-dd-menu uses a setTimeout internally which can result in
                // the `close` callback being invoked after our wrapper component
                // has unmounted. Use local `mounted` variable to guard against
                // this. Setting or unsetting this variable should *not* trigger
                // a re-render, hence why it is not set in `state`.
                this.mounted = true;
            };
            Dropdown.prototype.componentWillUnmount = function () {
                this.mounted = false;
            };
            Dropdown.prototype.render = function () {
                var _a = this.props, align = _a.align, toggle = _a.toggle, toggleProps = _a.toggleProps, props = __rest(_a, ["align", "toggle", "toggleProps"]);
                var isOpen = this.state.isOpen;
                return (React.createElement(DropdownMenu, __assign({}, props, { align: align, isOpen: isOpen, close: this.onClose, toggle: React.cloneElement(toggle, __assign({ onClick: this.onToggle, open: isOpen }, passThroughProps(toggleProps || {}))) }), this.props.children));
            };
            return Dropdown;
        }(React.Component)),
        _a.propTypes = {
            align: PropTypes.oneOf(['center', 'left', 'right']),
            children: PropTypes.node,
            startOpen: PropTypes.bool,
            toggle: PropTypes.node,
            closeOnInsideClick: PropTypes.bool,
            toggleProps: PropTypes.objectOf(PropTypes.string),
        },
        _a.defaultProps = dropdownDefaultProps,
        _a;
})();

var css_248z$C = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n/* Not really sure why, but the inverse version has a bigger gap */\n.dd-menu {\n  display: inline-block;\n  position: relative;\n}\n.dd-menu.dd-menu-center .dd-menu-items {\n  left: 50%;\n  transform: translateX(-50%);\n}\n.dd-menu.dd-menu-left .dd-menu-items {\n  left: 0;\n}\n.dd-menu.dd-menu-left .dd-menu-items [class^='nested-']:not(.nested-reverse) > span {\n  'left': 100%;\n  padding-'left': 0.5em;\n}\n.dd-menu.dd-menu-left .dd-menu-items .nested-reverse > span {\n  left: 100%;\n  padding-left: 0.5em;\n}\n.dd-menu.dd-menu-left.dd-menu-inverse .dd-menu-items [class^='nested-']:not(.nested-reverse) > span {\n  'left': 100%;\n  padding-'left': 0.3em;\n}\n.dd-menu.dd-menu-left.dd-menu-inverse .dd-menu-items .nested-reverse > span {\n  left: 100%;\n  padding-left: 0.3em;\n}\n.dd-menu.dd-menu-right .dd-menu-items {\n  right: 0;\n}\n.dd-menu.dd-menu-right .dd-menu-items [class^='nested-']:not(.nested-reverse) > span {\n  'left': 100%;\n  padding-'left': 0.5em;\n}\n.dd-menu.dd-menu-right .dd-menu-items .nested-reverse > span {\n  right: 100%;\n  padding-right: 0.5em;\n}\n.dd-menu.dd-menu-right.dd-menu-inverse .dd-menu-items [class^='nested-']:not(.nested-reverse) > span {\n  'left': 100%;\n  padding-'left': 0.3em;\n}\n.dd-menu.dd-menu-right.dd-menu-inverse .dd-menu-items .nested-reverse > span {\n  right: 100%;\n  padding-right: 0.3em;\n}\n.dd-menu .dd-menu-items {\n  position: absolute;\n  z-index: 1011;\n  margin: 0 0 0 0;\n}\n.dd-menu .dd-menu-items.dd-items-upwards {\n  bottom: 100%;\n  margin: 0 0 0;\n}\n.dd-menu .dd-menu-items ul,\n.dd-menu .dd-menu-items ol {\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 2px;\n  list-style: none;\n  padding: 5px 0;\n  margin: 0;\n  min-width: 160px;\n  color: #303434;\n  background-color: #fefefe;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n}\n.dd-menu .dd-menu-items ul.dd-items-right li > *,\n.dd-menu .dd-menu-items ol.dd-items-right li > * {\n  text-align: left;\n}\n.dd-menu .dd-menu-items ul.dd-items-left li > *,\n.dd-menu .dd-menu-items ol.dd-items-left li > * {\n  text-align: left;\n}\n.dd-menu .dd-menu-items ul.dd-items-center li > *,\n.dd-menu .dd-menu-items ol.dd-items-center li > * {\n  text-align: center;\n}\n.dd-menu .dd-menu-items ul li,\n.dd-menu .dd-menu-items ol li {\n  cursor: pointer;\n  font-size: 13px;\n  line-height: 1.42857143;\n  list-style: none;\n}\n.dd-menu .dd-menu-items ul li.dd-item-ignore,\n.dd-menu .dd-menu-items ol li.dd-item-ignore {\n  color: #a09f9e;\n}\n.dd-menu .dd-menu-items ul li:hover:not([role='separator']):not(.separator):not(.dd-item-ignore),\n.dd-menu .dd-menu-items ol li:hover:not([role='separator']):not(.separator):not(.dd-item-ignore),\n.dd-menu .dd-menu-items ul li > *:focus,\n.dd-menu .dd-menu-items ol li > *:focus {\n  color: #303434;\n  background-color: #e6e6e6;\n  outline: none;\n}\n.dd-menu .dd-menu-items ul li > *:not(.dd-item-ignore),\n.dd-menu .dd-menu-items ol li > *:not(.dd-item-ignore) {\n  display: block;\n  width: auto;\n  min-width: 100%;\n  padding: 6px 10px;\n  font-family: 'Akzidenz', sans-serif;\n  white-space: pre;\n  color: inherit;\n  text-decoration: none;\n  font-size: inherit;\n}\n.dd-menu .dd-menu-items ul li > button,\n.dd-menu .dd-menu-items ol li > button {\n  border: none;\n  background: transparent;\n}\n.dd-menu.dd-menu-inverse .dd-menu-items ul,\n.dd-menu.dd-menu-inverse .dd-menu-items ol {\n  color: #fff;\n  background-color: #2c3e50;\n}\n.dd-menu.dd-menu-inverse .dd-menu-items ul li:hover:not([role='separator']):not(.separator),\n.dd-menu.dd-menu-inverse .dd-menu-items ol li:hover:not([role='separator']):not(.separator),\n.dd-menu.dd-menu-inverse .dd-menu-items ul li > *:focus,\n.dd-menu.dd-menu-inverse .dd-menu-items ol li > *:focus {\n  color: #fff;\n  background-color: #34495e;\n}\n.dd-menu.dd-menu-inverse [role='separator'],\n.dd-menu.dd-menu-inverse .separator {\n  background-color: #45595e;\n}\n.dd-menu [role='separator'],\n.dd-menu .separator {\n  content: '';\n  display: block;\n  height: 2px;\n  background-color: rgba(0, 0, 0, 0.15);\n  margin: 0.5em 0 0.5em 0;\n}\n.dd-menu .dd-items-upwards li.nested-dd-menu > span {\n  bottom: 0;\n  top: initial;\n}\n.dd-menu li.nested-dd-menu {\n  position: relative;\n}\n.dd-menu li.nested-dd-menu > span {\n  position: absolute;\n  top: 0;\n}\n.tb-dd-list-item-danger {\n  color: #ef4c4c;\n}\n";
styleInject(css_248z$C);

var dropdownListItemDefaultProps = {
    children: null,
    className: '',
    disabled: false,
    onClick: function () { },
};
var DropdownListItem = /* #__PURE__ */ (function () {
    var DropdownListItem = function (props) {
        var onClick = props.onClick, givenClassName = props.className, disabled = props.disabled, children = props.children;
        var newProps = __assign(__assign({}, props), { className: classNames({
                'dd-item-ignore': disabled,
            }, givenClassName), onClick: props.disabled ? stopPropagation(function () { }) : stopPropagation(onClick) });
        delete newProps.disabled;
        return React.createElement("li", __assign({}, newProps), children);
    };
    DropdownListItem.propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        onClick: PropTypes.func,
    };
    DropdownListItem.defaultProps = dropdownListItemDefaultProps;
    return DropdownListItem;
})();

var css_248z$B = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n@-webkit-keyframes fade-in {\n  from {\n    margin-top: 50px;\n    opacity: 0;\n  }\n  to {\n    margin-top: 0;\n    opacity: 1;\n  }\n}\n@-moz-keyframes fade-in {\n  from {\n    margin-top: 50px;\n    opacity: 0;\n  }\n  to {\n    margin-top: 0;\n    opacity: 1;\n  }\n}\n@keyframes fade-in {\n  from {\n    margin-top: 50px;\n    opacity: 0;\n  }\n  to {\n    margin-top: 0;\n    opacity: 1;\n  }\n}\n.tb-view-modal-dialog {\n  max-width: 90%;\n  display: flex;\n  margin: 30px auto;\n  outline: none;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: auto;\n}\n.tb-view-modal-header {\n  margin: 0;\n  padding-bottom: 25px;\n  border-bottom: 1px solid #ebebed;\n}\n.tb-view-modal-header-auth {\n  padding-top: 20px;\n  align-items: flex-start;\n  display: flex;\n}\n.tb-view-modal-header-auth-name {\n  margin-right: auto;\n}\n.tb-view-modal-header-auth-toggle {\n  margin-left: auto;\n}\n.tb-view-modal-header-title {\n  margin: 0;\n}\n.tb-view-modal-header-title-is-large {\n  font-size: 30px;\n}\n.tb-view-modal-title {\n  margin: 0;\n  font-weight: 400;\n  font-size: 1.5em;\n}\n.tb-view-modal-description {\n  margin: 0;\n  padding-top: 10px;\n}\n.tb-view-modal-header-icon,\n.tb-view-modal-header i.tb-view-modal-header-icon {\n  font-size: 22px;\n  color: #dee0e3;\n}\n.tb-view-modal-row {\n  display: flex;\n  margin: 15px 0;\n}\n.tb-view-modal-row-item {\n  min-width: 80px;\n  margin-right: 5px;\n}\n.tb-view-modal-body {\n  margin: 0;\n  padding: 18px 0;\n}\n.tb-view-modal-body-service {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n}\n.tb-view-modal-body-confirm {\n  color: #807f7f;\n  margin-bottom: 15px;\n  display: block;\n}\n.tb-view-modal-body-confirm-bold {\n  color: #494747;\n  font-weight: bold;\n}\n.tb-view-modal-body-checkboxes {\n  margin-bottom: 5px;\n}\n.tb-view-modal-body-checkboxes-label {\n  font-weight: normal;\n}\n.tb-view-modal-service-form {\n  width: 100%;\n}\n.tb-view-modal-back {\n  background-color: transparent;\n  border: none;\n  text-transform: uppercase;\n  font-size: 11px;\n  font-weight: bold;\n  position: absolute;\n  top: 70px;\n  color: #bfbfbe;\n}\n.tb-view-modal-back:hover {\n  color: #006cbc;\n}\n.tb-view-modal-paragraph {\n  font-size: 14px;\n  line-height: 20px;\n}\n.tb-view-modal-paragraph-is-secondary {\n  color: #a09f9e;\n}\n.tb-view-modal-paragraph-is-padded {\n  padding: 30px 0 10px 0;\n}\n.tb-view-modal-paragraph-is-padded-deep {\n  padding: 10px 25px 10px 25px;\n}\n.tb-view-modal-close {\n  border: none;\n  background: none;\n  float: right;\n  font-size: 27px;\n  font-weight: bold;\n  line-height: 1;\n  color: #000;\n  text-shadow: 0 1px 0 #fff;\n  opacity: 0.2;\n  font-size: 28px;\n  font-weight: 200;\n  color: #464c4f;\n  position: relative;\n  top: -18px;\n  right: -10px;\n  margin-top: -2px;\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n}\n.tb-view-modal-close:hover,\n.tb-view-modal-close:focus,\n.tb-view-modal-close:active {\n  border: none;\n  background: none;\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n  opacity: 0.5;\n}\n.tb-view-modal-overlay {\n  /* background-color: #000;\n        opacity: .5;\n\n        position: fixed;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        z-index: 1050; */\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  background-color: rgba(0, 0, 0, 0.6);\n  outline: none;\n  -webkit-appearance: none;\n  z-index: 1050;\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: flex;\n}\n.tb-view-modal-layout {\n  animation: fade-in 500ms cubic-bezier(0.165, 0.84, 0.44, 1);\n  -webkit-animation: fade-in 500ms cubic-bezier(0.165, 0.84, 0.44, 1);\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1051;\n  overflow-y: scroll;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.tb-view-modal-content {\n  min-width: 650px;\n  max-width: 850px;\n  padding: 30px;\n  align-self: flex-start;\n  color: #494747;\n  position: relative;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 3px;\n  outline: none;\n  -webkit-appearance: none;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n@media (max-width: 700px) {\n  .tb-view-modal-content {\n    min-width: unset;\n    width: 100%;\n  }\n}\n.tb-view-modal-content-fill {\n  padding: 0;\n}\n.tb-view-modal-content-service {\n  width: 650px;\n}\n.tb-view-modal-content:selected,\n.tb-view-modal-content:active {\n  outline: none;\n  -webkit-appearance: none;\n}\n.tb-view-modal-content-is-bordered .tb-view-modal-body {\n  border-bottom: 1px solid #ebebed;\n  padding: 18px 0;\n}\n.tb-view-modal-content-is-xs {\n  min-width: inherit;\n  max-width: inherit;\n  width: 418px;\n}\n.tb-view-modal-content-is-small {\n  min-width: inherit;\n  max-width: inherit;\n  width: 562px;\n}\n.tb-view-modal-content-is-medium {\n  min-width: inherit;\n  max-width: inherit;\n  width: 700px;\n}\n.tb-view-modal-content-is-large {\n  min-width: inherit;\n  max-width: inherit;\n  width: 800px;\n}\n.tb-view-modal-content-is-xlarge {\n  min-width: inherit;\n  max-width: inherit;\n  width: 880px;\n}\n.tb-view-modal-content-is-edit-ranges-modal {\n  min-width: inherit;\n  max-width: inherit;\n  width: 825px;\n}\n.tb-view-modal-body-alert {\n  padding: 0 15px;\n}\n.tb-view-modal-body-has-padding {\n  padding-bottom: 24px;\n}\n.tb-view-modal-input-row {\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n}\n.tb-view-modal-input-row-is-left-aligned {\n  justify-content: flex-start;\n}\n.tb-view-modal-input-row-is-vertically-centered {\n  align-items: center;\n}\n.tb-view-modal-input-row-spaced-element {\n  margin-right: 5px;\n}\n.tb-view-modal-label {\n  width: 25%;\n}\n.tb-view-modal-input {\n  margin-left: 15px;\n}\n.tb-view-modal-input-error-message {\n  color: #ac0f0f;\n  font-style: italic;\n  font-size: 14px;\n  font-weight: 100;\n  margin-left: 15px;\n  margin-top: 10px;\n}\n.tb-view-modal-input-has-error {\n  border-color: #ac0f0f;\n}\n.tb-view-modal-input-container {\n  display: flex;\n  flex-direction: column;\n}\n.tb-view-modal-input-container-is-wide {\n  width: 290px;\n}\n.tb-view-modal-input-container-has-left-margin {\n  margin-left: 15px;\n}\n.tb-view-modal-input-container-is-right-aligned {\n  align-items: flex-end;\n}\n.tb-view-modal-open {\n  overflow: hidden;\n}\n.tb-view-modal-footer {\n  padding-top: 24px;\n  text-align: right;\n  justify-content: space-between;\n}\n.tb-view-modal-footer-buttons {\n  display: inline-block;\n}\n.tb-view-modal-step-header {\n  font-size: 18px;\n  vertical-align: middle;\n}\n.tb-view-modal-step-subheader {\n  padding-top: 3px;\n  font-size: 14px;\n  color: #888888;\n}\n.tb-view-modal-step-num {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  height: 20px;\n  width: 20px;\n  border-radius: 15px;\n  color: white;\n  font-size: 12px;\n  text-align: center;\n  background-color: #bfbfbe;\n  margin-right: 10px;\n}\n.tb-view-modal-step-num-active {\n  background-color: #569d3f;\n}\n.tb-view-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n.tb-view-modal-actions .tb-button,\n.tb-view-modal-actions .tb-modal-footer-button {\n  margin: 0 0 0 10px;\n}\n";
styleInject(css_248z$B);

var css_248z$A = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.form-row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  padding: 25px;\n  border-bottom: 1px solid #ebebed;\n}\n.form-row-is-last {\n  border-bottom: none;\n}\n.form-row-is-solo {\n  margin-top: 50px;\n  border-top: 1px solid #ebebed;\n}\n.form-row-no-header {\n  padding-left: 25px;\n  padding-right: 25px;\n  padding-bottom: 25px;\n  padding-top: 0px;\n}\n.form-row-no-footer {\n  padding-bottom: 0px;\n}\n.form-row-no-wrap {\n  flex-wrap: nowrap;\n}\n.form-row-is-nested {\n  padding-left: 65px;\n}\n.form-row-header {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.form-row-labeled-checkbox {\n  padding: 5px;\n  display: inline-flex;\n  align-items: center;\n}\n.form-row-labeled-checkbox label {\n  padding-left: 10px;\n}\n.form-row-labeled-checkbox-group {\n  display: flex;\n  flex-direction: column;\n  margin: 10px;\n}\n.form-row-contents {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n}\n.form-row-radio-group {\n  display: flex;\n  flex-direction: column;\n}\n.form-row-radio-group-item {\n  display: flex;\n  flex-direction: row;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  align-items: center;\n}\n.form-row-radio-group-item input[type='radio'] {\n  margin-right: 5px;\n}\n.form-row-error-message {\n  flex-basis: 100%;\n  background-color: #fff6f6;\n  color: #ef4c4c;\n  border-radius: 4px;\n  border: 1px solid #fbcccc;\n  padding: 10px;\n  margin-top: 14px;\n}\n.form-row-button-group {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n}\n.form-row-label {\n  font-size: 16px;\n  font-weight: bold;\n  text-transform: capitalize;\n}\n.form-row-label-group {\n  flex-grow: 0;\n  flex-shrink: 1;\n  min-width: 50%;\n  width: 50%;\n}\n.form-row-label-group-is-compact {\n  width: inherit;\n  margin-right: 20px;\n}\n.form-row-label-group-is-quarter {\n  width: 25%;\n}\n.form-row-label-group-is-wide {\n  width: 100%;\n}\n.form-row-label-group-is-aligned-top {\n  align-self: baseline;\n}\n.form-row-label-no-transform {\n  font-size: 16px;\n  font-weight: bold;\n}\n.form-row-description {\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 20px;\n  color: #a09f9e;\n  margin-top: 10px;\n  padding-right: 20px;\n}\n.form-row-description-link {\n  font-size: 14px;\n  color: #006cbc;\n  text-decoration: underline;\n}\n.form-row-banner {\n  padding-right: 20px;\n}\n.form-row-input-group {\n  flex-grow: 1;\n  align-items: center;\n  max-width: 100%;\n}\n.form-row-input-group-flex-column {\n  display: flex;\n  flex-direction: column;\n}\n.form-row-input-group-is-right {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n.form-row-input-group-is-right .tb-text-input,\n.form-row-input-group-is-right .switch {\n  margin-left: 10px;\n}\n.form-row-input-group-is-two-line {\n  min-height: 80px;\n}\n.form-row-input-group-label {\n  font-size: 12px;\n  font-weight: bold;\n  margin-bottom: 8px;\n}\n.form-row-input-group-read-only-value {\n  font-size: 18px;\n}\n.form-row-input-group-match-json-editor {\n  align-self: stretch;\n  margin-top: 10px;\n}\n.form-row-input-group p {\n  font-size: 20px;\n}\n.form-row-input-error {\n  border: 1px solid;\n  border-radius: 3px;\n  border-color: #ef4c4c !important;\n  box-shadow: 0 2px 6px pink;\n}\n.form-row-input-error-message {\n  margin-top: 2px;\n  position: absolute;\n  color: #ef4c4c;\n  font-size: 12px;\n}\n.form-row-input-error-wrapped-message {\n  margin-top: 2px;\n  color: #ef4c4c;\n  font-size: 12px;\n  overflow-wrap: break-word;\n}\n.form-row-is-small {\n  padding: 5px;\n}\n.form-row-is-wide {\n  padding: 15px 0px;\n}\n.form-row-is-compact {\n  padding-left: 0px;\n  padding-bottom: 0px;\n  border-bottom: none;\n}\n.form-row-is-compact-top {\n  padding-top: 0px;\n}\n.form-row-text-input {\n  width: 100%;\n}\n.form-row-button-footer-actions-container {\n  display: flex;\n  align-items: baseline;\n}\n.form-row-button-footer-actions-container-button {\n  margin-left: 10px;\n}\n";
styleInject(css_248z$A);

var FormRow = /* #__PURE__ */ (function () {
    var FormRow = function (_a) {
        var children = _a.children, className = _a.className, noBorder = _a.noBorder, last = _a.last, small = _a.small, nested = _a.nested, wide = _a.wide, noHeader = _a.noHeader, noFooter = _a.noFooter, noWrap = _a.noWrap, solo = _a.solo, compact = _a.compact, errorMessage = _a.errorMessage, rest = __rest(_a, ["children", "className", "noBorder", "last", "small", "nested", "wide", "noHeader", "noFooter", "noWrap", "solo", "compact", "errorMessage"]);
        var newProps = {
            className: classNames('form-row', {
                'form-row-is-last': last || noBorder,
                'form-row-is-nested': nested,
                'form-row-is-small': small,
                'form-row-is-solo': solo,
                'form-row-is-wide': wide,
                'form-row-is-compact': compact,
                'form-row-no-footer': noFooter,
                'form-row-no-header': noHeader,
                'form-row-no-wrap': noWrap,
            }, className),
        };
        var outProps = __assign(__assign({}, newProps), rest);
        return (React.createElement("div", __assign({}, outProps),
            children,
            errorMessage && React.createElement("div", { className: "form-row-error-message" }, errorMessage)));
    };
    FormRow.defaultProps = {
        children: null,
        className: undefined,
        last: false,
        nested: false,
        noBorder: false,
        noFooter: false,
        noHeader: false,
        noWrap: false,
        small: false,
        solo: false,
        wide: false,
        compact: false,
    };
    // Leave these until all components using this component are converted to TS
    FormRow.propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        last: PropTypes.bool,
        nested: PropTypes.bool,
        noBorder: PropTypes.bool,
        noFooter: PropTypes.bool,
        noHeader: PropTypes.bool,
        noWrap: PropTypes.bool,
        small: PropTypes.bool,
        solo: PropTypes.bool,
        wide: PropTypes.bool,
        compact: PropTypes.bool,
    };
    return FormRow;
})();

var DEFAULT_DATE_FORMAT = 'MM/DD/YYYY HH:mm:ss';
var DEFAULT_SAVE_ERROR_MESSAGE = 'Changes could not be saved. Please resolve the errors above.';
var DEFAULT_SAVE_STATUS_TIMEOUT = 3e3;

var css_248z$z = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-spinner-circle {\n  color: #13aa52;\n}\n";
styleInject(css_248z$z);

var SpinnerCircle = /* #__PURE__ */ (function () {
    var SpinnerCircle = function (_a) {
        var className = _a.className, rest = __rest(_a, ["className"]);
        return (React.createElement("div", __assign({ className: className }, passThroughProps(rest)),
            React.createElement(FontAwesome, { className: "tb-spinner-circle", name: "circle-o-notch", spin: true })));
    };
    SpinnerCircle.propTypes = {
        className: PropTypes.string,
    };
    SpinnerCircle.defaultProps = {
        className: '',
    };
    return SpinnerCircle;
})();

var css_248z$y = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-save-status-container {\n  display: flex;\n}\n.tb-save-status-error-msg {\n  color: #ef4c4c;\n  font-weight: bold;\n}\n.tb-save-status-saved-msg {\n  display: flex;\n  align-items: center;\n  color: #13aa52;\n}\n.tb-save-status-saved-msg-icon {\n  margin-right: 5px;\n}\n.tb-save-status-saved-msg-enter {\n  opacity: 1;\n}\n.tb-save-status-saved-msg-exit.tb-save-status-saved-msg-exit-active {\n  opacity: 0.01;\n  transition: opacity 500ms ease-in;\n}\n";
styleInject(css_248z$y);

var SaveStatus = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(SaveStatus, _super);
            function SaveStatus() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.state = {
                    showStatusSuccess: false,
                    showStatusError: false,
                    skipExitAnimation: false,
                    timeoutID: undefined,
                };
                _this.clear = function (timeoutID) {
                    clearTimeout(timeoutID);
                    _this.setState({ skipExitAnimation: true, showStatusSuccess: false, showStatusError: false });
                };
                return _this;
            }
            SaveStatus.prototype.componentDidUpdate = function (prevProps, prevState) {
                var _this = this;
                var _a = this.props, saving = _a.saving, saveError = _a.saveError, displayTimeMillis = _a.displayTimeMillis;
                // When a saving attempt is started, immediately clear any previous status.
                if (!prevProps.saving && saving) {
                    this.clear(prevState.timeoutID);
                }
                // When saveError is cleared, immediately clear any previous status.
                if (prevProps.saveError && !saveError) {
                    this.clear(prevState.timeoutID);
                }
                // When saving completes without error, show success status with timeout.
                if (prevProps.saving && !saving && !saveError) {
                    var timeoutID = window.setTimeout(function () {
                        // eslint-disable-next-line react/no-did-update-set-state
                        _this.setState({
                            showStatusSuccess: false,
                        });
                    }, displayTimeMillis);
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        timeoutID: timeoutID,
                        showStatusSuccess: true,
                        skipExitAnimation: false,
                    });
                }
                // When saving completes with error, show error status.
                if (prevProps.saving && !saving && saveError) {
                    this.setState({ showStatusError: true }); // eslint-disable-line react/no-did-update-set-state
                }
            };
            SaveStatus.prototype.componentWillUnmount = function () {
                clearTimeout(this.state.timeoutID);
            };
            SaveStatus.prototype.render = function () {
                var _a = this.props, className = _a.className, saveErrorMessage = _a.saveErrorMessage, hasValidationError = _a.hasValidationError, saving = _a.saving, isDraft = _a.isDraft, rest = __rest(_a, ["className", "saveErrorMessage", "hasValidationError", "saving", "isDraft"]);
                var _b = this.state, skipExitAnimation = _b.skipExitAnimation, showStatusError = _b.showStatusError, showStatusSuccess = _b.showStatusSuccess;
                var showValidationError = hasValidationError && !saving;
                var showError = showStatusError || showValidationError;
                return (React.createElement("div", __assign({ className: classNames('tb-save-status-container', className) }, passThroughProps(rest)),
                    saving && React.createElement(SpinnerCircle, null),
                    showError && React.createElement("span", { className: "tb-save-status-error-msg" }, saveErrorMessage),
                    React.createElement(CSSTransition, { in: showStatusSuccess, classNames: "tb-save-status-saved-msg", enter: false, exit: !skipExitAnimation, timeout: { exit: 500 }, unmountOnExit: true },
                        React.createElement("div", { className: "tb-save-status-saved-msg" },
                            React.createElement(FontAwesome, { name: "check", className: "tb-save-status-saved-msg-icon" }),
                            React.createElement("span", null, isDraft ? 'Draft Saved!' : 'Saved!')))));
            };
            return SaveStatus;
        }(React.Component)),
        _a.propTypes = {
            className: PropTypes.string,
            displayTimeMillis: PropTypes.number,
            saveError: PropTypes.string,
            hasValidationError: PropTypes.bool,
            saveErrorMessage: PropTypes.string,
            saving: PropTypes.bool,
            isDraft: PropTypes.bool,
        },
        _a.defaultProps = {
            saving: false,
            className: '',
            displayTimeMillis: DEFAULT_SAVE_STATUS_TIMEOUT,
            saveError: '',
            saveErrorMessage: DEFAULT_SAVE_ERROR_MESSAGE,
            hasValidationError: false,
            isDraft: false,
        },
        _a;
})();

var FormRowInputGroup = /* #__PURE__ */ (function () {
    var FormRowInputGroup = function (_a) {
        var children = _a.children, right = _a.right, className = _a.className, rest = __rest(_a, ["children", "right", "className"]);
        var newProps = {
            className: classNames('form-row-input-group', {
                'form-row-input-group-is-right': right,
            }, className),
        };
        return (React.createElement("div", __assign({}, newProps, passThroughProps(rest)), children));
    };
    FormRowInputGroup.defaultProps = {
        children: null,
        className: '',
        right: false,
    };
    // Leave these until all components using this component are converted to TS
    FormRowInputGroup.propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        right: PropTypes.bool,
    };
    return FormRowInputGroup;
})();

var SaveButton = /* #__PURE__ */ (function () {
    var SaveButton = function (_a) {
        var className = _a.className, editing = _a.editing, onSave = _a.onSave, saving = _a.saving, isDirty = _a.isDirty, namePrefix = _a.namePrefix, disabled = _a.disabled, isDraft = _a.isDraft, rest = __rest(_a, ["className", "editing", "onSave", "saving", "isDirty", "namePrefix", "disabled", "isDraft"]);
        return isDirty || !editing ? (React.createElement(Button, __assign({ name: namePrefix + "Save", className: className, variant: "primary", onClick: onSave, disabled: saving || disabled }, passThroughProps(rest)),
            isDraft && (saving ? 'Saving Draft...' : 'Save Draft'),
            !isDraft && (saving ? 'Saving...' : 'Save'))) : (React.createElement(Button, __assign({ name: namePrefix + "NoChanges", className: className, disabled: true }, passThroughProps(rest)), "No Changes"));
    };
    SaveButton.defaultProps = {
        className: '',
        editing: true,
        isDirty: false,
        saving: false,
        namePrefix: 'header',
        disabled: false,
        isDraft: false,
    };
    SaveButton.propTypes = {
        className: PropTypes.string,
        editing: PropTypes.bool,
        isDirty: PropTypes.bool,
        onSave: PropTypes.func.isRequired,
        saving: PropTypes.bool,
        namePrefix: PropTypes.string,
        disabled: PropTypes.bool,
        isDraft: PropTypes.bool,
    };
    return SaveButton;
})();

var TestSelector$h;
(function (TestSelector) {
    TestSelector["ContainerFormRow"] = "container-form-row";
    TestSelector["SaveButtonFormFooter"] = "save-button-form-footer";
    TestSelector["CancelButtonFormFooter"] = "cancel-button-form-footer";
    TestSelector["DiscardButtonFormFooter"] = "discard-button-form-footer";
})(TestSelector$h || (TestSelector$h = {}));
var formRowButtonFooterButtonClassName = 'form-row-button-footer-actions-container-button';
var FormRowButtonFooter = /* #__PURE__ */ (function () {
    var FormRowButtonFooter = function (_a) {
        var className = _a.className, editing = _a.editing, onDiscard = _a.onDiscard, onCancel = _a.onCancel, onSave = _a.onSave, saving = _a.saving, formIsDirty = _a.formIsDirty, saveError = _a.saveError, saveErrorMessage = _a.saveErrorMessage, hasValidationError = _a.hasValidationError, buttonNamePrefix = _a.buttonNamePrefix, saveButtonDisabled = _a.saveButtonDisabled, isDraft = _a.isDraft, rest = __rest(_a, ["className", "editing", "onDiscard", "onCancel", "onSave", "saving", "formIsDirty", "saveError", "saveErrorMessage", "hasValidationError", "buttonNamePrefix", "saveButtonDisabled", "isDraft"]);
        var saveButton = (React.createElement(SaveButton, { className: formRowButtonFooterButtonClassName, namePrefix: buttonNamePrefix, onSave: onSave, isDirty: formIsDirty, saving: saving, editing: editing, disabled: saveButtonDisabled, isDraft: isDraft, "data-test-selector": TestSelector$h.SaveButtonFormFooter }));
        var newButtons = (React.createElement(React.Fragment, null,
            !saving && (React.createElement(Button, { name: buttonNamePrefix + "Cancel", className: formRowButtonFooterButtonClassName, onClick: onCancel, "data-test-selector": TestSelector$h.CancelButtonFormFooter }, "Cancel")),
            saveButton));
        var editButtons = (React.createElement(React.Fragment, null,
            formIsDirty && !saving && (React.createElement(Button, { name: buttonNamePrefix + "Discard", className: formRowButtonFooterButtonClassName, onClick: onDiscard, "data-test-selector": TestSelector$h.DiscardButtonFormFooter }, "Discard Changes")),
            saveButton));
        return (React.createElement(FormRow, __assign({ last: true, className: className, "data-test-selector": TestSelector$h.ContainerFormRow }, passThroughProps(rest)),
            React.createElement(FormRowInputGroup, { className: "form-row-button-footer-actions-container", right: true },
                React.createElement(SaveStatus, { saving: saving, saveError: saveError, saveErrorMessage: saveErrorMessage, hasValidationError: hasValidationError, className: "form-footer-save-status", isDraft: isDraft }),
                editing ? editButtons : newButtons)));
    };
    FormRowButtonFooter.defaultProps = {
        className: undefined,
        editing: true,
        formIsDirty: false,
        hasValidationError: false,
        onCancel: function () { },
        saveError: '',
        saving: false,
        buttonNamePrefix: 'formFooter',
        saveButtonDisabled: false,
        isDraft: false,
    };
    // Leave these until all components using this component are converted to TS
    FormRowButtonFooter.propTypes = {
        className: PropTypes.string,
        editing: PropTypes.bool,
        formIsDirty: PropTypes.bool,
        hasValidationError: PropTypes.bool,
        onCancel: PropTypes.func,
        onDiscard: PropTypes.func.isRequired,
        onSave: PropTypes.func.isRequired,
        saveError: PropTypes.string,
        saving: PropTypes.bool,
        buttonNamePrefix: PropTypes.string,
        saveButtonDisabled: PropTypes.bool,
        isDraft: PropTypes.bool,
    };
    return FormRowButtonFooter;
})();

var FormRowHeader = /* #__PURE__ */ (function () {
    var FormRowHeader = function (_a) {
        var children = _a.children, rest = __rest(_a, ["children"]);
        return (React.createElement("div", __assign({ className: "form-row-header" }, passThroughProps(rest)), children));
    };
    FormRowHeader.propTypes = {
        children: PropTypes.node,
    };
    FormRowHeader.defaultProps = {
        children: null,
    };
    FormRowHeader.displayName = 'FormRowHeader';
    return FormRowHeader;
})();

var FormRowLabelGroup = /* #__PURE__ */ (function () {
    var FormRowLabelGroup = function (_a) {
        var alignTop = _a.alignTop, children = _a.children, compact = _a.compact, wide = _a.wide, rest = __rest(_a, ["alignTop", "children", "compact", "wide"]);
        return (React.createElement("div", __assign({ className: classNames('form-row-label-group', {
                'form-row-label-group-is-compact': compact,
                'form-row-label-group-is-wide': wide,
                'form-row-label-group-is-aligned-top': alignTop,
            }) }, passThroughProps(rest)), children));
    };
    FormRowLabelGroup.propTypes = {
        children: PropTypes.node,
        compact: PropTypes.bool,
        wide: PropTypes.bool,
        alignTop: PropTypes.bool,
    };
    FormRowLabelGroup.defaultProps = {
        children: null,
        compact: false,
        wide: false,
        alignTop: false,
    };
    return FormRowLabelGroup;
})();

var TestSelector$g;
(function (TestSelector) {
    TestSelector["ContainerFormRow"] = "container-form-row";
})(TestSelector$g || (TestSelector$g = {}));
var FormRowSubmitButtonFooter = /* #__PURE__ */ (function () {
    var FormRowSubmitButtonFooter = function (_a) {
        var className = _a.className, onCancel = _a.onCancel, onSubmit = _a.onSubmit, submitLabel = _a.submitLabel, submitPrimary = _a.submitPrimary, submitDisabled = _a.submitDisabled, submitDisabledLabel = _a.submitDisabledLabel, submitError = _a.submitError, submitting = _a.submitting, hasValidationError = _a.hasValidationError, isDraft = _a.isDraft, rest = __rest(_a, ["className", "onCancel", "onSubmit", "submitLabel", "submitPrimary", "submitDisabled", "submitDisabledLabel", "submitError", "submitting", "hasValidationError", "isDraft"]);
        return (React.createElement(FormRow, __assign({ last: true, className: className, "data-test-selector": TestSelector$g.ContainerFormRow }, passThroughProps(rest)),
            React.createElement(FormRowInputGroup, { className: "form-row-button-footer-actions-container", right: true },
                React.createElement(SaveStatus, { saving: submitting, saveError: submitError, hasValidationError: hasValidationError, className: "form-footer-save-status", isDraft: isDraft }),
                !submitting && (React.createElement(Button, { name: "formFooterCancel", onClick: onCancel }, "Cancel")),
                React.createElement(Button, { name: "formFooterSubmit", variant: submitPrimary ? 'primary' : 'danger', onClick: onSubmit, disabled: submitDisabled || submitting }, submitDisabled ? submitDisabledLabel : submitLabel))));
    };
    FormRowSubmitButtonFooter.propTypes = {
        className: PropTypes.string,
        onCancel: PropTypes.func,
        onSubmit: PropTypes.func.isRequired,
        submitLabel: PropTypes.string.isRequired,
        submitPrimary: PropTypes.bool,
        submitDisabled: PropTypes.bool,
        submitDisabledLabel: PropTypes.string,
        submitError: PropTypes.string,
        submitting: PropTypes.bool,
        hasValidationError: PropTypes.bool,
        isDraft: PropTypes.bool,
    };
    FormRowSubmitButtonFooter.defaultProps = {
        className: undefined,
        onCancel: function () { },
        submitPrimary: true,
        submitDisabled: false,
        submitDisabledLabel: 'disabled',
        submitError: '',
        submitting: false,
        hasValidationError: false,
        isDraft: false,
    };
    return FormRowSubmitButtonFooter;
})();

var css_248z$x = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-state-indicator {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.tb-state-indicator-is-message {\n  font-size: 14px;\n  color: #ef4c4c;\n}\n.tb-state-indicator-error {\n  padding-right: 4px;\n  margin-top: -2px;\n  color: #ef4c4c;\n}\n.tb-state-indicator-fixed {\n  padding-left: 17px;\n  padding-right: 17px;\n}\n.tb-state-indicator-fixed-error {\n  margin-right: calc(4px - 17px);\n  margin-top: -2px;\n  color: #ef4c4c;\n}\n.tb-state-indicator-fixed-dirty {\n  margin-left: -17px;\n  padding-right: calc(17px - 5.672px);\n}\n.tb-state-indicator-placeholder {\n  font-style: italic;\n  color: #bfbfbe;\n}\n";
styleInject(css_248z$x);

var StateIndicator = /* #__PURE__ */ (function () {
    function StateIndicator(_a) {
        var children = _a.children, placeholder = _a.placeholder, dirty = _a.dirty, error = _a.error, isMessage = _a.isMessage, fixed = _a.fixed, className = _a.className, rest = __rest(_a, ["children", "placeholder", "dirty", "error", "isMessage", "fixed", "className"]);
        return (React.createElement("div", __assign({ className: classNames('tb-state-indicator', className, {
                'tb-state-indicator-is-message': error && isMessage,
            }) }, passThroughProps(rest)),
            error && (React.createElement(FontAwesome, { className: classNames({ 'tb-state-indicator-fixed-error': fixed, 'tb-state-indicator-error': !fixed }), name: "exclamation-circle" })),
            React.createElement("div", { className: classNames({ 'tb-state-indicator-fixed': fixed }) },
                children,
                !children && React.createElement("div", { className: "tb-state-indicator-placeholder" }, placeholder)),
            dirty && React.createElement("span", { className: classNames({ 'tb-state-indicator-fixed-dirty': fixed }) }, "*")));
    }
    StateIndicator.propTypes = {
        children: PropTypes.node,
        placeholder: PropTypes.string,
        dirty: PropTypes.bool,
        error: PropTypes.bool,
        isMessage: PropTypes.bool,
        fixed: PropTypes.bool,
        className: PropTypes.string,
    };
    StateIndicator.defaultProps = {
        dirty: false,
        error: false,
        isMessage: false,
        children: null,
        placeholder: '',
        fixed: false,
        className: '',
    };
    return StateIndicator;
})();

var css_248z$w = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-text-input {\n  display: block;\n  padding: 7px 8px;\n  font-size: 14px;\n  border-radius: 3px;\n  outline: none;\n  border: 1px solid #bfbfbe;\n}\n.tb-text-input-is-inline-block {\n  display: inline-block;\n}\n.tb-text-input-for-variable {\n  width: 100%;\n  font-family: Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n.tb-text-input-for-filter {\n  font-size: 10px;\n  padding: 3px 4px;\n}\n.tb-text-input-has-error {\n  border-color: #ef4c4c;\n}\n.tb-text-input:focus {\n  border-color: #5b81a9;\n  box-shadow: 0 2px 6px rgba(78, 175, 233, 0.3);\n}\n";
styleInject(css_248z$w);

var css_248z$v = ".tb-confirm {\n  z-index: 1001;\n}\n.tb-confirm-state-indicator {\n  padding-top: 2px;\n}\n";
styleInject(css_248z$v);

var TestSelector$f;
(function (TestSelector) {
    TestSelector["ConfirmButton"] = "confirm-button";
})(TestSelector$f || (TestSelector$f = {}));
var ConfirmComponent = /* #__PURE__ */ (function () {
    var Component = function (_a) {
        var _b = _a.alert, alert = _b === void 0 ? false : _b, _c = _a.cancel, cancel = _c === void 0 ? function () { } : _c, _d = _a.cancelButtonText, cancelButtonText = _d === void 0 ? 'Cancel' : _d, confirmBody = _a.confirmBody, _e = _a.confirmButtonText, confirmButtonText = _e === void 0 ? 'OK' : _e, confirmHeader = _a.confirmHeader, _f = _a.confirmButtonVariant, confirmButtonVariant = _f === void 0 ? 'primary' : _f, _g = _a.disableConfirm, disableConfirm = _g === void 0 ? false : _g, _h = _a.dismiss, dismiss = _h === void 0 ? function () { } : _h, _j = _a.options, options = _j === void 0 ? {
            prompt: false,
            promptValidator: function () { return ''; },
        } : _j, _k = _a.proceed, proceed = _k === void 0 ? function () { } : _k, _l = _a.proceedResult, proceedResult = _l === void 0 ? [] : _l, _m = _a.show, show = _m === void 0 ? false : _m, rest = __rest(_a, ["alert", "cancel", "cancelButtonText", "confirmBody", "confirmButtonText", "confirmHeader", "confirmButtonVariant", "disableConfirm", "dismiss", "options", "proceed", "proceedResult", "show"]);
        var promptInput = null;
        var _o = __read$1(useState(''), 2), error = _o[0], setError = _o[1];
        var handleConfirmation = function () {
            if (disableConfirm) {
                return;
            }
            if (options.prompt && promptInput) {
                var promptValidator = options.promptValidator;
                var validationError = promptValidator && promptValidator(promptInput.value);
                if (validationError) {
                    setError(validationError);
                    return;
                }
                setError('');
                proceed({ promptValue: promptInput.value });
            }
            else {
                proceed(proceedResult);
            }
        };
        return (React.createElement(Modal, __assign({ open: show, setOpen: function (isOpen) {
                if (!isOpen) {
                    dismiss();
                }
            }, className: "tb-confirm" }, passThroughProps(rest)),
            React.createElement(H3, null, confirmHeader),
            React.createElement("div", { className: "tb-view-modal-body", onKeyPress: enterPressedCaller(handleConfirmation) },
                confirmBody,
                options.prompt && (React.createElement(FormRow, { last: true },
                    React.createElement("input", { name: "prompt", ref: function (input) {
                            promptInput = input;
                        }, type: "text", className: "tb-text-input form-row-text-input", placeholder: "" }),
                    error && (React.createElement(StateIndicator, { className: "tb-confirm-state-indicator", isMessage: true, error: true }, error))))),
            React.createElement("footer", { className: "tb-view-modal-footer" },
                React.createElement("div", { className: "tb-view-modal-actions" },
                    !alert && (React.createElement(Button, { name: "cancel", onClick: cancel, className: "tb-modal-footer-button" }, cancelButtonText)),
                    React.createElement(Button, { variant: confirmButtonVariant, name: "confirm", className: "tb-modal-footer-button", disabled: disableConfirm, "data-test-selector": TestSelector$f.ConfirmButton, onClick: handleConfirmation }, confirmButtonText)))));
    };
    Component.displayName = 'Confirm';
    Component.defaultProps = {
        alert: false,
        cancel: function () { },
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        confirmButtonVariant: 'primary',
        disableConfirm: false,
        dismiss: function () { },
        options: {
            prompt: false,
            promptValidator: function () { return ''; },
        },
        proceed: function () { },
        proceedResult: [],
        show: false,
    };
    return Component;
})();
var Confirm = /* #__PURE__ */ (function () {
    return confirmable(ConfirmComponent);
})();

var buildCheckCriterion = function (criterion) {
    return typeof criterion === 'string'
        ? { defaultValue: false, text: criterion }
        : { defaultValue: !!criterion.defaultValue, text: criterion.text };
};
var ConfirmChecklistComponent = /* #__PURE__ */ (function () {
    var Component = function (_a) {
        var checkCriteria = _a.checkCriteria, confirmBody = _a.confirmBody, requireAllChecked = _a.requireAllChecked, props = __rest(_a, ["checkCriteria", "confirmBody", "requireAllChecked"]);
        var _b = __read$1(useState(checkCriteria.map(function (criterion) { return buildCheckCriterion(criterion).defaultValue; })), 2), criteriaStates = _b[0], setCriteriaStates = _b[1];
        var disableConfirm = requireAllChecked ? criteriaStates.some(function (isChecked) { return !isChecked; }) : false;
        var confirmBodyWithCriteria = (React.createElement(React.Fragment, null,
            confirmBody,
            checkCriteria.map(function (criterion, i) {
                var text = buildCheckCriterion(criterion).text;
                return (
                /* eslint-disable-next-line react/no-array-index-key */
                React.createElement("div", { className: "tb-view-modal-body-checkboxes", key: i },
                    React.createElement(Checkbox, { className: "tb-view-modal-body-checkboxes-label", label: text, checked: criteriaStates[i], name: text, onChange: function () {
                            return setCriteriaStates(criteriaStates.map(function (isChecked, j) { return (i === j ? !isChecked : isChecked); }));
                        } })));
            })));
        var newProps = __assign(__assign({}, props), { confirmBody: confirmBodyWithCriteria, disableConfirm: disableConfirm, proceedResult: checkCriteria.map(function (criterion, i) { return (__assign(__assign({}, buildCheckCriterion(criterion)), { confirmed: criteriaStates[i] })); }) });
        return React.createElement(ConfirmComponent, __assign({}, newProps));
    };
    Component.displayName = 'ConfirmChecklistComponent';
    Component.defaultProps = __assign(__assign({}, ConfirmComponent.defaultProps), { requireAllChecked: true });
    return Component;
})();
var ConfirmChecklist = /* #__PURE__ */ (function () {
    return confirmable(ConfirmChecklistComponent);
})();

var confirm$1 = createConfirmation(ConfirmChecklist);
var default_1$1 = /** @class */ (function () {
    function default_1() {
    }
    default_1.confirm = function (_a) {
        var checkCriteria = _a.checkCriteria, requireAllChecked = _a.requireAllChecked, confirmHeader = _a.confirmHeader, confirmBody = _a.confirmBody, confirmButtonText = _a.confirmButtonText, confirmButtonVariant = _a.confirmButtonVariant, _b = _a.modalDataProps, modalDataProps = _b === void 0 ? {} : _b;
        return confirm$1(__assign({ checkCriteria: checkCriteria,
            requireAllChecked: requireAllChecked,
            confirmHeader: confirmHeader,
            confirmBody: confirmBody,
            confirmButtonText: confirmButtonText,
            confirmButtonVariant: confirmButtonVariant }, passThroughProps(modalDataProps)));
    };
    return default_1;
}());

var confirm = createConfirmation(Confirm);
var default_1 = /** @class */ (function () {
    function default_1() {
    }
    default_1.confirm = function (_a) {
        var alert = _a.alert, cancelButtonText = _a.cancelButtonText, confirmHeader = _a.confirmHeader, confirmBody = _a.confirmBody, confirmButtonText = _a.confirmButtonText, confirmButtonVariant = _a.confirmButtonVariant, options = _a.options, _b = _a.modalDataProps, modalDataProps = _b === void 0 ? {} : _b;
        return confirm(__assign({ alert: alert,
            cancelButtonText: cancelButtonText,
            confirmHeader: confirmHeader,
            confirmBody: confirmBody,
            confirmButtonText: confirmButtonText,
            confirmButtonVariant: confirmButtonVariant,
            options: options }, passThroughProps(modalDataProps)));
    };
    return default_1;
}());

var css_248z$u = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-select-dd-toggle {\n  background-image: linear-gradient(to bottom, #fefefe, #fcfcfc, #fafbfa, #f9f9f9, #f7f7f7);\n  border-radius: 2px;\n  cursor: pointer;\n  padding: 6px;\n  font-size: 13px;\n  border: 1px solid #dddddd;\n  -webkit-box-shadow: 0px 2px 1px -1px #dddddd;\n  -moz-box-shadow: 0px 2px 1px -1px #dddddd;\n  box-shadow: 0px 2px 1px -1px #dddddd;\n  display: flex;\n  justify-content: space-between;\n}\n.tb-select-dd-toggle-contents {\n  overflow: hidden;\n}\n.tb-select-dd-toggle-caret {\n  margin-left: 5px;\n}\n.tb-select-dd-toggle-caret-open {\n  color: black;\n}\n.tb-select-dd-toggle-caret-closed {\n  color: #c8d2d8;\n}\n.tb-select-dd-toggle-is-open {\n  background-image: none;\n  background-color: white;\n}\n.tb-select-dd-toggle-is-disabled {\n  background: #dee0e3;\n  border-color: #bfbfbe;\n  color: #807f7f;\n  cursor: default;\n}\n.tb-select-dd-toggle-summary {\n  display: flex;\n  align-items: center;\n}\n.tb-select-dd-toggle-summary-summarytext {\n  padding-left: 10px;\n  padding-right: 3px;\n  display: inline;\n  white-space: nowrap;\n  color: #a09f9e;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n";
styleInject(css_248z$u);

var SelectDropdownToggle = /* #__PURE__ */ (function () {
    function SelectDropdownToggle(_a) {
        var open = _a.open, onClick = _a.onClick, children = _a.children, disabled = _a.disabled, className = _a.className, rest = __rest(_a, ["open", "onClick", "children", "disabled", "className"]);
        var allClassNames = classNames('tb-select-dd-toggle', {
            'tb-select-dd-toggle-is-disabled': disabled,
        }, className);
        var caretClassName = classNames('tb-select-dd-toggle-caret', {
            'tb-select-dd-toggle-caret-open': open,
            'tb-select-dd-toggle-caret-closed': !open,
        });
        return (React.createElement("div", __assign({ className: allClassNames, onClick: !disabled ? onClick : function () { } }, passThroughProps(rest)),
            React.createElement("span", { className: 'tb-select-dd-toggle-contents' }, children),
            React.createElement("span", { className: caretClassName },
                React.createElement(FontAwesome, { name: open ? 'caret-up' : 'caret-down' }))));
    }
    SelectDropdownToggle.propTypes = {
        open: PropTypes.bool,
        children: PropTypes.node,
        onClick: PropTypes.func,
        disabled: PropTypes.bool,
        className: PropTypes.string,
    };
    SelectDropdownToggle.defaultProps = {
        open: false,
        children: null,
        onClick: function () { },
        disabled: false,
        className: '',
    };
    return SelectDropdownToggle;
})();

var SelectDropdownSummaryToggle = /* #__PURE__ */ (function () {
    var SelectDropdownSummaryToggle = function (_a) {
        var title = _a.title, summary = _a.summary, open = _a.open, onClick = _a.onClick, disabled = _a.disabled, className = _a.className, rest = __rest(_a, ["title", "summary", "open", "onClick", "disabled", "className"]);
        return (React.createElement(SelectDropdownToggle, __assign({ open: open, onClick: onClick, disabled: disabled, className: className }, passThroughProps(rest)),
            React.createElement("div", { className: "tb-select-dd-toggle-summary" },
                React.createElement("div", { className: "tb-select-dd-toggle-summary-title" }, title),
                React.createElement("div", { className: "tb-select-dd-toggle-summary-summarytext", title: summary },
                    "(",
                    summary,
                    ")"))));
    };
    SelectDropdownSummaryToggle.propTypes = {
        open: PropTypes.bool,
        title: PropTypes.node.isRequired,
        summary: PropTypes.node.isRequired,
        onClick: PropTypes.func,
        disabled: PropTypes.bool,
        className: PropTypes.string,
    };
    SelectDropdownSummaryToggle.defaultProps = {
        open: false,
        onClick: function () { },
        disabled: false,
        className: '',
    };
    return SelectDropdownSummaryToggle;
})();

var css_248z$t = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-tab-container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: baseline;\n  list-style: none;\n  margin: 0;\n}\n.tb-tab-container-for-section-header {\n  padding: 20px 0 0 0;\n  border-bottom: 3px solid #ebebed;\n}\n.tb-tab-container-for-section-header .tb-section-header-title {\n  align-self: flex-start;\n  padding: 0;\n}\n.tb-tab-container-for-debug-console {\n  border-bottom: none;\n  padding-top: 5px;\n  padding-left: 10px;\n}\n.tb-tab:hover {\n  color: #494747;\n}\n.tb-tab-for-section-header {\n  display: inline-block;\n  color: #a09f9e;\n  font-weight: bold;\n  font-size: 15px;\n  line-height: 1;\n  margin-bottom: -3px;\n}\n.tb-tab-for-section-header-is-active {\n  background-color: white;\n  border-bottom: 3px solid #13aa52;\n  color: #494747;\n}\n.tb-tab-for-section-header-is-link {\n  color: inherit;\n  cursor: pointer;\n  display: block;\n  text-decoration: inherit;\n  padding: 8px 24px;\n}\n.tb-tab-for-section-header-is-link:hover,\n.tb-tab-for-section-header-is-link:focus {\n  color: inherit;\n  text-decoration: inherit;\n}\n.tb-tab-for-debug-console {\n  height: 35px;\n  text-align: center;\n  cursor: pointer;\n  vertical-align: middle;\n  display: flex;\n  align-items: center;\n  padding: 5px 14px 7px;\n  font-weight: normal;\n  font-size: 12px;\n  margin-bottom: 3px;\n  border: 1px solid #dddddd;\n  border-bottom: none;\n}\n.tb-tab-for-debug-console:first-child {\n  border-right: none;\n}\n.tb-tab-for-debug-console a {\n  color: inherit;\n}\n.tb-tab-for-debug-console a:hover {\n  color: #494747;\n  text-decoration: none;\n}\n.tb-tab-for-debug-console-is-active {\n  background-color: white;\n  border-bottom: none;\n}\n";
styleInject(css_248z$t);

var Tab = /* #__PURE__ */ (function () {
    var Tab = function (_a) {
        var active = _a.active, variant = _a.variant, children = _a.children, otherProps = __rest(_a, ["active", "variant", "children"]);
        return (React.createElement("li", __assign({ className: classNames('tb-tab', {
                'tb-tab-for-section-header': variant === 'sectionHeader',
                'tb-tab-for-section-header-is-active': variant === 'sectionHeader' && active,
                'tb-tab-for-debug-console': variant === 'debugConsole',
                'tb-tab-for-debug-console-is-active': variant === 'debugConsole' && active,
            }) }, otherProps), children));
    };
    Tab.propTypes = {
        active: PropTypes.bool,
        children: PropTypes.node,
        variant: PropTypes.oneOf(['sectionHeader', 'debugConsole']),
    };
    Tab.defaultProps = {
        active: false,
        children: undefined,
        variant: 'sectionHeader',
    };
    return Tab;
})();

var Tabs = /* #__PURE__ */ (function () {
    var Tabs = function (_a) {
        var children = _a.children, variant = _a.variant, rest = __rest(_a, ["children", "variant"]);
        return (React.createElement("ul", __assign({ className: classNames('tb-tab-container', {
                'tb-tab-container-for-debug-console': variant === 'debugConsole',
                'tb-tab-container-for-section-header': variant === 'sectionHeader',
            }) }, passThroughProps(rest)), children));
    };
    Tabs.propTypes = {
        variant: PropTypes.oneOf(['sectionHeader', 'debugConsole']),
        children: PropTypes.node,
    };
    Tabs.defaultProps = {
        variant: 'sectionHeader',
        children: undefined,
    };
    return Tabs;
})();

var COLORS = {
  green1: '#168B46',
  green2: '#13AA52',
  // Primary green
  green3: '#1CC061',
  green4: '#89E5B3',
  green5: '#CCFFE1',
  green6: '#f0f7ec',
  green7: '#629c3b',
  green8: '#EFFEF6',
  gray0: '#313030',
  gray1: '#494747',
  gray2: '#615f5f',
  gray3: '#807f7f',
  gray4: '#a09f9e',
  gray5: '#bfbfbe',
  gray6: '#dee0e3',
  gray7: '#ebebed',
  gray8: '#f5f6f7',
  gray9: '#e8e9e9',
  gray10: '#dddddd',
  gray11: '#d8d8d8',
  gray12: '#ababab',
  gray13: '#f8f8f8',
  gray14: '#859196',
  blue2: '#46b1e2',
  blue3: '#5caeeb',
  blue6: '#e1f4ff'
};
var COLORS$1 = COLORS;

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$d =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var aFunction$2 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var aFunction$1 = aFunction$2;

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var fails$7 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var fails$6 = fails$7;
var classof$1 = classofRaw;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$6(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$1(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

var requireObjectCoercible$1 = requireObjectCoercible$2;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$3 = function (argument) {
  return Object(requireObjectCoercible$1(argument));
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger$2 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var toInteger$1 = toInteger$2;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$2 = function (argument) {
  return argument > 0 ? min$1(toInteger$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var isObject$5 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var classof = classofRaw;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$2 = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};

var shared$3 = {exports: {}};

var fails$5 = fails$7;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$5(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var objectDefineProperty = {};

var global$c = global$d;
var isObject$4 = isObject$5;

var document$1 = global$c.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$4(document$1) && isObject$4(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

var DESCRIPTORS$3 = descriptors;
var fails$4 = fails$7;
var createElement = documentCreateElement;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$3 && !fails$4(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var isObject$3 = isObject$5;

var anObject$2 = function (it) {
  if (!isObject$3(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var isObject$2 = isObject$5;

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$2 = function (input, PREFERRED_STRING) {
  if (!isObject$2(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$2(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$2(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$2(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var DESCRIPTORS$2 = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var anObject$1 = anObject$2;
var toPrimitive$1 = toPrimitive$2;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$2 ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPrimitive$1(P, true);
  anObject$1(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$1 = descriptors;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;

var createNonEnumerableProperty$5 = DESCRIPTORS$1 ? function (object, key, value) {
  return definePropertyModule$1.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var global$b = global$d;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;

var setGlobal$3 = function (key, value) {
  try {
    createNonEnumerableProperty$4(global$b, key, value);
  } catch (error) {
    global$b[key] = value;
  } return value;
};

var global$a = global$d;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$a[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.12.1',
  mode: 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});

var toObject$2 = toObject$3;

var hasOwnProperty = {}.hasOwnProperty;

var has$6 = function hasOwn(it, key) {
  return hasOwnProperty.call(toObject$2(it), key);
};

var id = 0;
var postfix = Math.random();

var uid$2 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var global$9 = global$d;

var path$1 = global$9;

var path = path$1;
var global$8 = global$d;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$2 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global$8[namespace])
    : path[namespace] && path[namespace][method] || global$8[namespace] && global$8[namespace][method];
};

var getBuiltIn$1 = getBuiltIn$2;

var engineUserAgent = getBuiltIn$1('navigator', 'userAgent') || '';

var global$7 = global$d;
var userAgent = engineUserAgent;

var process = global$7.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$3 = fails$7;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$3(function () {
  return !String(Symbol()) ||
    // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$6 = global$d;
var shared$2 = shared$3.exports;
var has$5 = has$6;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$2('wks');
var Symbol$1 = global$6.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$1 = function (name) {
  if (!has$5(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has$5(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};

var isObject$1 = isObject$5;
var isArray$1 = isArray$2;
var wellKnownSymbol = wellKnownSymbol$1;

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  var C;
  if (isArray$1(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray$1(C.prototype))) C = undefined;
    else if (isObject$1(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var bind = functionBindContext;
var IndexedObject$1 = indexedObject;
var toObject$1 = toObject$3;
var toLength$1 = toLength$2;
var arraySpeciesCreate = arraySpeciesCreate$1;

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$1($this);
    var self = IndexedObject$1(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength$1(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod$1(7)
};

var fails$2 = fails$7;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$2(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $forEach = arrayIteration.forEach;
var arrayMethodIsStrict = arrayMethodIsStrict$1;

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

var global$5 = global$d;
var DOMIterables = domIterables;
var forEach = arrayForEach;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global$5[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty$3(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = indexedObject;
var requireObjectCoercible = requireObjectCoercible$2;

var toIndexedObject$3 = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};

var DESCRIPTORS = descriptors;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var createPropertyDescriptor = createPropertyDescriptor$2;
var toIndexedObject$2 = toIndexedObject$3;
var toPrimitive = toPrimitive$2;
var has$4 = has$6;
var IE8_DOM_DEFINE = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$2(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has$4(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};

var redefine$1 = {exports: {}};

var store$1 = sharedStore;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store$1.inspectSource != 'function') {
  store$1.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource$2 = store$1.inspectSource;

var global$4 = global$d;
var inspectSource$1 = inspectSource$2;

var WeakMap$1 = global$4.WeakMap;

var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource$1(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$1 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$3 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$3 = global$d;
var isObject = isObject$5;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var objectHas = has$6;
var shared = sharedStore;
var sharedKey = sharedKey$1;
var hiddenKeys$2 = hiddenKeys$3;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global$3.WeakMap;
var set, get, has$3;

var enforce = function (it) {
  return has$3(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$3 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$2[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$2(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$3 = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$3,
  enforce: enforce,
  getterFor: getterFor
};

var global$2 = global$d;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var has$2 = has$6;
var setGlobal$1 = setGlobal$3;
var inspectSource = inspectSource$2;
var InternalStateModule = internalState;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(redefine$1.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has$2(value, 'name')) {
      createNonEnumerableProperty$1(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global$2) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$1(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});

var objectGetOwnPropertyNames = {};

var toInteger = toInteger$2;

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var toIndexedObject$1 = toIndexedObject$3;
var toLength = toLength$2;
var toAbsoluteIndex = toAbsoluteIndex$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var has$1 = has$6;
var toIndexedObject = toIndexedObject$3;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$1 = hiddenKeys$3;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$1(hiddenKeys$1, key) && has$1(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$1(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$2 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$2;

var hiddenKeys = enumBugKeys$1.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn = getBuiltIn$2;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var anObject = anObject$2;

// all object keys, includes non-enumerable and symbols
var ownKeys$2 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var has = has$6;
var ownKeys$1 = ownKeys$2;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys$1(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$1 = fails$7;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails$1(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$1 = global$d;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty = createNonEnumerableProperty$5;
var redefine = redefine$1.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$1;
  } else if (STATIC) {
    target = global$1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$2;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

var $ = _export;
var toObject = toObject$3;
var nativeKeys = objectKeys;
var fails = fails$7;

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});

var selectStyles$1 = {
  control: function control(base, state) {
    return _objectSpread2(_objectSpread2({}, base), {}, {
      height: '38px',
      minHeight: '38px',
      borderRadius: '3px',
      borderWidth: '1px',
      borderColor: state.isFocused ? COLORS$1.blue3 : COLORS$1.gray5,
      boxShadow: state.isFocused ? '0 2px 6px rgba(78, 175, 233, 0.3)' : 'none'
    });
  },
  menu: function menu(base) {
    return _objectSpread2(_objectSpread2({}, base), {}, {
      borderRadius: '3px',
      zIndex: '10'
    });
  },
  option: function option(base, state) {
    return _objectSpread2(_objectSpread2({}, base), {}, {
      padding: '8px 6px',
      width: 'auto',
      margin: '0 4px',
      borderRadius: '3px',
      color: state.isDisabled ? COLORS$1.gray14 : COLORS$1.gray0,
      background: state.isFocused && !state.isDisabled ? COLORS$1.gray7 : 'none',
      cursor: state.isDisabled ? 'not-allowed' : 'default',
      '&:active': {
        background: COLORS$1.gray6
      },
      '&::before': state.isSelected ? {
        fontFamily: 'MMS Icons',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '21px',
        lineHeight: '18px',
        zoom: '1',
        content: "'\\E213'",
        color: COLORS$1.green2,
        position: 'relative',
        left: '-2px'
      } : {}
    });
  },
  multiValueLabel: function multiValueLabel(base) {
    return _objectSpread2(_objectSpread2({}, base), {}, {
      background: COLORS$1.gray9,
      borderBottomRightRadius: '0',
      borderTopRightRadius: '0',
      paddingRight: '8px'
    });
  },
  multiValueRemove: function multiValueRemove(base) {
    return _objectSpread2(_objectSpread2({}, base), {}, {
      background: COLORS$1.gray9,
      color: COLORS$1.gray4,
      borderLeft: "1px solid ".concat(COLORS$1.gray10),
      borderBottomLeftRadius: '0',
      borderTopLeftRadius: '0',
      '&:hover': {
        color: COLORS$1.gray1,
        background: COLORS$1.gray10
      }
    });
  }
};
var mergeSelectStyles = function mergeSelectStyles(customStyles) {
  var styles = _objectSpread2({}, selectStyles$1);

  Object.keys(customStyles).forEach(function (key) {
    if (selectStyles$1[key]) {
      styles[key] = function (base, state) {
        return customStyles[key](selectStyles$1[key](base, state), state);
      };
    } else {
      styles[key] = customStyles[key];
    }
  });
  return styles;
};

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    COLORS: COLORS$1,
    mergeSelectStyles: mergeSelectStyles,
    selectStyles: selectStyles$1
});

var css_248z$s = ".tb-add-dependency-modal-banner {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n.tb-add-dependency-modal-inputs-container {\n  margin-top: 10px;\n}\n";
styleInject(css_248z$s);

/* eslint-disable react/require-default-props */
var Variant;
(function (Variant) {
    Variant[Variant["Default"] = 0] = "Default";
    Variant[Variant["Brand"] = 1] = "Brand";
})(Variant || (Variant = {}));
var IndexSvg = function (_a) {
    var index = _a.index, size = _a.size, variant = _a.variant, className = _a.className;
    return (React.createElement("svg", { height: size, width: size, viewBox: "0 0 24 24", className: className },
        variant === Variant.Default && (React.createElement(React.Fragment, null,
            React.createElement("circle", { cx: "12", cy: "12", r: "11", fill: palette.gray.dark2, stroke: palette.gray.dark2 }),
            React.createElement("text", { x: "50%", y: "50%", textAnchor: "middle", fill: "white", dy: ".3em", fontSize: "smaller", fontWeight: "bold" }, index))),
        variant === Variant.Brand && (React.createElement(React.Fragment, null,
            React.createElement("circle", { cx: "12", cy: "12", r: "11", fill: "#4F4FBF", stroke: "#4F4FBF" }),
            React.createElement("text", { x: "50%", y: "50%", textAnchor: "middle", fill: palette.white, dy: ".3em", fontSize: "smaller", fontWeight: "bold" }, index)))));
};
var DisabledIndexSvg = function (_a) {
    var index = _a.index, size = _a.size, className = _a.className;
    return (React.createElement("svg", { height: size, width: size, viewBox: "0 0 24 24", className: className },
        React.createElement("circle", { cx: "12", cy: "12", r: "11", fill: "white", stroke: palette.gray.base }),
        React.createElement("text", { x: "50%", y: "50%", textAnchor: "middle", fill: palette.gray.base, dy: ".3em", fontSize: "smaller", fontWeight: "bold" }, index)));
};
var IndexIcon = function (_a) {
    var _b;
    var index = _a.index, _c = _a.size, size = _c === void 0 ? 24 : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.variant, variant = _e === void 0 ? Variant.Default : _e, className = _a.className;
    var Icon = createIconComponent((_b = {},
        _b["" + index] = function () {
            return disabled ? (React.createElement(DisabledIndexSvg, { index: index, size: size, className: className })) : (React.createElement(IndexSvg, { index: index, size: size, variant: variant, className: className }));
        },
        _b));
    return React.createElement(Icon, { glyph: "" + index });
};

var css_248z$r = ".index-row-container {\n  display: flex;\n  flex-direction: row;\n}\n.index-row-icon {\n  display: flex;\n  flex-direction: row;\n  margin-top: 10px;\n  margin-right: 10px;\n}\n.index-row-content {\n  margin-bottom: 10px;\n  width: 100%;\n}\n.index-row-no-title-description {\n  margin-top: 10px;\n}\n.index-row-title {\n  margin-top: 10px;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 8px;\n}\n.index-row-description {\n  font-size: 14px;\n  margin-bottom: 8px;\n}\n";
styleInject(css_248z$r);

var TestSelector$e;
(function (TestSelector) {
    TestSelector["Index"] = "index-icon";
    TestSelector["Title"] = "title";
    TestSelector["Description"] = "description";
})(TestSelector$e || (TestSelector$e = {}));
var baseClassName$4 = 'index-row';
function IndexRow(_a) {
    var index = _a.index, indexSize = _a.indexSize, title = _a.title, description = _a.description, children = _a.children;
    return (React.createElement("div", { className: baseClassName$4 + "-container" },
        React.createElement(IndexIcon, { className: baseClassName$4 + "-icon", "data-test-selector": TestSelector$e.Index, index: index, size: indexSize }),
        React.createElement("div", { className: classNames(baseClassName$4 + "-content", {
                'index-row-no-title-description': !(title && description),
            }) },
            title && (React.createElement(Subtitle, { "data-test-selector": TestSelector$e.Title, className: baseClassName$4 + "-title" }, title)),
            description && (React.createElement(Body, { "data-test-selector": TestSelector$e.Description, className: baseClassName$4 + "-description" }, description)),
            children)));
}

var CLASS_PREFIX = 'tb-add-dependency-modal';
var TestSelector$d;
(function (TestSelector) {
    TestSelector["PackageNameInput"] = "package-name-input";
    TestSelector["PackageVersionInput"] = "package-version-input";
})(TestSelector$d || (TestSelector$d = {}));
var getErrorMessage = function (e) {
    if (e === null || e === void 0 ? void 0 : e.message) {
        return e.message;
    }
    return 'an unexpected error occurred during validation';
};
var AddDependencyModal = /* #__PURE__ */ (function () {
    var Modal = function (_a) {
        var _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.version, version = _c === void 0 ? '' : _c, _d = _a.onAdd, onAdd = _d === void 0 ? function () { return Promise.resolve(); } : _d, _e = _a.onClose, onClose = _e === void 0 ? function () { } : _e, _f = _a.open, open = _f === void 0 ? false : _f, _g = _a.dependenciesListLink, dependenciesListLink = _g === void 0 ? '' : _g, _h = _a.installedViaArchive, installedViaArchive = _h === void 0 ? false : _h;
        var isUpdatingPackage = !!name && !!version;
        var _j = __read$1(React.useState(name), 2), packageName = _j[0], setPackageName = _j[1];
        var _k = __read$1(React.useState(version), 2), packageVersion = _k[0], setPackageVersion = _k[1];
        var _l = __read$1(React.useState(), 2), packageNameError = _l[0], setPackageNameError = _l[1];
        var _m = __read$1(React.useState(), 2), packageVersionError = _m[0], setPackageVersionError = _m[1];
        var _o = __read$1(React.useState(false), 2), submitDisabled = _o[0], setSubmitDisabled = _o[1];
        React.useEffect(function () {
            setPackageName(name);
            setPackageVersion(version);
        }, [name, version]);
        var clearErrors = function () {
            setPackageNameError('');
            setPackageVersionError('');
        };
        var closeAndClearForm = function () {
            onClose();
            clearErrors();
            setPackageName('');
            setPackageVersion('');
        };
        var handleAddDependency = function () { return __awaiter$1(void 0, void 0, void 0, function () {
            var e_1;
            var _a, _b;
            return __generator$1(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        clearErrors();
                        if (!packageName) {
                            setPackageNameError('Please enter a package name');
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        setSubmitDisabled(true);
                        return [4 /*yield*/, onAdd(packageName, packageVersion)];
                    case 2:
                        _c.sent();
                        closeAndClearForm();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _c.sent();
                        if (((_b = (_a = e_1 === null || e_1 === void 0 ? void 0 : e_1.json) === null || _a === void 0 ? void 0 : _a.errorDetails) === null || _b === void 0 ? void 0 : _b.field) === 'version') {
                            setPackageVersionError(getErrorMessage(e_1));
                        }
                        else {
                            setPackageNameError(getErrorMessage(e_1));
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setSubmitDisabled(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var handleOnKeyDown = function (e) {
            if (e.key === 'Enter') {
                handleAddDependency();
            }
        };
        return (React.createElement(ConfirmationModal, { open: open, onConfirm: handleAddDependency, onCancel: closeAndClearForm, title: isUpdatingPackage ? 'Update Dependency' : 'Add Dependency', buttonText: isUpdatingPackage ? 'Update' : 'Add', className: "tb-confirm", submitDisabled: submitDisabled },
            installedViaArchive && (React.createElement("div", { className: CLASS_PREFIX + "-banner" },
                React.createElement(Banner, { variant: Variant$1.Warning }, "Existing dependencies uploaded to your app will be overridden by the dependencies in this file."))),
            React.createElement("div", null,
                React.createElement("a", { href: dependenciesListLink }, "Visit Dependencies"),
                " to view and manage your existing dependencies."),
            React.createElement("div", { className: CLASS_PREFIX + "-inputs-container" },
                React.createElement(IndexRow, { index: 1 },
                    React.createElement(TextInput, { label: "Define a Package Name", description: "Enter in a package name from npm containing the desired dependencies.", placeholder: 'Enter a package name (e.g. "lodash")', value: packageName, onChange: function (e) { return setPackageName(e.target.value); }, onKeyDown: function (e) { return handleOnKeyDown(e); }, state: packageNameError ? 'error' : 'none', errorMessage: packageNameError, "data-test-id": TestSelector$d.PackageNameInput, disabled: isUpdatingPackage, autoFocus: true })),
                React.createElement(IndexRow, { index: 2 },
                    React.createElement(TextInput, { label: "Package Version", description: "Enter in the specific version of the dependency you would like to use. By default, we will use the latest version available.", placeholder: "Enter a version (e.g. 2.6.17)", value: packageVersion, onChange: function (e) { return setPackageVersion(e.target.value); }, onKeyDown: function (e) { return handleOnKeyDown(e); }, state: packageVersionError ? 'error' : 'none', errorMessage: packageVersionError, optional: true, "data-test-id": TestSelector$d.PackageVersionInput })))));
    };
    return Modal;
})();
var AddDependencyDialog = /* #__PURE__ */ (function () {
    return AddDependencyModal;
})();

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var COMMON_MIME_TYPES = new Map([
    ['avi', 'video/avi'],
    ['gif', 'image/gif'],
    ['ico', 'image/x-icon'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['mp4', 'video/mp4'],
    ['pdf', 'application/pdf'],
    ['png', 'image/png'],
    ['zip', 'application/zip'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, isDragEvt(evt) && evt.dataTransfer
                    ? getDataTransferFiles(evt.dataTransfer, evt.type)
                    : getInputFiles(evt)];
        });
    });
}
function isDragEvt(value) {
    return !!value.dataTransfer;
}
function getInputFiles(evt) {
    var files = isInput(evt.target)
        ? evt.target.files
            ? fromList(evt.target.files)
            : []
        : [];
    return files.map(function (file) { return toFileWithPath(file); });
}
function isInput(value) {
    return value !== null;
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spread(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var _default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

var FILE_INVALID_TYPE = 'file-invalid-type';
var FILE_TOO_LARGE = 'file-too-large';
var FILE_TOO_SMALL = 'file-too-small';
var TOO_MANY_FILES = 'too-many-files';

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: 'Too many files'
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === 'application/x-moz-file' || _default(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    return accepted && sizeMatch;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}

var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React.createElement(Fragment, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone'; // Add default props for react-docgen

var defaultProps$9 = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null
};
Dropzone.defaultProps = defaultProps$9;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,

  /**
   * Custom validation function
   * @param {File} file
   * @returns {FileError|FileError[]}
   */
  validator: PropTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$options = _objectSpread(_objectSpread({}, defaultProps$9), options),
      accept = _defaultProps$options.accept,
      disabled = _defaultProps$options.disabled,
      getFilesFromEvent = _defaultProps$options.getFilesFromEvent,
      maxSize = _defaultProps$options.maxSize,
      minSize = _defaultProps$options.minSize,
      multiple = _defaultProps$options.multiple,
      maxFiles = _defaultProps$options.maxFiles,
      onDragEnter = _defaultProps$options.onDragEnter,
      onDragLeave = _defaultProps$options.onDragLeave,
      onDragOver = _defaultProps$options.onDragOver,
      onDrop = _defaultProps$options.onDrop,
      onDropAccepted = _defaultProps$options.onDropAccepted,
      onDropRejected = _defaultProps$options.onDropRejected,
      onFileDialogCancel = _defaultProps$options.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$options.onFileDialogOpen,
      preventDropOnDocument = _defaultProps$options.preventDropOnDocument,
      noClick = _defaultProps$options.noClick,
      noKeyboard = _defaultProps$options.noKeyboard,
      noDrag = _defaultProps$options.noDrag,
      noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling,
      validator = _defaultProps$options.validator;

  var rootRef = useRef(null);
  var inputRef = useRef(null);

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically

  var openFileDialog = useCallback(function () {
    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });

      if (typeof onFileDialogOpen === 'function') {
        onFileDialogOpen();
      }

      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpen]); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });

            if (typeof onFileDialogCancel === 'function') {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };

  useEffect(function () {
    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = useCallback(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick, openFileDialog]);
  var dragTargetsRef = useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function (file) {
          var _fileAccepted = fileAccepted(file, accept),
              _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
              accepted = _fileAccepted2[0],
              acceptError = _fileAccepted2[1];

          var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
              _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
              sizeMatch = _fileMatchSize2[0],
              sizeError = _fileMatchSize2[1];

          var customErrors = validator ? validator(file) : null;

          if (accepted && sizeMatch && !customErrors) {
            acceptedFiles.push(file);
          } else {
            var errors = [acceptError, sizeError];

            if (customErrors) {
              errors = errors.concat(customErrors);
            }

            fileRejections.push({
              file: file,
              errors: errors.filter(function (e) {
                return e;
              })
            });
          }
        });

        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
          // Reject everything and empty accepted files
          acceptedFiles.forEach(function (file) {
            fileRejections.push({
              file: file,
              errors: [TOO_MANY_FILES_REJECTION]
            });
          });
          acceptedFiles.splice(0);
        }

        dispatch({
          acceptedFiles: acceptedFiles,
          fileRejections: fileRejections,
          type: 'setFiles'
        });

        if (onDrop) {
          onDrop(acceptedFiles, fileRejections, event);
        }

        if (fileRejections.length > 0 && onDropRejected) {
          onDropRejected(fileRejections, event);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }

    dispatch({
      type: 'reset'
    });
  }, [multiple, accept, minSize, maxSize, maxFiles, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling, validator]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = _defineProperty({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple,
    maxFiles: maxFiles
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread(_objectSpread({}, state), {}, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread(_objectSpread({}, state), {}, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case 'reset':
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

var css_248z$q = ".tb-archive-upload-modal {\n  z-index: 9999;\n}\n.tb-archive-upload-modal-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 105px;\n  border: 2px dashed #0498EC;\n  color: #083C90;\n  font-size: 14px;\n}\n.tb-archive-upload-modal-dropzone-active {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-width: 1px;\n  background: #b8e6cb;\n  font-size: 10px;\n  height: 105px;\n  color: #00A35C;\n}\n.tb-archive-upload-modal-file {\n  margin-top: 10px;\n  width: 100%;\n  display: flex;\n  height: 30px;\n}\n.tb-archive-upload-modal-file-info {\n  color: #001E2B;\n  font-size: 16px;\n}\n.tb-archive-upload-modal-file-size {\n  color: #889397;\n  margin-left: 10px;\n}\n.tb-archive-upload-modal-file-delete {\n  margin-left: auto;\n}\n.tb-archive-upload-modal-error {\n  color: #DB3030;\n  margin-top: 12px;\n  margin-bottom: -20px;\n  font-size: 14px;\n  white-space: pre-line;\n}\n.tb-archive-upload-modal-upload {\n  margin-top: 5px;\n}\n.tb-archive-upload-modal-upload svg {\n  color: #3D4F58;\n}\n";
styleInject(css_248z$q);

var classPrefix = 'tb-archive-upload-modal';
var inputID = classPrefix + "-file-input";
var uploadLimit = 10 * 1024 * 1024;
var TestSelector$c;
(function (TestSelector) {
    TestSelector["ArchiveUploadInput"] = "archive-upload-input";
    TestSelector["ArchiveFileInfo"] = "archive-file-info";
    TestSelector["ArchiveFileSize"] = "archive-file-size";
    TestSelector["ArchiveDeleteButton"] = "archive-delete-button";
    TestSelector["ArchiveUploadError"] = "archive-upload-error";
    TestSelector["ArchiveDocLink"] = "archive-doc-link";
})(TestSelector$c || (TestSelector$c = {}));
var formatBytes = function (bytes) {
    if (bytes === 0)
        return '0 B';
    var k = 1024;
    var sizes = ['B', 'KB', 'MB', 'GB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.floor(bytes / Math.pow(k, i)) + " " + sizes[i];
};
var ArchiveUploadModal = /* #__PURE__ */ (function () {
    var Dialog = function (_a) {
        var _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b, _c = _a.open, open = _c === void 0 ? false : _c, hasDependencies = _a.hasDependencies, _d = _a.onUpload, onUpload = _d === void 0 ? function () { return Promise.resolve(); } : _d, uploadDepsDocLink = _a.uploadDepsDocLink;
        var _e = __read$1(React.useState(), 2), uploadedFile = _e[0], setUploadedFile = _e[1];
        var _f = __read$1(React.useState(), 2), uploadError = _f[0], setUploadError = _f[1];
        var _g = __read$1(React.useState(false), 2), submitEnabled = _g[0], setSubmitEnabled = _g[1];
        var DocLink = function (_a) {
            var children = _a.children, href = _a.href;
            return React.createElement("a", { href: href }, children);
        };
        var onDrop = useCallback(function (files) {
            setUploadError('');
            var file = files[0];
            if (file.size > uploadLimit) {
                setUploadError("Failed to upload '" + file.name + "': File size is too large.\nFiles must be a maximum of 10MB.");
                return;
            }
            setUploadedFile(file);
            setSubmitEnabled(true);
        }, []);
        var _h = useDropzone({ onDrop: onDrop }), getRootProps = _h.getRootProps, getInputProps = _h.getInputProps, isDragActive = _h.isDragActive;
        var rootProps = getRootProps();
        delete rootProps.onClick;
        var inputProps = getInputProps();
        delete inputProps.onClick;
        var clearUploadedFile = function () {
            setUploadedFile(undefined);
            setSubmitEnabled(false);
        };
        var closeAndClearForm = function () {
            onClose();
            setUploadError('');
            setUploadedFile(undefined);
        };
        var uploadDependencies = function (event) {
            if (!event.target.files) {
                return;
            }
            var files = Array.from(event.target.files);
            if (files.length === 0) {
                setUploadError("Please choose a file to upload.");
                return;
            }
            setUploadError('');
            var file = files[0];
            if (file.size > uploadLimit) {
                setUploadError("Failed to upload '" + file.name + "': File size is too large.\nFiles must be a maximum of 10MB.");
                return;
            }
            setUploadedFile(file);
            setSubmitEnabled(true);
        };
        var handleAddDependencies = function () { return __awaiter$1(void 0, void 0, void 0, function () {
            var e_1;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setUploadError('');
                        if (!uploadedFile) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, onUpload(uploadedFile)];
                    case 2:
                        _a.sent();
                        closeAndClearForm();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        setUploadError(e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setSubmitEnabled(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var codeSnippet = "{\n  \"dependencies\": {\n    \"lodash\": \"4.17.15\"\n  }\n}";
        var tarExample = "tar -czf node_modules.tar.gz node_modules/";
        return (React.createElement(ConfirmationModal, { open: open, onConfirm: handleAddDependencies, onCancel: closeAndClearForm, title: "Upload node_modules Folder", buttonText: "Add", submitDisabled: !submitEnabled, className: "" + classPrefix },
            hasDependencies && (React.createElement("div", { className: classPrefix + "-banner" },
                React.createElement(Banner, { variant: Variant$1.Warning }, "Existing dependencies uploaded to your app will be overridden by the dependencies in this file."))),
            React.createElement("div", { className: classPrefix + "-instructions" },
                React.createElement(IndexRow, { index: 1 },
                    React.createElement(DocLink, { "data-test-selector": TestSelector$c.ArchiveDocLink, href: uploadDepsDocLink }, "Create a package.json file"),
                    "\u00A0to define the dependencies you would like to use. Then, from the command line, run npm install. This will create a node_modules folder containing your dependencies.",
                    React.createElement(Code, { language: "json", onCopy: function () { return navigator.clipboard.writeText(codeSnippet); } }, codeSnippet)),
                React.createElement(IndexRow, { index: 2 },
                    "From the command line, run the code below to create a compressed archive of your node_modules folder. The folder must be a ",
                    React.createElement("b", null, "max size of 10MB."),
                    React.createElement(Code, { language: "bash", onCopy: function () { return navigator.clipboard.writeText(tarExample); } }, tarExample)),
                React.createElement(IndexRow, { index: 3 },
                    "Upload your newly created node_modules folder archive (.tar, .tar.gz, or .zip) here",
                    !uploadedFile && (React.createElement("div", __assign({}, rootProps),
                        React.createElement("input", __assign({}, inputProps)),
                        isDragActive ? (React.createElement("div", { className: classPrefix + "-dropzone-active" },
                            React.createElement("h1", null, "Drop your .tar, .tar.gz or .zip file here to upload"))) : (React.createElement("div", { className: classNames(classPrefix + "-empty-state", "" + classPrefix) },
                            React.createElement("span", null, "Drag your folder here, or click \"Upload Folder\" to upload"),
                            React.createElement("input", { type: "file", id: inputID, style: { display: 'none' }, multiple: false, onChange: uploadDependencies, "data-test-selector": TestSelector$c.ArchiveUploadInput, "aria-label": "Upload Folder" }),
                            React.createElement(Button, { className: classPrefix + "-upload", variant: "default", leftGlyph: React.createElement(Icon, { glyph: "Upload", fill: palette.gray.dark2 }), onClick: function (e) {
                                    e.preventDefault();
                                    var fileInput = document.getElementById(inputID);
                                    fileInput.value = '';
                                    return fileInput.click();
                                } }, "Upload Folder"))))),
                    uploadedFile && (React.createElement("div", { className: classPrefix + "-file" },
                        React.createElement("div", { className: classPrefix + "-file-info", "data-test-selector": TestSelector$c.ArchiveFileInfo },
                            uploadedFile.name,
                            React.createElement("span", { className: classPrefix + "-file-size", "data-test-selector": TestSelector$c.ArchiveFileSize },
                                "(",
                                formatBytes(uploadedFile.size),
                                ")")),
                        React.createElement(IconButton, { "data-test-selector": TestSelector$c.ArchiveDeleteButton, onClick: clearUploadedFile, className: classPrefix + "-file-delete", "aria-label": "Delete Uploaded Archive" },
                            React.createElement(XIcon, { fill: palette.gray.light1 })))),
                    uploadError && (React.createElement("div", { className: classPrefix + "-error", "data-test-selector": TestSelector$c.ArchiveUploadError }, uploadError))))));
    };
    return Dialog;
})();
var ArchiveUploadModal$1 = /* #__PURE__ */ (function () {
    return ArchiveUploadModal;
})();

var css_248z$p = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-display-list-item-is-modal {\n  max-height: 400px;\n  overflow-y: scroll;\n}\n.tb-display-list-item-row {\n  display: flex;\n}\n.tb-display-list-item-row-header.tb-display-list-item-is-table {\n  margin-left: 5px;\n  margin-right: 5px;\n  padding: 5px;\n  border-bottom: 1px solid #dee0e3;\n}\n.tb-display-list-item-row.tb-display-list-item-is-table {\n  margin-left: 5px;\n  margin-right: 5px;\n  padding: 5px;\n  padding-left: 20px;\n  padding-right: 20px;\n  align-items: center;\n  border-bottom: 1px solid #dee0e3;\n}\n.tb-display-list-item-row-header {\n  font-size: 14px;\n  font-weight: bold;\n  font-style: normal;\n  margin-left: 5px;\n  margin-right: 5px;\n  padding: 5px;\n  align-items: center;\n  border-bottom: 1px solid #dee0e3;\n}\n.tb-display-list-item-row-header.tb-display-list-item-row-header {\n  font-size: 14px;\n  font-weight: bold;\n  font-style: normal;\n}\n.tb-display-list-item-row-is-selectable {\n  cursor: pointer;\n}\n.tb-display-list-item-row-is-selected {\n  background: #eff5ec;\n}\n.tb-display-list-item-row-column {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  align-items: center;\n}\n.tb-display-list-item-row-column.tb-display-list-item-is-table {\n  padding: 5px;\n  overflow-x: hidden;\n  font-size: 14px;\n  margin-left: 4px;\n  margin-right: 4px;\n  min-width: 50px;\n}\n.tb-display-list-item-row-column-is-sortable {\n  cursor: pointer;\n}\n.tb-display-list-item-row-caret {\n  align-items: center;\n  display: flex;\n  justify-content: space-around;\n  font-size: 14px;\n  margin-left: -10px;\n  min-width: 10px;\n}\n.tb-display-list-item-row-child {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.tb-display-list-item-row-child-indent {\n  margin-left: 14px;\n}\n.tb-display-list-is-empty {\n  padding: 5px;\n  font-style: italic;\n  text-align: center;\n}\n.tb-display-list-item-row-header > .tb-display-list-item-row-column {\n  border-right: 1px solid #dee0e3;\n}\n.tb-display-list-item-row-header > .tb-display-list-item-row-column:last-child {\n  border-right: none;\n}\n";
styleInject(css_248z$p);

var DisplayItemColumn = /* #__PURE__ */ (function () {
    var DisplayItemColumn = function (props) {
        var className = props.className, table = props.table;
        var outProps = __assign(__assign({}, props), { className: classNames('tb-display-list-item-row-column', { 'tb-display-list-item-is-table': table }, className) });
        delete outProps.table;
        return React.createElement("div", __assign({}, outProps));
    };
    DisplayItemColumn.propTypes = {
        className: PropTypes.string,
        table: PropTypes.bool,
    };
    DisplayItemColumn.defaultProps = {
        className: '',
        table: true,
    };
    return DisplayItemColumn;
})();

var TestSelector$b;
(function (TestSelector) {
    TestSelector["Container"] = "container";
})(TestSelector$b || (TestSelector$b = {}));
var DisplayItemRow = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(DisplayItemRow, _super);
            function DisplayItemRow() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.state = {
                    open: _this.props.open,
                };
                _this.handleOnClick = function () {
                    _this.props.onClick();
                    if (_this.props.expandable) {
                        if (!_this.state.open) {
                            _this.props.onExpand();
                        }
                        _this.setState(function (prevState) { return ({ open: !prevState.open }); });
                    }
                };
                return _this;
            }
            DisplayItemRow.prototype.render = function () {
                var _a = this.props, className = _a.className, columns = _a.columns, expandable = _a.expandable, selectable = _a.selectable, selected = _a.selected, header = _a.header, indentChildren = _a.indentChildren, table = _a.table, children = _a.children, rest = __rest(_a, ["className", "columns", "expandable", "selectable", "selected", "header", "indentChildren", "table", "children"]);
                var rowClassName = classNames('tb-display-list-item-row', {
                    'tb-display-list-item-is-table': table,
                    'tb-display-list-item-row-header': header,
                    'tb-display-list-item-row-is-selectable': selectable || expandable,
                    'tb-display-list-item-row-is-selected': selected,
                }, className);
                var showChildren = expandable && this.state.open;
                var caret = showChildren ? React.createElement(FontAwesome, { name: "caret-down" }) : React.createElement(FontAwesome, { name: "caret-right" });
                var childrenClassname = classNames('tb-display-list-item-row-child', {
                    'tb-display-list-item-row-child-indent': indentChildren,
                });
                return (React.createElement("div", __assign({}, passThroughProps(rest)),
                    React.createElement("div", { className: rowClassName, onClick: this.handleOnClick, "data-test-selector": TestSelector$b.Container },
                        expandable && React.createElement("div", { className: "tb-display-list-item-row-caret" }, caret),
                        columns),
                    showChildren ? React.createElement("div", { className: childrenClassname }, children) : null));
            };
            return DisplayItemRow;
        }(React.Component)),
        _a.propTypes = {
            children: PropTypes.node,
            className: PropTypes.string,
            columns: PropTypes.arrayOf(PropTypes.shape({
                className: PropTypes.string,
                table: PropTypes.bool,
            })),
            expandable: PropTypes.bool,
            header: PropTypes.bool,
            indentChildren: PropTypes.bool,
            onClick: PropTypes.func,
            onExpand: PropTypes.func,
            open: PropTypes.bool,
            selectable: PropTypes.bool,
            selected: PropTypes.bool,
            table: PropTypes.bool,
        },
        _a.defaultProps = {
            children: null,
            className: '',
            columns: [],
            expandable: false,
            header: false,
            indentChildren: false,
            onClick: function () { },
            onExpand: function () { },
            open: false,
            selectable: false,
            selected: false,
            table: true,
        },
        _a;
})();

var CLUSTERTYPE_SERVERLESS = 'serverless';
var DataSourceServiceType;
(function (DataSourceServiceType) {
    DataSourceServiceType["SVCTYPE_MONGODB"] = "mongodb";
    DataSourceServiceType["SVCTYPE_MONGODB_ATLAS"] = "mongodb-atlas";
    DataSourceServiceType["SVCTYPE_DATALAKE"] = "datalake";
})(DataSourceServiceType || (DataSourceServiceType = {}));
var MongoServiceStatus;
(function (MongoServiceStatus) {
    MongoServiceStatus["Unlinked"] = "UNLINKED";
    MongoServiceStatus["Linking"] = "LINKING";
    MongoServiceStatus["Linked"] = "LINKED";
    MongoServiceStatus["Error"] = "ERROR";
})(MongoServiceStatus || (MongoServiceStatus = {}));
var isCluster = function (cfg) {
    return (cfg === null || cfg === void 0 ? void 0 : cfg.serviceType) === DataSourceServiceType.SVCTYPE_MONGODB_ATLAS;
};
var isDataLake = function (cfg) {
    return (cfg === null || cfg === void 0 ? void 0 : cfg.serviceType) === DataSourceServiceType.SVCTYPE_DATALAKE;
};
var isSelfHostedMongoService = function (cfg) {
    return (cfg === null || cfg === void 0 ? void 0 : cfg.serviceType) === DataSourceServiceType.SVCTYPE_MONGODB;
};

var isArray = function (o) { return typeof o === 'object' && typeof o.length === 'number'; };
/*
isClean returns a boolean determining if two values are equal or not.

As of now, this only handles values and arrays, but not objects.
*/
var isClean = function (newValue, cleanValue) {
    if (isArray(newValue) && isArray(cleanValue)) {
        if (newValue.length !== cleanValue.length) {
            return false;
        }
        for (var i = newValue.length - 1; i >= 0; i -= 1) {
            if (newValue[i] !== cleanValue[i]) {
                return false;
            }
        }
        return true;
    }
    return newValue === cleanValue;
};
/*
areFormsEqualChecker returns a function which can determine if two objects are equal or not.

As of now, this only handles values and arrays, but not objects.
*/
var areFormsEqual = function (current, previous) {
    var currentEntries = Object.entries(current);
    if (currentEntries.length !== Object.keys(previous).length) {
        return false;
    }
    return currentEntries.every(function (_a) {
        var _b = __read$1(_a, 2), key = _b[0], currentValue = _b[1];
        return isClean(currentValue, previous[key]);
    });
};
var getDataSourceDisplay = function (svc) {
    var name;
    if (isCluster(svc.config)) {
        name = svc.config.clusterName;
    }
    else if (isDataLake(svc.config)) {
        name = svc.config.dataLakeName;
    }
    else {
        name = svc.name;
    }
    return name;
};

var css_248z$o = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-creatable-select-text-input {\n  margin-bottom: 6px;\n  margin-top: 16px;\n}\n.tb-creatable-select-button-container {\n  width: inherit;\n  display: flex;\n  justify-content: flex-end;\n}\n.tb-creatable-select-create-button {\n  margin-left: 8px;\n}\n.tb-creatable-select-create-option {\n  font-weight: 700;\n}\n.tb-creatable-select-plus-icon {\n  color: black;\n}\n";
styleInject(css_248z$o);

var TestSelector$a;
(function (TestSelector) {
    TestSelector["Container"] = "container";
    TestSelector["CreatableSelect"] = "creatable-select";
    TestSelector["NewOption"] = "new-option";
    TestSelector["NewOptionInput"] = "new-option-input";
    TestSelector["CreateButton"] = "create-button";
    TestSelector["CancelButton"] = "cancel-button";
})(TestSelector$a || (TestSelector$a = {}));
var baseClassName$3 = 'tb-creatable-select';
var NEW_VALUE = "NEW_VALUE_FOR_THE_CREATABLE_SELECT_" + Math.random();
var CreatableSelect = function (_a) {
    var _b = _a.createNewOptionText, createNewOptionText = _b === void 0 ? 'Create New Option' : _b, children = _a.children, value = _a.value, _c = _a.createTextInputPlaceholder, createTextInputPlaceholder = _c === void 0 ? 'Enter your new option here' : _c, _d = _a.createTextInputErrorMessage, createTextInputErrorMessage = _d === void 0 ? 'This is not a valid option.' : _d, className = _a.className, innerSelectClassName = _a.innerSelectClassName, _e = _a.onChange, onChange = _e === void 0 ? function () { } : _e, _f = _a.onCreateNewValue, onCreateNewValue = _f === void 0 ? function () { } : _f, _g = _a.isValidNewValue, isValidNewValue = _g === void 0 ? function () { return true; } : _g, selectProps = __rest(_a, ["createNewOptionText", "children", "value", "createTextInputPlaceholder", "createTextInputErrorMessage", "className", "innerSelectClassName", "onChange", "onCreateNewValue", "isValidNewValue"]);
    var _h = __read$1(useState(false), 2), showCreateInput = _h[0], setShowTextInput = _h[1];
    var _j = __read$1(useState(''), 2), customOptionValue = _j[0], setCustomOptionValue = _j[1];
    var _k = __read$1(useState(State.None), 2), textInputState = _k[0], setTextInputState = _k[1];
    var creatableSelectLabelProps;
    /*
      The following logic is required for the below Select component to work correctly. Regardless of the
      prop values passed into the CreatableSelect, the Select requires that either label or aria-labelledby
      be provided to it, and their types cannot be string | undefined. Only string. Or undefined.
      Therefore the logic is as follows: by default set label to undefined and aria-labelledby to a
      default string or the passed value. Then reset the values as necessary based on the parent's passed
      props, and apply to the Select.
    */
    var noLabelNoAriaProps = {
        label: undefined,
        'aria-labelledby': selectProps['aria-labelledby'] || 'creatable-select',
    };
    var hasLabelnoAria = {
        label: selectProps.label,
        'aria-labelledby': undefined,
    };
    if (selectProps.label) {
        creatableSelectLabelProps = hasLabelnoAria;
    }
    else {
        creatableSelectLabelProps = noLabelNoAriaProps;
    }
    return (React.createElement("div", { className: className, "data-test-selector": TestSelector$a.Container },
        React.createElement(Select, __assign({ "data-test-selector": TestSelector$a.CreatableSelect, className: classNames(baseClassName$3, innerSelectClassName), allowDeselect: false, value: value }, selectProps, { onChange: function (optionValue, changeEvent) {
                if (optionValue === NEW_VALUE) {
                    setShowTextInput(true);
                }
                else {
                    setShowTextInput(false);
                    onChange(optionValue, changeEvent);
                }
            } }, creatableSelectLabelProps),
            React.createElement(OptionGroup, { label: "" },
                React.createElement(Option, { "data-test-selector": TestSelector$a.NewOption, className: baseClassName$3 + "-create-option", glyph: React.createElement(PlusIcon, { className: baseClassName$3 + "-plus-icon" }), value: NEW_VALUE }, createNewOptionText)),
            children),
        showCreateInput && (React.createElement(React.Fragment, null,
            React.createElement(TextInput, { "aria-labelledby": "create-option-input", "data-test-selector": TestSelector$a.NewOptionInput, className: baseClassName$3 + "-text-input", id: 'SelectCreateInput', label: "", value: customOptionValue, placeholder: createTextInputPlaceholder, onChange: function (e) { return setCustomOptionValue(e.target.value); }, state: textInputState, errorMessage: createTextInputErrorMessage }),
            React.createElement("div", { className: baseClassName$3 + "-button-container" },
                React.createElement(Button, { "data-test-selector": TestSelector$a.CancelButton, size: Size.Small, onClick: function () {
                        setShowTextInput(false);
                        setCustomOptionValue('');
                        setTextInputState(State.None);
                    } }, "Cancel"),
                React.createElement(Button, { "data-test-selector": TestSelector$a.CreateButton, className: baseClassName$3 + "-create-button", variant: "primaryOutline", size: Size.Small, onClick: function () {
                        if (isValidNewValue(customOptionValue)) {
                            onCreateNewValue(customOptionValue);
                            setTextInputState(State.None);
                            setShowTextInput(false);
                            setCustomOptionValue('');
                        }
                        else {
                            setTextInputState(State.Error);
                        }
                    } }, "Create"))))));
};

var css_248z$n = ".tb-db-col-select-row {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n}\n.tb-db-col-select-row-item {\n  width: 50%;\n  min-width: 500px;\n  display: flex;\n  align-items: baseline;\n  padding: 10px 10px 10px 0;\n}\n.tb-db-col-select-row-label {\n  min-width: 122px;\n  font-weight: bold;\n  display: flex;\n}\n.tb-db-col-select-row-input-group {\n  padding-left: 4px;\n  padding-right: 4px;\n}\n.tb-db-col-select-new {\n  margin-left: 4px;\n}\n";
styleInject(css_248z$n);

var css_248z$m = ".ns-loading-spinner {\n  margin-right: 6px;\n}\n";
styleInject(css_248z$m);

var _a;
var defaultProps$8 = {
    collectionName: '',
    collectionNameError: undefined,
    compact: false,
    dbName: '',
    dbNameError: undefined,
    isCreatable: false,
    isDisabled: false,
    isLoading: false,
    isMultiRow: false,
    namespaces: [],
    onCollectionNameChange: function () { },
    onDbNameChange: function () { },
};
var rowStylePrefix = 'tb-db-col-select-row';
var dbNameSelectId = 'dbNameSelect';
var colNameSelectId = 'colNameSelect';
// eslint-disable-next-line
var flatMap = function (coll, fn) {
    return coll.reduce(function (acc, item) { return acc.concat(fn(item)); }, []);
};
var memo = function (fn, keyFn, defaultResult) {
    var results = {};
    var accessFn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var key = keyFn.apply(void 0, __spreadArray([], __read$1(args)));
        if (key === undefined) {
            return defaultResult;
        }
        var result = results[key];
        if (typeof result === 'undefined') {
            result = fn.apply(void 0, __spreadArray([], __read$1(args)));
            results[keyFn.apply(void 0, __spreadArray([], __read$1(args)))] = result;
        }
        return result;
    };
    var clearFn = function () {
        results = {};
    };
    return { accessFn: accessFn, clearFn: clearFn };
};
var buildOptionsFromNamespaces = (_a = memo(function (namespaces) {
    var databaseOptions = namespaces.map(function (_a) {
        var database = _a.database;
        return ({ label: database, value: database });
    });
    var collectionOptions = namespaces.map(function (_a, dbIdx) {
        var database = _a.database, collections = _a.collections;
        return ({
            label: database,
            options: collections.map(function (col) { return ({ label: col, value: col, dbIdx: dbIdx }); }),
        });
    });
    return { databaseOptions: databaseOptions, collectionOptions: collectionOptions };
}, function (namespaces, clusterId) {
    var numCollections = namespaces ? namespaces.reduce(function (total, n) { return total + n.collections.length; }, 0) : 0;
    var key;
    if (namespaces || clusterId) {
        key = clusterId + "-" + namespaces.length + "-" + numCollections;
    }
    return key;
}, { databaseOptions: [], collectionOptions: [] }), _a.accessFn), clearNamespacesCache = _a.clearFn;
var filterCollectionOptions = function (opts, dbNameLabel) {
    if (!dbNameLabel) {
        return opts;
    }
    var selected = opts.find(function (option) { return option.label === dbNameLabel; });
    if (!selected) {
        return [];
    }
    return selected.options || [];
};
var NamespaceSelectRow = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.state = {
                    customDatabaseOptions: [],
                    customCollectionOptions: [],
                };
                _this.handleDbChange = function (opt) {
                    var _a = (opt || {}).value, value = _a === void 0 ? '' : _a;
                    var _b = _this.props, onCollectionNameChange = _b.onCollectionNameChange, onDbNameChange = _b.onDbNameChange, collectionName = _b.collectionName, namespaces = _b.namespaces, clusterId = _b.clusterId;
                    var customCollectionOptions = _this.state.customCollectionOptions;
                    onDbNameChange(value, opt === null || opt === void 0 ? void 0 : opt.isNew);
                    if (value === '') {
                        onCollectionNameChange('');
                        return;
                    }
                    var collectionOptions = buildOptionsFromNamespaces(namespaces, clusterId).collectionOptions;
                    var filteredCollectionOptions = filterCollectionOptions(collectionOptions, value).concat(customCollectionOptions);
                    var collectionOption = filteredCollectionOptions.find(function (option) { return option.value === collectionName; });
                    if (collectionOption && collectionOption.isNew) {
                        return;
                    }
                    onCollectionNameChange('');
                };
                _this.handleCreateDbOption = function (newDb) {
                    var option = { label: newDb, value: newDb, isNew: true };
                    _this.setState(function (_a, _b) {
                        var customDatabaseOptions = _a.customDatabaseOptions;
                        var namespaces = _b.namespaces;
                        var databaseOptions = buildOptionsFromNamespaces(namespaces, _this.props.clusterId).databaseOptions;
                        var isDuplicate = !!databaseOptions.concat(customDatabaseOptions).find(function (opt) { return opt.label === newDb; });
                        return {
                            customDatabaseOptions: isDuplicate ? customDatabaseOptions : customDatabaseOptions.concat(option),
                        };
                    }, function () { return _this.handleDbChange(option); });
                };
                _this.handleCollectionChange = function (opt) {
                    var _a = (opt || {}).value, value = _a === void 0 ? '' : _a;
                    _this.props.onCollectionNameChange(value, opt === null || opt === void 0 ? void 0 : opt.isNew);
                };
                _this.handleCreateCollectionOption = function (newCollection) {
                    var option = { label: newCollection, value: newCollection, isNew: true };
                    _this.setState(function (_a, _b) {
                        var customCollectionOptions = _a.customCollectionOptions;
                        var namespaces = _b.namespaces;
                        var collectionOptions = buildOptionsFromNamespaces(namespaces, _this.props.clusterId).collectionOptions;
                        var isDuplicate = !!flatMap(collectionOptions, function (namespace) { return namespace.options; })
                            .concat(customCollectionOptions)
                            .find(function (opt) { return opt.label === newCollection; });
                        return {
                            customCollectionOptions: isDuplicate ? customCollectionOptions : customCollectionOptions.concat(option),
                        };
                    }, function () { return _this.handleCollectionChange(option); });
                };
                return _this;
            }
            class_1.prototype.componentWillUnmount = function () {
                clearNamespacesCache();
            };
            class_1.prototype.render = function () {
                var _this = this;
                var _a = this.props, clusterId = _a.clusterId, dbName = _a.dbName, namespaces = _a.namespaces, collectionName = _a.collectionName, dbNameError = _a.dbNameError, collectionNameError = _a.collectionNameError, isCreatable = _a.isCreatable, isDisabled = _a.isDisabled, isLoading = _a.isLoading, isMultiRow = _a.isMultiRow, compact = _a.compact, rest = __rest(_a, ["clusterId", "dbName", "namespaces", "collectionName", "dbNameError", "collectionNameError", "isCreatable", "isDisabled", "isLoading", "isMultiRow", "compact"]);
                var _b = buildOptionsFromNamespaces(namespaces, clusterId), databaseOptions = _b.databaseOptions, collectionOptions = _b.collectionOptions;
                var _c = this.state, customDatabaseOptions = _c.customDatabaseOptions, customCollectionOptions = _c.customCollectionOptions;
                var selectOrEnterPlaceholder = "Select " + (isCreatable ? 'or enter' : '');
                var allDatabaseOptions = databaseOptions.concat(customDatabaseOptions);
                var filteredCollectionOptions = filterCollectionOptions(collectionOptions, dbName).concat(customCollectionOptions);
                var dbOption = allDatabaseOptions.find(function (option) { return option.value === dbName; });
                if (dbName && !dbOption) {
                    dbOption = { label: dbName, value: dbName };
                }
                var collectionOption = filteredCollectionOptions.find(function (option) { return option.value === collectionName; });
                if (collectionName && !collectionOption) {
                    collectionOption = { label: collectionName, value: collectionName };
                }
                var dbSelect = (React.createElement(React.Fragment, null, isCreatable ? (React.createElement(React.Fragment, null,
                    React.createElement(CreatableSelect, { "aria-labelledby": "database-select", id: dbNameSelectId, name: "dbName", placeholder: selectOrEnterPlaceholder + " a database name...", disabled: isDisabled || isLoading || !clusterId, value: isLoading ? 'Loading databases...' : (!!clusterId && (dbOption === null || dbOption === void 0 ? void 0 : dbOption.value)) || '', onChange: function (selectedOption) {
                            var completeOption = allDatabaseOptions.find(function (_a) {
                                var value = _a.value;
                                return value === selectedOption;
                            });
                            _this.handleDbChange(completeOption);
                        }, isValidNewValue: function (newOpt) { return isCreatable && !!newOpt; }, onCreateNewValue: function (selectedOption) {
                            _this.handleCreateDbOption(selectedOption);
                        }, createTextInputErrorMessage: dbNameError }, allDatabaseOptions.length > 0 && (React.createElement(OptionGroup, { label: 'Existing Options:' }, allDatabaseOptions.map(function (opt) { return (React.createElement(Option, { key: opt.label, value: opt.value }, opt.label)); })))))) : (React.createElement(Select, { "aria-labelledby": "database-select", name: "dbName", id: dbNameSelectId, placeholder: selectOrEnterPlaceholder + " a database name...", disabled: isDisabled || isLoading || !clusterId, value: isLoading ? 'Loading databases...' : (!!clusterId && (dbOption === null || dbOption === void 0 ? void 0 : dbOption.value)) || '', allowDeselect: false, onChange: function (selectedOption) {
                        var completeOption = allDatabaseOptions.find(function (_a) {
                            var value = _a.value;
                            return value === selectedOption;
                        });
                        _this.handleDbChange(completeOption);
                    } }, allDatabaseOptions.map(function (opt) { return (React.createElement(Option, { key: opt.label, value: opt.value }, opt.label)); })))));
                var colSelect = (React.createElement(React.Fragment, null,
                    isCreatable ? (React.createElement(React.Fragment, null,
                        React.createElement(CreatableSelect, { "aria-labelledby": "collection-select", id: colNameSelectId, name: "collectionName", placeholder: (dbOption ? selectOrEnterPlaceholder : 'Select') + " a collection name...", disabled: isDisabled || !dbOption || !clusterId || isLoading, value: (isLoading ? 'Loading collections...' : !!clusterId && (collectionOption === null || collectionOption === void 0 ? void 0 : collectionOption.value)) || '', onChange: function (selectedOption) {
                                var completeOption = filteredCollectionOptions.find(function (_a) {
                                    var value = _a.value;
                                    return value === selectedOption;
                                });
                                _this.handleCollectionChange(completeOption);
                            }, isValidNewValue: function (newOpt) { return isCreatable && !!newOpt && !!dbOption; }, onCreateNewValue: function (selectedOption) {
                                _this.handleCreateCollectionOption(selectedOption);
                            }, createTextInputErrorMessage: collectionNameError }, filteredCollectionOptions.length > 0 && (React.createElement(OptionGroup, { label: 'Existing Options:' }, filteredCollectionOptions.map(function (opt) {
                            return opt.label ? (React.createElement(Option, { key: opt.label, value: opt.value }, opt.label)) : ({});
                        })))))) : (React.createElement(Select, { "aria-labelledby": "collection-select", id: colNameSelectId, name: "collectionName", placeholder: (dbOption ? selectOrEnterPlaceholder : 'Select') + " a collection name...", disabled: isDisabled || !dbOption || !clusterId || isLoading, value: (isLoading ? 'Loading collections...' : !!clusterId && (collectionOption === null || collectionOption === void 0 ? void 0 : collectionOption.value)) || '', allowDeselect: false, onChange: function (selectedOption) {
                            var completeOption = filteredCollectionOptions.find(function (_a) {
                                var value = _a.value;
                                return value === selectedOption;
                            });
                            _this.handleCollectionChange(completeOption);
                        } }, filteredCollectionOptions.map(function (opt) {
                        return opt.label ? (React.createElement(Option, { key: opt.label, value: opt.value }, opt.label)) : ({});
                    }))),
                    collectionNameError && (React.createElement(StateIndicator, { isMessage: true, error: !!collectionNameError }, collectionNameError))));
                return isMultiRow ? (React.createElement("div", __assign({}, passThroughProps(rest)),
                    React.createElement(FormRow, { compact: compact },
                        !compact && (React.createElement(FormRowLabelGroup, null,
                            React.createElement("label", { className: "form-row-label", htmlFor: dbNameSelectId }, "Database Name"))),
                        React.createElement(FormRowInputGroup, null,
                            compact && React.createElement("label", { htmlFor: dbNameSelectId }, "Database Name"),
                            dbSelect)),
                    React.createElement(FormRow, { compact: compact },
                        !compact && (React.createElement(FormRowLabelGroup, null,
                            React.createElement("label", { className: "form-row-label", htmlFor: colNameSelectId }, "Collection Name"))),
                        React.createElement(FormRowInputGroup, null,
                            compact && React.createElement("label", { htmlFor: colNameSelectId }, "Collection Name"),
                            colSelect)))) : (React.createElement(FormRow, __assign({ compact: compact, wide: true, last: true }, passThroughProps(rest)),
                    React.createElement("div", { className: rowStylePrefix },
                        React.createElement("div", { className: rowStylePrefix + "-item" },
                            React.createElement("label", { htmlFor: dbNameSelectId, className: rowStylePrefix + "-label" }, "Database Name"),
                            React.createElement(FormRowInputGroup, { className: rowStylePrefix + "-input-group" }, dbSelect)),
                        React.createElement("div", { className: rowStylePrefix + "-item" },
                            React.createElement("label", { htmlFor: colNameSelectId, className: rowStylePrefix + "-label" }, "Collection Name"),
                            React.createElement(FormRowInputGroup, { className: rowStylePrefix + "-input-group" }, colSelect)))));
            };
            return class_1;
        }(React.Component)),
        _a.defaultProps = defaultProps$8,
        _a;
})();

var NAMESPACES_SHAPE = PropTypes.shape({
  database: PropTypes.string,
  collections: PropTypes.arrayOf(PropTypes.string)
});

var TestSelector$9;
(function (TestSelector) {
    TestSelector["ClusterNamespaceSelect"] = "cluster-namespace-select";
    TestSelector["ClusterNameDescription"] = "cluster-name-description";
})(TestSelector$9 || (TestSelector$9 = {}));
var ClusterNamespaceSelect = /* #__PURE__ */ (function () {
    var defaultProps = __assign({ isReadOnly: false, isLoadingNamespaces: false, mongoServices: [], onClusterIdChange: function (_clusterID) { } }, defaultProps$8);
    var ClusterNamespaceSelect = function (_a) {
        var collectionName = _a.collectionName, collectionNameError = _a.collectionNameError, compact = _a.compact, clusterId = _a.clusterId, clusterNameDescription = _a.clusterNameDescription, dbName = _a.dbName, dbNameError = _a.dbNameError, isCreatable = _a.isCreatable, isDisabled = _a.isDisabled, isMultiRow = _a.isMultiRow, isReadOnly = _a.isReadOnly, isLoadingNamespaces = _a.isLoadingNamespaces, mongoServices = _a.mongoServices, namespaces = _a.namespaces, onDbNameChange = _a.onDbNameChange, onCollectionNameChange = _a.onCollectionNameChange, onClusterIdChange = _a.onClusterIdChange, rest = __rest(_a, ["collectionName", "collectionNameError", "compact", "clusterId", "clusterNameDescription", "dbName", "dbNameError", "isCreatable", "isDisabled", "isMultiRow", "isReadOnly", "isLoadingNamespaces", "mongoServices", "namespaces", "onDbNameChange", "onCollectionNameChange", "onClusterIdChange"]);
        return (React.createElement("div", __assign({}, passThroughProps(rest)),
            React.createElement(FormRow, { compact: compact, className: "form-row-is-compact-top" },
                !compact && (React.createElement(FormRowLabelGroup, null,
                    React.createElement(Label, { htmlFor: "clusterId", className: "form-row-label" }, "Cluster Name"),
                    clusterNameDescription && (React.createElement(Body, { className: "form-row-description", "data-test-selector": TestSelector$9.ClusterNameDescription }, clusterNameDescription)))),
                React.createElement(FormRowInputGroup, null,
                    compact && React.createElement(Label, { htmlFor: "clusterId" }, "Cluster Name"),
                    React.createElement(Select, { "data-test-selector": TestSelector$9.ClusterNamespaceSelect, "aria-labelledby": "clusterId-select", id: "clusterId", placeholder: "Select a cluster...", disabled: isDisabled || isReadOnly, value: clusterId, allowDeselect: false, onChange: function (selectedOption) {
                            onClusterIdChange(selectedOption);
                        } }, mongoServices.map(function (svc) {
                        var name = getDataSourceDisplay(svc);
                        return (React.createElement(Option, { key: name, value: svc._id, disabled: svc.isDisabled }, name));
                    })))),
            React.createElement(NamespaceSelectRow, { clusterId: clusterId, compact: compact, isCreatable: isCreatable, isDisabled: isDisabled || isReadOnly, isLoading: isLoadingNamespaces, isMultiRow: isMultiRow, namespaces: namespaces, dbName: dbName, dbNameError: dbNameError, collectionName: collectionName, collectionNameError: collectionNameError, onDbNameChange: onDbNameChange, onCollectionNameChange: onCollectionNameChange })));
    };
    ClusterNamespaceSelect.defaultProps = defaultProps;
    ClusterNamespaceSelect.propTypes = {
        collectionName: PropTypes.string,
        collectionNameError: PropTypes.string,
        compact: PropTypes.bool,
        dbName: PropTypes.string,
        dbNameError: PropTypes.string,
        isCreatable: PropTypes.bool,
        isDisabled: PropTypes.bool,
        isMultiRow: PropTypes.bool,
        namespaces: PropTypes.arrayOf(NAMESPACES_SHAPE),
        onCollectionNameChange: PropTypes.func,
        onDbNameChange: PropTypes.func,
    };
    return ClusterNamespaceSelect;
})();

var css_248z$l = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-collapsible {\n  border: 1px solid #bfbfbe;\n  border-radius: 3px;\n  margin-top: 30px;\n  margin-bottom: 30px;\n  transition: box-shadow 0.3s ease-in-out;\n}\n.tb-collapsible:hover {\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);\n}\n.tb-collapsible-is-open {\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);\n}\n.tb-collapsible-is-dirty {\n  border: 1px solid #fdb100;\n}\n.tb-collapsible-is-deleted {\n  border: 1px solid #ef4c4c;\n}\n.tb-collapsible-is-new {\n  border: 1px solid #23e675;\n}\n.tb-collapsible-number {\n  background-color: black;\n  color: white;\n  border-radius: 15px;\n  width: 20px;\n  height: 20px;\n  font-size: 12px;\n  margin-left: 10px;\n  margin-right: 10px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n.tb-collapsible-controls {\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n}\n.tb-collapsible-controls-left {\n  display: inline-flex;\n  margin-right: auto;\n  align-items: center;\n}\n.tb-collapsible-controls-right {\n  display: inline-flex;\n  margin-left: auto;\n  align-items: center;\n  margin-right: 10px;\n}\n.tb-collapsible-controls-title {\n  display: flex;\n  align-items: center;\n}\n.tb-collapsible-accordion {\n  box-shadow: none;\n  /* no box shadow when open */\n  border: none;\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.tb-collapsible-accordion:hover {\n  box-shadow: none;\n}\n.tb-collapsible-header {\n  align-items: center;\n  border-radius: 3px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  padding: 10px 15px;\n  transition: background-color 0.3s ease-in-out;\n}\n.tb-collapsible-header:hover {\n  background-color: #f5f5f5;\n}\n.tb-collapsible-header-is-open {\n  background-color: #f5f5f5;\n  border-bottom: 1px solid #bfbfbe;\n  border-top-left-radius: 2px;\n  border-top-right-radius: 2px;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n.tb-collapsible-header-is-dirty {\n  background-color: #fffbf5;\n}\n.tb-collapsible-header-is-dirty.tb-collapsible-header-is-open {\n  border-bottom: 1px solid #fdb100;\n}\n.tb-collapsible-header-is-dirty:hover {\n  background-color: #fffbf5;\n}\n.tb-collapsible-header-is-deleted {\n  background-color: #fff6f6;\n}\n.tb-collapsible-header-is-deleted.tb-collapsible-header-is-open {\n  border-bottom: 1px solid #ef4c4c;\n}\n.tb-collapsible-header-is-deleted:hover {\n  background-color: #fff6f6;\n}\n.tb-collapsible-header-is-new {\n  background-color: #effef6;\n}\n.tb-collapsible-header-is-new.tb-collapsible-header-is-open {\n  border-bottom: 1px solid #23e675;\n}\n.tb-collapsible-header-is-new:hover {\n  background-color: #effef6;\n}\n.tb-collapsible-header-toggle {\n  display: inline-block;\n  font-size: 28px;\n  margin-left: auto;\n  margin-right: 15px;\n  transition: transform 0.3s ease-in-out;\n  transform: rotate(0deg);\n}\n.tb-collapsible-header-toggle-open {\n  transition: transform 0.3s ease-in-out;\n  transform: rotate(180deg);\n}\n.tb-collapsible-header-toggle-accordion {\n  margin-right: 10px;\n  color: #807f7f;\n  transform: rotate(-90deg);\n}\n.tb-collapsible-header-toggle-accordion-open {\n  transition: transform 0.3 ease-in-out;\n  transform: rotate(0deg);\n}\n.tb-collapsible-header-content {\n  width: 100%;\n}\n.tb-collapsible-header-content-accordion {\n  text-transform: uppercase;\n  font-weight: bold;\n  color: #807f7f;\n}\n.tb-collapsible-header:hover .tb-collapsible-header-controls {\n  visibility: inherit;\n}\n.tb-collapsible-header-controls {\n  margin-left: auto;\n  visibility: hidden;\n}\n.tb-collapsible-header-accordion {\n  border: none;\n  background-color: #ffffff;\n  padding: 5px 15px;\n}\n.tb-collapsible-header-accordion:hover {\n  background-color: #ffffff;\n}\n.tb-collapsible-content-is-hidden {\n  display: none;\n}\n.tb-collapsible-content-is-wide {\n  padding: 20px 15px;\n}\n.tb-collapsible-content-accordion {\n  padding-top: 10px;\n  padding-bottom: 0px;\n}\n";
styleInject(css_248z$l);

var Collapsible = /* #__PURE__ */ (function () {
    var Collapsible = function (_a) {
        var open = _a.open, toggle = _a.toggle, headerContent = _a.headerContent, children = _a.children, hoverControls = _a.hoverControls, className = _a.className, dirty = _a.dirty, deleted = _a.deleted, isNew = _a.isNew, wide = _a.wide, accordion = _a.accordion, rest = __rest(_a, ["open", "toggle", "headerContent", "children", "hoverControls", "className", "dirty", "deleted", "isNew", "wide", "accordion"]);
        var headerContentClassNames = classNames('tb-collapsible-header-content', {
            'tb-collapsible-header-content-accordion': accordion,
        });
        return (React.createElement("div", __assign({ className: classNames('tb-collapsible', {
                'tb-collapsible-is-open': open,
                'tb-collapsible-is-dirty': dirty,
                'tb-collapsible-is-deleted': deleted,
                'tb-collapsible-is-new': isNew,
                'tb-collapsible-accordion': accordion,
            }, className) }, passThroughProps(rest)),
            React.createElement("div", { className: classNames('tb-collapsible-header', {
                    'tb-collapsible-header-is-open': open,
                    'tb-collapsible-header-is-dirty': dirty,
                    'tb-collapsible-header-is-deleted': deleted,
                    'tb-collapsible-header-is-new': isNew,
                    'tb-collapsible-header-accordion': accordion,
                }), onClick: toggle },
                !accordion && React.createElement("div", { className: headerContentClassNames }, headerContent),
                hoverControls && React.createElement("div", { className: "tb-collapsible-header-controls" }, hoverControls),
                React.createElement("div", { className: classNames('tb-collapsible-header-toggle', {
                        'tb-collapsible-header-toggle-open': open && !accordion,
                        'tb-collapsible-header-toggle-accordion': accordion,
                        'tb-collapsible-header-toggle-accordion-open': accordion && open,
                    }) },
                    React.createElement(FontAwesome, { name: "angle-down" })),
                accordion && React.createElement("div", { className: headerContentClassNames }, headerContent)),
            React.createElement("div", { className: classNames('tb-collapsible-content', {
                    'tb-collapsible-content-is-hidden': !open,
                    'tb-collapsible-content-is-wide': wide,
                    'tb-collapsible-content-accordion': accordion,
                }) }, children)));
    };
    Collapsible.propTypes = {
        open: PropTypes.bool,
        toggle: PropTypes.func.isRequired,
        headerContent: PropTypes.node,
        children: PropTypes.node,
        hoverControls: PropTypes.node,
        dirty: PropTypes.bool,
        deleted: PropTypes.bool,
        isNew: PropTypes.bool,
        className: PropTypes.string,
        wide: PropTypes.bool,
        accordion: PropTypes.bool,
    };
    Collapsible.defaultProps = {
        open: false,
        headerContent: '',
        children: null,
        hoverControls: null,
        dirty: false,
        deleted: false,
        isNew: false,
        className: '',
        wide: false,
        accordion: false,
    };
    return Collapsible;
})();

// DateTimeDisplay takes optionally a unix time and optionally a format string
// and returns a formatted date time or default placeholder
var DateTimeDisplay = function (_a) {
    var time = _a.time, _b = _a.format, format = _b === void 0 ? DEFAULT_DATE_FORMAT : _b;
    return time ? moment.unix(time).utc().format(format) : '--';
};

var css_248z$k = ".stitch-error-boundary {\n  background-image: url(\"data:image/svg+xml,%3Csvg width='1200' height='675' viewBox='0 0 1200 675' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='1200' height='675' fill='white'/%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M1205.21 -27.3H-7.16895V655.575H1205.21V-27.3Z' fill='url(%23paint0_linear)'/%3E%3Cpath opacity='0.45' d='M1231.11 -27.3H606.981C601.919 -27.3 597.064 -25.289 593.485 -21.7094C589.905 -18.1298 587.894 -13.2748 587.894 -8.21249V-8.21249C587.894 -3.15017 589.905 1.70481 593.485 5.28441C597.064 8.86401 601.919 10.875 606.981 10.875H803.538C806.044 10.8742 808.526 11.3671 810.842 12.3257C813.157 13.2842 815.262 14.6896 817.034 16.4616C818.807 18.2335 820.213 20.3373 821.172 22.6527C822.131 24.9682 822.625 27.4499 822.625 29.9563V35.1563C822.625 40.2186 820.614 45.0736 817.034 48.6532C813.455 52.2328 808.6 54.2438 803.538 54.2438H518.944C510.674 54.2438 502.743 57.5289 496.895 63.3765C491.048 69.2241 487.763 77.1552 487.763 85.425V85.425C487.762 89.52 488.568 93.5751 490.135 97.3585C491.701 101.142 493.998 104.58 496.894 107.475C499.789 110.371 503.227 112.668 507.01 114.234C510.794 115.801 514.849 116.607 518.944 116.606H955.425C960.487 116.606 965.342 118.617 968.922 122.197C972.501 125.776 974.512 130.631 974.512 135.694V136.481C974.512 141.544 972.501 146.399 968.922 149.978C965.342 153.558 960.487 155.569 955.425 155.569H715C706.289 155.57 697.935 159.032 691.776 165.192C685.616 171.353 682.156 179.707 682.156 188.419V188.419C682.16 197.127 685.621 205.478 691.781 211.635C697.94 217.791 706.292 221.25 715 221.25H1232.3' fill='url(%23paint1_linear)'/%3E%3Cpath d='M1310.86 349.763L810.856 350.175L597.244 350.356H557.562C567.956 313.888 580.475 292.65 594.987 280.838C617.831 262.219 645.613 266.925 677.819 272.219C722.281 279.519 775.175 287.925 835.181 237.631C951.081 140.488 1031.05 255.756 1139.26 196.119C1240.55 140.269 1283.76 176.238 1301.49 227.369C1302.79 231.119 1303.94 234.919 1304.98 238.788C1318.65 289.844 1310.86 349.763 1310.86 349.763Z' fill='url(%23paint2_linear)'/%3E%3Cpath d='M1219.97 331.012H-18.5813V692.569H1219.97V331.012Z' fill='%23E1F2F6'/%3E%3Cpath d='M1219.97 331.012V669.631L434.582 493.706L586.644 344.775L600.7 331.012H1219.97Z' fill='url(%23paint3_linear)'/%3E%3Cpath d='M769.725 506.694C769.9 514.194 763.838 521.069 753.938 525.987C744.181 530.85 730.7 533.85 715.813 533.85H-26.4497V331.012H580.75C599.675 331.012 615.019 338.65 615.019 348.075C615.019 361.319 593.456 372.056 566.856 372.056H552.25C504.706 372.056 464.3 387.281 449.619 408.475C445.788 414 443.706 419.931 443.706 426.106C443.706 435.719 448.744 444.744 457.588 452.569C463.021 457.251 469.043 461.203 475.5 464.325C495.144 474.106 522.275 480.156 552.25 480.156H715.125C744.775 480.156 769.375 491.931 769.725 506.694Z' fill='url(%23paint4_linear)'/%3E%3Cpath d='M1229.49 350.975C1229.49 350.975 641.656 324.15 649.063 404.444C658.781 509.825 1324.37 272.956 1060.7 488.481' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M666.482 340.431C666.482 340.431 78.6441 313.606 86.0504 393.894C95.7691 499.275 761.344 262.412 497.682 477.931' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M614.656 422.5C513.531 417.888 454.888 561.531 581.319 580.625C707.75 599.719 797.331 415.419 895.394 432.744C993.456 450.069 798.988 664.844 943.438 564.113C1134.06 431.181 1226.76 503.388 1242.43 608.288' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M1211.21 433.187H-11.6245V673.431H1211.21V433.187Z' fill='%23E1F2F6'/%3E%3Cpath opacity='0.7' d='M1211.21 433.187H-11.6245V687.169H1211.21V433.187Z' fill='url(%23paint5_linear)'/%3E%3Cpath d='M1211.21 423.687H-28.5562V434.687H1211.21V423.687Z' fill='url(%23paint6_linear)'/%3E%3Cpath d='M711.75 506.319L719.425 513.531' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M704.3 517.831L713.982 520.775' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M722.775 498.163L726.319 507.644' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M748.963 541.081L741.294 533.869' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M756.419 529.569L746.738 526.625' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M737.944 549.238L734.4 539.756' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M152.125 123.194H563.669C563.498 108.918 557.711 95.2839 547.561 85.2437C537.411 75.2036 523.715 69.5654 509.438 69.55C506.273 69.5369 503.113 69.8172 500 70.3875C494.462 56.2297 484.785 44.0697 472.233 35.4938C459.68 26.918 444.834 22.3245 429.631 22.3125C421.052 22.2795 412.532 23.7452 404.456 26.6438C392.049 13.2391 376.359 3.3042 358.936 -2.17918C341.514 -7.66255 322.962 -8.50452 305.114 -4.62188C287.266 -0.739237 270.741 7.73361 257.17 19.9593C243.6 32.1849 233.455 47.7401 227.738 65.0875C222.721 63.7832 217.559 63.1237 212.375 63.125C204.483 63.1045 196.663 64.6389 189.364 67.6407C182.064 70.6425 175.427 75.0529 169.832 80.6199C164.237 86.187 159.794 92.8016 156.756 100.086C153.718 107.371 152.144 115.182 152.125 123.075V123.194Z' fill='url(%23paint7_linear)'/%3E%3Cpath d='M877.5 126.144H1200.99C1200.87 114.92 1196.32 104.197 1188.34 96.3024C1180.37 88.4082 1169.59 83.9807 1158.37 83.9813C1155.89 83.9582 1153.41 84.1675 1150.97 84.6063C1146.6 73.4726 1138.98 63.9156 1129.09 57.1841C1119.2 50.4526 1107.52 46.8598 1095.56 46.8751C1088.81 46.8686 1082.11 48.0382 1075.76 50.3313C1066.01 39.7979 1053.68 31.9904 1039.99 27.68C1026.3 23.3696 1011.72 22.7056 997.699 25.7535C983.673 28.8014 970.685 35.4557 960.018 45.0592C949.351 54.6626 941.374 66.8828 936.875 80.5126C932.929 79.4941 928.87 78.9755 924.794 78.9688C918.592 78.9582 912.448 80.1693 906.713 82.533C900.979 84.8967 895.766 88.3668 891.373 92.7451C886.979 97.1234 883.491 102.324 881.108 108.05C878.724 113.777 877.492 119.916 877.481 126.119L877.5 126.144Z' fill='url(%23paint8_linear)'/%3E%3Cpath d='M860.001 163.894C860.004 157.836 858.418 151.883 855.401 146.63C852.385 141.377 848.043 137.007 842.81 133.956C837.576 130.906 831.634 129.281 825.576 129.245C819.519 129.209 813.558 130.762 808.288 133.75C806.073 119.684 799.006 106.837 788.313 97.4357C777.62 88.0339 763.974 82.67 749.74 82.2737C735.507 81.8774 721.584 86.4737 710.384 95.2659C699.184 104.058 691.413 116.492 688.419 130.412C683.079 129.014 677.488 128.861 672.079 129.965C666.67 131.069 661.587 133.399 657.221 136.778C652.855 140.157 649.323 144.493 646.898 149.452C644.472 154.411 643.218 159.861 643.232 165.381' fill='url(%23paint9_linear)'/%3E%3Cpath opacity='0.65' d='M1310.49 215.187C1308.68 215.525 1306.83 215.894 1304.96 216.306C1282.95 221.125 1257.46 231.044 1227.92 247.325C1095.16 320.519 997.05 179.075 854.85 298.256C839.812 310.863 831.1 309.138 810.837 309.138L615.55 308.281C615.55 308.281 611.356 305.338 619.337 298.844C642.181 280.225 669.962 284.931 702.169 290.225C746.631 297.525 799.525 305.931 859.531 255.638C975.431 158.494 1055.4 273.763 1163.61 214.125C1233.91 175.375 1276.23 180.831 1301.47 204.887C1304.77 208.053 1307.79 211.499 1310.49 215.187V215.187Z' fill='url(%23paint10_linear)'/%3E%3Cpath d='M51.6001 569.419L56.9439 574.288L53.1251 574.375C57.1296 578.453 62.2505 581.256 67.8439 582.431V559.625C61.4754 560.953 55.7476 564.407 51.6001 569.419V569.419Z' fill='%23FFE1EA'/%3E%3Cpath d='M67.8628 571.031V582.437C70.003 582.898 72.1862 583.128 74.3753 583.125C84.4878 583.125 93.3565 578.294 98.4003 571.025L67.8628 571.031Z' fill='%23F97216'/%3E%3Cpath d='M67.8625 571.031H98.4187C93.375 563.75 84.5062 558.931 74.375 558.931C72.1794 558.929 69.9898 559.161 67.8438 559.625L67.8625 571.031Z' fill='%23FFDD49'/%3E%3Cpath d='M98.4189 571.031L107.963 579.469V562.594L98.4189 571.031Z' fill='%236E60F9'/%3E%3Cpath d='M59.9626 569.181C60.8186 569.181 61.5126 568.487 61.5126 567.631C61.5126 566.775 60.8186 566.082 59.9626 566.082C59.1066 566.082 58.4126 566.775 58.4126 567.631C58.4126 568.487 59.1066 569.181 59.9626 569.181Z' fill='%236E60F9'/%3E%3Cpath d='M61.4941 565.194C61.9341 565.465 62.2932 565.849 62.534 566.307C62.7747 566.764 62.8883 567.278 62.8629 567.794C62.8251 568.254 62.682 568.698 62.4446 569.094C62.2072 569.49 61.882 569.825 61.4941 570.075' stroke='%236E60F9' stroke-miterlimit='10'/%3E%3Cpath d='M136.056 540.981L141.406 545.85L137.606 545.944C141.613 550.02 146.733 552.822 152.325 554V531.181C145.949 532.511 140.213 535.966 136.056 540.981V540.981Z' fill='%23FFE1EA'/%3E%3Cpath d='M152.325 542.588V554C154.472 554.459 156.661 554.689 158.856 554.688C168.969 554.688 177.838 549.863 182.875 542.588H152.325Z' fill='%23F97216'/%3E%3Cpath d='M152.325 542.588H182.875C177.838 535.319 168.969 530.488 158.856 530.488C156.661 530.488 154.472 530.72 152.325 531.181V542.588Z' fill='%23FFDD49'/%3E%3Cpath d='M182.881 542.588L192.425 551.025V534.15L182.881 542.588Z' fill='%236E60F9'/%3E%3Cpath d='M144.419 540.744C145.275 540.744 145.969 540.05 145.969 539.194C145.969 538.338 145.275 537.644 144.419 537.644C143.563 537.644 142.869 538.338 142.869 539.194C142.869 540.05 143.563 540.744 144.419 540.744Z' fill='%236E60F9'/%3E%3Cpath d='M145.957 536.756C146.396 537.026 146.755 537.41 146.996 537.866C147.236 538.322 147.35 538.835 147.325 539.35C147.286 539.809 147.142 540.254 146.905 540.649C146.668 541.044 146.343 541.38 145.957 541.631' stroke='%236E60F9' stroke-miterlimit='10'/%3E%3Cpath d='M77.2188 498.537L82.5625 503.406L78.7687 503.5C82.7721 507.579 87.8935 510.383 93.4875 511.556V488.75C87.1127 490.076 81.3769 493.527 77.2188 498.537V498.537Z' fill='%23FFE1EA'/%3E%3Cpath d='M93.4878 500.15V511.556C95.6281 512.016 97.8111 512.249 100 512.25C110.107 512.25 118.982 507.419 124.019 500.15H93.4878Z' fill='%23F97216'/%3E%3Cpath d='M93.4875 500.15H124.038C119 492.875 110.125 488.05 100 488.05C97.8047 488.048 95.6154 488.278 93.4688 488.738L93.4875 500.15Z' fill='%23FFDD49'/%3E%3Cpath d='M124.038 500.15L133.588 508.587V491.713L124.038 500.15Z' fill='%236E60F9'/%3E%3Cpath d='M85.5815 498.3C86.4375 498.3 87.1315 497.606 87.1315 496.75C87.1315 495.894 86.4375 495.2 85.5815 495.2C84.7255 495.2 84.0315 495.894 84.0315 496.75C84.0315 497.606 84.7255 498.3 85.5815 498.3Z' fill='%236E60F9'/%3E%3Cpath d='M87.1125 494.312C87.5522 494.583 87.9116 494.966 88.1534 495.422C88.3951 495.878 88.5105 496.391 88.4875 496.906C88.4499 497.367 88.3063 497.812 88.0677 498.208C87.8292 498.604 87.5022 498.939 87.1125 499.188' stroke='%236E60F9' stroke-miterlimit='10'/%3E%3Cpath d='M1055.83 498.869L1050.48 503.737L1054.28 503.831C1050.27 507.903 1045.15 510.701 1039.56 511.875V489.069C1045.94 490.399 1051.67 493.855 1055.83 498.869V498.869Z' fill='%23FFE1EA'/%3E%3Cpath d='M1039.56 500.481V511.875C1037.42 512.336 1035.23 512.568 1033.03 512.569C1022.92 512.569 1014.05 507.737 1009.01 500.469L1039.56 500.481Z' fill='%23F97216'/%3E%3Cpath d='M1039.56 500.481H1009.01C1014.05 493.206 1022.92 488.375 1033.03 488.375C1035.23 488.376 1037.42 488.608 1039.56 489.069V500.481Z' fill='%23FFDD49'/%3E%3Cpath d='M1009.01 500.481L999.463 508.919V492.038L1009.01 500.481Z' fill='%236E60F9'/%3E%3Cpath d='M1047.46 498.631C1048.32 498.631 1049.01 497.937 1049.01 497.081C1049.01 496.225 1048.32 495.531 1047.46 495.531C1046.61 495.531 1045.91 496.225 1045.91 497.081C1045.91 497.937 1046.61 498.631 1047.46 498.631Z' fill='%236E60F9'/%3E%3Cpath d='M1045.93 494.644C1045.49 494.914 1045.13 495.297 1044.89 495.753C1044.65 496.21 1044.54 496.722 1044.56 497.238C1044.6 497.698 1044.74 498.144 1044.98 498.54C1045.22 498.936 1045.54 499.271 1045.93 499.519' stroke='%236E60F9' stroke-miterlimit='10'/%3E%3Cpath d='M1123.82 540.119L1118.48 544.987L1122.27 545.081C1118.27 549.152 1113.15 551.951 1107.56 553.125V530.319C1113.94 531.649 1119.67 535.105 1123.82 540.119V540.119Z' fill='%23FFE1EA'/%3E%3Cpath d='M1107.56 541.725V553.125C1105.41 553.584 1103.22 553.814 1101.03 553.812C1090.92 553.812 1082.05 548.987 1077.01 541.712L1107.56 541.725Z' fill='%23F97216'/%3E%3Cpath d='M1107.56 541.725H1077.01C1082.05 534.456 1090.92 529.625 1101.03 529.625C1103.22 529.625 1105.41 529.858 1107.56 530.319V541.725Z' fill='%23FFDD49'/%3E%3Cpath d='M1077.01 541.725L1067.46 550.162V533.287L1077.01 541.725Z' fill='%236E60F9'/%3E%3Cpath d='M1115.46 539.881C1116.32 539.881 1117.01 539.187 1117.01 538.331C1117.01 537.475 1116.32 536.781 1115.46 536.781C1114.61 536.781 1113.91 537.475 1113.91 538.331C1113.91 539.187 1114.61 539.881 1115.46 539.881Z' fill='%236E60F9'/%3E%3Cpath d='M1113.93 535.887C1113.49 536.159 1113.13 536.543 1112.89 537C1112.65 537.457 1112.53 537.971 1112.56 538.487C1112.59 538.948 1112.74 539.393 1112.98 539.789C1113.22 540.184 1113.54 540.52 1113.93 540.769' stroke='%236E60F9' stroke-miterlimit='10'/%3E%3Cpath d='M1155.49 388.056C1159.51 388.056 1159.51 381.806 1155.49 381.806C1151.46 381.806 1151.46 388.056 1155.49 388.056Z' fill='white'/%3E%3Cpath d='M1065.99 341.519C1070.02 341.519 1070.02 335.269 1065.99 335.269C1061.96 335.269 1061.97 341.519 1065.99 341.519Z' fill='white'/%3E%3Cpath d='M1030.2 400C1034.22 400 1034.23 393.75 1030.2 393.75C1026.18 393.75 1026.17 400 1030.2 400Z' fill='white'/%3E%3Cpath d='M805.875 368.962C809.894 368.962 809.9 362.712 805.875 362.712C801.85 362.712 801.844 368.962 805.875 368.962Z' fill='white'/%3E%3Cpath d='M741.444 350.894C745.463 350.894 745.469 344.644 741.444 344.644C737.419 344.644 737.413 350.894 741.444 350.894Z' fill='white'/%3E%3Cpath d='M520.7 521.694C524.719 521.694 524.725 515.444 520.7 515.444C516.675 515.444 516.669 521.694 520.7 521.694Z' fill='white'/%3E%3Cpath d='M504.238 564.194C508.256 564.194 508.262 557.944 504.238 557.944C500.213 557.944 500.206 564.194 504.238 564.194Z' fill='white'/%3E%3Cpath d='M1007.5 367.769C1011.53 367.769 1011.53 361.519 1007.5 361.519C1003.47 361.519 1003.48 367.769 1007.5 367.769Z' fill='white'/%3E%3Cpath d='M853.707 371.181C857.726 371.181 857.732 364.931 853.707 364.931C849.682 364.931 849.675 371.181 853.707 371.181Z' fill='white'/%3E%3Cpath d='M1163.84 352.263C1167.86 352.263 1167.87 346.012 1163.84 346.012C1159.81 346.012 1159.81 352.263 1163.84 352.263Z' fill='white'/%3E%3Cpath d='M1089.86 400C1093.88 400 1093.89 393.75 1089.86 393.75C1085.83 393.75 1085.83 400 1089.86 400Z' fill='white'/%3E%3Cpath d='M783.582 371.725C787.601 371.725 787.607 365.475 783.582 365.475C779.556 365.475 779.55 371.725 783.582 371.725Z' fill='white'/%3E%3Cpath d='M1116.11 352.263C1120.13 352.263 1120.14 346.012 1116.11 346.012C1112.09 346.012 1112.08 352.263 1116.11 352.263Z' fill='white'/%3E%3Cpath d='M581.319 598.031C585.338 598.031 585.344 591.781 581.319 591.781C577.294 591.781 577.288 598.031 581.319 598.031Z' fill='white'/%3E%3Cpath d='M556.119 584.938C560.144 584.938 560.15 578.688 556.119 578.688C552.087 578.688 552.094 584.938 556.119 584.938Z' fill='white'/%3E%3Cpath d='M781.194 347.319C785.213 347.319 785.219 341.069 781.194 341.069C777.169 341.069 777.163 347.319 781.194 347.319Z' fill='white'/%3E%3Cpath d='M294.419 371.875C298.438 371.875 298.444 365.625 294.419 365.625C290.394 365.625 290.388 371.875 294.419 371.875Z' fill='white'/%3E%3Cpath d='M170.625 402.425C174.644 402.425 174.65 396.175 170.625 396.175C166.6 396.175 166.594 402.425 170.625 402.425Z' fill='white'/%3E%3Cpath d='M388.681 378.631C392.7 378.631 392.706 372.381 388.681 372.381C384.656 372.381 384.65 378.631 388.681 378.631Z' fill='white'/%3E%3Cpath d='M435.9 361.531C439.919 361.531 439.925 355.281 435.9 355.281C431.875 355.281 431.869 361.531 435.9 361.531Z' fill='white'/%3E%3Cpath d='M468.675 339.144C472.694 339.144 472.7 332.894 468.675 332.894C464.65 332.894 464.644 339.144 468.675 339.144Z' fill='white'/%3E%3Cpath d='M122.106 327.3C126.131 327.3 126.138 321.05 122.106 321.05C118.075 321.05 118.081 327.3 122.106 327.3Z' fill='white'/%3E%3Cpath d='M320.669 368.262C324.688 368.262 324.694 362.012 320.669 362.012C316.644 362.012 316.638 368.262 320.669 368.262Z' fill='white'/%3E%3Cpath d='M88.8065 21.7125C92.8315 21.7125 92.8378 15.4626 88.8065 15.4626C84.7752 15.4626 84.7815 21.7125 88.8065 21.7125Z' fill='%23E1F2F6'/%3E%3Cpath d='M69.7189 150.581C73.7376 150.581 73.7439 144.331 69.7189 144.331C65.6938 144.331 65.6876 150.581 69.7189 150.581Z' fill='%23E1F2F6'/%3E%3Cpath d='M141.313 30.0626C145.331 30.0626 145.338 23.8126 141.313 23.8126C137.288 23.8126 137.281 30.0626 141.313 30.0626Z' fill='%23E1F2F6'/%3E%3Cpath d='M143.7 168.475C147.719 168.475 147.725 162.225 143.7 162.225C139.675 162.225 139.669 168.475 143.7 168.475Z' fill='%23E1F2F6'/%3E%3Cpath d='M280.919 118.363C284.938 118.363 284.944 112.112 280.919 112.112C276.894 112.112 276.888 118.363 280.919 118.363Z' fill='%23E1F2F6'/%3E%3Cpath d='M405 189.956C409.019 189.956 409.025 183.706 405 183.706C400.975 183.706 400.969 189.956 405 189.956Z' fill='%23E1F2F6'/%3E%3Cpath d='M451.544 150.581C455.569 150.581 455.575 144.331 451.544 144.331C447.513 144.331 447.519 150.581 451.544 150.581Z' fill='%23E1F2F6'/%3E%3Cpath d='M638.882 83.75C642.901 83.75 642.907 77.5 638.882 77.5C634.856 77.5 634.85 83.75 638.882 83.75Z' fill='%23E1F2F6'/%3E%3Cpath d='M532.681 6.2001C536.706 6.2001 536.713 -0.0498962 532.681 -0.0498962C528.65 -0.0498962 528.656 6.2001 532.681 6.2001Z' fill='%23E1F2F6'/%3E%3Cpath d='M455.125 40.8061C459.144 40.8061 459.156 34.5561 455.125 34.5561C451.094 34.5561 451.1 40.8061 455.125 40.8061Z' fill='%23E1F2F6'/%3E%3Cpath d='M320.294 62.2812C324.313 62.2812 324.319 56.0312 320.294 56.0312C316.269 56.0312 316.263 62.2812 320.294 62.2812Z' fill='%23E1F2F6'/%3E%3Cpath d='M297.619 16.9377C301.644 16.9377 301.65 10.6877 297.619 10.6877C293.587 10.6877 293.594 16.9377 297.619 16.9377Z' fill='%23E1F2F6'/%3E%3Cpath d='M198.588 2.6188C202.606 2.6188 202.613 -3.6312 198.588 -3.6312C194.563 -3.6312 194.556 2.6188 198.588 2.6188Z' fill='%23E1F2F6'/%3E%3Cpath d='M817.863 155.35C821.881 155.35 821.888 149.1 817.863 149.1C813.838 149.1 813.831 155.35 817.863 155.35Z' fill='%23E1F2F6'/%3E%3Cpath d='M700.925 199.5C704.95 199.5 704.956 193.25 700.925 193.25C696.894 193.25 696.9 199.5 700.925 199.5Z' fill='%23E1F2F6'/%3E%3Cpath d='M657.969 229.331C661.994 229.331 662 223.081 657.969 223.081C653.938 223.081 653.944 229.331 657.969 229.331Z' fill='%23E1F2F6'/%3E%3Cpath d='M573.256 195.919C577.275 195.919 577.281 189.669 573.256 189.669C569.231 189.669 569.225 195.919 573.256 195.919Z' fill='%23E1F2F6'/%3E%3Cpath d='M500.469 246.037C504.487 246.037 504.494 239.787 500.469 239.787C496.444 239.787 496.438 246.037 500.469 246.037Z' fill='%23E1F2F6'/%3E%3Cpath d='M673.482 65.8625C677.507 65.8625 677.513 59.6125 673.482 59.6125C669.45 59.6125 669.457 65.8625 673.482 65.8625Z' fill='%23E1F2F6'/%3E%3Cpath d='M721.212 9.78119C725.231 9.78119 725.237 3.53119 721.212 3.53119C717.188 3.53119 717.181 9.78119 721.212 9.78119Z' fill='%23E1F2F6'/%3E%3Cpath d='M866.781 12.1686C870.807 12.1686 870.813 5.91864 866.781 5.91864C862.75 5.91864 862.756 12.1686 866.781 12.1686Z' fill='%23E1F2F6'/%3E%3Cpath d='M834.569 49.1562C838.588 49.1562 838.594 42.9062 834.569 42.9062C830.544 42.9062 830.538 49.1562 834.569 49.1562Z' fill='%23E1F2F6'/%3E%3Cpath d='M864.375 76.6C868.4 76.6 868.406 70.35 864.375 70.35C860.344 70.35 860.35 76.6 864.375 76.6Z' fill='%23E1F2F6'/%3E%3Cpath d='M920.475 133.875C924.5 133.875 924.506 127.625 920.475 127.625C916.444 127.625 916.45 133.875 920.475 133.875Z' fill='%23E1F2F6'/%3E%3Cpath d='M1013.55 46.7687C1017.57 46.7687 1017.58 40.5187 1013.55 40.5187C1009.53 40.5187 1009.52 46.7687 1013.55 46.7687Z' fill='%23E1F2F6'/%3E%3Cpath d='M1004 164.9C1008.02 164.9 1008.03 158.65 1004 158.65C999.969 158.65 999.975 164.9 1004 164.9Z' fill='%23E1F2F6'/%3E%3Cpath d='M1063.66 74.2126C1067.69 74.2126 1067.69 67.9626 1063.66 67.9626C1059.63 67.9626 1059.64 74.2126 1063.66 74.2126Z' fill='%23E1F2F6'/%3E%3Cpath d='M1159.12 38.4186C1163.14 38.4186 1163.15 32.1686 1159.12 32.1686C1155.09 32.1686 1155.09 38.4186 1159.12 38.4186Z' fill='%23E1F2F6'/%3E%3Cpath d='M1150.77 6.2001C1154.79 6.2001 1154.79 -0.0498962 1150.77 -0.0498962C1146.74 -0.0498962 1146.74 6.2001 1150.77 6.2001Z' fill='%23E1F2F6'/%3E%3Cpath d='M1080.37 8.58762C1084.39 8.58762 1084.39 2.33762 1080.37 2.33762C1076.34 2.33762 1076.34 8.58762 1080.37 8.58762Z' fill='%23E1F2F6'/%3E%3Cpath d='M1014.74 14.5499C1018.76 14.5499 1018.77 8.29993 1014.74 8.29993C1010.72 8.29993 1010.71 14.5499 1014.74 14.5499Z' fill='%23E1F2F6'/%3E%3Cpath d='M1184.18 110C1188.2 110 1188.21 103.75 1184.18 103.75C1180.14 103.75 1180.15 110 1184.18 110Z' fill='%23E1F2F6'/%3E%3Cpath d='M1187.76 156.544C1191.78 156.544 1191.79 150.294 1187.76 150.294C1183.73 150.294 1183.73 156.544 1187.76 156.544Z' fill='%23E1F2F6'/%3E%3Cpath d='M1165.09 172.056C1169.11 172.056 1169.11 165.806 1165.09 165.806C1161.06 165.806 1161.06 172.056 1165.09 172.056Z' fill='%23E1F2F6'/%3E%3Cpath d='M943.125 50.35C947.144 50.35 947.15 44.1 943.125 44.1C939.1 44.1 939.094 50.35 943.125 50.35Z' fill='%23E1F2F6'/%3E%3Cpath d='M937.181 9.78119C941.206 9.78119 941.212 3.53119 937.181 3.53119C933.15 3.53119 933.156 9.78119 937.181 9.78119Z' fill='%23E1F2F6'/%3E%3Cpath d='M38.6942 12.1686C42.7192 12.1686 42.7254 5.91864 38.6942 5.91864C34.6629 5.91864 34.6692 12.1686 38.6942 12.1686Z' fill='%23E1F2F6'/%3E%3Cpath d='M41.0811 78.9875C45.0999 78.9875 45.1061 72.7375 41.0811 72.7375C37.0562 72.7375 37.0499 78.9875 41.0811 78.9875Z' fill='%23E1F2F6'/%3E%3Cpath d='M198.588 68.25C202.606 68.25 202.613 62 198.588 62C194.563 62 194.556 68.25 198.588 68.25Z' fill='%23E1F2F6'/%3E%3Cpath d='M346.544 19.3251C350.563 19.3251 350.569 13.0751 346.544 13.0751C342.519 13.0751 342.513 19.3251 346.544 19.3251Z' fill='%23E1F2F6'/%3E%3Cpath d='M125.8 212.625C129.819 212.625 129.825 206.375 125.8 206.375C121.775 206.375 121.769 212.625 125.8 212.625Z' fill='%23E1F2F6'/%3E%3Cpath d='M188.1 353.081H242.931' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M223.763 367.469H260.763' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M81.0688 629.594H164.244' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M146.525 639.938H203.925' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M847.844 529.531H931.019' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M907.181 540.381H964.575' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M871.182 553.882H928.575' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M834.244 632.838H814.444C810.851 632.838 807.938 635.75 807.938 639.344V641.588C807.938 645.181 810.851 648.094 814.444 648.094H834.244C837.837 648.094 840.75 645.181 840.75 641.588V639.344C840.75 635.75 837.837 632.838 834.244 632.838Z' fill='%23FEF7E3'/%3E%3Cpath d='M1161.94 639.775H1142.14C1138.54 639.775 1135.63 642.688 1135.63 646.281V648.525C1135.63 652.118 1138.54 655.031 1142.14 655.031H1161.94C1165.53 655.031 1168.44 652.118 1168.44 648.525V646.281C1168.44 642.688 1165.53 639.775 1161.94 639.775Z' fill='%23FEF7E3'/%3E%3Cpath d='M1106.9 630.619H1067.4C1063.81 630.619 1060.89 633.532 1060.89 637.125V639.369C1060.89 642.962 1063.81 645.875 1067.4 645.875H1106.9C1110.49 645.875 1113.41 642.962 1113.41 639.369V637.125C1113.41 633.532 1110.49 630.619 1106.9 630.619Z' fill='%23FEF7E3'/%3E%3Cpath d='M-224.725 322.5L-194.869 278.031L-148.494 252.8L-112.819 218.294L-86.0687 252.794L-61.0937 245.05L-32.5562 193.325H-7.58747L15.6 227.213L49.25 245.05L72 307.069L117.269 310.013L173.688 380.344L207.375 388.688L271.238 423.419L-268 422.975L-224.725 322.5Z' fill='%23FEF7E3'/%3E%3Cpath d='M-22.6623 220.363L7.3565 262.444L52.1378 283.338L14.8378 277.556L-18.981 272.119L-26.3373 255.313L-61.0935 245.05L-22.6623 220.363Z' fill='%23E1F2F6'/%3E%3Cpath d='M-7.58765 193.325L15.8124 247.925L52.1373 265.625L61.7311 277.556L49.2498 245.05L15.5999 227.213L-7.58765 193.325Z' fill='%23E1F2F6'/%3E%3Cpath d='M-240.15 422.969L-218.231 372.663L-190.05 354.638L-166.269 317.675L-126.756 322.45L-101.3 298.588L-86.0687 307.919H-67.8062L-46.4124 282.888L22.7939 296.2L57.0001 334.381L103.225 327.225L131.494 422.969H-240.15Z' fill='%23E1F2F6'/%3E%3Cpath d='M-126.756 396.8L-89.7624 340.4H-61.0936L-29.7061 346.35L1.61889 330.062L27.0751 364.15L41.8064 396.8H-126.756Z' fill='%23FEF7E3'/%3E%3Cpath d='M27.6938 399.875L16.7188 373.112L7.3251 355.088L-18.1687 373.112L-30.0249 396.8L27.6938 399.875Z' fill='%23E1F2F6'/%3E%3Cpath d='M867.013 678.206L875.738 645.225L890.575 641.544L901.1 624.55L914.738 608.906H931.331L945.375 599.75L957.225 615.2L988.638 618.706L992.888 633.763L1018.28 643.844L1032.64 678.206H867.013Z' fill='%23FEF7E3'/%3E%3Cpath d='M892.163 678.206L910.65 647.194L932.331 626.306L949.825 643.587L977.819 647.194L998.181 678.206H892.163Z' fill='%23E1F2F6'/%3E%3Cpath d='M957.225 615.2L953.813 634.437L988.638 618.706L957.225 615.2Z' fill='%23E1F2F6'/%3E%3Cpath d='M1007.9 678.206L1003.13 654.875L1022.31 678.206H1007.9Z' fill='%23E1F2F6'/%3E%3Cpath d='M1043.43 667.844H1021.85C1017.91 667.844 1014.72 671.037 1014.72 674.975V677.438C1014.72 681.376 1017.91 684.569 1021.85 684.569H1043.43C1047.36 684.569 1050.56 681.376 1050.56 677.438V674.975C1050.56 671.037 1047.36 667.844 1043.43 667.844Z' fill='%23FEF7E3'/%3E%3Cpath d='M61.7503 675.825L53.0253 642.844L38.1815 639.163L27.669 622.169L14.0253 606.525H-2.5685L-16.606 597.363L-28.456 612.819L-59.8748 616.325L-64.1248 631.375L-89.5185 641.463L-103.875 675.825H61.7503Z' fill='%23FEF7E3'/%3E%3Cpath d='M36.6003 675.825L18.1128 644.812L-3.56844 623.925L-21.0622 641.206L-49.056 644.812L-69.4185 675.825H36.6003Z' fill='%23E1F2F6'/%3E%3Cpath d='M645.35 338.606H667.706C668.71 338.606 669.703 338.804 670.63 339.188C671.556 339.573 672.398 340.136 673.107 340.846C673.816 341.556 674.378 342.398 674.76 343.326C675.143 344.253 675.339 345.247 675.338 346.25H645.338V338.606H645.35Z' fill='%23383944'/%3E%3Cpath d='M642.594 281.119C642.594 281.119 656.344 262.706 661.888 261.656C667.431 260.606 691.306 255.894 691.306 255.894C691.306 255.894 672.319 283.394 642.594 281.119Z' fill='%23B8C4C2'/%3E%3Cpath d='M674.544 311.1C674.313 292.6 660.963 281.231 661.681 251.1L622.763 242.5C622.863 251.637 623.7 263.125 618.806 282.394C608.844 321.687 612.844 346.219 639.432 346.937C666.325 347.681 674.763 328.494 674.544 311.1Z' fill='url(%23paint11_linear)'/%3E%3Cpath d='M622.556 265.681C622.556 265.681 602.869 283.806 599.706 292.787C596.544 301.769 596.519 315.975 596.519 315.975C596.519 315.975 615.337 300.35 620 284.587C623.169 273.837 622.556 265.681 622.556 265.681Z' fill='%23B8C4C2'/%3E%3Cpath d='M631.363 265.681C630.644 270.978 629.617 276.229 628.288 281.406C618.325 320.7 622.325 345.231 648.912 345.95' stroke='%239FA1A2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M675.563 245.15C675.563 245.15 669.651 243.519 664.726 242.5C665.356 237.383 664.095 232.212 661.18 227.96C658.265 223.708 653.897 220.667 648.897 219.41C643.898 218.152 638.611 218.765 634.031 221.132C629.451 223.499 625.894 227.459 624.029 232.265C622.164 237.071 622.119 242.393 623.902 247.23C625.686 252.067 629.176 256.086 633.715 258.53C638.254 260.975 643.53 261.677 648.55 260.504C653.57 259.331 657.989 256.365 660.976 252.163C661.213 252.269 661.457 252.369 661.713 252.456L675.563 245.15Z' fill='%23383944'/%3E%3Cpath d='M648.869 259.169C657.502 259.169 664.5 252.17 664.5 243.537C664.5 234.905 657.502 227.906 648.869 227.906C640.236 227.906 633.238 234.905 633.238 243.537C633.238 252.17 640.236 259.169 648.869 259.169Z' fill='url(%23paint12_linear)'/%3E%3Cpath d='M645.356 245.713C646.924 245.713 648.194 244.442 648.194 242.875C648.194 241.308 646.924 240.037 645.356 240.037C643.789 240.037 642.519 241.308 642.519 242.875C642.519 244.442 643.789 245.713 645.356 245.713Z' fill='%23383944'/%3E%3Cpath d='M661.706 252.456C656.563 252.225 655.581 245.944 659.206 242.375C662.831 238.806 660.825 229.088 649.638 227.913L653.281 224.481C656.97 226.729 660.16 229.707 662.656 233.231C665.006 236.656 664.263 241.481 664.825 243.406C665.613 246.075 668.363 248.969 668.363 248.969L661.706 252.456Z' fill='%23383944'/%3E%3Cpath d='M620.075 338.606H642.432C643.435 338.605 644.429 338.803 645.357 339.187C646.284 339.57 647.127 340.134 647.836 340.844C648.546 341.554 649.108 342.397 649.491 343.324C649.874 344.252 650.071 345.246 650.069 346.25H627.713C625.689 346.25 623.748 345.446 622.317 344.015C620.885 342.584 620.081 340.643 620.081 338.619V338.619L620.075 338.606Z' fill='%23383944'/%3E%3Cpath d='M1167.15 402.969H1137.15C1137.15 400.945 1137.95 399.004 1139.39 397.572C1140.82 396.141 1142.76 395.337 1144.78 395.337H1167.14V402.969H1167.15Z' fill='%23383944'/%3E%3Cpath d='M1174.38 320.575C1174.38 320.575 1152.14 314.706 1147.16 317.306C1142.18 319.906 1120.53 331.056 1120.53 331.056C1120.53 331.056 1152.5 340.825 1174.38 320.575Z' fill='%23B8C4C2'/%3E%3Cpath d='M1134.56 353.281C1140.09 334.331 1149.12 335.469 1150.58 305.356L1190.01 299.612C1189.26 308.719 1202.09 344.744 1203.76 370.344C1205.44 395.944 1189.48 404.512 1167.44 405.044C1145.68 405.575 1124.44 383.712 1134.56 353.281Z' fill='url(%23paint13_linear)'/%3E%3Cpath d='M1137.16 298.425C1137.16 298.425 1143.18 297.225 1148.16 296.55C1148.07 294.816 1148.2 293.078 1148.54 291.375C1149.5 286.538 1152.12 282.187 1155.94 279.077C1159.77 275.967 1164.56 274.293 1169.5 274.344C1174.43 274.394 1179.19 276.167 1182.95 279.356C1186.71 282.544 1189.24 286.947 1190.1 291.803C1190.96 296.659 1190.09 301.663 1187.65 305.949C1185.21 310.234 1181.35 313.532 1176.74 315.271C1172.12 317.01 1167.04 317.082 1162.38 315.473C1157.72 313.865 1153.77 310.677 1151.21 306.462C1150.96 306.56 1150.71 306.641 1150.45 306.706L1137.16 298.425Z' fill='%23383944'/%3E%3Cpath d='M1192.28 316.875C1192.28 316.875 1210.98 336.019 1213.66 345.15C1216.34 354.281 1215.63 368.438 1215.63 368.438C1215.63 368.438 1197.65 351.869 1193.83 335.856C1191.25 324.956 1192.28 316.875 1192.28 316.875Z' fill='%23B8C4C2'/%3E%3Cpath d='M1163.9 314.375C1172.53 314.375 1179.53 307.377 1179.53 298.744C1179.53 290.111 1172.53 283.113 1163.9 283.113C1155.27 283.113 1148.27 290.111 1148.27 298.744C1148.27 307.377 1155.27 314.375 1163.9 314.375Z' fill='url(%23paint14_linear)'/%3E%3Cpath d='M1167.45 301.175C1169.02 301.175 1170.29 299.905 1170.29 298.337C1170.29 296.77 1169.02 295.5 1167.45 295.5C1165.88 295.5 1164.61 296.77 1164.61 298.337C1164.61 299.905 1165.88 301.175 1167.45 301.175Z' fill='%23383944'/%3E%3Cpath d='M1150.45 306.719C1155.6 306.856 1157.03 300.663 1153.7 296.844C1150.37 293.025 1153.08 283.475 1164.29 283.094L1160.91 279.406C1157.06 281.374 1153.66 284.107 1150.91 287.438C1148.31 290.681 1148.71 295.563 1148.01 297.438C1147.03 300.044 1144.08 302.731 1144.08 302.731L1150.45 306.719Z' fill='%23383944'/%3E%3Cpath d='M1183.22 317.5C1184.37 322.721 1185.83 327.869 1187.59 332.919C1200.76 371.256 1198.81 396.044 1172.35 398.944' stroke='%239FA1A2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M1186.9 404.406L1164.54 404.406C1164.54 403.403 1164.74 402.409 1165.13 401.482C1165.51 400.555 1166.07 399.713 1166.79 399.004C1167.5 398.295 1168.34 397.733 1169.27 397.351C1170.2 396.968 1171.19 396.773 1172.19 396.775H1194.55C1194.55 397.779 1194.35 398.773 1193.97 399.7C1193.58 400.627 1193.02 401.469 1192.31 402.178C1191.6 402.887 1190.75 403.448 1189.83 403.831C1188.9 404.213 1187.9 404.409 1186.9 404.406V404.406Z' fill='%23383944'/%3E%3Cpath d='M1025.17 259.375L920.981 310.294C920.981 310.294 923.819 284.225 954.381 266.137C986.725 246.994 1025.17 259.375 1025.17 259.375Z' fill='%23383944'/%3E%3Cpath d='M1022.14 394.531H984.013C984.013 391.657 985.154 388.9 987.187 386.868C989.219 384.836 991.976 383.694 994.85 383.694H1022.14V394.531H1022.14Z' fill='%23383944'/%3E%3Cpath d='M973.075 335.681C977.006 369.431 1005.58 394.531 1024.25 394.531H1065.96V363.75C1028.97 363.681 1044.34 299.506 1044.34 299.506C1044.34 299.506 1041.76 277.737 1040.48 261.044C1039.68 250.656 1043.26 242.006 1044.5 241.575C1046.05 241.049 1047.48 240.221 1048.7 239.138C1049.93 238.056 1050.93 236.74 1051.64 235.269C1049.98 231.625 1048.64 222.512 1047.86 220.137C1046.95 217.381 1045.78 214.722 1044.34 212.2C1043.12 211.79 1041.83 211.579 1040.54 211.575C1038.92 211.574 1037.31 211.893 1035.82 212.512C1034.32 213.131 1032.96 214.039 1031.81 215.185C1030.67 216.33 1029.76 217.689 1029.14 219.186C1028.52 220.682 1028.2 222.286 1028.2 223.906C1028.2 223.954 1028.2 224.002 1028.2 224.05C1028.2 224.05 1002.06 245.925 1003.2 247.137C973.613 270.125 973.075 335.681 973.075 335.681Z' fill='url(%23paint15_linear)'/%3E%3Cpath d='M1065.96 379.15V394.531H1092.9L1065.96 379.15Z' fill='%23383944'/%3E%3Cpath d='M1011.38 239.606C1012.15 252.562 1021.59 261.731 1034.75 261.731C1036.72 261.731 1050.21 238.237 1051.63 235.287C1049.96 231.644 1048.63 222.531 1047.84 220.156C1046.93 217.4 1045.76 214.741 1044.33 212.219C1043.1 211.809 1041.81 211.598 1040.52 211.594C1038.9 211.593 1037.29 211.911 1035.8 212.531C1034.3 213.15 1032.94 214.058 1031.8 215.203C1030.65 216.348 1029.74 217.708 1029.12 219.205C1028.5 220.701 1028.18 222.305 1028.18 223.925C1028.18 223.973 1028.18 224.021 1028.18 224.069L1011.38 239.606Z' fill='%23FFDD49'/%3E%3Cpath d='M1035.3 345.094C1043.01 355.65 1053.11 363.744 1065.93 363.769V272.819C1065.93 267.471 1064.65 262.2 1062.18 257.456C1062.18 257.45 1062.18 257.444 1062.18 257.438C1062.18 257.431 1062.18 257.425 1062.18 257.419C1058.43 249.519 1054.51 241.65 1051.62 235.288C1050.19 238.238 1033.29 254.338 1027.54 267.119C1016.09 292.638 1018.8 322.5 1035.3 345.094Z' fill='%23383944'/%3E%3Cpath d='M968.125 203.044C983.806 209.875 1004.17 235.312 1003.02 247.337L1013.91 243.35C1024.95 238.887 1027.54 236.675 1028.22 223.975C1028.23 220.704 1029.53 217.567 1031.84 215.255C1034.15 212.943 1037.29 211.644 1040.56 211.644C1041.86 211.648 1043.14 211.859 1044.37 212.269C1038.47 201.894 1028.74 195.319 1017.62 195.319C1004.21 195.319 996.856 204.875 995.194 209.244L968.619 201.875C967.788 201.569 967.531 202.663 968.125 203.044Z' fill='%23383944'/%3E%3Cpath d='M1020.58 218.669C1021.87 218.669 1022.93 217.617 1022.93 216.319C1022.93 215.021 1021.87 213.969 1020.58 213.969C1019.28 213.969 1018.23 215.021 1018.23 216.319C1018.23 217.617 1019.28 218.669 1020.58 218.669Z' fill='white'/%3E%3Cpath d='M1105.62 357.531L1050.79 255.35C1050.79 255.35 1074.96 254.231 1097 282.081C1115.12 305 1105.62 357.531 1105.62 357.531Z' fill='%23383944'/%3E%3Cpath d='M976.088 206.044C976.088 206.044 984.394 210.988 987.619 214C994.669 220.606 996.432 222.125 996.432 222.125C996.432 222.125 994.813 218.025 988.456 212.431C982.1 206.838 976.088 206.044 976.088 206.044Z' fill='%23F97216'/%3E%3Cpath d='M1052.71 247.956C1046.96 254.481 1041.34 261.194 1037.84 268.969C1026.37 294.487 1029.09 324.35 1045.58 346.944C1049.44 352.225 1053.89 356.887 1058.99 360.231' stroke='%239FA1A2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath opacity='0.7' d='M766.838 395.325C806.599 395.325 838.832 386.463 838.832 375.531C838.832 364.599 806.599 355.737 766.838 355.737C727.077 355.737 694.844 364.599 694.844 375.531C694.844 386.463 727.077 395.325 766.838 395.325Z' fill='url(%23paint16_linear)'/%3E%3Cpath d='M766.838 365.494C800.481 365.494 828.713 371.838 836.631 380.406C838.069 378.85 838.838 377.212 838.838 375.531C838.838 364.594 806.6 355.731 766.838 355.731C727.075 355.731 694.844 364.594 694.844 375.531C694.844 377.212 695.613 378.85 697.05 380.406C704.957 371.838 733.2 365.494 766.838 365.494Z' fill='%239795F9'/%3E%3Cpath d='M716.431 541.725C711.431 549.95 702.538 561.825 687.956 570.062C664.206 583.475 641.406 574.75 631.75 588.625C628.831 592.819 625.931 600.669 630.437 616.125' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M767.281 434.831C767.225 437.775 767.1 442.131 766.8 447.4C765.844 464.012 765.331 473.025 762.519 481.862C760.525 488.112 756.169 498.112 745.538 508.644' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M766.944 152.688C783.549 158.988 799.718 166.384 815.344 174.825C876.888 208.069 918.906 251.594 945.831 286.075' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M766.944 152.688V395.075' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M790.6 178.525C792.043 178.525 793.213 175.027 793.213 170.713C793.213 166.398 792.043 162.9 790.6 162.9C789.157 162.9 787.988 166.398 787.988 170.713C787.988 175.027 789.157 178.525 790.6 178.525Z' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M832.669 200.756C834.112 200.756 835.282 197.258 835.282 192.944C835.282 188.629 834.112 185.131 832.669 185.131C831.226 185.131 830.057 188.629 830.057 192.944C830.057 197.258 831.226 200.756 832.669 200.756Z' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M872.688 228.8C874.131 228.8 875.3 225.302 875.3 220.987C875.3 216.673 874.131 213.175 872.688 213.175C871.245 213.175 870.075 216.673 870.075 220.987C870.075 225.302 871.245 228.8 872.688 228.8Z' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M910.8 262.425C912.243 262.425 913.413 258.927 913.413 254.613C913.413 250.298 912.243 246.8 910.8 246.8C909.357 246.8 908.188 250.298 908.188 254.613C908.188 258.927 909.357 262.425 910.8 262.425Z' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M939.435 274.654L934.319 278.815L952.814 301.556L957.93 297.396L939.435 274.654Z' fill='%239795F9'/%3E%3Cpath d='M933.588 273.125C929.649 272.312 925.898 270.764 922.531 268.562C917.374 265.125 913.305 260.288 910.8 254.619C902.261 252.38 894.365 248.172 887.745 242.333C881.124 236.494 875.963 229.186 872.675 220.994C864.488 219.187 856.739 215.78 849.874 210.967C843.01 206.154 837.164 200.031 832.675 192.95C824.326 193.294 816.034 191.417 808.647 187.51C801.26 183.604 795.041 177.807 790.625 170.713C784.995 169.121 779.775 166.335 775.319 162.544C772.023 159.729 769.204 156.401 766.969 152.688' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M933.588 281.975C938.479 281.975 942.444 278.01 942.444 273.119C942.444 268.228 938.479 264.262 933.588 264.262C928.697 264.262 924.731 268.228 924.731 273.119C924.731 278.01 928.697 281.975 933.588 281.975Z' fill='%234F4FBF'/%3E%3Cpath d='M933.588 278.569C936.598 278.569 939.038 276.129 939.038 273.119C939.038 270.109 936.598 267.669 933.588 267.669C930.578 267.669 928.138 270.109 928.138 273.119C928.138 276.129 930.578 278.569 933.588 278.569Z' stroke='white' stroke-miterlimit='10'/%3E%3Cpath d='M777.969 361.581C777.969 361.725 777.969 361.869 777.969 362.019C777.969 364.946 776.806 367.754 774.736 369.823C772.666 371.893 769.859 373.056 766.931 373.056C764.004 373.056 761.197 371.893 759.127 369.823C757.057 367.754 755.894 364.946 755.894 362.019C755.894 361.869 755.894 361.725 755.894 361.581H777.969Z' fill='%23FFDD49'/%3E%3Cpath d='M777.969 361.669C777.969 361.519 777.969 361.375 777.969 361.231C777.969 358.304 776.806 355.496 774.736 353.427C772.666 351.357 769.859 350.194 766.931 350.194C764.004 350.194 761.197 351.357 759.127 353.427C757.057 355.496 755.894 358.304 755.894 361.231C755.894 361.375 755.894 361.519 755.894 361.669H777.969Z' fill='%23F97216'/%3E%3Cpath d='M620.713 652.569C620.713 653.858 621.225 655.095 622.137 656.007C623.049 656.919 624.286 657.431 625.575 657.431C626.865 657.431 628.102 656.919 629.013 656.007C629.925 655.095 630.438 653.858 630.438 652.569' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M630.438 652.569C630.438 653.858 630.95 655.095 631.862 656.007C632.774 656.919 634.01 657.431 635.3 657.431C636.59 657.431 637.826 656.919 638.738 656.007C639.65 655.095 640.162 653.858 640.162 652.569' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M630.438 652.569V638.238' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M620.713 652.569L622.275 653.669' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M640.163 652.569L638.594 653.669' stroke='%23273359' stroke-miterlimit='10'/%3E%3Cpath d='M634.063 620.938C639.544 632.588 631.625 645.619 630.438 647.513C629.25 645.638 621.332 632.588 626.813 620.938C627.733 618.996 628.957 617.213 630.438 615.656C631.919 617.213 633.142 618.996 634.063 620.938Z' fill='%236E60F9'/%3E%3Cpath d='M630.481 615.656C631.962 617.213 633.186 618.996 634.106 620.938C639.587 632.587 631.669 645.619 630.481 647.512C627.481 637.099 627.481 626.051 630.481 615.638V615.656Z' fill='%236E60F9'/%3E%3Cpath d='M635.975 628.419C635.742 623.632 633.792 619.09 630.481 615.625V615.669L630.444 615.625C628.966 617.186 627.745 618.97 626.825 620.913C625.722 623.268 625.085 625.815 624.95 628.413L635.975 628.419Z' fill='%2336367F'/%3E%3Cpath d='M630.519 625.2C631.675 625.2 632.613 624.263 632.613 623.106C632.613 621.95 631.675 621.013 630.519 621.013C629.363 621.013 628.425 621.95 628.425 623.106C628.425 624.263 629.363 625.2 630.519 625.2Z' fill='%23FFDD49'/%3E%3Cpath d='M630.519 624.188C631.116 624.188 631.6 623.703 631.6 623.106C631.6 622.509 631.116 622.025 630.519 622.025C629.922 622.025 629.438 622.509 629.438 623.106C629.438 623.703 629.922 624.188 630.519 624.188Z' fill='%23383944'/%3E%3Cpath d='M470.119 453.913V467.181L477.369 469.125L470.119 476.369V575.625C486.148 575.463 501.465 568.981 512.743 557.589C524.02 546.197 530.346 530.814 530.346 514.784C530.346 498.754 524.02 483.372 512.743 471.98C501.465 460.588 486.148 454.106 470.119 453.944V453.913Z' fill='%23E1F2F6'/%3E%3Cpath d='M581.981 566.875H533.681C544.919 601.887 544.919 639.538 533.681 674.55C551.125 672.675 561.594 665.556 566.631 661.425C589.706 642.313 596.213 604.413 581.981 566.875Z' fill='%237DC5DB'/%3E%3Cpath d='M608.525 517.369C472.782 453.457 320.831 545.769 298.794 559.6C320.831 573.438 472.782 665.75 608.525 601.838C631.163 591.115 651.95 576.857 670.107 559.6C651.949 542.347 631.162 528.092 608.525 517.369V517.369Z' fill='url(%23paint17_linear)'/%3E%3Cpath d='M670.107 559.062C651.95 541.805 631.163 527.548 608.525 516.825C472.782 452.913 320.831 545.231 298.794 559.062C361.573 577.165 426.661 585.993 491.994 585.269C552.273 584.579 612.184 575.764 670.107 559.062V559.062Z' fill='%23E1F2F6'/%3E%3Cpath d='M248.844 609.55C262.091 609.55 274.796 604.287 284.164 594.92C293.531 585.552 298.794 572.847 298.794 559.6L229.288 605.575C235.471 608.209 242.123 609.561 248.844 609.55V609.55Z' fill='%23E1F2F6'/%3E%3Cpath d='M298.794 559.6C298.782 551.349 296.729 543.229 292.818 535.965C288.906 528.7 283.257 522.516 276.376 517.965C269.494 513.414 261.592 510.636 253.376 509.88C245.16 509.124 236.885 510.412 229.288 513.631L298.794 559.6Z' fill='%23E1F2F6'/%3E%3Cpath d='M542.844 566.875H494.544C505.79 601.886 505.79 639.539 494.544 674.55C511.988 672.675 522.456 665.556 527.5 661.425C550.575 642.313 557.075 604.413 542.844 566.875Z' fill='%23E1F2F6'/%3E%3Cpath d='M566.231 570.569L566.756 596.75' stroke='%23383944' stroke-miterlimit='10'/%3E%3Cpath d='M560.8 570.569L561.325 596.75' stroke='%23383944' stroke-miterlimit='10'/%3E%3Cpath d='M571.656 570.55L572.188 596.731' stroke='%23383944' stroke-miterlimit='10'/%3E%3Cpath d='M577.088 570.531L577.613 596.713' stroke='%23383944' stroke-miterlimit='10'/%3E%3Cpath d='M613.144 557.837C615.702 557.837 617.775 555.764 617.775 553.206C617.775 550.648 615.702 548.575 613.144 548.575C610.586 548.575 608.513 550.648 608.513 553.206C608.513 555.764 610.586 557.837 613.144 557.837Z' fill='%23383944'/%3E%3Cpath d='M554.569 548.569H624.531' stroke='%23383944' stroke-miterlimit='10'/%3E%3Cpath d='M608.506 583.625C611.603 586.125 615.18 587.963 619.016 589.024C622.852 590.085 626.865 590.347 630.807 589.794' stroke='%23383944' stroke-miterlimit='10'/%3E%3Cpath d='M407.406 630.113L401.244 602.031L428.388 610.45L407.406 630.113Z' fill='url(%23paint18_linear)'/%3E%3Cpath d='M349.913 499.737C353.006 505.315 354.516 511.632 354.28 518.005C354.044 524.378 352.072 530.566 348.575 535.9L379.2 526.394C376.815 519.922 372.905 514.12 367.801 509.48C362.698 504.839 356.551 501.498 349.881 499.737H349.913Z' fill='%23E1F2F6'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='-7.16895' y1='314.137' x2='1205.21' y2='314.137' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23D5D4F9'/%3E%3Cstop offset='0.23' stop-color='%23D8D5F8'/%3E%3Cstop offset='0.37' stop-color='%23E0D7F5'/%3E%3Cstop offset='0.49' stop-color='%23EFDCF0'/%3E%3Cstop offset='0.58' stop-color='%23FFE1EA'/%3E%3Cstop offset='0.63' stop-color='%23F6D9EB'/%3E%3Cstop offset='0.72' stop-color='%23DDC3ED'/%3E%3Cstop offset='0.83' stop-color='%23B59FF2'/%3E%3Cstop offset='0.96' stop-color='%237E6EF7'/%3E%3Cstop offset='1' stop-color='%236E60F9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear' x1='487.763' y1='96.9812' x2='1232.29' y2='96.9812' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FCEBE2'/%3E%3Cstop offset='0.19' stop-color='%23FBF1EB'/%3E%3Cstop offset='0.59' stop-color='%23F9F8F6'/%3E%3Cstop offset='1' stop-color='%23F9FBFA'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear' x1='935.306' y1='350.388' x2='935.306' y2='167.95' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%237DC5DB'/%3E%3Cstop offset='0.19' stop-color='%239FD4E4'/%3E%3Cstop offset='0.4' stop-color='%23BCE1EC'/%3E%3Cstop offset='0.6' stop-color='%23D0EBF2'/%3E%3Cstop offset='0.8' stop-color='%23DDF0F5'/%3E%3Cstop offset='1' stop-color='%23E1F2F6'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear' x1='822.425' y1='627.85' x2='857.625' y2='292.925' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23E1F2F6' stop-opacity='0'/%3E%3Cstop offset='0.58' stop-color='%23E1F2F6' stop-opacity='0'/%3E%3Cstop offset='0.6' stop-color='%23E4F0F5' stop-opacity='0.05'/%3E%3Cstop offset='0.64' stop-color='%23EBECF2' stop-opacity='0.18'/%3E%3Cstop offset='0.69' stop-color='%23F6E6ED' stop-opacity='0.4'/%3E%3Cstop offset='0.73' stop-color='%23FFE1EA' stop-opacity='0.56'/%3E%3Cstop offset='0.79' stop-color='%23F8DFE9' stop-opacity='0.58'/%3E%3Cstop offset='0.84' stop-color='%23E1D7E5' stop-opacity='0.62'/%3E%3Cstop offset='0.89' stop-color='%23BACBDE' stop-opacity='0.71'/%3E%3Cstop offset='0.94' stop-color='%2384BAD4' stop-opacity='0.82'/%3E%3Cstop offset='0.99' stop-color='%233EA4C8' stop-opacity='0.97'/%3E%3Cstop offset='1' stop-color='%232F9FC5'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint4_linear' x1='-33720.7' y1='140672' x2='980523' y2='140672' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23E1F2F6' stop-opacity='0'/%3E%3Cstop offset='0.58' stop-color='%23E1F2F6' stop-opacity='0'/%3E%3Cstop offset='0.6' stop-color='%23E4F0F5' stop-opacity='0.05'/%3E%3Cstop offset='0.64' stop-color='%23EBECF2' stop-opacity='0.18'/%3E%3Cstop offset='0.69' stop-color='%23F6E6ED' stop-opacity='0.4'/%3E%3Cstop offset='0.73' stop-color='%23FFE1EA' stop-opacity='0.56'/%3E%3Cstop offset='0.79' stop-color='%23F8DFE9' stop-opacity='0.58'/%3E%3Cstop offset='0.84' stop-color='%23E1D7E5' stop-opacity='0.62'/%3E%3Cstop offset='0.89' stop-color='%23BACBDE' stop-opacity='0.71'/%3E%3Cstop offset='0.94' stop-color='%2384BAD4' stop-opacity='0.82'/%3E%3Cstop offset='0.99' stop-color='%233EA4C8' stop-opacity='0.97'/%3E%3Cstop offset='1' stop-color='%232F9FC5'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint5_linear' x1='600.788' y1='706.3' x2='598.607' y2='385.687' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%237DC5DB'/%3E%3Cstop offset='1' stop-color='%239795F9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint6_linear' x1='-28.5562' y1='429.187' x2='1211.21' y2='429.187' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.01' stop-color='%237DC5DB'/%3E%3Cstop offset='0.36' stop-color='%23D5D4F9'/%3E%3Cstop offset='0.49' stop-color='%23D1D3F8'/%3E%3Cstop offset='0.63' stop-color='%23C4D1F3'/%3E%3Cstop offset='0.77' stop-color='%23B0CEEC'/%3E%3Cstop offset='0.91' stop-color='%2393C9E3'/%3E%3Cstop offset='1' stop-color='%237DC5DB'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint7_linear' x1='357.894' y1='123.194' x2='357.894' y2='-7.01875' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23C5E4F2' stop-opacity='0'/%3E%3Cstop offset='0.24' stop-color='%23C5E4F2' stop-opacity='0.29'/%3E%3Cstop offset='0.51' stop-color='%23C5E4F2' stop-opacity='0.59'/%3E%3Cstop offset='0.74' stop-color='%23C5E4F2' stop-opacity='0.81'/%3E%3Cstop offset='0.91' stop-color='%23C5E4F2' stop-opacity='0.95'/%3E%3Cstop offset='1' stop-color='%23C5E4F2'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint8_linear' x1='-2.59475e+06' y1='-607275' x2='-2.59475e+06' y2='-590534' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23C5E4F2' stop-opacity='0'/%3E%3Cstop offset='0.24' stop-color='%23C5E4F2' stop-opacity='0.29'/%3E%3Cstop offset='0.51' stop-color='%23C5E4F2' stop-opacity='0.59'/%3E%3Cstop offset='0.74' stop-color='%23C5E4F2' stop-opacity='0.81'/%3E%3Cstop offset='0.91' stop-color='%23C5E4F2' stop-opacity='0.95'/%3E%3Cstop offset='1' stop-color='%23C5E4F2'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint9_linear' x1='166101' y1='495190' x2='166101' y2='484130' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23C5E4F2' stop-opacity='0'/%3E%3Cstop offset='0.24' stop-color='%23C5E4F2' stop-opacity='0.29'/%3E%3Cstop offset='0.51' stop-color='%23C5E4F2' stop-opacity='0.59'/%3E%3Cstop offset='0.74' stop-color='%23C5E4F2' stop-opacity='0.81'/%3E%3Cstop offset='0.91' stop-color='%23C5E4F2' stop-opacity='0.95'/%3E%3Cstop offset='1' stop-color='%23C5E4F2'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint10_linear' x1='962.469' y1='309.219' x2='962.469' y2='185.925' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23E1F2F6'/%3E%3Cstop offset='0.2' stop-color='%23DDF0F5'/%3E%3Cstop offset='0.4' stop-color='%23D0EBF2'/%3E%3Cstop offset='0.6' stop-color='%23BCE1EC'/%3E%3Cstop offset='0.81' stop-color='%239FD4E4'/%3E%3Cstop offset='1' stop-color='%237DC5DB'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint11_linear' x1='615.181' y1='293.714' x2='675.66' y2='298.091' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23B8C4C2'/%3E%3Cstop offset='0.05' stop-color='%23BFCAC8'/%3E%3Cstop offset='0.32' stop-color='%23DCE4E2'/%3E%3Cstop offset='0.47' stop-color='%23E7EEEC'/%3E%3Cstop offset='0.64' stop-color='%23E4EBE9'/%3E%3Cstop offset='0.78' stop-color='%23D9E2E0'/%3E%3Cstop offset='0.91' stop-color='%23C8D2D0'/%3E%3Cstop offset='1' stop-color='%23B8C4C2'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint12_linear' x1='633.262' y1='242.511' x2='664.449' y2='244.768' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FEF7E3'/%3E%3Cstop offset='0.53' stop-color='%23FEF5E4'/%3E%3Cstop offset='0.8' stop-color='%23FEEDE6'/%3E%3Cstop offset='1' stop-color='%23FFE1EA'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint13_linear' x1='-506798' y1='59739.7' x2='-515074' y2='59739.7' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23B8C4C2'/%3E%3Cstop offset='0.05' stop-color='%23BFCAC8'/%3E%3Cstop offset='0.32' stop-color='%23DCE4E2'/%3E%3Cstop offset='0.47' stop-color='%23E7EEEC'/%3E%3Cstop offset='0.64' stop-color='%23E4EBE9'/%3E%3Cstop offset='0.78' stop-color='%23D9E2E0'/%3E%3Cstop offset='0.91' stop-color='%23C8D2D0'/%3E%3Cstop offset='1' stop-color='%23B8C4C2'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint14_linear' x1='-218986' y1='15226.3' x2='-220550' y2='15226.3' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FEF7E3'/%3E%3Cstop offset='0.53' stop-color='%23FEF5E4'/%3E%3Cstop offset='0.8' stop-color='%23FEEDE6'/%3E%3Cstop offset='1' stop-color='%23FFE1EA'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint15_linear' x1='-76509.1' y1='83200.5' x2='-96932' y2='89186.4' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FEF7E3'/%3E%3Cstop offset='0.53' stop-color='%23FEF5E4'/%3E%3Cstop offset='0.8' stop-color='%23FEEDE6'/%3E%3Cstop offset='1' stop-color='%23FFE1EA'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint16_linear' x1='177273' y1='22589.7' x2='177289' y2='26400' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%237DC5DB'/%3E%3Cstop offset='1' stop-color='%239795F9'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint17_linear' x1='287892' y1='118084' x2='287742' y2='129501' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FEF7E3'/%3E%3Cstop offset='0.53' stop-color='%23FEF5E4'/%3E%3Cstop offset='0.8' stop-color='%23FEEDE6'/%3E%3Cstop offset='1' stop-color='%23FFE1EA'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint18_linear' x1='18481.4' y1='26066.4' x2='18384.4' y2='28546.5' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FEF7E3'/%3E%3Cstop offset='0.53' stop-color='%23FEF5E4'/%3E%3Cstop offset='0.8' stop-color='%23FEEDE6'/%3E%3Cstop offset='1' stop-color='%23FFE1EA'/%3E%3C/linearGradient%3E%3CclipPath id='clip0'%3E%3Crect width='1200' height='675' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 100%;\n  height: 100vh;\n  background-position: right;\n}\n.stitch-error-boundary-message {\n  padding: 64px 0 0 88px;\n  max-width: 487px;\n}\n.stitch-error-boundary-message > *,\n.stitch-error-boundary-message a {\n  color: #36367F;\n}\n.stitch-error-boundary-code {\n  margin: 24px 0 0;\n  max-width: 487px;\n  height: auto;\n}\n.stitch-error-boundary-code code {\n  white-space: normal;\n  padding-right: 22%;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  color: #A0A1A7;\n}\n.stitch-error-boundary-announcement {\n  margin-top: 24px;\n}\n.stitch-error-boundary-announcement a {\n  font-weight: bold;\n}\n";
styleInject(css_248z$k);

var baseClassName$2 = 'stitch-error-boundary';
var ErrorBoundary = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(ErrorBoundary, _super);
            function ErrorBoundary() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.state = {
                    hasError: false,
                    error: undefined,
                };
                return _this;
            }
            ErrorBoundary.prototype.componentDidCatch = function (error, info) {
                this.props.onError(error, info);
                this.setState({ hasError: true, error: error });
            };
            ErrorBoundary.prototype.render = function () {
                var error = this.state.error;
                if (this.state.hasError) {
                    return (React.createElement("div", __assign({ className: "" + baseClassName$2 }, passThroughProps(this.props)),
                        React.createElement("div", { className: baseClassName$2 + "-message" },
                            React.createElement(H2, null, "Oops!"),
                            React.createElement(H2, null, "Something went wrong."),
                            (error === null || error === void 0 ? void 0 : error.message) && React.createElement(Copyable, { className: baseClassName$2 + "-code" }, error.message),
                            React.createElement(Body, { className: baseClassName$2 + "-announcement" },
                                "It seems we encountered an error while processing your request. You can file a ticket for it at our\u00A0",
                                React.createElement(Link, { href: "https://support.mongodb.com/", target: "_blank", rel: "noreferrer" }, "help center")))));
                }
                return this.props.children;
            };
            return ErrorBoundary;
        }(React.Component)),
        _a.propTypes = {
            children: PropTypes.node.isRequired,
            onError: PropTypes.func,
        },
        _a.defaultProps = {
            onError: console.error.bind(console), // eslint-disable-line no-console
        },
        _a;
})();

var css_248z$j = ".hidden-file-input {\n  display: flex;\n}\n.hidden-file-input-label {\n  display: inherit;\n}\n";
styleInject(css_248z$j);

var lastUnique = 0;
var getInputId = function () {
    lastUnique += 1;
    return "hidden-file-input-" + lastUnique;
};
var HiddenFileInput = /* #__PURE__ */ (function () {
    // HiddenFileInput displays either an <a> or a <button> in place of a standard <input type="file">
    // When the displayed element is clicked, it behaves like the input element and opens the file selector
    var HiddenFileInput = function (_a) {
        var children = _a.children, multiple = _a.multiple, classNames = _a.classNames, handleFiles = _a.handleFiles, disabled = _a.disabled, rest = __rest(_a, ["children", "multiple", "classNames", "handleFiles", "disabled"]);
        var inputId = getInputId();
        return (React.createElement("div", __assign({ className: "hidden-file-input" }, passThroughProps(rest)),
            React.createElement("label", { className: "hidden-file-input-label" },
                React.createElement(Button, { variant: "primary", size: "xsmall", disabled: disabled, style: disabled ? { color: palette.gray.base } : {}, className: classNames, onClick: function () {
                        var fileInput = document.getElementById(inputId);
                        fileInput.value = '';
                        return fileInput.click();
                    } },
                    React.createElement("input", { type: "file", id: inputId, style: { display: 'none' }, multiple: multiple, onChange: handleFiles }),
                    React.createElement(FontAwesome, { name: "cloud-upload" }),
                    "\u00A0",
                    children))));
    };
    HiddenFileInput.defaultProps = {
        children: 'browse',
        multiple: false,
        classNames: '',
        disabled: false,
    };
    HiddenFileInput.propTypes = {
        children: PropTypes.node,
        multiple: PropTypes.bool,
        classNames: PropTypes.string,
        handleFiles: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
    };
    return HiddenFileInput;
})();

var InlineTextInput = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(InlineTextInput, _super);
            function InlineTextInput() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.textInput = React.createRef();
                _this.state = {
                    value: _this.props.value || '',
                    error: undefined,
                    hideTimer: undefined,
                    dirty: false,
                };
                _this.onChange = function (e) {
                    _this.setState({ value: e.target.value, dirty: e.target.value !== _this.props.value });
                };
                _this.onSave = function () {
                    var _a = _this.props, onCancel = _a.onCancel, onSave = _a.onSave, value = _a.value;
                    if (!_this.state.dirty) {
                        onCancel();
                    }
                    onSave(_this.state.value, value);
                };
                return _this;
            }
            InlineTextInput.prototype.componentDidMount = function () {
                if (this.textInput.current) {
                    this.textInput.current.focus();
                }
            };
            InlineTextInput.prototype.componentDidUpdate = function (prevProps) {
                var _this = this;
                if (this.props.error !== prevProps.error && this.props.error !== this.state.error) {
                    var hideTimer = window.setTimeout(function () {
                        ReactTooltip.hide(_this.error);
                        _this.setState({ error: '', hideTimer: undefined });
                    }, 3000);
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({ error: this.props.error, hideTimer: hideTimer }, function () {
                        setTimeout(function () { return ReactTooltip.show(_this.error); }, 0);
                    });
                }
            };
            InlineTextInput.prototype.componentWillUnmount = function () {
                if (this.state.hideTimer) {
                    clearTimeout(this.state.hideTimer);
                }
            };
            InlineTextInput.prototype.render = function () {
                var _this = this;
                var _a = this.props, className = _a.className, placeholder = _a.placeholder, onCancel = _a.onCancel, rest = __rest(_a, ["className", "placeholder", "onCancel"]);
                return (React.createElement("div", __assign({ className: className }, passThroughProps(rest)),
                    React.createElement(ReactTooltip, null),
                    React.createElement("p", { ref: function (node) {
                            _this.error = node;
                        }, "data-tip": this.state.error, "data-type": "error", "data-class": "tooltip" },
                        React.createElement("input", { type: "text", ref: this.textInput, value: this.state.value, onChange: this.onChange, onKeyDown: enterPressedCaller(this.onSave, onCancel), placeholder: placeholder })),
                    React.createElement(Button, { size: "xsmall", variant: "primary", disabled: !this.state.dirty, onClick: this.onSave, name: "save" },
                        React.createElement(FontAwesome, { name: "check" })),
                    React.createElement(Button, { size: "xsmall", onClick: onCancel, name: "cancel" },
                        React.createElement(FontAwesome, { name: "times" }))));
            };
            return InlineTextInput;
        }(React.Component)),
        _a.propTypes = {
            className: PropTypes.string,
            value: PropTypes.string,
            placeholder: PropTypes.string,
            onCancel: PropTypes.func,
            onSave: PropTypes.func,
            error: PropTypes.string,
        },
        _a.defaultProps = {
            className: '',
            value: '',
            error: undefined,
            placeholder: '',
            onCancel: function () { },
            onSave: function () { },
        },
        _a;
})();

var css_248z$i = ".tb-spinner {\n  background: url(\"data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22utf-8%22%3F%3E%3Csvg width%3D'50px' height%3D'50px' xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 100 100%22 preserveAspectRatio%3D%22xMidYMid%22 class%3D%22uil-ellipsis%22%3E%3Ccircle cx%3D%2216%22 cy%3D%2250%22 r%3D%2215%22 fill%3D%22%23403d3d%22 transform%3D%22rotate(0 50 50)%22%3E%3Canimate id%3D%22anir11%22 attributeName%3D%22r%22 from%3D%220%22 to%3D%2215%22 begin%3D%220s%3Banir14.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir12%22 attributeName%3D%22r%22 from%3D%2215%22 to%3D%2215%22 begin%3D%22anir11.end%22 dur%3D%220.625s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir13%22 attributeName%3D%22r%22 from%3D%2215%22 to%3D%220%22 begin%3D%22anir12.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir14%22 attributeName%3D%22r%22 from%3D%220%22 to%3D%220%22 begin%3D%22anir13.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix11%22 attributeName%3D%22cx%22 from%3D%2216%22 to%3D%2216%22 begin%3D%220s%3Banix18.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix12%22 attributeName%3D%22cx%22 from%3D%2216%22 to%3D%2216%22 begin%3D%22anix11.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix13%22 attributeName%3D%22cx%22 from%3D%2216%22 to%3D%2250%22 begin%3D%22anix12.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix14%22 attributeName%3D%22cx%22 from%3D%2250%22 to%3D%2250%22 begin%3D%22anix13.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix15%22 attributeName%3D%22cx%22 from%3D%2250%22 to%3D%2284%22 begin%3D%22anix14.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix16%22 attributeName%3D%22cx%22 from%3D%2284%22 to%3D%2284%22 begin%3D%22anix15.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix17%22 attributeName%3D%22cx%22 from%3D%2284%22 to%3D%2284%22 begin%3D%22anix16.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix18%22 attributeName%3D%22cx%22 from%3D%2284%22 to%3D%2216%22 begin%3D%22anix17.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3C%2Fcircle%3E%3Ccircle cx%3D%2250%22 cy%3D%2250%22 r%3D%2215%22 fill%3D%22%23808a80%22 transform%3D%22rotate(0 50 50)%22%3E%3Canimate id%3D%22anir21%22 attributeName%3D%22r%22 from%3D%2215%22 to%3D%2215%22 begin%3D%220s%3Banir25.end%22 dur%3D%220.5s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir22%22 attributeName%3D%22r%22 from%3D%2215%22 to%3D%220%22 begin%3D%22anir21.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir23%22 attributeName%3D%22r%22 from%3D%220%22 to%3D%220%22 begin%3D%22anir22.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir24%22 attributeName%3D%22r%22 from%3D%220%22 to%3D%2215%22 begin%3D%22anir23.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir25%22 attributeName%3D%22r%22 from%3D%2215%22 to%3D%2215%22 begin%3D%22anir24.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix21%22 attributeName%3D%22cx%22 from%3D%2216%22 to%3D%2250%22 begin%3D%220s%3Banix28.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix22%22 attributeName%3D%22cx%22 from%3D%2250%22 to%3D%2250%22 begin%3D%22anix21.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix23%22 attributeName%3D%22cx%22 from%3D%2250%22 to%3D%2284%22 begin%3D%22anix22.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix24%22 attributeName%3D%22cx%22 from%3D%2284%22 to%3D%2284%22 begin%3D%22anix23.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix25%22 attributeName%3D%22cx%22 from%3D%2284%22 to%3D%2284%22 begin%3D%22anix24.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix26%22 attributeName%3D%22cx%22 from%3D%2284%22 to%3D%2216%22 begin%3D%22anix25.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix27%22 attributeName%3D%22cx%22 from%3D%2216%22 to%3D%2216%22 begin%3D%22anix26.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix28%22 attributeName%3D%22cx%22 from%3D%2216%22 to%3D%2216%22 begin%3D%22anix27.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3C%2Fcircle%3E%3Ccircle cx%3D%2284%22 cy%3D%2250%22 r%3D%2215%22 fill%3D%22%23403d3d%22 transform%3D%22rotate(0 50 50)%22%3E%3Canimate id%3D%22anir31%22 attributeName%3D%22r%22 from%3D%2215%22 to%3D%2215%22 begin%3D%220s%3Banir35.end%22 dur%3D%220.25s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir32%22 attributeName%3D%22r%22 from%3D%2215%22 to%3D%220%22 begin%3D%22anir31.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir33%22 attributeName%3D%22r%22 from%3D%220%22 to%3D%220%22 begin%3D%22anir32.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir34%22 attributeName%3D%22r%22 from%3D%220%22 to%3D%2215%22 begin%3D%22anir33.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir35%22 attributeName%3D%22r%22 from%3D%2215%22 to%3D%2215%22 begin%3D%22anir34.end%22 dur%3D%220.375s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix31%22 attributeName%3D%22cx%22 from%3D%2250%22 to%3D%2284%22 begin%3D%220s%3Banix38.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix32%22 attributeName%3D%22cx%22 from%3D%2284%22 to%3D%2284%22 begin%3D%22anix31.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix33%22 attributeName%3D%22cx%22 from%3D%2284%22 to%3D%2284%22 begin%3D%22anix32.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix34%22 attributeName%3D%22cx%22 from%3D%2284%22 to%3D%2216%22 begin%3D%22anix33.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix35%22 attributeName%3D%22cx%22 from%3D%2216%22 to%3D%2216%22 begin%3D%22anix34.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix36%22 attributeName%3D%22cx%22 from%3D%2216%22 to%3D%2216%22 begin%3D%22anix35.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix37%22 attributeName%3D%22cx%22 from%3D%2216%22 to%3D%2250%22 begin%3D%22anix36.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix38%22 attributeName%3D%22cx%22 from%3D%2250%22 to%3D%2250%22 begin%3D%22anix37.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3C%2Fcircle%3E%3Ccircle cx%3D%2284%22 cy%3D%2250%22 r%3D%2215%22 fill%3D%22%23808a80%22 transform%3D%22rotate(0 50 50)%22%3E%3Canimate id%3D%22anir41%22 attributeName%3D%22r%22 from%3D%2215%22 to%3D%220%22 begin%3D%220s%3Banir44.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir42%22 attributeName%3D%22r%22 from%3D%220%22 to%3D%220%22 begin%3D%22anir41.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir43%22 attributeName%3D%22r%22 from%3D%220%22 to%3D%2215%22 begin%3D%22anir42.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anir44%22 attributeName%3D%22r%22 from%3D%2215%22 to%3D%2215%22 begin%3D%22anir43.end%22 dur%3D%220.625s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix41%22 attributeName%3D%22cx%22 from%3D%2284%22 to%3D%2284%22 begin%3D%220s%3Banix48.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix42%22 attributeName%3D%22cx%22 from%3D%2284%22 to%3D%2216%22 begin%3D%22anix41.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix43%22 attributeName%3D%22cx%22 from%3D%2216%22 to%3D%2216%22 begin%3D%22anix42.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix44%22 attributeName%3D%22cx%22 from%3D%2216%22 to%3D%2216%22 begin%3D%22anix43.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix45%22 attributeName%3D%22cx%22 from%3D%2216%22 to%3D%2250%22 begin%3D%22anix44.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix46%22 attributeName%3D%22cx%22 from%3D%2250%22 to%3D%2250%22 begin%3D%22anix45.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix47%22 attributeName%3D%22cx%22 from%3D%2250%22 to%3D%2284%22 begin%3D%22anix46.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3Canimate id%3D%22anix48%22 attributeName%3D%22cx%22 from%3D%2284%22 to%3D%2284%22 begin%3D%22anix47.end%22 dur%3D%220.125s%22 fill%3D%22freeze%22%3E%3C%2Fanimate%3E%3C%2Fcircle%3E%3C%2Fsvg%3E\") no-repeat;\n  background-size: 100%;\n  min-height: 10px;\n  width: 15px;\n  margin-left: 10px;\n  display: inline-block;\n}\n.tb-spinner-is-large {\n  width: 30px;\n  min-height: 30px;\n}\n.tb-spinner-is-xlarge {\n  width: 45px;\n  min-height: 45px;\n}\n.tb-spinner-is-centered {\n  display: block;\n  margin: auto;\n}\n";
styleInject(css_248z$i);

var Spinner = /* #__PURE__ */ (function () {
    function Spinner(_a) {
        var open = _a.open, large = _a.large, xlarge = _a.xlarge, centered = _a.centered, rest = __rest(_a, ["open", "large", "xlarge", "centered"]);
        if (!open) {
            return null;
        }
        return (React.createElement("div", __assign({ className: classNames('tb-spinner', {
                'tb-spinner-is-large': large,
                'tb-spinner-is-xlarge': xlarge,
                'tb-spinner-is-centered': centered,
            }) }, passThroughProps(rest))));
    }
    Spinner.defaultProps = {
        large: false,
        xlarge: false,
        open: false,
        centered: false,
    };
    Spinner.propTypes = {
        large: PropTypes.bool,
        xlarge: PropTypes.bool,
        open: PropTypes.bool,
        centered: PropTypes.bool,
    };
    return Spinner;
})();

var css_248z$h = ".tb-loading-wrapper {\n  position: relative;\n  width: 100%;\n  flex-grow: 1;\n}\n.tb-loading-wrapper .tb-loading-indicator-container {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-height: 50vh;\n}\n";
styleInject(css_248z$h);

var onClick = function (_a) {
    var e = _a.e, allowInteraction = _a.allowInteraction, isLoading = _a.isLoading;
    if (!allowInteraction && isLoading) {
        e.preventDefault();
    }
};
var delayTimeMS = 300;
var TestSelector$8;
(function (TestSelector) {
    TestSelector["Container"] = "loading-wrapper-container";
})(TestSelector$8 || (TestSelector$8 = {}));
var LoadingWrapper = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1(props) {
                var _this = _super.call(this, props) || this;
                _this.state = {
                    timer: _this.setTimer(),
                    timedOut: false,
                };
                _this.setTimer = _this.setTimer.bind(_this);
                return _this;
            }
            class_1.prototype.componentDidUpdate = function (_a) {
                var wasLoading = _a.isLoading;
                var isLoading = this.props.isLoading;
                var _b = this.state, timedOut = _b.timedOut, timer = _b.timer;
                // Handle case where we need to cancel existing timer
                // When wasLoading is true and isLoading is false and timedOut is false
                if (wasLoading && !isLoading && !timedOut) {
                    clearTimeout(timer);
                    return;
                }
                if (!wasLoading && isLoading) {
                    clearTimeout(timer);
                    // NOTE: according to the React docs, this is the recommended approach this this behavior.
                    // The conditional above prevents an infinite loop
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        timer: this.setTimer(),
                        timedOut: false,
                    });
                }
            };
            class_1.prototype.componentWillUnmount = function () {
                var timer = this.state.timer;
                clearTimeout(timer);
            };
            class_1.prototype.setTimer = function () {
                var _this = this;
                return setTimeout(function () { return _this.setState({ timedOut: true }); }, delayTimeMS);
            };
            class_1.prototype.render = function () {
                var _a = this.props, allowInteraction = _a.allowInteraction, isLoading = _a.isLoading, showLoadingIndicator = _a.showLoadingIndicator, children = _a.children, className = _a.className, rest = __rest(_a, ["allowInteraction", "isLoading", "showLoadingIndicator", "children", "className"]);
                var timedOut = this.state.timedOut;
                return (React.createElement("div", __assign({ "data-test-selector": TestSelector$8.Container, className: classNames('tb-loading-wrapper', className), onClick: function (e) { return onClick({ e: e, allowInteraction: allowInteraction, isLoading: isLoading }); }, style: {
                        opacity: isLoading && timedOut ? 0.5 : 1.0,
                    } }, passThroughProps(rest)),
                    children,
                    isLoading && timedOut && showLoadingIndicator && (React.createElement("div", { className: "tb-loading-indicator-container" },
                        React.createElement(Spinner, { open: true, xlarge: true })))));
            };
            return class_1;
        }(React.Component)),
        _a.propTypes = {
            allowInteraction: PropTypes.bool,
            children: PropTypes.node,
            isLoading: PropTypes.bool,
            showLoadingIndicator: PropTypes.bool,
            className: PropTypes.string,
        },
        _a.defaultProps = {
            allowInteraction: false,
            children: null,
            isLoading: false,
            showLoadingIndicator: true,
            className: '',
        },
        _a;
})();

var ItemListLoadingWrapper = /* #__PURE__ */ (function () {
    var ItemListLoadingWrapper = function (_a) {
        var children = _a.children, hasItems = _a.hasItems, isLoading = _a.isLoading, emptyState = _a.emptyState, showLoadingIndicator = _a.showLoadingIndicator, rest = __rest(_a, ["children", "hasItems", "isLoading", "emptyState", "showLoadingIndicator"]);
        var content;
        if (isLoading && !hasItems) {
            content = React.createElement("div", null);
        }
        else if (hasItems) {
            content = children;
        }
        else {
            content = emptyState;
        }
        return (React.createElement(LoadingWrapper, __assign({ isLoading: isLoading, showLoadingIndicator: showLoadingIndicator }, passThroughProps(rest)), content));
    };
    ItemListLoadingWrapper.propTypes = {
        children: PropTypes.node,
        emptyState: PropTypes.node,
        isLoading: PropTypes.bool,
        hasItems: PropTypes.bool,
        showLoadingIndicator: PropTypes.bool,
    };
    ItemListLoadingWrapper.defaultProps = {
        children: null,
        emptyState: null,
        isLoading: false,
        hasItems: false,
        showLoadingIndicator: true,
    };
    return ItemListLoadingWrapper;
})();

var loadable = /* #__PURE__ */ (function () {
    var Loader = function (_a) {
        var _b = _a.delay, delay = _b === void 0 ? 200 : _b;
        var _c = __read$1(useState(false), 2), show = _c[0], setShow = _c[1];
        useEffect(function () {
            var timeout = setTimeout(function () { return setShow(true); }, delay);
            return function () {
                clearTimeout(timeout);
            };
        }, [delay]);
        return show ? (React.createElement(LoadingWrapper, { isLoading: true },
            React.createElement("div", { style: { width: '100%' } }))) : null;
    };
    var loadable = function (loadableComponent, options) {
        if (options === void 0) { options = {}; }
        var LoadableComponent = lazy(function () { return loadableComponent(); });
        var Loadable = function (props) { return (React.createElement(Suspense, { fallback: React.createElement(Loader, { delay: options.delay }) },
            React.createElement(LoadableComponent, __assign({}, props)))); };
        Loadable.displayName = options.name;
        return Loadable;
    };
    return loadable;
})();

var DEFAULT_RICH_JSON_EDITOR_MIN_LINES = 5;
var DEFAULT_RICH_JSON_EDITOR_MAX_LINES = 10;

var RichJSONEditor = loadable(function () { return import('./RichJSONEditor-11415e59.js'); });
var RichJavascriptEditor = loadable(function () { return import('./RichJavascriptEditor-6b033258.js'); });

var defaultProps$7 = {
    value: '',
    errorMessage: undefined,
    readOnly: false,
    label: null,
    onChange: function () { },
};
var lastUniqueId$2 = 0;
var JSONEditorFormRow = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(JSONEditorFormRow, _super);
            function JSONEditorFormRow(props) {
                var _this = _super.call(this, props) || this;
                lastUniqueId$2 += 1;
                _this.id = "JSONEditorFormRow-" + lastUniqueId$2;
                return _this;
            }
            JSONEditorFormRow.prototype.render = function () {
                var _a = this.props, onChange = _a.onChange, value = _a.value, label = _a.label, children = _a.children, errorMessage = _a.errorMessage, readOnly = _a.readOnly, rest = __rest(_a, ["onChange", "value", "label", "children", "errorMessage", "readOnly"]);
                return (React.createElement(FormRow, __assign({ errorMessage: errorMessage }, passThroughProps(rest)),
                    React.createElement(FormRowLabelGroup, null,
                        React.createElement("label", { htmlFor: this.id, className: "form-row-label" }, label),
                        React.createElement("div", { className: "form-row-description" }, children)),
                    React.createElement(FormRowInputGroup, null,
                        React.createElement(RichJSONEditor, { error: !!errorMessage, id: this.id, minLines: 5, maxLines: 10, onChange: onChange, value: value, readOnly: readOnly }))));
            };
            return JSONEditorFormRow;
        }(React.Component)),
        _a.propTypes = {
            value: PropTypes.string,
            errorMessage: PropTypes.string,
            readOnly: PropTypes.bool,
            label: PropTypes.node,
            onChange: PropTypes.func,
        },
        _a.defaultProps = defaultProps$7,
        _a;
})();

var css_248z$g = ".tb-text-input {\n  display: block;\n  padding: 7px 8px;\n  font-size: 14px;\n  border-radius: 3px;\n  outline: none;\n  border: 1px solid #bfbfbe;\n}\n.tb-text-input-is-inline-block {\n  display: inline-block;\n}\n.tb-text-input-for-variable {\n  width: 100%;\n  font-family: Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n.tb-text-input-for-filter {\n  font-size: 10px;\n  padding: 3px 4px;\n}\n.tb-text-input-has-error {\n  border-color: #ef4c4c;\n}\n.tb-text-input:focus {\n  border-color: #5b81a9;\n  box-shadow: 0 2px 6px rgba(78, 175, 233, 0.3);\n}\n/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-masked-input {\n  display: flex;\n  flex-direction: row;\n  white-space: nowrap;\n  align-items: center;\n}\n.tb-masked-input-toggle {\n  margin-left: 5px;\n  color: #006cbc;\n}\n.tb-masked-input input {\n  margin-right: -4px;\n  flex-grow: 1;\n}\n.tb-masked-input-button {\n  height: 33px;\n}\n.tb-masked-input-label {\n  font-size: 12px;\n  color: #006cbc;\n  cursor: pointer;\n}\n.tb-masked-input-is-disabled {\n  color: #a09f9e;\n}\n";
styleInject(css_248z$g);

var TestSelector$7;
(function (TestSelector) {
    TestSelector["ShowHide"] = "show-hide-button";
    TestSelector["Input"] = "input";
    TestSelector["Label"] = "label";
})(TestSelector$7 || (TestSelector$7 = {}));
var baseClassName$1 = 'tb-masked-input';
var MaskedInput = /* #__PURE__ */ (function () {
    var MaskedInput = function (_a) {
        var _b, _c;
        var _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.buttonIsDisabled, buttonIsDisabled = _e === void 0 ? false : _e, _f = _a.hideInput, hideInput = _f === void 0 ? false : _f, _g = _a.inputProps, inputProps = _g === void 0 ? {} : _g, rest = __rest(_a, ["className", "buttonIsDisabled", "hideInput", "inputProps"]);
        var _h = __read$1(useState(true), 2), hidden = _h[0], setHidden = _h[1];
        var inputOutProps = __assign(__assign({}, inputProps), { type: hidden ? 'password' : inputProps.type || 'text', autoComplete: inputProps.autoComplete || 'new-password' });
        return (React.createElement("div", __assign({ className: classNames(baseClassName$1, className) }, passThroughProps(rest)),
            React.createElement("input", __assign({}, inputOutProps, { "data-test-selector": TestSelector$7.Input })),
            !hideInput && (React.createElement(Button, { className: baseClassName$1 + "-button", disabled: buttonIsDisabled, onClick: function () { return setHidden(!hidden); }, "data-test-selector": TestSelector$7.ShowHide },
                React.createElement(Icon, { glyph: hidden ? 'Visibility' : 'VisibilityOff', size: "default", className: classNames(baseClassName$1 + "-toggle", (_b = {}, _b[baseClassName$1 + "-is-disabled"] = buttonIsDisabled, _b)) }),
                React.createElement("label", { className: classNames(baseClassName$1 + "-label", (_c = {}, _c[baseClassName$1 + "-is-disabled"] = buttonIsDisabled, _c)), "data-test-selector": TestSelector$7.Label },
                    "\u00A0",
                    hidden ? 'SHOW' : 'HIDE')))));
    };
    return MaskedInput;
})();

var css_248z$f = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-panel {\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border: 1px solid #dee0e3;\n  border-radius: 3pt;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.13);\n  flex-grow: 1;\n}\n.tb-panel-content {\n  padding: 20px;\n}\n.tb-panel-content-step {\n  padding-bottom: 15px;\n}\n.tb-panel-is-dirty {\n  background-color: #fffbf5;\n  border: 1px solid #fdb100;\n}\n.tb-panel-header {\n  width: 100%;\n  background-color: #f5f6f7;\n  border-bottom: 1px solid #dee0e3;\n  border-top-left-radius: 3pt;\n  border-top-right-radius: 3pt;\n  padding: 10px 20px;\n  display: flex;\n  flex-direction: row;\n  align-self: center;\n  justify-content: space-between;\n}\n.tb-panel-header-actions {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n}\n.tb-panel-header-actions button {\n  margin-left: 10px;\n}\n.tb-panel-header-save-status {\n  margin-right: 10px;\n}\n.tb-panel-header-title {\n  padding-right: 10px;\n  display: inline-flex;\n}\n.tb-panel-header-title-label {\n  align-self: center;\n  padding-right: 6px;\n  font-size: 0.83em;\n  font-weight: bold;\n}\n.tb-panel-tabs {\n  padding: 10px 0 0 0;\n}\n.tb-panel-tabs-content {\n  padding: 20px;\n}\n.tb-panel-is-alone:not(:first-child) {\n  margin-top: 30px;\n}\n.tb-panel-discard {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  background-color: #fdb100;\n  border-bottom-left-radius: 3pt;\n  border-bottom-right-radius: 3pt;\n  padding: 5px 12px;\n}\n.tb-panel-discard-modified {\n  color: white;\n  font-style: italic;\n  font-size: 0.8em;\n  margin-right: auto;\n}\n.tb-panel-discard-controls {\n  margin-left: auto;\n}\n";
styleInject(css_248z$f);

var Panel = /* #__PURE__ */ (function () {
    var Panel = basicComponent({ dirty: 'tb-panel-is-dirty', alone: 'tb-panel-is-alone' }, 'Panel', 'tb-panel');
    return Panel;
})();

var Column = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(Column, _super);
            function Column() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.render = function () { return null; };
                return _this;
            }
            return Column;
        }(React.PureComponent)),
        /* eslint react/no-unused-prop-types: 0 */
        _a.propTypes = {
            header: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]),
            accessor: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
            cell: PropTypes.func,
            sortable: PropTypes.bool,
            sortOrder: PropTypes.oneOf(['descending', 'ascending']),
            className: PropTypes.string,
            empty: PropTypes.string,
        },
        _a.defaultProps = {
            header: undefined,
            sortable: false,
            sortOrder: undefined,
            cell: undefined,
            className: '',
            accessor: function () { return undefined; },
            empty: undefined,
        },
        _a;
})();

var css_248z$e = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-table {\n  width: 100%;\n  max-width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n.tb-table-header {\n  border-bottom: 2px solid #d7dbdb;\n  padding: 10px;\n  text-align: left;\n}\n.tb-table-header-is-sortable {\n  color: inherit;\n  text-decoration: none;\n  cursor: pointer;\n}\n.tb-table-header-is-sortable > div {\n  vertical-align: middle;\n}\n.tb-table-header-is-sortable:hover,\n.tb-table-header-is-sortable:focus {\n  color: inherit;\n  outline: none;\n  text-decoration: none;\n}\n.tb-table-header-is-sortable::after {\n  content: '\\f0d8';\n  color: #dee0e3;\n  min-width: 1em;\n  display: inline-block;\n  font-family: FontAwesome;\n  margin-left: 4px;\n}\n.tb-table-header-is-sortable:hover::after {\n  color: #494747;\n}\n.tb-table-header-is-ascending::after {\n  content: '\\f0d7';\n  color: #2469BE;\n}\n.tb-table-header-is-descending::after {\n  content: '\\f0d8';\n  color: #2469BE;\n}\n.tb-table-cell {\n  border-bottom: 1px solid #d7dbdb;\n  padding: 10px;\n}\n.tb-table-row-is-clickable {\n  cursor: pointer;\n}\n.tb-table-row-is-clickable:hover {\n  background: #ebebed;\n}\n.tb-table-is-no-head {\n  margin-top: -10px;\n}\n.tb-table-warning-icon {\n  padding-right: 5px;\n  color: #fc3613;\n}\n.tb-table-has-top-margin {\n  margin-top: 20px;\n}\n.tb-table-has-no-margin {\n  margin: 0;\n}\n";
styleInject(css_248z$e);

var CellHeader = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(CellHeader, _super);
            function CellHeader() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            CellHeader.prototype.render = function () {
                var _a = this.props, sortable = _a.sortable, children = _a.children, sortOrder = _a.sortOrder, onClick = _a.onClick, className = _a.className, rest = __rest(_a, ["sortable", "children", "sortOrder", "onClick", "className"]);
                return (React.createElement("th", __assign({ className: classNames('tb-table-header', className) }, passThroughProps(rest)), sortable ? (React.createElement("a", { role: "button", tabIndex: 0, onClick: onClick, className: classNames('tb-table-header-is-sortable', {
                        'tb-table-header-is-descending': sortOrder === 'descending',
                        'tb-table-header-is-ascending': sortOrder === 'ascending',
                    }) }, children)) : (children)));
            };
            return CellHeader;
        }(PureComponent)),
        _a.propTypes = {
            children: PropTypes.node,
            className: PropTypes.string,
            onClick: PropTypes.func,
            sortable: PropTypes.bool,
            sortOrder: PropTypes.oneOf(['ascending', 'descending']),
        },
        _a.defaultProps = {
            children: null,
            className: '',
            sortable: false,
            sortOrder: undefined,
            onClick: function () { },
        },
        _a;
})();

var Cell = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(Cell, _super);
            function Cell() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Cell.prototype.render = function () {
                var _a = this.props, children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
                return (React.createElement("td", __assign({ className: classNames('tb-table-cell', className) }, passThroughProps(rest)), children));
            };
            return Cell;
        }(PureComponent)),
        _a.propTypes = {
            children: PropTypes.node,
            className: PropTypes.string,
        },
        _a.defaultProps = {
            children: null,
            className: '',
        },
        _a;
})();

var Empty = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(Empty, _super);
            function Empty() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Empty.prototype.render = function () {
                var _a = this.props, children = _a.children, text = _a.text, rest = __rest(_a, ["children", "text"]);
                return (React.createElement("div", __assign({ className: "tb-table-empty-container well text-center" }, passThroughProps(rest)), children || React.createElement("em", null, text)));
            };
            return Empty;
        }(PureComponent)),
        _a.propTypes = {
            text: PropTypes.string,
            children: PropTypes.node,
        },
        _a.defaultProps = {
            text: undefined,
            children: undefined,
        },
        _a;
})();

var TablePropTypes = {
    propTypes: {
        children: PropTypes.node.isRequired,
        data: PropTypes.arrayOf(PropTypes.object).isRequired,
        sortOverride: PropTypes.func,
        className: PropTypes.string,
        tableClassName: PropTypes.string,
        headerRowClassName: PropTypes.string,
        headerCellClassName: PropTypes.string,
        rowClassName: PropTypes.func,
        rowOnClick: PropTypes.func,
        empty: PropTypes.node,
        hasHeader: PropTypes.bool,
        rowKey: PropTypes.func,
    },
    defaultPropTypes: {
        sortOverride: null,
        className: '',
        tableClassName: classNames('tb-table', 'tb-table-has-no-margin'),
        headerRowClassName: '',
        headerCellClassName: '',
        rowClassName: function () { return ''; },
        rowOnClick: undefined,
        empty: null,
        hasHeader: true,
        rowKey: function (datum, rowIndex) { return rowIndex; },
    },
    paginatedPropTypes: {
        pageSize: PropTypes.number,
    },
    serverPaginatedPropTypes: {
        onPrevPageClick: PropTypes.func,
        onNextPageClick: PropTypes.func,
        prev: PropTypes.string,
        next: PropTypes.string,
    },
    defaultPaginatedPropTypes: {
        pageSize: 0, // turns off the pagination
    },
    defaultServerPaginatedPropTypes: {
        onPrevPageClick: function () { },
        onNextPageClick: function () { },
        prev: null,
        next: null,
    },
};

function normalizeAccessor(accessor) {
    if (typeof accessor === 'string') {
        if (accessor.includes('.')) {
            var accessorArr_1 = accessor.split('.');
            return function (data) { return accessorArr_1.reduce(function (obj, access) { return obj[access]; }, data); };
        }
        return function (data) { return data[accessor]; };
    }
    return accessor;
}
var TablePlain = /* #__PURE__ */ (function () { var _a; return _a = /** @class */ (function (_super) {
        __extends(TablePlain, _super);
        function TablePlain() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                sortColumnId: undefined,
                sortValueAccessor: undefined,
                sortOrder: undefined,
            };
            _this.sortData = function (data) {
                var sortedData = data;
                if (_this.state.sortValueAccessor) {
                    sortedData = data.sort(function (a, b) {
                        var comparison;
                        if (typeof _this.state.sortValueAccessor === 'function') {
                            var sortValA = _this.state.sortValueAccessor(a);
                            var sortValB = _this.state.sortValueAccessor(b);
                            comparison = sortValA < sortValB;
                            if (sortValA && typeof sortValA === 'string') {
                                comparison = sortValA.toLowerCase() < sortValB.toLowerCase();
                            }
                        }
                        var sort = comparison ? -1 : 1;
                        if (_this.state.sortOrder === 'ascending') {
                            sort = -sort;
                        }
                        return sort;
                    });
                }
                return sortedData;
            };
            return _this;
        }
        TablePlain.prototype.render = function () {
            var _this = this;
            var _a = this.props, children = _a.children, data = _a.data, sortOverride = _a.sortOverride, className = _a.className, tableClassName = _a.tableClassName, headerRowClassName = _a.headerRowClassName, headerCellClassName = _a.headerCellClassName, rowClassName = _a.rowClassName, rowOnClick = _a.rowOnClick, empty = _a.empty, hasHeader = _a.hasHeader, rowKey = _a.rowKey, rest = __rest(_a, ["children", "data", "sortOverride", "className", "tableClassName", "headerRowClassName", "headerCellClassName", "rowClassName", "rowOnClick", "empty", "hasHeader", "rowKey"]);
            var _b = this.state, sortColumnId = _b.sortColumnId, sortOrder = _b.sortOrder;
            var childrenArray = React.Children.toArray(children);
            var columns = childrenArray.reduce(function (acc, child) {
                if (!React.isValidElement(child)) {
                    return acc;
                }
                acc.push(__assign(__assign({}, child.props), { 
                    // Normalize the accessor (as it can be either a string or a function)
                    // so that when we iterate over the array of data we have a consistent
                    // method to access the data, and don't have to switch logic depending
                    // on if it's a string or a function.
                    accessor: normalizeAccessor(child.props.accessor), 
                    // We're caching the originalAccessor as well so we can use it as an
                    // unique way to identify a column. For example when a user sorts
                    // a column we need to track which column is being sorted.
                    // Rather than add an additional prop of `id` we're using the original
                    // accessor value as our way to uniquely identify a column.
                    originalAccessor: child.props.accessor }));
                return acc;
            }, []);
            var sortedData = this.sortData(data);
            var emptyProps = {};
            if (typeof empty === 'string') {
                emptyProps.text = empty;
            }
            else if (empty != null) {
                emptyProps.children = empty;
            }
            return (React.createElement("div", __assign({}, passThroughProps(rest)),
                React.createElement("table", { className: classNames(tableClassName, className) },
                    hasHeader && (React.createElement("thead", null,
                        React.createElement("tr", { className: headerRowClassName }, columns &&
                            columns.map(function (column, columnIndex) {
                                if (typeof column.header === 'object') {
                                    return column.header;
                                }
                                var columnSortOrder;
                                if (column.sortOrder) {
                                    columnSortOrder = column.sortOrder;
                                }
                                else {
                                    columnSortOrder = sortColumnId === column.originalAccessor ? sortOrder : null;
                                }
                                var cellHeaderProps = {
                                    className: classNames(headerCellClassName, column.className),
                                    sortable: column.sortable,
                                    sortOrder: columnSortOrder,
                                    onClick: function () {
                                        if (sortOverride) {
                                            sortOverride(column);
                                        }
                                        else {
                                            _this.setState({
                                                sortColumnId: column.originalAccessor,
                                                sortValueAccessor: column.accessor,
                                                sortOrder: sortOrder === 'descending' ? 'ascending' : 'descending',
                                            });
                                        }
                                    },
                                };
                                if (typeof column.header === 'function') {
                                    return column.header(cellHeaderProps);
                                }
                                return (React.createElement(CellHeader, __assign({}, cellHeaderProps, { key: column.header || columnIndex }), column.header));
                            })))),
                    React.createElement("tbody", null, sortedData.map(function (datum, rowIndex) { return (React.createElement("tr", { key: rowKey(datum, rowIndex), className: classNames(rowClassName(datum), { 'tb-table-row-is-clickable': rowOnClick != null }), onClick: rowOnClick ? function (e) { return rowOnClick(datum, e); } : undefined }, columns.map(function (column, index) {
                        var value = column.accessor(datum);
                        if (typeof column.cell === 'function') {
                            return column.cell({
                                column: column,
                                data: datum,
                                value: value,
                            });
                        }
                        var child = value != null ? value.toString() : column.empty;
                        // eslint-disable-next-line react/no-array-index-key
                        return React.createElement(Cell, { key: index }, child);
                    }))); }))),
                data.length === 0 && empty && React.createElement(Empty, __assign({}, emptyProps))));
        };
        return TablePlain;
    }(Component)),
    _a.propTypes = __assign({}, TablePropTypes.propTypes),
    _a.defaultProps = __assign({}, TablePropTypes.defaultPropTypes),
    _a; })();

var css_248z$d = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-paginator {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0px;\n  border-bottom: 2px solid #ebebed;\n  border-top: 2px solid #ebebed;\n}\n.tb-paginator-is-borderless {\n  border: 0;\n  padding: 30px;\n}\n.tb-paginator-control {\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  color: #615f5f;\n}\n.tb-paginator-control-is-disabled {\n  color: #a09f9e;\n}\n.tb-paginator-button-is-previous {\n  padding: 0px 12px 0px 10px;\n  margin-right: 10px;\n}\n.tb-paginator-button-is-next {\n  padding: 0px 10px 0px 12px;\n  margin-left: 10px;\n}\n";
styleInject(css_248z$d);

var TestSelector$6;
(function (TestSelector) {
    TestSelector["PreviousButton"] = "previous-button";
    TestSelector["NextButton"] = "next-button";
})(TestSelector$6 || (TestSelector$6 = {}));
var TablePaginator = /* #__PURE__ */ (function () {
    var TablePaginator = function (_a) {
        var hasPreviousPage = _a.hasPreviousPage, getPreviousPage = _a.getPreviousPage, hasNextPage = _a.hasNextPage, getNextPage = _a.getNextPage, startRange = _a.startRange, endRange = _a.endRange, totalRange = _a.totalRange, rest = __rest(_a, ["hasPreviousPage", "getPreviousPage", "hasNextPage", "getNextPage", "startRange", "endRange", "totalRange"]);
        return (React.createElement("div", __assign({ className: 'tb-paginator' }, passThroughProps(rest)),
            React.createElement("span", { className: classNames('tb-paginator-control', {
                    'tb-paginator-control-is-disabled': !hasPreviousPage,
                }) },
                React.createElement(Button, { className: "tb-paginator-button-is-previous", "data-test-selector": TestSelector$6.PreviousButton, variant: "primary", disabled: !hasPreviousPage, onClick: getPreviousPage },
                    React.createElement("i", { className: "fa fa-angle-left" })),
                "Previous"),
            totalRange && (React.createElement("span", { className: 'tb-paginator-text' },
                React.createElement("strong", null, startRange),
                " to ",
                React.createElement("strong", null, endRange),
                " of ",
                React.createElement("strong", null, totalRange))),
            React.createElement("span", { className: classNames('tb-paginator-control', {
                    'tb-paginator-control-is-disabled': !hasNextPage,
                }) },
                "Next",
                React.createElement(Button, { className: "tb-paginator-button-is-next", "data-test-selector": TestSelector$6.NextButton, variant: "primary", disabled: !hasNextPage, onClick: getNextPage },
                    React.createElement("i", { className: "fa fa-angle-right" })))));
    };
    TablePaginator.propTypes = {
        hasPreviousPage: PropTypes.bool.isRequired,
        getPreviousPage: PropTypes.func.isRequired,
        hasNextPage: PropTypes.bool.isRequired,
        getNextPage: PropTypes.func.isRequired,
        startRange: PropTypes.number,
        endRange: PropTypes.number,
        totalRange: PropTypes.number,
    };
    TablePaginator.defaultProps = {
        startRange: null,
        endRange: null,
        totalRange: null,
    };
    return TablePaginator;
})();

var TablePaginated = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(TablePaginated, _super);
            function TablePaginated() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.state = {
                    columnSortMap: {},
                    currentData: [],
                    currentPage: 0,
                    currentRange: 0,
                    sortedData: _this.props.data,
                };
                _this.getFirstPage = function () {
                    _this.goToPage(0);
                };
                _this.getNextPage = function () {
                    _this.goToPage(_this.state.currentPage + 1);
                };
                _this.getPreviousPage = function () {
                    _this.goToPage(_this.state.currentPage - 1);
                };
                _this.goToPage = function (pageNumber) {
                    var pageSize = _this.props.pageSize;
                    var sortedData = _this.state.sortedData;
                    var newRange = pageNumber * pageSize;
                    _this.setState({
                        currentData: sortedData.slice(newRange, newRange + pageSize),
                        currentPage: pageNumber,
                        currentRange: newRange,
                    });
                };
                _this.sortData = function (column) {
                    var _a;
                    var data = _this.props.data;
                    var columnSortMap = _this.state.columnSortMap;
                    var columnId = column.originalAccessor;
                    var sortOrder = columnSortMap[columnId] === 'descending' ? 'ascending' : 'descending';
                    var sortedData = data.sort(function (a, b) {
                        var sort = column.accessor(a) < column.accessor(b) ? -1 : 1;
                        if (sortOrder === 'ascending') {
                            sort = -sort;
                        }
                        return sort;
                    });
                    _this.setState({
                        sortedData: sortedData,
                        columnSortMap: __assign(__assign({}, columnSortMap), (_a = {}, _a[columnId] = sortOrder, _a)),
                    }, function () {
                        _this.goToPage(_this.state.currentPage);
                    });
                };
                return _this;
            }
            TablePaginated.prototype.componentDidMount = function () {
                this.goToPage(0);
            };
            TablePaginated.getDerivedStateFromProps = function (props, state) {
                if (props.data !== state.sortedData) {
                    return { sortedData: props.data };
                }
                return null;
            };
            TablePaginated.prototype.componentDidUpdate = function (prevProps) {
                if (prevProps.data !== this.props.data) {
                    this.getFirstPage();
                }
            };
            TablePaginated.prototype.render = function () {
                var _a = this.props, children = _a.children, pageSize = _a.pageSize, tableClassName = _a.tableClassName, headerRowClassName = _a.headerRowClassName, rowClassName = _a.rowClassName, rest = __rest(_a, ["children", "pageSize", "tableClassName", "headerRowClassName", "rowClassName"]);
                var _b = this.state, currentData = _b.currentData, currentRange = _b.currentRange, sortedData = _b.sortedData;
                var endOfCurrentRange = currentRange + pageSize < sortedData.length ? currentRange + pageSize - 1 : sortedData.length - 1;
                var hasNextPage = sortedData.length - 1 > endOfCurrentRange;
                var hasPreviousPage = this.state.currentRange > 0;
                return (React.createElement("div", __assign({}, passThroughProps(rest)),
                    React.createElement(TablePlain, { data: currentData, tableClassName: tableClassName, headerRowClassName: headerRowClassName, rowClassName: rowClassName, sortOverride: this.sortData }, children),
                    React.createElement(TablePaginator, { hasPreviousPage: hasPreviousPage, getPreviousPage: this.getPreviousPage, hasNextPage: hasNextPage, getNextPage: this.getNextPage, startRange: currentRange + 1, endRange: endOfCurrentRange + 1, totalRange: sortedData.length })));
            };
            return TablePaginated;
        }(Component)),
        _a.propTypes = __assign(__assign({}, TablePropTypes.propTypes), TablePropTypes.paginatedPropTypes),
        _a.defaultProps = __assign(__assign({}, TablePropTypes.defaultPropTypes), TablePropTypes.defaultPaginatedPropTypes),
        _a;
})();

var TableServerPaginated = /* #__PURE__ */ (function () {
    function TableServerPaginated(props) {
        var children = props.children, tableClassName = props.tableClassName, headerRowClassName = props.headerRowClassName, rowClassName = props.rowClassName, onPrevPageClick = props.onPrevPageClick, onNextPageClick = props.onNextPageClick, prev = props.prev, next = props.next, data = props.data, rest = __rest(props, ["children", "tableClassName", "headerRowClassName", "rowClassName", "onPrevPageClick", "onNextPageClick", "prev", "next", "data"]);
        return (React.createElement("div", __assign({}, passThroughProps(rest)),
            React.createElement(TablePlain, { data: data, tableClassName: tableClassName, headerRowClassName: headerRowClassName, rowClassName: rowClassName }, children),
            React.createElement(TablePaginator, { hasPreviousPage: !!prev, getPreviousPage: onPrevPageClick, hasNextPage: !!next, getNextPage: onNextPageClick })));
    }
    TableServerPaginated.propTypes = __assign(__assign({}, TablePropTypes.propTypes), TablePropTypes.serverPaginatedPropTypes);
    TableServerPaginated.defaultProps = __assign(__assign({}, TablePropTypes.defaultPropTypes), TablePropTypes.defaultServerPaginatedPropTypes);
    return TableServerPaginated;
})();

var Table = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(Table, _super);
            function Table() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Table.prototype.render = function () {
                var _a = this.props, pageSize = _a.pageSize, data = _a.data, serverPagination = _a.serverPagination, forcePagination = _a.forcePagination, rest = __rest(_a, ["pageSize", "data", "serverPagination", "forcePagination"]);
                var showPagination = (pageSize > 0 && data.length > pageSize) || serverPagination || forcePagination;
                var table = React.createElement(TablePlain, __assign({}, this.props, passThroughProps(rest)));
                if (showPagination) {
                    if (serverPagination) {
                        table = React.createElement(TableServerPaginated, __assign({}, this.props, passThroughProps(rest)));
                    }
                    else {
                        table = React.createElement(TablePaginated, __assign({}, this.props, { pageSize: pageSize }, passThroughProps(rest)));
                    }
                }
                return table;
            };
            return Table;
        }(Component)),
        _a.propTypes = __assign(__assign(__assign(__assign({}, TablePropTypes.propTypes), TablePropTypes.paginatedPropTypes), TablePropTypes.serverPaginatedPropTypes), { forcePagination: PropTypes.bool, serverPagination: PropTypes.bool }),
        _a.defaultProps = __assign(__assign(__assign({}, TablePropTypes.defaultPropTypes), TablePropTypes.defaultPaginatedPropTypes), { forcePagination: false, serverPagination: false }),
        _a.Column = Column,
        _a.CellHeader = CellHeader,
        _a.Cell = Cell,
        _a.Empty = Empty,
        _a;
})();

var lastUniqueId$1 = 0;
var TextInputFormRow = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(TextInputFormRow, _super);
            function TextInputFormRow() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.id = "TextInputFormRow-" + lastUniqueId$1;
                return _this;
            }
            TextInputFormRow.prototype.componentDidMount = function () {
                lastUniqueId$1 += 1;
            };
            TextInputFormRow.prototype.render = function () {
                var _a = this.props, value = _a.value, onChange = _a.onChange, label = _a.label, placeholder = _a.placeholder, errorMessage = _a.errorMessage, readOnly = _a.readOnly, rest = __rest(_a, ["value", "onChange", "label", "placeholder", "errorMessage", "readOnly"]);
                return (React.createElement(FormRow, __assign({ errorMessage: errorMessage }, passThroughProps(rest)),
                    React.createElement(FormRowLabelGroup, null,
                        React.createElement("label", { htmlFor: this.id, className: "form-row-label" }, label)),
                    React.createElement(FormRowInputGroup, null,
                        React.createElement("input", { type: "text", id: this.id, className: classNames('tb-text-input', 'form-row-text-input', {
                                'form-row-input-error': errorMessage,
                            }), placeholder: placeholder, name: "name", value: value, onChange: function (e) { return onChange(e.target.value); }, disabled: readOnly }))));
            };
            return TextInputFormRow;
        }(React.Component)),
        _a.propTypes = {
            onChange: PropTypes.func,
            value: PropTypes.string,
            label: PropTypes.node,
            placeholder: PropTypes.string,
            errorMessage: PropTypes.string,
            readOnly: PropTypes.bool,
        },
        _a.defaultProps = {
            onChange: function () { },
            value: '',
            placeholder: '',
            label: null,
            errorMessage: undefined,
            readOnly: false,
        },
        _a;
})();

var EmptyLogsIcon = function EmptyLogsIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "59px",
    height: "55px",
    viewBox: "0 0 59 55",
    version: "1.1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00",
    transform: "translate(-753.000000, -310.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dash-overview-zero",
    transform: "translate(753.000000, 310.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,14 L24,14 L1,14 C0.44771525,14 0,13.5522847 0,13 C0,12.4477153 0.44771525,12 1,12 L58,12 C58.5522847,12 59,12.4477153 59,13 C59,13.5522847 58.5522847,14 58,14 L26,14 Z",
    id: "Combined-Shape",
    fill: "#116149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,30 L57,7 C57,4.23917118 54.761602,2 52,2 L7,2 C4.24028475,2 2,4.24028475 2,7 L2,37 C2,39.7597153 4.24028475,42 7,42 L28,42 L28,30.000355 L57,30 Z M57,30.0003072 L28,30.0047622 L28,42 L29,42 C29.5522847,42 30,42.4477153 30,43 C30,43.5522847 29.5522847,44 29,44 L28,44 L7,44 C3.13571525,44 0,40.8642847 0,37 L0,7 C0,3.13571525 3.13571525,0 7,0 L52,0 C55.8663262,0 59,3.13475628 59,7 L59,30 L59,33 C59,33.5522847 58.5522847,34 58,34 C57.4477153,34 57,33.5522847 57,33 L57,30.0003072 Z",
    id: "Combined-Shape",
    fill: "#116149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8,41.4 C52.8,37.3130985 49.4863293,34 45.4021,34 C41.3129067,34 38,37.3117627 38,41.4 C38,45.4869013 41.3136708,48.8 45.4021,48.8 C49.4855653,48.8 52.8,45.4855653 52.8,41.4 Z M54.8,41.4 C54.8,46.5901347 50.5901347,50.8 45.4021,50.8 C40.2091786,50.8 36,46.5915481 36,41.4 C36,36.2070386 40.2084918,32 45.4021,32 C50.5908215,32 54.8,36.2084517 54.8,41.4 Z",
    id: "Stroke-2333",
    fill: "#116149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6319032,48.0461168 C50.2413789,47.6555925 50.2413789,47.0224275 50.6319032,46.6319032 C51.0224275,46.2413789 51.6555925,46.2413789 52.0461168,46.6319032 L58.7073168,53.2931032 C59.0978411,53.6836275 59.0978411,54.3167925 58.7073168,54.7073168 C58.3167925,55.0978411 57.6836275,55.0978411 57.2931032,54.7073168 L50.6319032,48.0461168 Z",
    id: "Stroke-2334",
    fill: "#116149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,5.5 C7.672,5.5 7,6.172 7,7 C7,7.828 7.672,8.5 8.5,8.5 C9.328,8.5 10,7.828 10,7 C10,6.172 9.328,5.5 8.5,5.5 Z",
    id: "Shape",
    fill: "#15CC62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,5.5 C13.672,5.5 13,6.172 13,7 C13,7.828 13.672,8.5 14.5,8.5 C15.328,8.5 16,7.828 16,7 C16,6.172 15.328,5.5 14.5,5.5 Z",
    id: "Shape",
    fill: "#15CC62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,5.5 C19.672,5.5 19,6.172 19,7 C19,7.828 19.672,8.5 20.5,8.5 C21.328,8.5 22,7.828 22,7 C22,6.172 21.328,5.5 20.5,5.5 Z",
    id: "Shape",
    fill: "#15CC62"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#15CC62",
    x: "7",
    y: "19",
    width: "8",
    height: "2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-3",
    fill: "#15CC62",
    x: "7",
    y: "33",
    width: "5",
    height: "2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy",
    fill: "#116149",
    x: "24",
    y: "26",
    width: "7",
    height: "2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#116149",
    x: "19",
    y: "19",
    width: "15",
    height: "2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-4",
    fill: "#15CC62",
    x: "16",
    y: "33",
    width: "16",
    height: "2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#15CC62",
    x: "38",
    y: "19",
    width: "14",
    height: "2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-2",
    fill: "#116149",
    x: "35",
    y: "26",
    width: "17",
    height: "2",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#116149",
    x: "7",
    y: "26",
    width: "13",
    height: "2",
    rx: "1"
  })))));
};

var EmptyLogsIcon$1 = EmptyLogsIcon;

var UserIcon = function UserIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    version: "1.1",
    className: className
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "functions-3a-copy-2",
    transform: "translate(-377.000000, -843.000000)",
    fill: "#464C4F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(235.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(2.000000, 591.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(9.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(131.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.002,2.0059 C6.899,2.0059 6.002,2.9019 6.002,4.0059 C6.002,5.1089 6.899,6.0059 8.002,6.0059 C9.106,6.0059 10.002,5.1089 10.002,4.0059 C10.002,2.9019 9.106,2.0059 8.002,2.0059 M8.002,8.0059 C5.796,8.0059 4.002,6.2119 4.002,4.0059 C4.002,1.8009 5.796,0.0059 8.002,0.0059 C10.208,0.0059 12.002,1.8009 12.002,4.0059 C12.002,6.2119 10.208,8.0059 8.002,8.0059",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1611,14.0059 L13.8441,14.0059 C13.2461,12.1979 11.0111,11.0059 8.0031,11.0059 C4.9951,11.0059 2.7591,12.1979 2.1611,14.0059 L2.1611,14.0059 Z M16.0021,16.0059 L0.0021,16.0059 L0.0021,15.0059 C0.0021,11.4729 3.2921,9.0059 8.0021,9.0059 C12.7121,9.0059 16.0021,11.4729 16.0021,15.0059 L16.0021,16.0059 Z",
    id: "Fill-3"
  })))))))));
};

UserIcon.propTypes = {
  className: PropTypes.string
};
UserIcon.defaultProps = {
  className: ''
};
var UserIcon$1 = UserIcon;

var fetchInstallationInterval = 3e3;
function getToastVariantAndTitle(install) {
    switch (install.status) {
        case InstallationStatus.Created:
            return {
                variant: Variant$2.Progress,
                title: 'Installing dependencies...',
            };
        case InstallationStatus.Successful:
            return {
                variant: Variant$2.Success,
                title: 'Dependencies installed successfully',
            };
        case InstallationStatus.Failed:
            return {
                variant: Variant$2.Warning,
                title: 'Failed to install dependencies',
            };
        default:
            throw new Error("unexpected installation status: " + install.status);
    }
}
function InstallationStatusToast(_a) {
    var className = _a.className, fetchInstallation = _a.fetchInstallation, installation = _a.installation, onSuccess = _a.onSuccess;
    var poller = usePoller();
    var _b = __read$1(useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var prevInstallation = usePrevious(installation);
    var fetchInstallationWrapper = useCallback(function () {
        return fetchInstallation().catch(function (e) {
            var _a;
            if (((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status) !== 404) {
                throw e;
            }
        });
    }, [fetchInstallation]);
    React.useEffect(function () {
        fetchInstallationWrapper();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // If users dismiss the toast while the installation is in progress, we still
    // want to let them know if the installation completed successfully or not.
    React.useEffect(function () {
        if (prevInstallation && prevInstallation.status !== (installation === null || installation === void 0 ? void 0 : installation.status)) {
            setIsOpen(true);
        }
    }, [installation === null || installation === void 0 ? void 0 : installation.status, prevInstallation]);
    React.useEffect(function () {
        if ((installation === null || installation === void 0 ? void 0 : installation.status) === InstallationStatus.Created && !poller.isPolling) {
            setIsOpen(true);
            poller.start(fetchInstallationWrapper, fetchInstallationInterval);
        }
    }, [fetchInstallationWrapper, installation === null || installation === void 0 ? void 0 : installation.status, poller]);
    React.useEffect(function () {
        if (poller.isPolling && (installation === null || installation === void 0 ? void 0 : installation.status) !== InstallationStatus.Created) {
            poller.stop();
            if ((installation === null || installation === void 0 ? void 0 : installation.status) === InstallationStatus.Successful) {
                onSuccess();
            }
        }
    }, [installation === null || installation === void 0 ? void 0 : installation.status, onSuccess, poller]);
    if (!installation) {
        return null;
    }
    var _c = getToastVariantAndTitle(installation), variant = _c.variant, title = _c.title;
    return (React.createElement(Toast, { open: isOpen, className: className, close: function () { return setIsOpen(false); }, variant: variant, title: title, body: installation.statusMessage }));
}

var css_248z$c = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-edit-list {\n  min-width: 300px;\n  display: flex;\n  flex-direction: column;\n}\n.tb-edit-list-is-small {\n  width: 200px;\n}\n.tb-edit-list-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-bottom: 10px;\n}\n.tb-edit-list-dropdown {\n  position: absolute;\n  right: 15px;\n  top: 12px;\n}\n.tb-edit-list-item {\n  border-bottom: 1px solid #dee0e3;\n  padding: 15px 10px;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n}\n.tb-edit-list-item:first-child {\n  border-top: 1px solid #dee0e3;\n}\n.tb-edit-list-item:hover {\n  background-color: #f5f6f7;\n}\n.tb-edit-list-item-arrow {\n  position: absolute;\n  right: 20px;\n  font-size: 26px;\n  color: #807f7f;\n  align-self: center;\n  display: flex;\n}\n.tb-edit-list-item-arrow-hide {\n  display: none;\n}\n.tb-edit-list-item-arrow-show {\n  display: flex;\n  align-self: center;\n}\n.tb-edit-list-item-header {\n  margin-bottom: 5px;\n}\n.tb-edit-list-item-is-active {\n  background-color: #f5f6f7;\n  position: relative;\n  z-index: 3;\n}\n.tb-edit-list-item-controls {\n  margin-left: auto;\n}\n";
styleInject(css_248z$c);

var EditList = /* #__PURE__ */ (function () {
    var EditList = basicComponent({}, 'EditList', 'tb-edit-list');
    return EditList;
})();

var EditListItem = /* #__PURE__ */ (function () {
    function EditListItem(props) {
        var givenClassName = props.className;
        var newProps = __assign(__assign({}, props), { className: classNames('tb-edit-list-item', {
                'tb-edit-list-item-is-active': props.active,
            }, givenClassName) });
        var arrowClass = classNames('tb-edit-list-item-arrow', {
            'tb-edit-list-item-arrow-hide': !props.active,
            'tb-edit-list-item-arrow-show': !!props.active,
        });
        var children = props.children;
        delete newProps.active;
        delete newProps.children;
        return (React.createElement("div", __assign({}, newProps),
            React.createElement("div", { className: arrowClass },
                React.createElement("i", { className: "fa fa-angle-right" })),
            children));
    }
    EditListItem.defaultProps = {
        active: false,
        className: '',
        children: null,
    };
    EditListItem.propTypes = {
        active: PropTypes.bool,
        className: PropTypes.string,
        children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    };
    return EditListItem;
})();

var TriggerType;
(function (TriggerType) {
    TriggerType["Database"] = "DATABASE";
    TriggerType["Authentication"] = "AUTHENTICATION";
    TriggerType["Scheduled"] = "SCHEDULED";
})(TriggerType || (TriggerType = {}));
var EditEventFormVariant;
(function (EditEventFormVariant) {
    EditEventFormVariant["Atlas"] = "ATLAS";
    EditEventFormVariant["BAAS"] = "BAAS-UI";
})(EditEventFormVariant || (EditEventFormVariant = {}));
var TriggerTypeReverseMap = Object.entries(TriggerType).reduce(function (acc, _a) {
    var _b;
    var _c = __read$1(_a, 2), triggerType = _c[0], str = _c[1];
    return (__assign(__assign({}, acc), (_b = {}, _b[str] = TriggerType[triggerType], _b)));
}, {});
var toTriggerType = function (str) { return TriggerTypeReverseMap[str]; };

var ScheduleUnit;
(function (ScheduleUnit) {
    ScheduleUnit["Minute"] = "MINUTE";
    ScheduleUnit["Hour"] = "HOUR";
    ScheduleUnit["DayOfWeek"] = "DAY_OF_WEEK";
    ScheduleUnit["DayOfMonth"] = "DAY_OF_MONTH";
})(ScheduleUnit || (ScheduleUnit = {}));
var scheduleUnitOptions = [
    { label: 'Minute', value: ScheduleUnit.Minute },
    { label: 'Hour', value: ScheduleUnit.Hour },
    { label: 'Day of the Week', value: ScheduleUnit.DayOfWeek },
    { label: 'Day of the Month', value: ScheduleUnit.DayOfMonth },
];
var DayOfTheWeek;
(function (DayOfTheWeek) {
    DayOfTheWeek[DayOfTheWeek["Sunday"] = 0] = "Sunday";
    DayOfTheWeek[DayOfTheWeek["Monday"] = 1] = "Monday";
    DayOfTheWeek[DayOfTheWeek["Tuesday"] = 2] = "Tuesday";
    DayOfTheWeek[DayOfTheWeek["Wednesday"] = 3] = "Wednesday";
    DayOfTheWeek[DayOfTheWeek["Thursday"] = 4] = "Thursday";
    DayOfTheWeek[DayOfTheWeek["Friday"] = 5] = "Friday";
    DayOfTheWeek[DayOfTheWeek["Saturday"] = 6] = "Saturday";
})(DayOfTheWeek || (DayOfTheWeek = {}));
var buildDaysOfTheWeek = function () {
    var days = [];
    Object.entries(DayOfTheWeek).forEach(function (_a) {
        var _b = __read$1(_a, 2), label = _b[0], value = _b[1];
        if (typeof value === 'number') {
            days.push({ label: label, value: value });
        }
    });
    return days;
};
var dayOfWeekOptions = buildDaysOfTheWeek();
var isDayOfTheMonth = function (day) { return day > 0 && day < 32; };
var buildDaysOfTheMonth = function () {
    var days = [];
    for (var d = 1; d < 32; d += 1) {
        if (isDayOfTheMonth(d)) {
            days.push({ label: "" + d, value: d });
        }
    }
    return days;
};
var dayOfMonthOptions = buildDaysOfTheMonth();
var minuteOptions = [
    { label: '1', value: '*/1' },
    { label: '2', value: '*/2' },
    { label: '3', value: '*/3' },
    { label: '4', value: '*/4' },
    { label: '5', value: '*/5' },
    { label: '6', value: '*/6' },
    { label: '10', value: '*/10' },
    { label: '12', value: '*/12' },
    { label: '15', value: '*/15' },
    { label: '20', value: '*/20' },
    { label: '30', value: '*/30' },
];
var hourOptions = [
    { label: '1', value: '*/1' },
    { label: '2', value: '*/2' },
    { label: '3', value: '*/3' },
    { label: '4', value: '*/4' },
    { label: '6', value: '*/6' },
    { label: '8', value: '*/8' },
    { label: '12', value: '*/12' },
];
Object.entries(TriggerType).reduce(function (acc, _a) {
    var _b;
    var _c = __read$1(_a, 2), triggerType = _c[0], str = _c[1];
    return (__assign(__assign({}, acc), (_b = {}, _b[str] = TriggerType[triggerType], _b)));
}, {});
var defaultSchedule = '*/1 * * * *';
TriggerType.Database;
TriggerType.Authentication;
TriggerType.Scheduled;
var buildDbTriggerFunctionPlaceholder = function (serviceName, databaseName, collectionName) { return "exports = function(changeEvent) {\n  /*\n    A Database Trigger will always call a function with a changeEvent.\n    Documentation on ChangeEvents: https://docs.mongodb.com/manual/reference/change-events/\n\n    Access the _id of the changed document:\n    const docId = changeEvent.documentKey._id;\n\n    Access the latest version of the changed document\n    (with Full Document enabled for Insert, Update, and Replace operations):\n    const fullDocument = changeEvent.fullDocument;\n\n    const updateDescription = changeEvent.updateDescription;\n\n    See which fields were changed (if any):\n    if (updateDescription) {\n      const updatedFields = updateDescription.updatedFields; // A document containing updated fields\n    }\n\n    See which fields were removed (if any):\n    if (updateDescription) {\n      const removedFields = updateDescription.removedFields; // An array of removed fields\n    }\n\n    Functions run by Triggers are run as System users and have full access to Services, Functions, and MongoDB Data.\n\n    Access a mongodb service:\n    const collection = context.services.get(\"" + (serviceName || '<SERVICE_NAME>') + "\").db(\"" + (databaseName || '<DB_NAME>') + "\").collection(\"" + (collectionName || '<COLL_NAME>') + "\");\n    const doc = collection.findOne({ name: \"mongodb\" });\n\n    Note: In Atlas Triggers, the service name is defaulted to the cluster name.\n\n    Call other named functions if they are defined in your application:\n    const result = context.functions.execute(\"function_name\", arg1, arg2);\n\n    Access the default http client and execute a GET request:\n    const response = context.http.get({ url: <URL> })\n\n    Learn more about http client here: https://www.mongodb.com/docs/atlas/app-services/functions/context/#context-http\n  */\n};\n"; };
var DB_TRIGGER_DEBUG_PLACEHOLDER = "exports({\n  _id: { _data: '62548f79e7f11292792497cc' },\n  operationType: 'insert',\n  clusterTime: { \n    \"$timestamp\": { \n      t: 1649712420,\n      i:6 \n    } \n  },\n  ns: {\n    db: 'engineering',\n    coll: 'users'\n  },\n  documentKey: {\n    userName: 'alice123',\n    _id: { \n      \"$oid\": \"599af247bb69cd89961c986d\" \n    }\n  },\n  fullDocument: {\n    _id: { \n      \"$oid\": \"599af247bb69cd89961c986d\" \n    },\n    userName: 'alice123',\n    name: 'Alice'\n  }\n})";
var AUTH_TRIGGER_FUNCTION_PLACEHOLDER = "exports = function(authEvent) {\n  /*\n    An Authentication Trigger will always call a function with an authEvent.\n    Documentation on Triggers: https://www.mongodb.com/docs/atlas/app-services/triggers/overview/\n\n    Access the user associated with the authEvent:\n    const user = authEvent.user\n\n    Access the time the authEvent happened:\n    const time = authEvent.time\n\n    Access the operation type for the authEvent:\n    const operationType = authEvent.operationType\n\n    Access the providers associated with the authEvent:\n    const providers = authEvent.providers\n\n    Functions run by Triggers are run as System users and have full access to Services, Functions, and MongoDB Data.\n\n    Access a mongodb service:\n    const collection = context.services.get(\"<SERVICE_NAME>\").db(\"<DB_NAME>\").collection(\"<COLL_NAME>\");\n    const doc = collection.findOne({ name: \"mongodb\" });\n\n    Call other named functions if they are defined in your application:\n    const result = context.functions.execute(\"function_name\", arg1, arg2);\n\n    Access the default http client and execute a GET request:\n    const response = context.http.get({ url: <URL> })\n\n    Learn more about http client here: https://www.mongodb.com/docs/atlas/app-services/functions/context/#context-http\n  */\n};\n";
var AUTH_TRIGGER_DEBUG_PLACEHOLDER = "exports({\n  operationType: 'LOGIN',\n  providers: [{'local-userpass'}],\n  user: {\n    id: '625487ace31863f7609c55a8',\n    type: 'normal',\n  },\n  time: new Date('2022-04-11T03:00:00'),\n})";
var SCHEDULED_TRIGGER_FUNCTION_PLACEHOLDER = "exports = function() {\n  /*\n    A Scheduled Trigger will always call a function without arguments.\n    Documentation on Triggers: https://www.mongodb.com/docs/atlas/app-services/triggers/overview/\n\n    Functions run by Triggers are run as System users and have full access to Services, Functions, and MongoDB Data.\n\n    Access a mongodb service:\n    const collection = context.services.get(<SERVICE_NAME>).db(\"<DB_NAME>\").collection(\"<COLL_NAME>\");\n    const doc = collection.findOne({ name: \"mongodb\" });\n\n    Note: In Atlas Triggers, the service name is defaulted to the cluster name.\n\n    Call other named functions if they are defined in your application:\n    const result = context.functions.execute(\"function_name\", arg1, arg2);\n\n    Access the default http client and execute a GET request:\n    const response = context.http.get({ url: <URL> })\n\n    Learn more about http client here: https://www.mongodb.com/docs/atlas/app-services/functions/context/#context-http\n  */\n};\n";
var GOOGLE = 'oauth2-google';
var FACEBOOK = 'oauth2-facebook';
var APPLE = 'oauth2-apple';
var CUSTOM = 'custom-token';
var FUNCTION = 'custom-function';
var USERPASS = 'local-userpass';
var APIKEY = 'api-key';
var ANONUSER = 'anon-user';
// formatted for react-select component
var PROVIDER_OPTIONS = [
    { value: ANONUSER, label: 'Anonymous Login' },
    { value: APIKEY, label: 'API Keys' },
    { value: CUSTOM, label: 'Custom JWT Authentication' },
    { value: FUNCTION, label: 'Custom Function Authentication' },
    { value: FACEBOOK, label: 'Facebook' },
    { value: GOOGLE, label: 'Google' },
    { value: APPLE, label: 'Apple' },
    { value: USERPASS, label: 'Email/Password' },
];
var PROVIDER_OPTIONS_MAP = PROVIDER_OPTIONS.reduce(function (acc, opt) {
    var _a;
    return (__assign(__assign({}, acc), (_a = {}, _a[opt.value] = opt, _a)));
}, {});
var DEFAULT_FUNCTION_NAME = 'myFunc';

var css_248z$b = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-cron-schedule-input {\n  width: 40px;\n  margin-right: 10px;\n}\n.tb-cron-schedule-summary {\n  background-color: #ebebed;\n  padding: 20px;\n}\n.tb-cron-schedule-summary-value {\n  font-weight: 700;\n  padding: 3px 0 3px 0;\n}\n.tb-cron-schedule-basic-input-label {\n  display: block;\n  margin-top: 30px;\n}\n.tb-cron-schedule-basic-input-container {\n  display: flex;\n  margin: 5px 0 30px;\n}\n.tb-cron-schedule-basic-input-container .tb-contextual-label {\n  margin: 10px;\n}\n.tb-cron-schedule-advanced {\n  min-width: 525px;\n}\n.tb-cron-schedule-advanced-description {\n  display: block;\n}\n.tb-cron-schedule-advanced-input {\n  display: flex;\n  flex-direction: column;\n}\n.tb-cron-schedule-advanced-input input {\n  max-width: 65%;\n}\n.tb-cron-schedule-advanced-input span {\n  padding: 10px 0 10px 0;\n}\n.tb-cron-schedule-advanced-display {\n  display: flex;\n  justify-content: space-between;\n  margin: 10px 0 20px 0;\n}\n.tb-schedule-segment {\n  flex-grow: 1;\n}\n.tb-schedule-segment-value {\n  padding: 10px;\n}\n.tb-schedule-segment-value:first-child {\n  font-weight: bold;\n}\n.tb-schedule-segment-value:nth-child(2) {\n  border: 1px solid #ebebed;\n}\n.tb-schedule-segment.invalid .tb-schedule-segment-value:nth-child(2) {\n  border: 1px solid red;\n}\n.tb-schedule-segment-value-disabled {\n  background-color: #F5F6F7;\n  color: #9FA1A2;\n}\n";
styleInject(css_248z$b);

var scheduleIsValid = function (schedule) {
    try {
        CronParser.parseExpression("0 " + schedule);
    }
    catch (err) {
        return false;
    }
    return true;
};
var minutesAreVAlid = function (minutes) { return scheduleIsValid(minutes + " * * * *"); };
var hoursAreValid = function (hours) { return scheduleIsValid(" * " + hours + " * * *"); };
var dayOfMonthIsValid = function (dayOfMonth) { return scheduleIsValid("* * " + dayOfMonth + " * *"); };
var monthIsValid = function (month) { return scheduleIsValid("* * * " + month + " *"); };
var dayOfWeekIsValid = function (dayOfWeek) { return scheduleIsValid("* * * * " + dayOfWeek); };
var ScheduleSegment = function (_a) {
    var value = _a.value, children = _a.children, disabled = _a.disabled, validate = _a.validate;
    return (React.createElement("div", { className: classNames('tb-schedule-segment', { invalid: !validate(value) }) },
        React.createElement("div", { className: "tb-schedule-segment-value" }, children),
        React.createElement("div", { className: classNames('tb-schedule-segment-value', { 'tb-schedule-segment-value-disabled': disabled }) }, value || '*')));
};
ScheduleSegment.defaultProps = {
    value: '*',
    disabled: false,
    validate: function () { return true; },
};
var CronScheduleAdvancedInput = /* #__PURE__ */ (function () {
    var CronScheduleAdvancedInput = function (_a) {
        var isReadOnly = _a.isReadOnly, value = _a.value, onChange = _a.onChange, rest = __rest(_a, ["isReadOnly", "value", "onChange"]);
        var _b = __read$1(value.trim().split(' '), 5), minutes = _b[0], hours = _b[1], dayOfMonth = _b[2], month = _b[3], dayOfWeek = _b[4];
        return (React.createElement("div", __assign({ className: "tb-cron-schedule-advanced" }, passThroughProps(rest)),
            React.createElement("div", { className: "tb-cron-schedule-advanced-input" },
                React.createElement("span", null,
                    "Set a CRON schedule.\u00A0",
                    React.createElement("a", { href: "https://en.wikipedia.org/wiki/Cron#CRON_expression", target: "_blank", rel: "noopener noreferrer" }, "Learn about CRON expressions")),
                React.createElement("input", { className: "tb-text-input form-row-text-input", name: "advancedSchedule", readOnly: isReadOnly, type: "text", placeholder: "* * * * *", value: value, onChange: function (e) { return onChange(e.target.value); } })),
            React.createElement("div", { className: "tb-cron-schedule-advanced-display" },
                React.createElement(ScheduleSegment, { value: minutes, validate: minutesAreVAlid }, "Minutes"),
                React.createElement(ScheduleSegment, { value: hours, validate: hoursAreValid }, "Hours"),
                React.createElement(ScheduleSegment, { value: dayOfMonth, validate: dayOfMonthIsValid }, "Day of Month"),
                React.createElement(ScheduleSegment, { value: month, validate: monthIsValid }, "Month"),
                React.createElement(ScheduleSegment, { value: dayOfWeek, validate: dayOfWeekIsValid }, "Day of Week"))));
    };
    CronScheduleAdvancedInput.defaultProps = {
        isReadOnly: false,
    };
    return CronScheduleAdvancedInput;
})();

var customSelectStyles$1 = mergeSelectStyles({
    control: function (base) { return (__assign(__assign({}, base), { width: '175px' })); },
    menu: function (base) { return (__assign(__assign({}, base), { width: '175px' })); },
});
var CronScheduleBasicInput = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(CronScheduleBasicInput, _super);
            function CronScheduleBasicInput(props) {
                var _this = _super.call(this, props) || this;
                _this.onSelectScheduleUnit = _this.onSelectScheduleUnit.bind(_this);
                _this.onSelectFrequency = _this.onSelectFrequency.bind(_this);
                _this.onChange = _this.onChange.bind(_this);
                return _this;
            }
            CronScheduleBasicInput.prototype.onSelectScheduleUnit = function (scheduleUnit) {
                switch (scheduleUnit.value) {
                    case ScheduleUnit.Minute:
                        this.onChange(scheduleUnit.value, minuteOptions[0]);
                        return;
                    case ScheduleUnit.Hour:
                        this.onChange(scheduleUnit.value, hourOptions[0]);
                        return;
                    case ScheduleUnit.DayOfWeek:
                        this.onChange(scheduleUnit.value, dayOfWeekOptions[0]);
                        return;
                    case ScheduleUnit.DayOfMonth:
                        this.onChange(scheduleUnit.value, dayOfMonthOptions[0]);
                        break;
                }
            };
            CronScheduleBasicInput.prototype.onSelectFrequency = function (frequency) {
                var scheduleUnit = this.parseExpression().scheduleUnit;
                this.onChange(scheduleUnit, frequency);
            };
            CronScheduleBasicInput.prototype.onChange = function (scheduleUnit, frequency) {
                var cronExp = defaultSchedule;
                switch (scheduleUnit) {
                    case ScheduleUnit.Minute:
                        cronExp = frequency.value + " * * * *";
                        break;
                    case ScheduleUnit.Hour:
                        cronExp = "0 " + frequency.value + " * * *";
                        break;
                    case ScheduleUnit.DayOfWeek:
                        cronExp = "0 0 * * " + frequency.value;
                        break;
                    case ScheduleUnit.DayOfMonth:
                        cronExp = "0 0 " + frequency.value + " * *";
                        break;
                }
                this.props.onChange(cronExp);
            };
            CronScheduleBasicInput.prototype.parseExpression = function () {
                var value = this.props.value;
                var _a = __read$1(value.trim().split(' '), 5), minutes = _a[0], hours = _a[1], dayOfMonth = _a[2], dayOfWeek = _a[4];
                var scheduleUnit = ScheduleUnit.Minute;
                var frequencyOption = minuteOptions[0];
                if (minutes !== '*') {
                    var selectedOption = minuteOptions.find(function (option) { return option.value === minutes; });
                    if (selectedOption) {
                        frequencyOption = selectedOption;
                        scheduleUnit = ScheduleUnit.Minute;
                    }
                }
                if (hours !== '*') {
                    var selectedOption = hourOptions.find(function (option) { return option.value === hours; });
                    if (selectedOption) {
                        frequencyOption = selectedOption;
                        scheduleUnit = ScheduleUnit.Hour;
                    }
                }
                if (dayOfWeek !== '*') {
                    var selectedOption = dayOfWeekOptions.find(function (option) { return option.value === parseInt(dayOfWeek, 10); });
                    if (selectedOption) {
                        frequencyOption = selectedOption;
                        scheduleUnit = ScheduleUnit.DayOfWeek;
                    }
                }
                if (dayOfMonth !== '*') {
                    var selectedOption = dayOfMonthOptions.find(function (option) { return option.value === parseInt(dayOfMonth, 10); });
                    if (selectedOption) {
                        frequencyOption = selectedOption;
                        scheduleUnit = ScheduleUnit.DayOfMonth;
                    }
                }
                return { frequencyOption: frequencyOption, scheduleUnit: scheduleUnit };
            };
            CronScheduleBasicInput.prototype.render = function () {
                var _a = this.parseExpression(), frequencyOption = _a.frequencyOption, scheduleUnit = _a.scheduleUnit;
                var frequencyOptions = [];
                var separatorString = '';
                var unitLabelString = '';
                switch (scheduleUnit) {
                    case ScheduleUnit.Minute:
                        frequencyOptions = minuteOptions;
                        separatorString = 'every';
                        unitLabelString = 'minute(s)';
                        break;
                    case ScheduleUnit.Hour:
                        frequencyOptions = hourOptions;
                        separatorString = 'every';
                        unitLabelString = 'hour(s)';
                        break;
                    case ScheduleUnit.DayOfWeek:
                        frequencyOptions = dayOfWeekOptions;
                        separatorString = 'on';
                        break;
                    case ScheduleUnit.DayOfMonth:
                        frequencyOptions = dayOfMonthOptions;
                        separatorString = 'on';
                        break;
                }
                var _b = this.props, isReadOnly = _b.isReadOnly, rest = __rest(_b, ["isReadOnly"]);
                return (React.createElement("div", __assign({}, passThroughProps(rest)),
                    React.createElement("div", { className: "tb-cron-schedule-basic-input-label" }, "Repeat once by:"),
                    React.createElement("div", { className: "tb-cron-schedule-basic-input-container" },
                        React.createElement(Select$1, { isDisabled: isReadOnly, name: "schedule-unit", onChange: this.onSelectScheduleUnit, options: scheduleUnitOptions, value: scheduleUnitOptions.find(function (option) { return option.value === scheduleUnit; }), styles: customSelectStyles$1 }),
                        React.createElement("span", { className: "tb-contextual-label" }, separatorString),
                        React.createElement(Select$1, { isDisabled: isReadOnly, name: "schedule-frequency", onChange: this.onSelectFrequency, options: frequencyOptions, value: frequencyOption, styles: customSelectStyles$1 }),
                        unitLabelString && React.createElement("span", { className: "tb-contextual-label" }, unitLabelString))));
            };
            return CronScheduleBasicInput;
        }(React.Component)),
        _a.defaultProps = {
            isReadOnly: false,
            value: defaultSchedule,
        },
        _a;
})();

var CronScheduleInput = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(CronScheduleInput, _super);
            function CronScheduleInput(props) {
                var _this = _super.call(this, props) || this;
                _this.onScheduleChange = _this.onScheduleChange.bind(_this);
                _this.onScheduleTypeChange = _this.onScheduleTypeChange.bind(_this);
                return _this;
            }
            CronScheduleInput.prototype.onScheduleChange = function (schedule) {
                var _a = this.props, onScheduleChange = _a.onScheduleChange, _b = _a.scheduleType, scheduleType = _b === void 0 ? 'BASIC' : _b;
                onScheduleChange(schedule, scheduleType);
            };
            CronScheduleInput.prototype.onScheduleTypeChange = function (newScheduleType) {
                var _a = this.props, scheduleType = _a.scheduleType, onScheduleChange = _a.onScheduleChange, currentSchedule = _a.schedule;
                var schedule = currentSchedule;
                if (scheduleType === 'ADVANCED' && newScheduleType === 'BASIC') {
                    schedule = defaultSchedule;
                }
                onScheduleChange(schedule, newScheduleType);
            };
            CronScheduleInput.prototype.render = function () {
                var _this = this;
                var _a = this.props, isReadOnly = _a.isReadOnly, schedule = _a.schedule, scheduleType = _a.scheduleType, rest = __rest(_a, ["isReadOnly", "schedule", "scheduleType"]);
                var nextEvents = [];
                if (schedule) {
                    try {
                        var expression = CronParser.parseExpression("0 " + schedule, { utc: true });
                        nextEvents = [
                            expression.next().toString(),
                            expression.next().toString(),
                            expression.next().toString(),
                            '...',
                        ];
                    }
                    catch (err) {
                        nextEvents = ['Invalid Schedule'];
                    }
                }
                return (React.createElement(FormRow, __assign({}, passThroughProps(rest)),
                    React.createElement(FormRowLabelGroup, { alignTop: true },
                        React.createElement("label", { htmlFor: "schedule", className: "form-row-label" }, "Schedule Type"),
                        React.createElement("p", { className: "form-row-description" },
                            React.createElement("a", { href: "https://www.mongodb.com/docs/atlas/app-services/triggers/", target: "_blank", rel: "noopener noreferrer" }, "Learn more about Scheduled Triggers."))),
                    React.createElement(FormRowInputGroup, null,
                        React.createElement(RadioBoxGroup, { size: "full", value: scheduleType },
                            React.createElement(RadioBox, { "data-id": "scheduleInputBasic", checked: scheduleType === 'BASIC', disabled: isReadOnly, onClick: function () { return _this.onScheduleTypeChange('BASIC'); }, value: "BASIC" }, "Basic"),
                            React.createElement(RadioBox, { "data-id": "scheduleInputAdvanced", checked: scheduleType === 'ADVANCED', disabled: isReadOnly, onClick: function () { return _this.onScheduleTypeChange('ADVANCED'); }, type: "string", value: "ADVANCED" }, "Advanced")),
                        scheduleType === 'BASIC' && (React.createElement(CronScheduleBasicInput, { isReadOnly: isReadOnly, value: schedule, onChange: this.onScheduleChange })),
                        scheduleType === 'ADVANCED' && (React.createElement(CronScheduleAdvancedInput, { isReadOnly: isReadOnly, value: schedule, onChange: this.onScheduleChange })),
                        React.createElement("div", { className: "tb-cron-schedule-summary" },
                            "Next Events: ",
                            nextEvents.length === 0 && React.createElement("span", { className: "tb-cron-schedule-summary-value" }, "--"),
                            nextEvents.map(function (nextEvent) { return (React.createElement("div", { key: nextEvent, className: "tb-cron-schedule-summary-value" }, nextEvent)); })))));
            };
            return CronScheduleInput;
        }(React.Component)),
        _a.defaultProps = {
            isReadOnly: false,
            schedule: defaultSchedule,
        },
        _a;
})();

var FunctionEditor = loadable(function () { return import('./FunctionEditor-9e94f901.js'); });

var css_248z$a = ".function-editor-form-row-read-only-container {\n  padding-top: 20px;\n  height: calc(100vh - 210px);\n  min-height: 300px;\n}\n.function-editor-form-row-add-dependency-button {\n  justify-content: flex-end;\n  display: flex;\n}\n";
styleInject(css_248z$a);

var FunctionEditorFormRow = /* #__PURE__ */ (function () {
    var FunctionEditorFormRow = function (_a) {
        var _b;
        var errorMessage = _a.errorMessage, formRowDescription = _a.formRowDescription, functionEditorProps = _a.functionEditorProps, functionData = _a.functionData, isReadOnly = _a.isReadOnly, nested = _a.nested, onDataChange = _a.onDataChange, toggleFullscreen = _a.toggleFullscreen, withDebugger = _a.withDebugger, rest = __rest(_a, ["errorMessage", "formRowDescription", "functionEditorProps", "functionData", "isReadOnly", "nested", "onDataChange", "toggleFullscreen", "withDebugger"]);
        var _c = __read$1(useState(false), 2), addDependencyDialogIsOpen = _c[0], setAddDependencyDialogIsOpen = _c[1];
        return (React.createElement(FormRow, __assign({ nested: nested, errorMessage: errorMessage }, passThroughProps(rest)),
            React.createElement(FormRowLabelGroup, { wide: true },
                React.createElement("label", { htmlFor: "functionSource", className: "form-row-label" }, "Function"),
                React.createElement("p", { className: "form-row-description" }, formRowDescription)),
            React.createElement(FormRowInputGroup, null, withDebugger && !isReadOnly ? (React.createElement(FunctionEditor, __assign({ onUpdateEditor: function (source) { return onDataChange({ name: functionData.name, source: source }); }, functionInput: functionData.source, onToggleFullscreen: toggleFullscreen, showAddDependency: (_b = functionEditorProps === null || functionEditorProps === void 0 ? void 0 : functionEditorProps.showAddDependency) !== null && _b !== void 0 ? _b : false }, functionEditorProps))) : (React.createElement(React.Fragment, null,
                (functionEditorProps === null || functionEditorProps === void 0 ? void 0 : functionEditorProps.showAddDependency) && functionEditorProps.onAddDependency && (React.createElement(React.Fragment, null,
                    React.createElement(AddDependencyDialog, { open: addDependencyDialogIsOpen, onClose: function () { return setAddDependencyDialogIsOpen(false); }, onAdd: functionEditorProps.onAddDependency, dependenciesListLink: functionEditorProps.dependenciesListLink, installedViaArchive: functionEditorProps.installedViaArchive }),
                    React.createElement("div", { className: "function-editor-form-row-add-dependency-button" },
                        React.createElement(Button, { variant: "default", onClick: function () { return setAddDependencyDialogIsOpen(true); } }, "Add Dependency")))),
                React.createElement("div", { className: "function-editor-form-row-read-only-container" },
                    React.createElement(RichJavascriptEditor, { id: "functionSource", height: "100%", width: "100%", inline: true, isExpandable: !!toggleFullscreen, readOnly: isReadOnly, value: functionData.source, onChange: function (val) { return onDataChange({ name: functionData.name, source: val }); }, toggleFullscreen: toggleFullscreen })))))));
    };
    FunctionEditorFormRow.defaultProps = {
        isReadOnly: false,
        nested: false,
        withDebugger: false,
    };
    return FunctionEditorFormRow;
})();

var NEW_ID = 'NEW';
var FunctionSelectorRow = /* #__PURE__ */ (function () {
    var FunctionSelectorRow = function (_a) {
        var _b;
        var errorMessage = _a.errorMessage, editing = _a.editing, formRowDescription = _a.formRowDescription, functions = _a.functions, selectedId = _a.selectedId, newFunctionData = _a.newFunctionData, isReadOnly = _a.isReadOnly, selectorDescription = _a.selectorDescription, onIdChange = _a.onIdChange, onNewFunctionDataChange = _a.onNewFunctionDataChange, toggleFullscreen = _a.toggleFullscreen, functionEditorProps = _a.functionEditorProps, withDebugger = _a.withDebugger, rest = __rest(_a, ["errorMessage", "editing", "formRowDescription", "functions", "selectedId", "newFunctionData", "isReadOnly", "selectorDescription", "onIdChange", "onNewFunctionDataChange", "toggleFullscreen", "functionEditorProps", "withDebugger"]);
        var options = Object.values(functions).map(function (_a) {
            var id = _a.id, name = _a.name;
            return ({ label: name, value: id });
        });
        if (!editing) {
            options.unshift({ label: '+ New Function', value: NEW_ID });
        }
        return (React.createElement("div", __assign({}, passThroughProps(rest)),
            React.createElement(FormRow, { errorMessage: errorMessage },
                React.createElement(FormRowLabelGroup, null,
                    React.createElement("label", { className: "form-row-label" }, "Function"),
                    React.createElement("p", { className: "form-row-description" }, selectorDescription)),
                React.createElement(FormRowInputGroup, null,
                    React.createElement(Select, { "aria-labelledby": "functionId-select", id: "functionId", placeholder: "Select a function...", disabled: isReadOnly, value: (_b = options.find(function (_a) {
                            var value = _a.value;
                            return value === selectedId;
                        })) === null || _b === void 0 ? void 0 : _b.value, allowDeselect: false, onChange: function (selectedOption) {
                            onIdChange(selectedOption);
                        } }, options.map(function (opt) { return (React.createElement(Option, { key: opt.label, value: opt.value }, opt.label.toString())); })))),
            !editing && selectedId === NEW_ID && (React.createElement(React.Fragment, null,
                React.createElement(FormRow, { nested: true },
                    React.createElement(FormRowLabelGroup, null,
                        React.createElement("label", { className: "form-row-label" }, "Function Name"),
                        React.createElement("p", { className: "form-row-description" }, "Enter the name for the new function.")),
                    React.createElement(FormRowInputGroup, null,
                        React.createElement("input", { className: "tb-text-input", id: "functionName", name: "functionName", type: "text", value: newFunctionData.name, onChange: function (e) {
                                return onNewFunctionDataChange({
                                    name: e.target.value,
                                    source: newFunctionData.source,
                                    private: newFunctionData.private,
                                });
                            } }))),
                React.createElement(FunctionEditorFormRow, { formRowDescription: formRowDescription, functionData: newFunctionData, nested: true, onDataChange: onNewFunctionDataChange, toggleFullscreen: toggleFullscreen, functionEditorProps: functionEditorProps, withDebugger: withDebugger })))));
    };
    FunctionSelectorRow.defaultProps = {
        isReadOnly: false,
        errorMessage: '',
        formRowDescription: '',
        selectorDescription: null,
        toggleFullscreen: function () { },
        functionEditorProps: {},
    };
    return FunctionSelectorRow;
})();

var TriggerTypeDescription = function (_a) {
    var type = _a.type;
    switch (type) {
        case TriggerType.Authentication:
            // wrapping the returned string values in a React.Fragment:
            // https://github.com/Microsoft/TypeScript/issues/21699
            return React.createElement(React.Fragment, null, "an auth event");
        case TriggerType.Database:
            return (React.createElement(React.Fragment, null,
                "a\u00A0",
                React.createElement("a", { href: "https://docs.mongodb.com/manual/reference/change-events/", target: "_blank", rel: "noopener noreferrer" }, "change event")));
        case TriggerType.Scheduled:
            return React.createElement(React.Fragment, null, "a scheduled event");
        default:
            throw new Error("unrecognized trigger type encountered while displaying function selector description: " + type);
    }
};
var FunctionSelectorDescription = function (props) { return (React.createElement(React.Fragment, null,
    "Select the function to be executed on\u00A0",
    React.createElement(TriggerTypeDescription, __assign({}, props)),
    ". Selecting a new function will create a default function you can edit in the future.")); };
var formRowDescription = 'The following code will be executed for each event. The default function provided has no side effects. You can edit this code later.';
var EventFunctionSelector = /* #__PURE__ */ (function () {
    var EventFunctionSelector = function (_a) {
        var functions = _a.functions, selectedId = _a.selectedId, newFunctionData = _a.newFunctionData, isReadOnly = _a.isReadOnly, type = _a.type, onIdChange = _a.onIdChange, onNewFunctionDataChange = _a.onNewFunctionDataChange, toggleFullscreen = _a.toggleFullscreen, functionEditorProps = _a.functionEditorProps, withDebugger = _a.withDebugger, rest = __rest(_a, ["functions", "selectedId", "newFunctionData", "isReadOnly", "type", "onIdChange", "onNewFunctionDataChange", "toggleFullscreen", "functionEditorProps", "withDebugger"]);
        return (React.createElement(FunctionSelectorRow, __assign({ editing: false, functionEditorProps: functionEditorProps, formRowDescription: formRowDescription, functions: functions, selectedId: selectedId, newFunctionData: newFunctionData, isReadOnly: isReadOnly, selectorDescription: React.createElement(FunctionSelectorDescription, { type: type }), onIdChange: onIdChange, onNewFunctionDataChange: onNewFunctionDataChange, toggleFullscreen: toggleFullscreen, withDebugger: withDebugger }, passThroughProps(rest))));
    };
    EventFunctionSelector.defaultProps = {
        isReadOnly: false,
        toggleFullscreen: function () { },
        functionEditorProps: {},
    };
    return EventFunctionSelector;
})();

var ResponseEventConfig = /* #__PURE__ */ (function () {
    var ResponseEventConfig = function (_a) {
        var onChange = _a.onChange, _b = _a.eventProcessorType, eventProcessorType = _b === void 0 ? EventProcessorType.Function : _b, children = _a.children, rest = __rest(_a, ["onChange", "eventProcessorType", "children"]);
        return (React.createElement(React.Fragment, null,
            React.createElement(FormRow, __assign({}, passThroughProps(rest)),
                React.createElement(FormRowLabelGroup, null,
                    React.createElement("label", { htmlFor: "type", className: "form-row-label" }, "Select an Event Type"),
                    React.createElement("p", { className: "form-row-description" },
                        React.createElement("a", { href: "https://aws.amazon.com/eventbridge/", target: "_blank", rel: "noopener noreferrer" }, "Learn how to use Amazon EventBridge with Triggers"))),
                React.createElement(FormRowInputGroup, null,
                    React.createElement(RadioBoxGroup, { size: "full", value: eventProcessorType, onChange: function (evtType) { return onChange(evtType.target.value); } },
                        React.createElement(RadioBox, { className: "edit-event-form-type-radio-box", key: EventProcessorType.Function, checked: eventProcessorType === EventProcessorType.Function, value: EventProcessorType.Function }, "Function"),
                        React.createElement(RadioBox, { className: "edit-event-form-type-radio-box", key: EventProcessorType.AWSEventBridge, checked: eventProcessorType === EventProcessorType.AWSEventBridge, value: EventProcessorType.AWSEventBridge }, "EventBridge")))),
            children));
    };
    ResponseEventConfig.defaultProps = {
        children: null,
        eventProcessorType: EventProcessorType.Function,
    };
    return ResponseEventConfig;
})();

var awsRegionOptions = [
    { label: 'Ohio (us-east-2)', value: 'us-east-2', title: 'Ohio (us-east-2)' },
    { label: 'N. Virginia (us-east-1)', value: 'us-east-1', title: 'N. Virginia (us-east-1)' },
    { label: 'N. California (us-west-1)', value: 'us-west-1', title: 'N. California (us-west-1)' },
    { label: 'Oregon (us-west-2)', value: 'us-west-2', title: 'Oregon (us-west-2)' },
    { label: 'Hong Kong (ap-east-1)', value: 'ap-east-1', title: 'Hong Kong (ap-east-1)' },
    { label: 'Mumbai (ap-south-1)', value: 'ap-south-1', title: 'Mumbai (ap-south-1)' },
    { label: 'Osaka-Local (ap-northeast-3)', value: 'ap-northeast-3', title: 'Osaka-Local (ap-northeast-3)' },
    { label: 'Seoul (ap-northeast-2)', value: 'ap-northeast-2', title: 'Seoul (ap-northeast-2)' },
    { label: 'Singapore (ap-southeast-1)', value: 'ap-southeast-1', title: 'Singapore (ap-southeast-1)' },
    { label: 'Sydney (ap-southeast-2)', value: 'ap-southeast-2', title: 'Sydney (ap-southeast-2)' },
    { label: 'Tokyo (ap-northeast-1)', value: 'ap-northeast-1', title: 'Tokyo (ap-northeast-1)' },
    { label: 'Central (ca-central-1)', value: 'ca-central-1', title: 'Central (ca-central-1)' },
    { label: 'Beijing (cn-north-1)', value: 'cn-north-1', title: 'Beijing (cn-north-1)' },
    { label: 'Ningxia (cn-northwest-1)', value: 'cn-northwest-1', title: 'Ningxia (cn-northwest-1)' },
    { label: 'Frankfurt (eu-central-1)', value: 'eu-central-1', title: 'Frankfurt (eu-central-1)' },
    { label: 'Ireland (eu-west-1)', value: 'eu-west-1', title: 'Ireland (eu-west-1)' },
    { label: 'London (eu-west-2)', value: 'eu-west-2', title: 'London (eu-west-2)' },
    { label: 'Paris (eu-west-3)', value: 'eu-west-3', title: 'Paris (eu-west-3)' },
    { label: 'Stockholm (eu-north-1)', value: 'eu-north-1', title: 'Stockholm (eu-north-1)' },
    { label: 'Bahrain (me-south-1)', value: 'me-south-1', title: 'Bahrain (me-south-1)' },
    { label: 'Sao Paulo (sa-east-1)', value: 'sa-east-1', title: 'Sao Paulo (sa-east-1)' },
];
var EventBridgeFormRow = /* #__PURE__ */ (function () {
    var EventBridgeFormRow = function (_a) {
        var _b;
        var onChange = _a.onChange, eventProcessor = _a.eventProcessor, isReadOnly = _a.isReadOnly, rest = __rest(_a, ["onChange", "eventProcessor", "isReadOnly"]);
        var _c = (eventProcessor || { config: {} }).config, _d = _c.accountID, accountID = _d === void 0 ? '' : _d, _e = _c.region, region = _e === void 0 ? '' : _e, _f = _c.useExtendedJSON, useExtendedJSON = _f === void 0 ? false : _f;
        return (React.createElement("div", __assign({}, passThroughProps(rest)),
            React.createElement(FormRow, null,
                React.createElement(FormRowLabelGroup, null,
                    React.createElement("label", { htmlFor: "awsAccountID", className: "form-row-label" }, "AWS Account ID"),
                    React.createElement("p", { className: "form-row-description" },
                        React.createElement("a", { href: "https://console.aws.amazon.com", target: "_blank", rel: "noopener noreferrer" }, "Sign in"),
                        "\u00A0to the AWS Management Console to find your account ID.")),
                React.createElement(FormRowInputGroup, null,
                    React.createElement("input", { className: "tb-text-input form-row-text-input", id: "awsAccountID", name: "awsAccountID", disabled: isReadOnly, type: "text", placeholder: "Enter your AWS Account ID", value: accountID, onChange: function (e) { return onChange({ config: { accountID: e.target.value, region: region, useExtendedJSON: useExtendedJSON } }); } }))),
            React.createElement(FormRow, null,
                React.createElement(FormRowLabelGroup, null,
                    React.createElement("label", { htmlFor: "awsRegion", className: "form-row-label" }, "Select an AWS Region")),
                React.createElement(FormRowInputGroup, null,
                    React.createElement(Select, { "aria-labelledby": "awsRegion-select", id: "awsRegion", placeholder: "Select region...", disabled: isReadOnly, value: (_b = awsRegionOptions.find(function (opt) { return opt.value === region; })) === null || _b === void 0 ? void 0 : _b.value, allowDeselect: false, onChange: function (selectedOption) {
                            onChange({ config: { accountID: accountID, region: selectedOption, useExtendedJSON: useExtendedJSON } });
                        } }, awsRegionOptions.map(function (opt) { return (React.createElement(Option, { key: opt.label, value: opt.value }, opt.label)); }))))));
    };
    EventBridgeFormRow.defaultProps = {
        isReadOnly: false,
        eventProcessor: { config: { region: '', accountID: '', useExtendedJSON: false } },
    };
    return EventBridgeFormRow;
})();

var defaultProps$6 = {
    onFormChange: function () { },
};
var TestSelector$5;
(function (TestSelector) {
    TestSelector["TriggerNameInput"] = "trigger-name-input";
})(TestSelector$5 || (TestSelector$5 = {}));
var AriaLabel$2;
(function (AriaLabel) {
    AriaLabel["TriggerNameLabel"] = "trigger-name-label";
})(AriaLabel$2 || (AriaLabel$2 = {}));
var buildFormData$2 = function (trigger) {
    if (trigger) {
        var name_1 = trigger.name, disabled = trigger.disabled, actionType = trigger.actionType, providers = trigger.providers, functionId = trigger.functionId, functionName = trigger.functionName, _a = trigger.eventProcessors, eventProcessors = _a === void 0 ? {} : _a;
        var eventProcessor = eventProcessors[EventProcessorType.AWSEventBridge];
        var _b = (eventProcessor || { config: {} }).config, _c = _b.region, region = _c === void 0 ? '' : _c, _d = _b.accountID, accountID = _d === void 0 ? '' : _d, _e = _b.useExtendedJSON, useExtendedJSON = _e === void 0 ? false : _e;
        return {
            name: name_1,
            disabled: disabled,
            actionType: actionType,
            providers: providers,
            functionId: functionId,
            functionName: functionName,
            functionPrivate: true,
            functionSource: '',
            eventProcessorType: eventProcessor ? EventProcessorType.AWSEventBridge : EventProcessorType.Function,
            region: region,
            accountID: accountID,
            useExtendedJSON: useExtendedJSON,
        };
    }
    return {
        name: '',
        disabled: false,
        actionType: '',
        providers: [],
        functionId: '',
        functionName: DEFAULT_FUNCTION_NAME,
        region: '',
        accountID: '',
        useExtendedJSON: false,
        eventProcessorType: EventProcessorType.Function,
        functionSource: AUTH_TRIGGER_FUNCTION_PLACEHOLDER,
        functionPrivate: true,
    };
};
var buildState$2 = function (_a) {
    var trigger = _a.trigger;
    var initialForm = buildFormData$2(trigger);
    return {
        cleanData: initialForm,
        data: initialForm,
        isDirty: false,
        showTriggerNameEmptyError: false,
    };
};
var customSelectStyles = mergeSelectStyles({
    control: function (base) { return (__assign(__assign({}, base), { height: 'auto', minHeight: 'auto' })); },
});
var EditAuthenticationEvent = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(EditAuthenticationEvent, _super);
            function EditAuthenticationEvent(props) {
                var _this = _super.call(this, props) || this;
                _this.state = buildState$2(_this.props);
                _this.handleDiscard = _this.handleDiscard.bind(_this);
                _this.handleSave = _this.handleSave.bind(_this);
                _this.onActionTypeChange = _this.onActionTypeChange.bind(_this);
                _this.onFunctionIdChange = _this.onFunctionIdChange.bind(_this);
                _this.onProvidersChange = _this.onProvidersChange.bind(_this);
                _this.setFormData = _this.setFormData.bind(_this);
                return _this;
            }
            EditAuthenticationEvent.prototype.componentDidUpdate = function () {
                var trigger = this.props.trigger;
                if (trigger) {
                    var newForm_1 = buildFormData$2(trigger);
                    if (!areFormsEqual(newForm_1, this.state.cleanData)) {
                        /* eslint-disable-next-line react/no-did-update-set-state */
                        this.setState(function () { return ({ cleanData: newForm_1, data: newForm_1, isDirty: false }); });
                    }
                }
            };
            EditAuthenticationEvent.prototype.handleDiscard = function () {
                this.setState(function (_a) {
                    var cleanData = _a.cleanData;
                    return ({ data: cleanData, isDirty: false });
                });
                this.props.onFormChange(this.state.cleanData.name, false);
            };
            EditAuthenticationEvent.prototype.handleSave = function () {
                var _a;
                var _b = this.state.data, name = _b.name, disabled = _b.disabled, actionType = _b.actionType, providers = _b.providers, functionId = _b.functionId, functionName = _b.functionName, functionSource = _b.functionSource, eventProcessorType = _b.eventProcessorType, region = _b.region, accountID = _b.accountID, useExtendedJSON = _b.useExtendedJSON;
                var triggerPayload = {
                    type: TriggerType.Authentication,
                    name: name,
                    disabled: disabled,
                    actionType: actionType,
                    providers: providers,
                    functionId: functionId,
                    functionName: functionName,
                };
                if (eventProcessorType === EventProcessorType.AWSEventBridge) {
                    triggerPayload.eventProcessors = (_a = {},
                        _a[EventProcessorType.AWSEventBridge] = {
                            config: {
                                region: region,
                                accountID: accountID,
                                useExtendedJSON: useExtendedJSON,
                            },
                        },
                        _a);
                }
                this.props.handleSave(triggerPayload, { name: functionName, source: functionSource, private: true });
            };
            EditAuthenticationEvent.prototype.onActionTypeChange = function (actionType) {
                this.setFormData({ actionType: actionType });
            };
            EditAuthenticationEvent.prototype.onFunctionIdChange = function (functionId) {
                var functions = this.props.functions;
                var functionName = DEFAULT_FUNCTION_NAME;
                var functionSource = AUTH_TRIGGER_FUNCTION_PLACEHOLDER;
                var func = functions[functionId];
                if (func) {
                    functionName = func.name;
                }
                this.setFormData({ functionId: functionId, functionName: functionName, functionSource: functionSource });
            };
            EditAuthenticationEvent.prototype.onProvidersChange = function (providers) {
                this.setFormData({ providers: (providers || []).map(function (p) { return p.value; }) });
            };
            EditAuthenticationEvent.prototype.setFormData = function (newValues) {
                var _this = this;
                var cleanData = this.state.cleanData;
                var isDirty = Object.keys(newValues).some(function (key) { return !isClean(newValues[key], cleanData[key]); });
                this.setState(function (_a) {
                    var prevData = _a.data;
                    return ({
                        data: __assign(__assign({}, prevData), newValues),
                        isDirty: isDirty,
                    });
                }, function () {
                    _this.props.onFormChange(_this.state.cleanData.name, isDirty);
                });
            };
            EditAuthenticationEvent.prototype.render = function () {
                var _this = this;
                var _a = this.props, editing = _a.editing, functionEditorProps = _a.functionEditorProps, functions = _a.functions, onCancel = _a.onCancel, saveError = _a.saveError, saving = _a.saving, toggleFullscreen = _a.toggleFullscreen, withDebugger = _a.withDebugger, runDebugWithSource = _a.runDebugWithSource, rest = __rest(_a, ["editing", "functionEditorProps", "functions", "onCancel", "saveError", "saving", "toggleFullscreen", "withDebugger", "runDebugWithSource"]);
                var _b = this.state, data = _b.data, isDirty = _b.isDirty;
                var responseEventContent;
                switch (data.eventProcessorType) {
                    case EventProcessorType.AWSEventBridge:
                        responseEventContent = (React.createElement(EventBridgeFormRow, { onChange: function (_a) {
                                var _b = _a.config, region = _b.region, accountID = _b.accountID;
                                return _this.setFormData({ region: region, accountID: accountID });
                            }, eventProcessor: {
                                config: {
                                    region: data.region,
                                    accountID: data.accountID,
                                    useExtendedJSON: data.useExtendedJSON,
                                },
                            } }));
                        break;
                    case EventProcessorType.Function:
                        responseEventContent = (React.createElement(EventFunctionSelector, { type: TriggerType.Authentication, functions: functions, functionEditorProps: __assign(__assign({}, functionEditorProps), { defaultDebugSource: withDebugger ? AUTH_TRIGGER_DEBUG_PLACEHOLDER : undefined, onRunDebug: runDebugWithSource ? runDebugWithSource(data.functionSource) : undefined }), selectedId: data.functionId, newFunctionData: { name: data.functionName, source: data.functionSource, private: data.functionPrivate }, onIdChange: this.onFunctionIdChange, onNewFunctionDataChange: function (_a) {
                                var functionName = _a.name, functionSource = _a.source;
                                return _this.setFormData({ functionName: functionName, functionSource: functionSource });
                            }, toggleFullscreen: toggleFullscreen, withDebugger: withDebugger }));
                        break;
                    default:
                        responseEventContent = null;
                }
                return (React.createElement("div", __assign({}, passThroughProps(rest)),
                    React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement("label", { id: AriaLabel$2.TriggerNameLabel, htmlFor: "name", className: "form-row-label" }, "Name")),
                        React.createElement(FormRowInputGroup, null,
                            React.createElement(TextInput, { id: "name", "aria-labelledby": AriaLabel$2.TriggerNameLabel, "data-test-id": TestSelector$5.TriggerNameInput, value: data.name, placeholder: "Name", state: this.state.showTriggerNameEmptyError ? 'error' : 'none', onChange: function (e) { return _this.setFormData({ name: e.target.value }); }, onBlur: function (e) {
                                    return _this.setState({ showTriggerNameEmptyError: !e.target.value || e.target.value.length === 0 });
                                }, errorMessage: "Trigger name must not be empty.", autoFocus: true }))),
                    React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement("label", { htmlFor: "disabled", className: "form-row-label" }, "Enabled")),
                        React.createElement(FormRowInputGroup, null,
                            React.createElement(Toggle, { id: "disabled", name: "disabled", "aria-label": "toggle", "aria-labelledby": "disabled", checked: !data.disabled, onChange: function (e) { return _this.setFormData({ disabled: !e }); } }))),
                    React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement("label", { htmlFor: "actionType", className: "form-row-label" }, "Action Type")),
                        React.createElement(FormRowInputGroup, null,
                            React.createElement(RadioBoxGroup, { size: "full", value: data.actionType },
                                React.createElement(RadioBox, { "data-id": "actionTypeCreate", checked: data.actionType === 'CREATE', onClick: function () { return _this.onActionTypeChange('CREATE'); }, value: "CREATE" }, "Create"),
                                React.createElement(RadioBox, { "data-id": "actionTypeLogin", checked: data.actionType === 'LOGIN', onClick: function () { return _this.onActionTypeChange('LOGIN'); }, value: "LOGIN" }, "Login"),
                                React.createElement(RadioBox, { "data-id": "actionTypeDelete", checked: data.actionType === 'DELETE', onClick: function () { return _this.onActionTypeChange('DELETE'); }, value: "DELETE" }, "Delete")))),
                    React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement("label", { htmlFor: "providers", className: "form-row-label-no-transform" }, "Provider(s)"),
                            React.createElement("p", { className: "form-row-description" }, "Select which provider(s) you want this auth trigger to apply to.")),
                        React.createElement(FormRowInputGroup, null,
                            React.createElement(Select$1, { id: "providers", name: "providers", isClearable: true, isMulti: true, isOpen: true, options: PROVIDER_OPTIONS, placeholder: "Select provider(s)...", styles: customSelectStyles, value: data.providers.map(function (provider) { return PROVIDER_OPTIONS_MAP[provider]; }), onChange: this.onProvidersChange }))),
                    React.createElement(ResponseEventConfig, { eventProcessorType: data.eventProcessorType, onChange: function (eventProcessorType) {
                            _this.setFormData({
                                functionId: '',
                                functionName: '',
                                accountID: '',
                                region: '',
                                eventProcessorType: eventProcessorType,
                            });
                        } }, responseEventContent),
                    React.createElement(FormRowButtonFooter, { onDiscard: this.handleDiscard, onCancel: onCancel, onSave: this.handleSave, formIsDirty: isDirty, editing: editing, saveError: saveError, saving: saving })));
            };
            return EditAuthenticationEvent;
        }(React.Component)),
        _a.defaultProps = defaultProps$6,
        _a;
})();

var MIN_PREIMAGE_COMPATIBLE_MONGO_VERSION = '4.4.0';
var isPreimageCompatibleMongoDBVersion = function (dbVersion) {
    return dbVersion ? semverGte(semverCoerce(dbVersion), MIN_PREIMAGE_COMPATIBLE_MONGO_VERSION) : false;
};
var isPreimageCompatibleClusterType = function (clusterType) {
    return clusterType ? clusterType === 'REPLICASET' || clusterType === 'STANDALONE' : false;
};
var isPreimageCompatibleService = function (service) {
    var _a, _b;
    return service
        ? isSelfHostedMongoService(service.config) ||
            (isCluster(service.config) &&
                isPreimageCompatibleClusterType((_a = service.config) === null || _a === void 0 ? void 0 : _a.clusterType) &&
                isPreimageCompatibleMongoDBVersion((_b = service.config) === null || _b === void 0 ? void 0 : _b.dbVersion))
        : false;
};

var css_248z$9 = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-event-data-source-badge {\n  text-transform: none;\n  font-weight: normal;\n  border-radius: 0;\n  padding: 0px 4px;\n  margin-right: 6px;\n}\n.tb-event-data-source-badge-linked {\n  color: #494747;\n}\n.tb-event-data-source-badge-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  padding: 0px 0px 12px 0px;\n}\n.tb-event-data-source-badge-container > * {\n  margin-top: 6px;\n}\n.tb-event-data-source-select-container {\n  display: flex;\n  align-items: center;\n}\n.tb-event-data-source-error-banner {\n  padding: 0px;\n}\n.tb-event-data-source-select-option-label {\n  display: flex;\n}\n.tb-event-data-source-select-badge {\n  margin-left: auto;\n  margin-right: 0;\n  white-space: nowrap;\n}\n";
styleInject(css_248z$9);

var selectStyles = mergeSelectStyles({
    container: function (base) { return (__assign(__assign({}, base), { flexGrow: 1, marginRight: '12px' })); },
});
var defaultProps$5 = {
    isReadOnly: false,
    mongoServices: [],
    onLinkDataSources: function () { },
};
var eventDataSourcePrefix = 'tb-event-data-source';
var badgeClassname = eventDataSourcePrefix + "-badge";
var errorMessage = function (dataSourceName, error) { return (React.createElement(React.Fragment, null,
    React.createElement("b", null, dataSourceName),
    ": ",
    error)); };
var DataSourceBadgeText;
(function (DataSourceBadgeText) {
    DataSourceBadgeText["Cluster"] = "Cluster";
    DataSourceBadgeText["DataFederation"] = "Federated DB";
})(DataSourceBadgeText || (DataSourceBadgeText = {}));
var FormatOptionLabel = function (dataSource) {
    var _a, _b, _c;
    return (React.createElement("div", { className: eventDataSourcePrefix + "-select-option-label" },
        React.createElement("span", null, ((_a = dataSource.config) === null || _a === void 0 ? void 0 : _a.clusterName) || ((_b = dataSource.config) === null || _b === void 0 ? void 0 : _b.dataLakeName) || dataSource.name),
        React.createElement(Badge, { variant: "lightgray", className: eventDataSourcePrefix + "-select-badge" }, dataSource.type === DataSourceServiceType.SVCTYPE_DATALAKE || ((_c = dataSource.config) === null || _c === void 0 ? void 0 : _c.dataLakeName)
            ? DataSourceBadgeText.DataFederation
            : DataSourceBadgeText.Cluster)));
};
var DataSourceLinkFormRow = /* #__PURE__ */ (function () {
    var DataSourceLinkFormRow = function (_a) {
        var description = _a.description, isReadOnly = _a.isReadOnly, mongoServices = _a.mongoServices, getDataSourceDisplay = _a.getDataSourceDisplay, onLinkDataSources = _a.onLinkDataSources, linkDataSourceDescription = _a.linkDataSourceDescription;
        var _b = __read$1(useState([]), 2), selectedDataSourceOptions = _b[0], setSelectedDataSourceOptions = _b[1];
        var linkedDataSources = mongoServices.filter(function (s) { return s.status === MongoServiceStatus.Linked; });
        var linkingDataSources = mongoServices.filter(function (s) { return s.status === MongoServiceStatus.Linking; });
        var errorDataSources = mongoServices.filter(function (s) { return s.status === MongoServiceStatus.Error; });
        return (React.createElement(FormRow, { noWrap: true },
            React.createElement(FormRowLabelGroup, { alignTop: true },
                React.createElement("label", { htmlFor: "dataSourceLinkSelect", className: "form-row-label-no-transform" }, "Link Data Source(s)"),
                React.createElement("p", { className: "form-row-description", id: "link-data-source-description" },
                    linkDataSourceDescription,
                    "\u00A0",
                    description),
                React.createElement("p", { className: "form-row-description" }, "Note: Only available clusters in this project running MongoDB 3.4 or greater are shown.")),
            React.createElement(FormRowInputGroup, null,
                React.createElement("div", { className: "form-row-input-group-flex-column" },
                    React.createElement("div", { className: badgeClassname + "-container" },
                        linkedDataSources.map(function (s) { return (React.createElement(Badge, { key: s._id, className: badgeClassname + " " + badgeClassname + "-linked" }, getDataSourceDisplay(s))); }),
                        linkingDataSources.map(function (s) { return (React.createElement(Badge, { key: s._id, className: badgeClassname },
                            React.createElement("em", null, "Linking"),
                            "\u00A0",
                            getDataSourceDisplay(s),
                            "...")); }),
                        errorDataSources.map(function (s) { return (React.createElement(Badge, { key: s._id, className: badgeClassname, variant: "red" }, getDataSourceDisplay(s))); })),
                    React.createElement("div", { className: eventDataSourcePrefix + "-select-container" },
                        React.createElement(Select$1, { id: "linkedDataSources", name: "linkedDataSources", isClearable: true, isDisabled: isReadOnly, isMulti: true, isOpen: true, options: mongoServices, formatOptionLabel: FormatOptionLabel, getOptionLabel: getDataSourceDisplay, getOptionValue: getDataSourceDisplay, isOptionDisabled: function (option) { return option.status !== MongoServiceStatus.Unlinked; }, placeholder: "Link Data Source(s)", styles: selectStyles, value: selectedDataSourceOptions, onChange: function (dataSources) { return setSelectedDataSourceOptions(dataSources); } }),
                        React.createElement(Button, { disabled: isReadOnly, name: "linkDataSourceButton", onClick: function () {
                                onLinkDataSources(selectedDataSourceOptions);
                                setSelectedDataSourceOptions([]);
                            } }, "Link")),
                    errorDataSources.map(function (s) { return (React.createElement(Banner, { key: s._id, variant: Variant$1.Danger, className: "tb-event-data-source-error-banner" }, errorMessage(getDataSourceDisplay(s), s.svcError))); })))));
    };
    DataSourceLinkFormRow.defaultProps = defaultProps$5;
    return DataSourceLinkFormRow;
})();

var EventFunctionConfig = /* #__PURE__ */ (function () {
    var EventFunctionConfig = function (_a) {
        var newFunctionData = _a.newFunctionData, functionEditorProps = _a.functionEditorProps, selectedId = _a.selectedId, functions = _a.functions, isReadOnly = _a.isReadOnly, onNewFunctionDataChange = _a.onNewFunctionDataChange, onIdChange = _a.onIdChange, toggleFullscreen = _a.toggleFullscreen, type = _a.type, variant = _a.variant, withDebugger = _a.withDebugger, rest = __rest(_a, ["newFunctionData", "functionEditorProps", "selectedId", "functions", "isReadOnly", "onNewFunctionDataChange", "onIdChange", "toggleFullscreen", "type", "variant", "withDebugger"]);
        if (variant === EditEventFormVariant.Atlas) {
            return (React.createElement(FunctionEditorFormRow, __assign({ functionData: newFunctionData, functionEditorProps: functionEditorProps, isReadOnly: isReadOnly, onDataChange: onNewFunctionDataChange, toggleFullscreen: toggleFullscreen, withDebugger: true }, passThroughProps(rest))));
        }
        if (variant === EditEventFormVariant.BAAS) {
            return (React.createElement(EventFunctionSelector, __assign({ isReadOnly: isReadOnly, type: type, functions: functions, selectedId: selectedId, newFunctionData: newFunctionData, onIdChange: onIdChange, onNewFunctionDataChange: onNewFunctionDataChange, toggleFullscreen: toggleFullscreen, functionEditorProps: functionEditorProps, withDebugger: withDebugger }, passThroughProps(rest))));
        }
        return null;
    };
    EventFunctionConfig.defaultProps = {
        functionEditorProps: {},
        isReadOnly: false,
        variant: EditEventFormVariant.BAAS,
    };
    return EventFunctionConfig;
})();

var css_248z$8 = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.edit-database-event-row-editor {\n  height: 100%;\n}\n.edit-database-event-operation-type {\n  display: flex;\n}\n.edit-database-event-operation-type-checkbox {\n  margin-right: 5px;\n}\n.edit-database-event-preimage-disabled {\n  color: #a09f9e;\n}\n.edit-database-event-tooltip {\n  position: relative;\n  margin-top: 20px;\n  margin-left: 20px;\n}\n";
styleInject(css_248z$8);

var baseClassName = 'edit-database-event';
var TestSelector$4;
(function (TestSelector) {
    TestSelector["PreimageInfoTooltip"] = "preimage-info-tooltip";
    TestSelector["PreimageToggle"] = "preimage-toggle";
    TestSelector["TriggerNameInput"] = "trigger-name-input";
})(TestSelector$4 || (TestSelector$4 = {}));
var AriaLabel$1;
(function (AriaLabel) {
    AriaLabel["TriggerNameLabel"] = "trigger-name-label";
})(AriaLabel$1 || (AriaLabel$1 = {}));
var defaultProps$4 = {
    functionEditorProps: {},
    isReadOnly: false,
    variant: EditEventFormVariant.BAAS,
    onFormChange: function () { },
    onLinkDataSources: function () { },
};
var buildFormData$1 = function (trigger, functionSource) {
    if (trigger) {
        var name_1 = trigger.name, disabled = trigger.disabled, skipCatchUpEvents = trigger.skipCatchUpEvents, operationTypes = trigger.operationTypes, database = trigger.database, collection = trigger.collection, serviceId = trigger.serviceId, match = trigger.match, project = trigger.project, fullDocument = trigger.fullDocument, fullDocumentBeforeChange = trigger.fullDocumentBeforeChange, unordered = trigger.unordered, functionId = trigger.functionId, functionName = trigger.functionName, _a = trigger.eventProcessors, eventProcessors = _a === void 0 ? {} : _a, autoResume = trigger.autoResume;
        var eventProcessor = eventProcessors[EventProcessorType.AWSEventBridge];
        var _b = (eventProcessor || { config: {} }).config, _c = _b.region, region = _c === void 0 ? '' : _c, _d = _b.accountID, accountID = _d === void 0 ? '' : _d, _e = _b.useExtendedJSON, useExtendedJSON = _e === void 0 ? false : _e;
        return {
            name: name_1,
            disabled: disabled,
            skipCatchUpEvents: skipCatchUpEvents,
            operationTypes: operationTypes,
            database: database,
            collection: collection,
            serviceId: serviceId,
            match: match,
            project: project,
            fullDocument: fullDocument,
            fullDocumentBeforeChange: fullDocumentBeforeChange,
            unordered: unordered,
            functionId: functionId,
            functionName: functionName,
            functionPrivate: true,
            functionSource: functionSource || '',
            eventProcessorType: eventProcessor ? EventProcessorType.AWSEventBridge : EventProcessorType.Function,
            region: region,
            accountID: accountID,
            useExtendedJSON: useExtendedJSON,
            autoResume: autoResume,
        };
    }
    return {
        name: '',
        disabled: false,
        skipCatchUpEvents: false,
        operationTypes: [],
        database: '',
        collection: '',
        serviceId: '',
        match: '',
        project: '',
        fullDocument: false,
        fullDocumentBeforeChange: false,
        unordered: false,
        functionId: '',
        functionName: DEFAULT_FUNCTION_NAME,
        functionPrivate: true,
        functionSource: functionSource || buildDbTriggerFunctionPlaceholder(),
        region: '',
        accountID: '',
        useExtendedJSON: false,
        eventProcessorType: EventProcessorType.Function,
        autoResume: false,
    };
};
var buildState$1 = function (_a) {
    var trigger = _a.trigger, functionSource = _a.functionSource;
    var initialForm = buildFormData$1(trigger, functionSource);
    return {
        collapsibles: {
            details: true,
            source: true,
            function: true,
            advanced: false,
        },
        form: {
            cleanData: initialForm,
            data: initialForm,
            isDirty: false,
        },
        showTriggerNameEmptyError: false,
        isNewDatabase: false,
        isNewCollection: false,
    };
};
var dbOperationTypes = [
    { name: 'INSERT', displayName: 'Insert' },
    { name: 'UPDATE', displayName: 'Update' },
    { name: 'DELETE', displayName: 'Delete' },
    { name: 'REPLACE', displayName: 'Replace' },
];
var matchExpressionExample = "\n{\n  \"updateDescription.updatedFields\": {\n    \"status\": \"blocked\"\n  }\n}";
var projectExpressionExample = "\n{\n  \"updateDescription.updatedFields.FieldA\": 1, \"operationType\": 1\n}";
var EditDatabaseEvent = /* #__PURE__ */ (function () { var _a; return _a = /** @class */ (function (_super) {
        __extends(EditDatabaseEvent, _super);
        function EditDatabaseEvent(props) {
            var _this = _super.call(this, props) || this;
            _this.state = buildState$1(_this.props);
            _this.handleDiscard = _this.handleDiscard.bind(_this);
            _this.handleSave = _this.handleSave.bind(_this);
            _this.onDataSourceChange = _this.onDataSourceChange.bind(_this);
            _this.onCollapsibleToggle = _this.onCollapsibleToggle.bind(_this);
            _this.onFunctionIdChange = _this.onFunctionIdChange.bind(_this);
            _this.onOperationTypesChange = _this.onOperationTypesChange.bind(_this);
            _this.setFormData = _this.setFormData.bind(_this);
            return _this;
        }
        EditDatabaseEvent.prototype.componentDidUpdate = function () {
            var _a = this.props, trigger = _a.trigger, functionSource = _a.functionSource;
            if (trigger || functionSource) {
                var newForm_1 = buildFormData$1(trigger, functionSource);
                if (!areFormsEqual(newForm_1, this.state.form.cleanData)) {
                    /* eslint-disable-next-line react/no-did-update-set-state */
                    this.setState(function () { return ({
                        form: {
                            cleanData: newForm_1,
                            data: newForm_1,
                            isDirty: false,
                        },
                    }); });
                }
            }
        };
        EditDatabaseEvent.prototype.handleDiscard = function () {
            this.setState(function (_a) {
                var cleanData = _a.form.cleanData;
                return ({
                    form: {
                        cleanData: cleanData,
                        data: cleanData,
                        isDirty: false,
                    },
                });
            });
            this.props.onFormChange(this.state.form.cleanData.name, false);
        };
        EditDatabaseEvent.prototype.handleSave = function () {
            var _a;
            var _b = this.state.form.data, name = _b.name, disabled = _b.disabled, skipCatchUpEvents = _b.skipCatchUpEvents, operationTypes = _b.operationTypes, database = _b.database, collection = _b.collection, serviceId = _b.serviceId, match = _b.match, project = _b.project, fullDocument = _b.fullDocument, fullDocumentBeforeChange = _b.fullDocumentBeforeChange, unordered = _b.unordered, functionId = _b.functionId, functionName = _b.functionName, functionSource = _b.functionSource, eventProcessorType = _b.eventProcessorType, region = _b.region, accountID = _b.accountID, useExtendedJSON = _b.useExtendedJSON, autoResume = _b.autoResume;
            var triggerPayload = {
                type: TriggerType.Database,
                name: name,
                disabled: disabled,
                skipCatchUpEvents: skipCatchUpEvents,
                operationTypes: operationTypes,
                database: database,
                collection: collection,
                serviceId: serviceId,
                match: match,
                project: project,
                fullDocument: fullDocument,
                fullDocumentBeforeChange: fullDocumentBeforeChange,
                unordered: unordered,
                functionId: functionId,
                functionName: functionName,
                autoResume: autoResume,
            };
            if (eventProcessorType === EventProcessorType.AWSEventBridge) {
                triggerPayload.eventProcessors = (_a = {},
                    _a[EventProcessorType.AWSEventBridge] = {
                        config: {
                            region: region,
                            accountID: accountID,
                            useExtendedJSON: useExtendedJSON,
                        },
                    },
                    _a);
            }
            this.props.handleSave(triggerPayload, { name: functionName, source: functionSource, private: true }, { isNewCollection: this.state.isNewCollection, isNewDatabase: this.state.isNewDatabase });
        };
        EditDatabaseEvent.prototype.onCollapsibleToggle = function (key) {
            this.setState(function (_a) {
                var _b;
                var collapsibles = _a.collapsibles;
                return ({
                    collapsibles: __assign(__assign({}, collapsibles), (_b = {}, _b[key] = !collapsibles[key], _b)),
                });
            });
        };
        EditDatabaseEvent.prototype.onDataSourceChange = function (serviceId) {
            this.setFormData({ serviceId: serviceId });
            this.props.onDataSourceChange(serviceId);
        };
        EditDatabaseEvent.prototype.onFunctionIdChange = function (functionId) {
            var _a = this.props, mongoServices = _a.mongoServices, functions = _a.functions, defaultFunctionSource = _a.functionSource;
            var _b = this.state.form.data, serviceId = _b.serviceId, database = _b.database, collection = _b.collection;
            var func = functions[functionId];
            var service = mongoServices.find(function (svc) { return svc._id === serviceId; });
            var serviceName = service ? service.name : '';
            var functionName = DEFAULT_FUNCTION_NAME;
            var functionSource = defaultFunctionSource || buildDbTriggerFunctionPlaceholder(serviceName, database, collection);
            if (func) {
                functionName = func.name;
            }
            this.setFormData({ functionId: functionId, functionName: functionName, functionSource: functionSource });
        };
        EditDatabaseEvent.prototype.onOperationTypesChange = function (e) {
            var _a = e.target, name = _a.name, checked = _a.checked;
            var operationTypes = this.state.form.data.operationTypes;
            if (checked) {
                this.setFormData({ operationTypes: operationTypes.concat(name) });
            }
            else {
                this.setFormData({
                    operationTypes: operationTypes.filter(function (operationType) { return operationType !== name; }),
                });
            }
        };
        EditDatabaseEvent.prototype.setFormData = function (newValues) {
            var _this = this;
            var cleanData = this.state.form.cleanData;
            var isDirty = Object.keys(newValues).some(function (key) { return !isClean(newValues[key], cleanData[key]); });
            this.setState(function (_a) {
                var form = _a.form;
                return ({
                    form: __assign(__assign({}, form), { data: __assign(__assign({}, form.data), newValues), isDirty: isDirty }),
                });
            }, function () {
                _this.props.onFormChange(_this.state.form.cleanData.name, isDirty);
            });
        };
        EditDatabaseEvent.prototype.render = function () {
            var _this = this;
            var _a = this.props, editing = _a.editing, functionEditorProps = _a.functionEditorProps, functions = _a.functions, isReadOnly = _a.isReadOnly, isCreatable = _a.isCreatable, isLoadingNamespaces = _a.isLoadingNamespaces, mongoServices = _a.mongoServices, namespaces = _a.namespaces, onLinkDataSources = _a.onLinkDataSources, onCancel = _a.onCancel, saveError = _a.saveError, saving = _a.saving, toggleFullscreen = _a.toggleFullscreen, variant = _a.variant, withDebugger = _a.withDebugger, runDebugWithSource = _a.runDebugWithSource, rest = __rest(_a, ["editing", "functionEditorProps", "functions", "isReadOnly", "isCreatable", "isLoadingNamespaces", "mongoServices", "namespaces", "onLinkDataSources", "onCancel", "saveError", "saving", "toggleFullscreen", "variant", "withDebugger", "runDebugWithSource"]);
            var _b = this.state, collapsibles = _b.collapsibles, _c = _b.form, data = _c.data, isDirty = _c.isDirty;
            var namespaceSelectMongoServices = mongoServices
                .filter(function (svc) {
                return (variant === EditEventFormVariant.BAAS || svc.status === MongoServiceStatus.Linked) &&
                    !isDataLake(svc.config);
            })
                .map(function (svc) { return (__assign(__assign({}, svc), { isDisabled: isCluster(svc.config) && svc.config.clusterType === CLUSTERTYPE_SERVERLESS })); });
            var selectedService = mongoServices.find(function (svc) { return svc._id === data.serviceId; });
            var documentPreimageEnabled = isPreimageCompatibleService(selectedService);
            var responseEventContent;
            switch (data.eventProcessorType) {
                case EventProcessorType.AWSEventBridge:
                    responseEventContent = (React.createElement(EventBridgeFormRow, { isReadOnly: isReadOnly, onChange: function (_a) {
                            var _b = _a.config, region = _b.region, accountID = _b.accountID;
                            return _this.setFormData({ region: region, accountID: accountID });
                        }, eventProcessor: {
                            config: {
                                region: data.region,
                                accountID: data.accountID,
                                useExtendedJSON: data.useExtendedJSON,
                            },
                        } }));
                    break;
                case EventProcessorType.Function:
                    responseEventContent = (React.createElement(EventFunctionConfig, { functionEditorProps: __assign(__assign({}, functionEditorProps), { defaultDebugSource: withDebugger ? DB_TRIGGER_DEBUG_PLACEHOLDER : undefined, onRunDebug: runDebugWithSource ? runDebugWithSource(data.functionSource) : undefined }), selectedId: data.functionId, newFunctionData: {
                            name: data.functionName,
                            source: data.functionSource,
                            private: data.functionPrivate,
                        }, functions: functions, isReadOnly: isReadOnly, onIdChange: this.onFunctionIdChange, onNewFunctionDataChange: function (_a) {
                            var functionName = _a.name, source = _a.source;
                            return _this.setFormData({ functionName: functionName, functionSource: source });
                        }, toggleFullscreen: toggleFullscreen, type: TriggerType.Database, variant: variant, withDebugger: withDebugger }));
                    break;
                default:
                    responseEventContent = null;
            }
            var fullDocBeforeChangeStr = 'fullDocumentBeforeChange';
            return (React.createElement("div", __assign({}, passThroughProps(rest)),
                React.createElement(Collapsible, { accordion: true, wide: true, headerContent: "Trigger Details", open: collapsibles.details, toggle: function () { return _this.onCollapsibleToggle('details'); } },
                    React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement(Label, { id: AriaLabel$1.TriggerNameLabel, htmlFor: "name", className: "form-row-label" }, "Name")),
                        React.createElement(FormRowInputGroup, null,
                            React.createElement(TextInput, { id: "name", "aria-labelledby": AriaLabel$1.TriggerNameLabel, "data-test-id": TestSelector$4.TriggerNameInput, readOnly: isReadOnly, value: data.name, placeholder: "Name", state: this.state.showTriggerNameEmptyError ? 'error' : 'none', onChange: function (e) { return _this.setFormData({ name: e.target.value }); }, onBlur: function (e) {
                                    return _this.setState({ showTriggerNameEmptyError: !e.target.value || e.target.value.length === 0 });
                                }, errorMessage: "Trigger name must not be empty.", autoFocus: true }))),
                    React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement(Label, { htmlFor: "disabled", className: "form-row-label" }, "Enabled")),
                        React.createElement(FormRowInputGroup, null,
                            React.createElement(Toggle, { disabled: isReadOnly, id: "disabled", name: "disabled", "aria-label": "toggle", "aria-labelledby": "disabled", checked: !data.disabled, onChange: function (e) { return _this.setFormData({ disabled: !e }); } }))),
                    React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement(Label, { htmlFor: "skipCatchUpEvents", className: "form-row-label" }, "Skip Events on Re-enable"),
                            React.createElement(Body, { className: "form-row-description" }, "Prevents change events generated while this Trigger is disabled from invoking this Trigger.")),
                        React.createElement(FormRowInputGroup, null,
                            React.createElement(Toggle, { id: "skipCatchUpEvents", name: "skipCatchUpEvents", "aria-label": "toggle", "aria-labelledby": "skipCatchUpEvents", checked: data.skipCatchUpEvents, disabled: isReadOnly, onChange: function (checked) { return _this.setFormData({ skipCatchUpEvents: checked }); } }))),
                    React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement(Label, { htmlFor: "unordered", className: "form-row-label" }, "Event Ordering"),
                            React.createElement(Body, { className: "form-row-description" },
                                "By default, database trigger events are processed sequentially. Turning Event Ordering off will allow requests to be processed in parallel and more quickly if many matching events are created at the same time. Learn more about \u00A0",
                                React.createElement("a", { href: "https://www.mongodb.com/docs/atlas/app-services/triggers/database-triggers/", target: "_blank", rel: "noopener noreferrer" }, "ordered triggers."))),
                        React.createElement(FormRowInputGroup, null,
                            React.createElement(Toggle, { disabled: isReadOnly, id: "unordered", name: "unordered", "aria-label": "toggle", "aria-labelledby": "unordered", checked: !data.unordered, onChange: function (e) { return _this.setFormData({ unordered: !e }); } }))),
                    variant === EditEventFormVariant.Atlas && (React.createElement(DataSourceLinkFormRow, { isReadOnly: isReadOnly, description: 'Only linked clusters will be available for cluster selection below.', mongoServices: mongoServices, getDataSourceDisplay: getDataSourceDisplay, onLinkDataSources: onLinkDataSources, linkDataSourceDescription: 'Link the Atlas clusters and federated database instances you would like to access in functions across all Atlas triggers.' }))),
                React.createElement(Collapsible, { accordion: true, wide: true, headerContent: "Trigger Source Details", open: collapsibles.source, toggle: function () { return _this.onCollapsibleToggle('source'); } },
                    React.createElement(ClusterNamespaceSelect, { dbName: data.database, clusterId: data.serviceId, clusterNameDescription: "Note: Serverless instances cannot be used as a database trigger source", collectionName: data.collection, isMultiRow: true, isLoadingNamespaces: isLoadingNamespaces, isReadOnly: isReadOnly, isCreatable: isCreatable, namespaces: namespaces, mongoServices: namespaceSelectMongoServices, onDbNameChange: function (val, isNew) {
                            if (isNew === void 0) { isNew = false; }
                            _this.setFormData({ database: val });
                            _this.setState({ isNewDatabase: isNew });
                        }, onClusterIdChange: function (value) { return _this.onDataSourceChange(value); }, onCollectionNameChange: function (val, isNew) {
                            if (isNew === void 0) { isNew = false; }
                            _this.setFormData({ collection: val });
                            _this.setState({ isNewCollection: isNew });
                        } }),
                    React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement("span", { className: "form-row-label" }, "Operation Type"),
                            React.createElement(Body, { className: "form-row-description" }, "This trigger will only execute on these operations.")),
                        React.createElement(FormRowInputGroup, { className: baseClassName + "-operation-type" }, dbOperationTypes.map(function (_a) {
                            var name = _a.name, displayName = _a.displayName;
                            return (React.createElement(Checkbox, { className: baseClassName + "-operation-type-checkbox", disabled: isReadOnly, key: name, name: name, checked: data.operationTypes.indexOf(name) >= 0, onChange: _this.onOperationTypesChange, label: displayName }));
                        }))),
                    React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement(Label, { htmlFor: "fullDocument", className: "form-row-label" }, "Full Document"),
                            React.createElement(Body, { className: "form-row-description" },
                                "By turning on Full Document, you will receive the document created or modified in your\u00A0",
                                React.createElement("a", { href: "https://docs.mongodb.com/manual/reference/change-events/", target: "_blank", rel: "noopener noreferrer" }, "change event"),
                                ". For Delete operations, the full document will not exist. For Insert or Replace operations, the full document will always be sent.")),
                        React.createElement(FormRowInputGroup, null,
                            React.createElement(Toggle, { disabled: isReadOnly, id: "fullDocument", name: "fullDocument", "aria-label": "toggle", "aria-labelledby": "fullDocument", checked: data.fullDocument, onChange: function (e) { return _this.setFormData({ fullDocument: !!e }); } }))),
                    React.createElement(Tooltip, { trigger: React.createElement("div", null,
                            React.createElement(FormRow, null,
                                React.createElement(FormRowLabelGroup, null,
                                    React.createElement(Label, { htmlFor: fullDocBeforeChangeStr, className: classNames('form-row-label', {
                                            'edit-database-event-preimage-disabled': !documentPreimageEnabled,
                                        }) }, "Document Preimage"),
                                    React.createElement(Body, { className: "form-row-description" },
                                        "By turning on Document Preimage, you will receive the document that was modified or deleted",
                                        ' ',
                                        React.createElement("b", null, "before"),
                                        " your",
                                        ' ',
                                        React.createElement("a", { href: "https://docs.mongodb.com/manual/reference/change-events/", target: "_blank", rel: "noopener noreferrer" }, "change event"),
                                        ". For Insert operations, the document preimage will not be sent.")),
                                React.createElement(FormRowInputGroup, null,
                                    React.createElement(Toggle, { disabled: !documentPreimageEnabled || isReadOnly, id: fullDocBeforeChangeStr, name: fullDocBeforeChangeStr, "aria-label": "toggle", "aria-labelledby": fullDocBeforeChangeStr, checked: data.fullDocumentBeforeChange, onChange: function (e) { return _this.setFormData({ fullDocumentBeforeChange: !!e }); }, "data-test-selector": TestSelector$4.PreimageToggle })))), darkMode: true, enabled: !documentPreimageEnabled, className: baseClassName + "-tooltip", "data-test-selector": TestSelector$4.PreimageInfoTooltip },
                        "You must be using an ",
                        React.createElement("b", null, "Atlas Cluster"),
                        " running MongoDB 4.4+ and a non-sharded cluster to use this feature.")),
                React.createElement(Collapsible, { accordion: true, wide: true, headerContent: "Function", open: collapsibles.function, toggle: function () { return _this.onCollapsibleToggle('function'); } },
                    React.createElement(ResponseEventConfig, { eventProcessorType: data.eventProcessorType, onChange: function (eventProcessorType) {
                            _this.setFormData({
                                functionId: '',
                                functionName: '',
                                accountID: '',
                                region: '',
                                useExtendedJSON: false,
                                eventProcessorType: eventProcessorType,
                            });
                        } }, responseEventContent)),
                React.createElement(Collapsible, { accordion: true, wide: true, headerContent: "Advanced (Optional)", open: collapsibles.advanced, toggle: function () { return _this.onCollapsibleToggle('advanced'); } },
                    data.eventProcessorType === EventProcessorType.AWSEventBridge && (React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, { wide: true },
                            React.createElement(Label, { className: "form-row-label", htmlFor: "enableEJSON" }, "Enable Extended JSON")),
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement(Body, { className: "form-row-description" },
                                "Enabling Extended JSON will preserve type information for BSON types,",
                                ' ',
                                React.createElement("a", { href: "https://docs.mongodb.com/manual/reference/mongodb-extended-json/", target: "_blank", rel: "noopener noreferrer" }, "learn more"),
                                ' ',
                                "about EJSON.")),
                        React.createElement(FormRowInputGroup, null,
                            React.createElement(Toggle, { disabled: isReadOnly, id: "useExtendedJSON", name: "useExtendedJSON", "aria-label": "toggle", "aria-labelledby": "enableEJSON", checked: !!data.useExtendedJSON, onChange: function (e) { return _this.setFormData({ useExtendedJSON: !!e }); } })))),
                    React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, { wide: true },
                            React.createElement(Label, { className: "form-row-label", htmlFor: "match" }, "Match Expression")),
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement(Body, { className: "form-row-description" },
                                "All change event objects for this trigger are evaluated against this",
                                ' ',
                                React.createElement("a", { href: "https://docs.mongodb.com/manual/reference/operator/aggregation/match/#pipe._S_match", target: "_blank", rel: "noopener noreferrer" }, "match expression"),
                                ". This trigger will not execute unless the expression evaluates to true for a given change event. Leaving this blank or setting to an empty object will match everything so that this trigger will always execute."),
                            React.createElement(Body, { className: "form-row-description" },
                                React.createElement("i", null, "Example: This expression prevents the trigger from executing unless the document's status field is updated to have a value of \"blocked\".")),
                            React.createElement(Code, { language: "json" }, matchExpressionExample)),
                        React.createElement(FormRowInputGroup, { className: "form-row-input-group-match-json-editor" },
                            React.createElement(RichJSONEditor, { id: "match", name: "match", height: "160px", readOnly: isReadOnly, width: "100%", value: data.match, onChange: function (val) { return _this.setFormData({ match: val }); }, className: baseClassName + "-row-editor" }))),
                    React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, { wide: true },
                            React.createElement(Label, { className: "form-row-label", htmlFor: "project" }, "Project Expression")),
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement(Body, { className: "form-row-description" },
                                "This",
                                ' ',
                                React.createElement("a", { href: "https://docs.mongodb.com/manual/reference/operator/aggregation/project/#pipe._S_project", target: "_blank", rel: "noopener noreferrer" }, "project expression"),
                                ' ',
                                "filters the change stream output from MongoDB by limiting the fields included in the change event. A $project stage may be useful for limiting data transfer. Leaving this blank or setting to an empty object will ensure that all change event fields are present."),
                            React.createElement(Body, { className: "form-row-description" },
                                React.createElement("i", null, "Example: This expression will only limit the change event to only include the update description for FieldA and the operation type.")),
                            React.createElement(Code, { language: "json" }, projectExpressionExample)),
                        React.createElement(FormRowInputGroup, { className: "form-row-input-group-match-json-editor" },
                            React.createElement(RichJSONEditor, { id: "project", name: "project", height: "160px", readOnly: isReadOnly, width: "100%", value: data.project, onChange: function (val) { return _this.setFormData({ project: val }); }, className: baseClassName + "-row-editor" }))),
                    React.createElement(FormRow, null,
                        React.createElement(FormRowLabelGroup, null,
                            React.createElement(Label, { htmlFor: "autoResume", className: "form-row-label" }, "Auto-resume Triggers"),
                            React.createElement(Body, { className: "form-row-description" }, "If enabled, when this Trigger's resume token cannot be found in the cluster's oplog, the Trigger automatically resumes processing events at the next relevant change stream event.")),
                        React.createElement(FormRowInputGroup, null,
                            React.createElement(Toggle, { id: "autoResume", name: "autoResume", "aria-label": "toggle", "aria-labelledby": "autoResume", checked: data.autoResume, disabled: isReadOnly, onChange: function (checked) { return _this.setFormData({ autoResume: checked }); } })))),
                !isReadOnly && (React.createElement(FormRowButtonFooter, { onDiscard: this.handleDiscard, onCancel: onCancel, onSave: this.handleSave, formIsDirty: isDirty, editing: editing, saveError: saveError, saving: saving }))));
        };
        return EditDatabaseEvent;
    }(React.Component)),
    _a.defaultProps = defaultProps$4,
    _a; })();

var defaultProps$3 = {
    functionEditorProps: {},
    isReadOnly: false,
    mongoServices: [],
    variant: EditEventFormVariant.BAAS,
    onFormChange: function () { },
    onLinkDataSources: function () { },
};
var TestSelector$3;
(function (TestSelector) {
    TestSelector["TriggerNameInput"] = "trigger-name-input";
})(TestSelector$3 || (TestSelector$3 = {}));
var AriaLabel;
(function (AriaLabel) {
    AriaLabel["TriggerNameLabel"] = "trigger-name-label";
})(AriaLabel || (AriaLabel = {}));
var buildFormData = function (trigger, functionSource) {
    if (trigger) {
        var name_1 = trigger.name, disabled = trigger.disabled, skipCatchUpEvents = trigger.skipCatchUpEvents, schedule = trigger.schedule, scheduleType = trigger.scheduleType, functionId = trigger.functionId, functionName = trigger.functionName, _a = trigger.eventProcessors, eventProcessors = _a === void 0 ? {} : _a;
        var eventProcessor = eventProcessors[EventProcessorType.AWSEventBridge];
        var _b = (eventProcessor || { config: {} }).config, _c = _b.region, region = _c === void 0 ? '' : _c, _d = _b.accountID, accountID = _d === void 0 ? '' : _d, _e = _b.useExtendedJSON, useExtendedJSON = _e === void 0 ? false : _e;
        return {
            name: name_1,
            disabled: disabled,
            skipCatchUpEvents: skipCatchUpEvents,
            schedule: schedule,
            scheduleType: scheduleType,
            functionId: functionId,
            functionName: functionName,
            functionSource: functionSource || '',
            eventProcessorType: eventProcessor ? EventProcessorType.AWSEventBridge : EventProcessorType.Function,
            region: region,
            accountID: accountID,
            useExtendedJSON: useExtendedJSON,
            functionPrivate: true,
        };
    }
    return {
        name: '',
        disabled: false,
        skipCatchUpEvents: false,
        schedule: defaultSchedule,
        scheduleType: 'BASIC',
        functionId: '',
        functionName: DEFAULT_FUNCTION_NAME,
        functionSource: functionSource || SCHEDULED_TRIGGER_FUNCTION_PLACEHOLDER,
        region: '',
        accountID: '',
        useExtendedJSON: false,
        eventProcessorType: EventProcessorType.Function,
        functionPrivate: true,
    };
};
var buildState = function (_a) {
    var trigger = _a.trigger, functionSource = _a.functionSource;
    var initialForm = buildFormData(trigger, functionSource);
    return {
        functionSectionOpen: true,
        cleanData: initialForm,
        data: initialForm,
        isDirty: false,
        showTriggerNameEmptyError: false,
    };
};
var EditScheduledEvent = /* #__PURE__ */ (function () { var _a; return _a = /** @class */ (function (_super) {
        __extends(EditScheduledEvent, _super);
        function EditScheduledEvent(props) {
            var _this = _super.call(this, props) || this;
            _this.state = buildState(_this.props);
            _this.handleDiscard = _this.handleDiscard.bind(_this);
            _this.handleSave = _this.handleSave.bind(_this);
            _this.onFunctionIdChange = _this.onFunctionIdChange.bind(_this);
            _this.setFormData = _this.setFormData.bind(_this);
            return _this;
        }
        EditScheduledEvent.prototype.componentDidUpdate = function () {
            var _a = this.props, functionSource = _a.functionSource, trigger = _a.trigger;
            if (trigger || functionSource) {
                var newForm_1 = buildFormData(trigger, functionSource);
                if (!areFormsEqual(newForm_1, this.state.cleanData)) {
                    /* eslint-disable-next-line react/no-did-update-set-state */
                    this.setState(function () { return ({ cleanData: newForm_1, data: newForm_1, isDirty: false }); });
                }
            }
        };
        EditScheduledEvent.prototype.handleSave = function () {
            var _a;
            var _b = this.state.data, name = _b.name, disabled = _b.disabled, skipCatchUpEvents = _b.skipCatchUpEvents, schedule = _b.schedule, scheduleType = _b.scheduleType, functionId = _b.functionId, functionName = _b.functionName, functionSource = _b.functionSource, eventProcessorType = _b.eventProcessorType, region = _b.region, accountID = _b.accountID, useExtendedJSON = _b.useExtendedJSON;
            var triggerPayload = {
                type: TriggerType.Scheduled,
                name: name,
                disabled: disabled,
                skipCatchUpEvents: skipCatchUpEvents,
                schedule: schedule,
                scheduleType: scheduleType,
                functionId: functionId,
                functionName: functionName,
            };
            if (eventProcessorType === EventProcessorType.AWSEventBridge) {
                triggerPayload.eventProcessors = (_a = {},
                    _a[EventProcessorType.AWSEventBridge] = {
                        config: {
                            region: region,
                            accountID: accountID,
                            useExtendedJSON: useExtendedJSON,
                        },
                    },
                    _a);
            }
            this.props.handleSave(triggerPayload, { name: functionName, source: functionSource, private: true });
        };
        EditScheduledEvent.prototype.handleDiscard = function () {
            this.setState(function (_a) {
                var cleanData = _a.cleanData;
                return ({ data: cleanData, isDirty: false });
            });
            this.props.onFormChange(this.state.cleanData.name, false);
        };
        EditScheduledEvent.prototype.onFunctionIdChange = function (functionId) {
            var _a = this.props, functions = _a.functions, defaultFunctionSource = _a.functionSource;
            var functionName = DEFAULT_FUNCTION_NAME;
            var functionSource = defaultFunctionSource || SCHEDULED_TRIGGER_FUNCTION_PLACEHOLDER;
            var func = functions[functionId];
            if (func) {
                functionName = func.name;
            }
            this.setFormData({ functionId: functionId, functionName: functionName, functionSource: functionSource });
        };
        EditScheduledEvent.prototype.setFormData = function (newValues) {
            var _this = this;
            var cleanData = this.state.cleanData;
            var isDirty = Object.keys(newValues).some(function (key) { return !isClean(newValues[key], cleanData[key]); });
            this.setState(function (_a) {
                var prevData = _a.data;
                return ({
                    data: __assign(__assign({}, prevData), newValues),
                    isDirty: isDirty,
                });
            }, function () {
                _this.props.onFormChange(_this.state.cleanData.name, isDirty);
            });
        };
        EditScheduledEvent.prototype.render = function () {
            var _this = this;
            var _a = this.props, editing = _a.editing, functionEditorProps = _a.functionEditorProps, functions = _a.functions, isReadOnly = _a.isReadOnly, mongoServices = _a.mongoServices, onCancel = _a.onCancel, onLinkDataSources = _a.onLinkDataSources, saveError = _a.saveError, saving = _a.saving, toggleFullscreen = _a.toggleFullscreen, variant = _a.variant, withDebugger = _a.withDebugger, runDebugWithSource = _a.runDebugWithSource, rest = __rest(_a, ["editing", "functionEditorProps", "functions", "isReadOnly", "mongoServices", "onCancel", "onLinkDataSources", "saveError", "saving", "toggleFullscreen", "variant", "withDebugger", "runDebugWithSource"]);
            var _b = this.state, data = _b.data, isDirty = _b.isDirty, functionSectionOpen = _b.functionSectionOpen;
            var responseEventContent;
            switch (data.eventProcessorType) {
                case EventProcessorType.AWSEventBridge:
                    responseEventContent = (React.createElement(EventBridgeFormRow, { isReadOnly: isReadOnly, onChange: function (_a) {
                            var _b = _a.config, region = _b.region, accountID = _b.accountID;
                            return _this.setFormData({ region: region, accountID: accountID });
                        }, eventProcessor: {
                            config: {
                                region: data.region,
                                accountID: data.accountID,
                                useExtendedJSON: data.useExtendedJSON,
                            },
                        } }));
                    break;
                case EventProcessorType.Function:
                    responseEventContent = (React.createElement(EventFunctionConfig, { functionEditorProps: __assign(__assign({}, functionEditorProps), { defaultDebugSource: withDebugger ? 'exports()' : undefined, onRunDebug: runDebugWithSource ? runDebugWithSource(data.functionSource) : undefined }), selectedId: data.functionId, newFunctionData: { name: data.functionName, source: data.functionSource, private: data.functionPrivate }, functions: functions, isReadOnly: isReadOnly, onIdChange: this.onFunctionIdChange, onNewFunctionDataChange: function (_a) {
                            var functionName = _a.name, source = _a.source;
                            return _this.setFormData({ functionName: functionName, functionSource: source });
                        }, toggleFullscreen: toggleFullscreen, type: TriggerType.Scheduled, variant: variant, withDebugger: withDebugger }));
                    break;
                default:
                    responseEventContent = null;
            }
            return (React.createElement("div", __assign({}, passThroughProps(rest)),
                React.createElement(FormRow, null,
                    React.createElement(FormRowLabelGroup, null,
                        React.createElement("label", { id: AriaLabel.TriggerNameLabel, htmlFor: "name", className: "form-row-label" }, "Name")),
                    React.createElement(FormRowInputGroup, null,
                        React.createElement(TextInput, { id: "name", "aria-labelledby": AriaLabel.TriggerNameLabel, "data-test-id": TestSelector$3.TriggerNameInput, readOnly: isReadOnly, value: data.name, placeholder: "Name", state: this.state.showTriggerNameEmptyError ? 'error' : 'none', onChange: function (e) { return _this.setFormData({ name: e.target.value }); }, onBlur: function (e) {
                                return _this.setState({ showTriggerNameEmptyError: !e.target.value || e.target.value.length === 0 });
                            }, errorMessage: "Trigger name must not be empty.", autoFocus: true }))),
                React.createElement(FormRow, null,
                    React.createElement(FormRowLabelGroup, null,
                        React.createElement("label", { htmlFor: "disabled", className: "form-row-label" }, "Enabled")),
                    React.createElement(FormRowInputGroup, null,
                        React.createElement(Toggle, { id: "disabled", name: "disabled", "aria-label": "toggle", "aria-labelledby": "disabled", checked: !data.disabled, disabled: isReadOnly, onChange: function (e) { return _this.setFormData({ disabled: !e }); } }))),
                React.createElement(FormRow, null,
                    React.createElement(FormRowLabelGroup, null,
                        React.createElement(Label, { htmlFor: "skipCatchUpEvents", className: "form-row-label" }, "Skip Events on Re-enable"),
                        React.createElement(Body, { className: "form-row-description" }, "Prevents executing upon the queued matching schedules from when this Trigger was disabled.")),
                    React.createElement(FormRowInputGroup, null,
                        React.createElement(Toggle, { id: "skipCatchUpEvents", name: "skipCatchUpEvents", "aria-label": "toggle", "aria-labelledby": "skipCatchUpEvents", checked: data.skipCatchUpEvents, disabled: isReadOnly, onChange: function (checked) { return _this.setFormData({ skipCatchUpEvents: checked }); } }))),
                React.createElement(CronScheduleInput, { isReadOnly: isReadOnly, schedule: data.schedule, scheduleType: data.scheduleType, onScheduleChange: function (schedule, scheduleType) {
                        return _this.setFormData({ schedule: schedule, scheduleType: scheduleType });
                    } }),
                variant === EditEventFormVariant.Atlas && (React.createElement(DataSourceLinkFormRow, { isReadOnly: isReadOnly, mongoServices: mongoServices, onLinkDataSources: onLinkDataSources, getDataSourceDisplay: getDataSourceDisplay })),
                React.createElement(Collapsible, { accordion: true, wide: true, headerContent: "Function", open: functionSectionOpen, toggle: function () { return _this.setState(function (_a) {
                        var prevOpen = _a.functionSectionOpen;
                        return ({ functionSectionOpen: !prevOpen });
                    }); } },
                    React.createElement(ResponseEventConfig, { eventProcessorType: data.eventProcessorType, onChange: function (eventProcessorType) {
                            _this.setFormData({
                                functionId: '',
                                functionName: '',
                                accountID: '',
                                region: '',
                                eventProcessorType: eventProcessorType,
                            });
                        } }, responseEventContent)),
                !isReadOnly && (React.createElement(FormRowButtonFooter, { onDiscard: this.handleDiscard, onCancel: onCancel, onSave: this.handleSave, formIsDirty: isDirty, editing: editing, saveError: saveError, saving: saving }))));
        };
        return EditScheduledEvent;
    }(React.Component)),
    _a.defaultProps = defaultProps$3,
    _a; })();

var css_248z$7 = ".edit-event-form-type-radio-box {\n  text-transform: capitalize;\n}\n";
styleInject(css_248z$7);

var TestSelectors;
(function (TestSelectors) {
    TestSelectors["EventFormContainer"] = "edit-event-form-container";
})(TestSelectors || (TestSelectors = {}));
var EditEventForm = /* #__PURE__ */ (function () {
    var EditEventForm = function (_a) {
        var className = _a.className, _b = _a.isEditing, isEditing = _b === void 0 ? false : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.isLoadingNamespaces, isLoadingNamespaces = _d === void 0 ? false : _d, _e = _a.isReadOnly, isReadOnly = _e === void 0 ? false : _e, _f = _a.isSaving, isSaving = _f === void 0 ? false : _f, _g = _a.isCollectionCreatable, isCollectionCreatable = _g === void 0 ? false : _g, saveError = _a.saveError, _h = _a.functionEditorProps, functionEditorProps = _h === void 0 ? {} : _h, _j = _a.functions, functions = _j === void 0 ? {} : _j, functionSource = _a.functionSource, trigger = _a.trigger, onTypeSelectChange = _a.onTypeSelectChange, _k = _a.onCancel, onCancel = _k === void 0 ? function () { } : _k, onToggleFullscreen = _a.onToggleFullscreen, mongoServices = _a.mongoServices, namespaces = _a.namespaces, triggerTypeOptions = _a.triggerTypeOptions, onDataSourceChange = _a.onDataSourceChange, onFormChange = _a.onFormChange, onLinkDataSources = _a.onLinkDataSources, onSave = _a.onSave, triggerType = _a.triggerType, _l = _a.variant, variant = _l === void 0 ? EditEventFormVariant.BAAS : _l, withDebugger = _a.withDebugger, runDebugWithSource = _a.runDebugWithSource, rest = __rest(_a, ["className", "isEditing", "isLoading", "isLoadingNamespaces", "isReadOnly", "isSaving", "isCollectionCreatable", "saveError", "functionEditorProps", "functions", "functionSource", "trigger", "onTypeSelectChange", "onCancel", "onToggleFullscreen", "mongoServices", "namespaces", "triggerTypeOptions", "onDataSourceChange", "onFormChange", "onLinkDataSources", "onSave", "triggerType", "variant", "withDebugger", "runDebugWithSource"]);
        var formProps = {
            editing: isEditing,
            functionEditorProps: functionEditorProps,
            functions: functions,
            functionSource: functionSource,
            handleSave: onSave,
            isReadOnly: isReadOnly,
            isLoadingNamespaces: isLoadingNamespaces,
            onCancel: onCancel,
            onFormChange: onFormChange,
            saving: isSaving,
            saveError: saveError,
            toggleFullscreen: onToggleFullscreen,
            variant: variant,
            withDebugger: withDebugger,
            runDebugWithSource: runDebugWithSource,
        };
        var form;
        // default to first available trigger type if no trigger type defined
        if (triggerType === undefined) {
            triggerType = triggerTypeOptions[Object.keys(triggerTypeOptions)[0]].value;
        }
        switch (triggerType) {
            case TriggerType.Authentication:
                form = React.createElement(EditAuthenticationEvent, __assign({}, formProps, { trigger: trigger }));
                break;
            case TriggerType.Scheduled:
                form = (React.createElement(EditScheduledEvent, __assign({}, formProps, { mongoServices: mongoServices, onLinkDataSources: onLinkDataSources, trigger: trigger })));
                break;
            case TriggerType.Database:
            default:
                form = (React.createElement(EditDatabaseEvent, __assign({}, formProps, { isCreatable: isCollectionCreatable, trigger: trigger, mongoServices: mongoServices, namespaces: namespaces, onLinkDataSources: onLinkDataSources, onDataSourceChange: onDataSourceChange, isLoadingNamespaces: isLoadingNamespaces })));
        }
        return (React.createElement("div", __assign({ "data-test-selector": TestSelectors.EventFormContainer, className: className }, passThroughProps(rest)),
            React.createElement(FormRow, null,
                React.createElement(FormRowLabelGroup, null,
                    React.createElement("label", { htmlFor: "type", className: "form-row-label" }, "Trigger Type")),
                React.createElement(FormRowInputGroup, null,
                    React.createElement(RadioBoxGroup, { size: "full", value: triggerType, onChange: function (event) { return onTypeSelectChange(event.target.value); } }, Object.keys(triggerTypeOptions).map(function (type) { return (React.createElement(RadioBox, { className: "edit-event-form-type-radio-box", key: type, checked: triggerType === type, value: type, disabled: isEditing && triggerType !== type }, type.toLowerCase())); })))),
            React.createElement(LoadingWrapper, { isLoading: isLoading }, form)));
    };
    return EditEventForm;
})();

var dbTriggerConfirmBody = (React.createElement(React.Fragment, null,
    React.createElement("div", { className: "tb-view-modal-body-confirm" }, "This trigger has been suspended due to an error. By selecting the checkbox below, you can choose whether or not to attempt to resume this trigger from the last processed change event. Please be aware, this can be an expensive operation and is not guaranteed to work in cases where the collection has been dropped or the oplog is large. If you are having trouble getting your trigger restarted, consider resuming without a resume token."),
    React.createElement("div", { className: "tb-view-modal-body-confirm" },
        "Please see\u00A0",
        React.createElement("a", { href: "https://docs.mongodb.com/manual/changeStreams/#resume-a-change-stream", target: "_blank", rel: "noopener noreferrer" }, "resuming a change stream"),
        "\u00A0for more details.")));
var defaultTriggerConfirmBody = (React.createElement("div", { className: "tb-view-modal-body-confirm" }, "This trigger has been suspended due to an error. Would you like to restart it?"));
var ResumeEventConfirm = /* #__PURE__ */ (function () {
    function ResumeEventConfirm(_a) {
        var name = _a.name, type = _a.type;
        var confirmHeader = (React.createElement("span", null,
            "Resume Trigger: ",
            React.createElement("b", null, name)));
        var confirmBody;
        var checkCriteria;
        switch (type) {
            case TriggerType.Database:
                checkCriteria = [{ text: 'Restart this trigger with a resume token?', defaultValue: true }];
                confirmBody = dbTriggerConfirmBody;
                break;
            default:
                checkCriteria = [];
                confirmBody = defaultTriggerConfirmBody;
        }
        return default_1$1.confirm({
            confirmHeader: confirmHeader,
            confirmBody: confirmBody,
            confirmButtonText: 'Resume Trigger',
            requireAllChecked: false,
            checkCriteria: checkCriteria,
        });
    }
    return ResumeEventConfirm;
})();

var EmptyTriggers = function EmptyTriggers() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "48px",
    height: "55px",
    viewBox: "0 0 48 55",
    version: "1.1",
    className: "empty-state-svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00",
    transform: "translate(-761.000000, -314.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1372",
    transform: "translate(762.000000, 315.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,8 C37,4.37218759 28.9922189,1 19,1 C9.0077811,1 1,4.37218759 1,8 C1,11.6303366 9.00455107,15 19,15 C28.9954489,15 37,11.6303366 37,8 Z M39,8 C39,13.2080639 29.9923507,17 19,17 C8.00764928,17 -1,13.2080639 -1,8 C-1,2.79464911 8.01098133,-1 19,-1 C29.9890187,-1 39,2.79464911 39,8 Z",
    id: "Stroke-6419",
    fill: "#116149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9326685,22.9006693 C22.4836999,22.8634832 22.9605445,23.2800371 22.9977307,23.8310685 C23.0349168,24.3820999 22.6183629,24.8589445 22.0673315,24.8961307 C21.04523,24.9651068 20.0217282,25.0004 19,25.0004 C8.00764928,25.0004 -1,21.2084639 -1,16.0004 C-1,15.4481153 -0.55228475,15.0004 0,15.0004 C0.55228475,15.0004 1,15.4481153 1,16.0004 C1,19.6307366 9.00455107,23.0004 19,23.0004 C19.9762718,23.0004 20.9548854,22.9666547 21.9326685,22.9006693 Z",
    id: "Stroke-6421",
    fill: "#116149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,32 C19.5522847,32 20,32.4477153 20,33 C20,33.5522847 19.5522847,34 19,34 C8.00764928,34 -1,30.2080639 -1,25 C-1,24.4477153 -0.55228475,24 0,24 C0.55228475,24 1,24.4477153 1,25 C1,28.6303366 9.00455107,32 19,32 Z",
    id: "Stroke-6423",
    fill: "#116149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,41 C19.5522847,41 20,41.4477153 20,42 C20,42.5522847 19.5522847,43 19,43 C8.00764928,43 -1,39.2080639 -1,34 L-1,8 C-1,7.44771525 -0.55228475,7 0,7 C0.55228475,7 1,7.44771525 1,8 L1,34 C1,37.6303366 9.00455107,41 19,41 Z",
    id: "Stroke-6425",
    fill: "#116149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,8 C37,7.44771525 37.4477153,7 38,7 C38.5522847,7 39,7.44771525 39,8 L39,19 C39,19.5522847 38.5522847,20 38,20 C37.4477153,20 37,19.5522847 37,19 L37,8 Z",
    id: "Stroke-6427",
    fill: "#116149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,37 C25.2321773,37 24.7508101,36.1705178 25.1317569,35.5038611 L33.1317569,21.5038611 C33.6405289,20.61351 35,20.9745372 35,22 L35,31 L40,31 C40.7678227,31 41.2491899,31.8294822 40.8682431,32.4961389 L32.8682431,46.4961389 C32.3594711,47.38649 31,47.0254628 31,46 L31,37 L26,37 Z M27.7231797,35 L32,35 C32.5522847,35 33,35.4477153 33,36 L33,42.2344356 L38.2768203,33 L34,33 C33.4477153,33 33,32.5522847 33,32 L33,25.7655644 L27.7231797,35 Z",
    id: "Stroke-6429",
    fill: "#15CC62"
  })))));
};
var EmptyScheduledTriggers = function EmptyScheduledTriggers() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#116149",
    fillRule: "nonzero",
    d: "M21.737981,42.737981 C21.1856963,42.737981 20.737981,42.2902658 20.737981,41.737981 C20.737981,41.1856963 21.1856963,40.737981 21.737981,40.737981 C32.2313913,40.737981 40.737981,32.2313913 40.737981,21.737981 C40.737981,18.4536797 39.9045073,15.2926553 38.3390509,12.4891006 C35.0043316,6.51699706 28.7029869,2.73798104 21.737981,2.73798104 C11.2445708,2.73798104 2.73798104,11.2445708 2.73798104,21.737981 C2.73798104,22.2902658 2.29026578,22.737981 1.73798104,22.737981 C1.18569629,22.737981 0.737981035,22.2902658 0.737981035,21.737981 C0.737981035,10.1400013 10.1400013,0.737981035 21.737981,0.737981035 C29.4351166,0.737981035 36.4006542,4.91532407 40.0852655,11.5140445 C41.8160869,14.613749 42.737981,18.1101159 42.737981,21.737981 C42.737981,33.3359608 33.3359608,42.737981 21.737981,42.737981 Z",
    transform: "scale(-1 1) rotate(16 0 -132.936)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16CC62",
    fillRule: "nonzero",
    d: "M35.7394587,35.7396529 L30.7394587,35.7396529 C29.971636,35.7396529 29.4902688,34.9101707 29.8712155,34.243514 L37.8712155,20.243514 C38.3799876,19.3531629 39.7394587,19.7141901 39.7394587,20.7396529 L39.7394587,29.7396529 L44.7394587,29.7396529 C45.5072814,29.7396529 45.9886485,30.5691351 45.6077018,31.2357918 L37.6077018,45.2357918 C37.0989298,46.1261429 35.7394587,45.7651157 35.7394587,44.7396529 L35.7394587,35.7396529 Z M32.4626384,33.7396529 L36.7394587,33.7396529 C37.2917434,33.7396529 37.7394587,34.1873681 37.7394587,34.7396529 L37.7394587,40.9740885 L43.016279,31.7396529 L38.7394587,31.7396529 C38.1871739,31.7396529 37.7394587,31.2919376 37.7394587,30.7396529 L37.7394587,24.5052173 L32.4626384,33.7396529 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#116149",
    fillRule: "nonzero",
    d: "M22.5951231,23.3347352 L28.6809394,26.9107423 C29.0589783,27.2528353 29.0845167,27.8326886 28.737981,28.2058809 C28.3914454,28.5790732 27.8040616,28.6042842 27.4260227,28.2621913 L21.0390938,24.4137028 C20.847224,24.2400771 20.737981,23.9949258 20.737981,23.7379783 L20.737981,13.6546475 C20.737981,13.1483866 21.1537164,12.737981 21.6665521,12.737981 C22.1793877,12.737981 22.5951231,13.1483866 22.5951231,13.6546475 L22.5951231,23.3347352 Z"
  })));
};
var EmptyAuthTriggers = function EmptyAuthTriggers() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "55px",
    height: "55px",
    viewBox: "0 0 55 55",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Auth-Triggers-UI",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Empty-State",
    transform: "translate(-713.000000, -241.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-411",
    transform: "translate(713.000000, 241.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.3647815,29.3505049 C32.9655956,29.5492298 33.2915533,30.1973841 33.0928284,30.7981982 C32.8941036,31.3990122 32.2459492,31.7249699 31.6451352,31.5262451 C28.7693718,30.5750595 27.5740517,30.1662485 25.9493092,29.5533903 C25.5031679,29.3851043 25.207875,28.9581169 25.207875,28.4812917 L25.207875,22.752125 C25.207875,22.2881276 25.4877039,21.8699323 25.9166158,21.6929347 C26.1851157,21.5821337 26.6765014,21.2493564 27.1903096,20.6295324 C28.0935016,19.5399819 28.645375,17.9982314 28.645375,15.877125 C28.645375,15.2466456 29.1545841,14.7350983 29.7841727,14.7313128 C29.9062668,14.3611748 29.9894375,13.9481794 29.9894375,13.5041042 C29.9894375,13.0600289 29.9062668,12.6470335 29.7758113,12.3879159 C29.1508078,12.2693076 28.645375,11.7592206 28.645375,11.1310833 C28.645375,10.7335652 29.4467108,8.70359717 29.3723877,8.9136327 C29.8890174,7.4536486 30.0964214,6.17948609 29.8922138,5.01298613 C29.8734153,4.90560303 29.8510733,4.79978056 29.825009,4.69504768 C29.0290602,1.49105911 17.9508727,1.49105911 17.1531042,4.69559768 C17.0051457,5.28992885 16.4159591,5.66282429 15.8154889,5.54217262 C14.8160977,5.34136629 14.3860532,5.46743195 14.2012002,5.75694511 C13.9919885,6.08460826 13.9330411,6.7535977 14.0612975,7.67143997 C14.1298846,8.1622703 14.2449658,8.69139273 14.4057728,9.29414052 C14.4538742,9.47443728 14.5042814,9.65504447 14.5655794,9.8685965 C14.5886071,9.94882129 14.6866931,10.2873057 14.7104051,10.3703145 C14.8515014,10.8642521 14.895375,11.0474273 14.895375,11.2937917 C14.895375,11.9266179 14.3823679,12.439625 13.7495417,12.439625 C13.7617361,12.439625 13.5495937,12.846028 13.5495937,13.5854583 C13.5495937,14.3248887 13.7617361,14.7312917 13.7495417,14.7312917 C14.3823679,14.7312917 14.895375,15.2442987 14.895375,15.877125 C14.895375,17.9982314 15.4472484,19.5399819 16.3504404,20.6295324 C16.8642486,21.2493564 17.3556343,21.5821337 17.6241342,21.6929347 C18.0530461,21.8699323 18.332875,22.2881276 18.332875,22.752125 L18.332875,28.4812917 C18.332875,28.9570444 18.03889,29.3833056 17.5941833,29.5523518 C16.6792913,29.9001293 15.7020127,30.2463876 14.5331528,30.6416112 C13.9725573,30.831164 10.7811722,31.8849824 9.91914653,32.1813204 C5.74745999,33.6154181 3.71132493,34.7129242 3.37900011,35.7163515 C3.09156141,36.5847445 2.85732318,37.7563403 2.6779094,39.1464445 C2.52159686,40.3575595 2.41525147,41.6620068 2.35019952,42.9674293 C2.34033097,43.1654653 2.33173918,43.3573347 2.32432861,43.542125 L32.082875,43.542125 C32.7157013,43.542125 33.2287083,44.0551321 33.2287083,44.6879583 C33.2287083,45.3207846 32.7157013,45.8337917 32.082875,45.8337917 L1.145375,45.8337917 C0.507972771,45.8337917 -0.00690969584,45.3136225 -0.00039854856,44.6762535 C0.000573571767,44.5810937 0.00371340122,44.407995 0.0102403594,44.1679816 C0.0210410046,43.7708134 0.0376735537,43.328957 0.061372943,42.8533722 C0.129190146,41.4924583 0.240218498,40.1305693 0.405094567,38.8531037 C0.601615901,37.3304495 0.862191665,36.0271206 1.20347791,34.9960465 C1.87227253,32.9766764 4.18928676,31.7277724 9.17413468,30.0141348 C10.0523098,29.7122452 13.2512973,28.6559163 13.7991041,28.4706878 C14.6322928,28.1889639 15.3635525,27.9335358 16.0412083,27.6856075 L16.0412083,23.4275568 C15.586996,23.1267727 15.0819833,22.6902101 14.586143,22.0920613 C13.4741667,20.7506472 12.7673191,18.9648538 12.6287583,16.7086514 C10.8806047,15.6116885 10.8044518,11.9482266 12.4002995,10.6276604 C12.3156452,10.3334786 12.2285372,10.0235012 12.1915524,9.88487221 C12.0087009,9.19949581 11.874972,8.58463477 11.7916824,7.98858889 C11.5946887,6.57884145 11.6967065,5.42105043 12.2696771,4.52367514 C12.8954921,3.54353605 13.9502604,3.09357142 15.3326549,3.17196017 C18.0486539,-1.35860275 30.7627848,-1.03525575 32.0489595,4.14207384 C32.088036,4.29909257 32.1215218,4.45769704 32.1495523,4.61781631 C32.4348285,6.24740703 32.1690958,7.8799061 31.5327836,9.67811005 C31.4538295,9.9012326 31.371581,10.120362 31.277059,10.3623862 C31.2612609,10.4028375 31.2359722,10.4669148 31.2082397,10.5369762 C32.731314,11.9366244 32.6327329,15.592858 30.9124963,16.7003908 C30.7751551,18.9604954 30.0679401,20.7490106 28.954607,22.0920613 C28.4587667,22.6902101 27.953754,23.1267727 27.4995417,23.4275568 L27.4995417,27.6854503 C28.7645481,28.1503759 29.9767257,28.5606332 32.3647815,29.3505049 Z M29.7912083,12.2769167 C29.7865193,12.2769167 29.7818368,12.2768885 29.7771611,12.2768323 C29.7807166,12.2768366 29.7857797,12.2769167 29.7912083,12.2769167 Z",
    id: "Stroke-7804",
    fill: "#116149",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5416667,43.5416667 L37.8125,43.5416667 C36.9327032,43.5416667 36.3811366,42.5912183 36.8176381,41.8273408 L45.9843047,25.7856741 C46.5672727,24.7654802 48.125,25.1791572 48.125,26.3541667 L48.125,36.6666667 L53.8541667,36.6666667 C54.7339635,36.6666667 55.2855301,37.617115 54.8490286,38.3809925 L45.6823619,54.4226592 C45.099394,55.4428531 43.5416667,55.0291761 43.5416667,53.8541667 L43.5416667,43.5416667 Z M39.7869767,41.25 L44.6875,41.25 C45.3203263,41.25 45.8333333,41.7630071 45.8333333,42.3958333 L45.8333333,49.5394574 L51.87969,38.9583333 L46.9791667,38.9583333 C46.3463404,38.9583333 45.8333333,38.4453263 45.8333333,37.8125 L45.8333333,30.6688759 L39.7869767,41.25 Z",
    id: "Stroke-7805",
    fill: "#16CC62",
    fillRule: "nonzero"
  }))))));
};
var EmptyAllTriggers = function EmptyAllTriggers() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "52",
    viewBox: "0 0 32 52"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#16CC62",
    d: "M477.000739,31.9992285 L467.002585,31.9992285 C465.467224,31.9992285 464.504667,30.3404775 465.26642,29.0073354 L481.263465,1.01093583 C482.280821,-0.769537249 484.999261,-0.0475757284 484.999261,2.00308611 L484.999261,20.0007715 L494.997415,20.0007715 C496.532776,20.0007715 497.495333,21.6595225 496.73358,22.9926646 L480.736535,50.9890642 C479.719179,52.7695372 477.000739,52.0475757 477.000739,49.9969139 L477.000739,31.9992285 Z M470.448308,27.9997428 L479.000369,27.9997428 C480.104735,27.9997428 481,28.8950582 481,29.9994856 L481,42.4667534 L491.551692,24.0002572 L482.999631,24.0002572 C481.895265,24.0002572 481,23.1049418 481,22.0005144 L481,9.53324657 L470.448308,27.9997428 Z",
    transform: "translate(-465)"
  }));
};

var TriggersIcon = function TriggersIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "12px",
    height: "20px",
    viewBox: "0 0 12 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stitch-Sidebar-(1)-Copy",
    transform: "translate(-13.000000, -346.000000)",
    fill: "#15CC62",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9997534,358 C13.2321198,358 12.7508711,357.170518 13.1317241,356.503861 L18.8446028,346.503861 C19.3532496,345.61351 20.712386,345.974537 20.712386,347 L20.712386,353.142857 L23.9972913,353.142857 C24.7649249,353.142857 25.2461736,353.972339 24.8653206,354.638996 L19.1524419,364.638996 C18.6437951,365.529347 17.2846587,365.16832 17.2846587,364.142857 L17.2846587,358 L13.9997534,358 Z M15.7225088,356 L18.2844125,356 C18.8365613,356 19.2841663,356.447715 19.2841663,357 L19.2841663,360.377293 L22.2745359,355.142857 L19.7126322,355.142857 C19.1604834,355.142857 18.7128784,354.695142 18.7128784,354.142857 L18.7128784,350.765564 L15.7225088,356 Z",
    id: "Stroke-6429"
  }))));
};

var TriggersIcon$1 = TriggersIcon;

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    EmptyAllTriggers: EmptyAllTriggers,
    EmptyAuthTriggers: EmptyAuthTriggers,
    EmptyScheduledTriggers: EmptyScheduledTriggers,
    EmptyTriggers: EmptyTriggers,
    TriggersIcon: TriggersIcon$1
});

function measurementTitle(name) {
    switch (name) {
        case MeasurementName.RequestCount:
            return 'Requests';
        case MeasurementName.DataOut:
            return 'Data Transfer';
        case MeasurementName.ComputeTime:
            return 'Compute Runtime';
        case MeasurementName.SyncTime:
            return 'Sync Runtime';
        default:
            return '';
    }
}
function measurementUnits(units) {
    switch (units) {
        case MeasurementUnit.Gigabytes:
            return ' GB';
        case MeasurementUnit.GigabyteSeconds:
            return ' GB·s';
        case MeasurementUnit.Hours:
            return ' Hours';
        case MeasurementUnit.None:
        default:
            return '';
    }
}
function measurementUsage(rawUsage, scaled) {
    if (scaled === void 0) { scaled = false; }
    var usage = '--';
    var precision = scaled ? 2 : 0;
    if (rawUsage >= 1000000000) {
        usage = (rawUsage / 1000000000).toFixed(precision) + "B";
    }
    else if (rawUsage >= 1000000) {
        usage = (rawUsage / 1000000).toFixed(precision) + "M";
    }
    else if (rawUsage >= 1000) {
        usage = (rawUsage / 1000).toFixed(precision) + "K";
    }
    else {
        usage = rawUsage.toFixed(precision);
    }
    return usage;
}

var SHORT_DATE = 'MMM DD';
function useBillingPeriod() {
    var billingPeriod = useMemo(function () {
        var startOfThisMonth = moment().utc().startOf('month');
        var endOfThisMonth = moment().utc().endOf('month');
        var daysRemainingInMonth = endOfThisMonth.diff(moment().utc(), 'days');
        return {
            start: {
                date: startOfThisMonth.toDate(),
                short: startOfThisMonth.format(SHORT_DATE),
            },
            end: {
                date: endOfThisMonth.toDate(),
                short: endOfThisMonth.format(SHORT_DATE),
            },
            daysUntil: {
                endOfMonth: daysRemainingInMonth,
                nextBillingPeriod: daysRemainingInMonth + 1,
            },
        };
    }, []);
    return billingPeriod;
}

var css_248z$6 = ".usage-tooltip {\n  min-width: 210px;\n  margin-bottom: 8px;\n  display: flex;\n  font-size: 14px;\n  font-weight: 700;\n}\n.usage-tooltip-container {\n  max-width: 260px;\n}\n.usage-tooltip-icon {\n  margin-left: 6px;\n}\n";
styleInject(css_248z$6);

var TestSelector$2;
(function (TestSelector) {
    TestSelector["Container"] = "container";
})(TestSelector$2 || (TestSelector$2 = {}));
function UsageTooltip(_a) {
    var className = _a.className, header = _a.header, rest = __rest(_a, ["className", "header"]);
    var _b = useBillingPeriod(), start = _b.start, end = _b.end, daysUntil = _b.daysUntil;
    return (React.createElement("div", __assign({ className: classNames('usage-tooltip', className), "data-test-selector": TestSelector$2.Container }, passThroughProps(rest)),
        header,
        React.createElement(Tooltip, { className: "usage-tooltip-container", trigger: React.createElement("span", null,
                React.createElement(Icon, { title: "Billing Period Info", glyph: "InfoWithCircle", size: "small", className: "usage-tooltip-icon" })), triggerEvent: "hover", justify: "middle", darkMode: true }, "Showing usage from " + start.short + " - " + end.short + ". Free Tier resets in " + daysUntil.nextBillingPeriod + " days.")));
}

var css_248z$5 = ".usage-card {\n  padding: 16px 32px;\n  min-width: 150px;\n}\n.usage-card-title {\n  margin-bottom: 16px;\n  font-size: 16px;\n}\n.usage-card-amount {\n  font-size: 21px;\n}\n";
styleInject(css_248z$5);

var TestSelector$1;
(function (TestSelector) {
    TestSelector["Title"] = "title";
    TestSelector["Amount"] = "amount";
})(TestSelector$1 || (TestSelector$1 = {}));
function UsageCard(_a) {
    var className = _a.className, name = _a.name, units = _a.units, usage = _a.usage, rest = __rest(_a, ["className", "name", "units", "usage"]);
    return (React.createElement(Card, __assign({ className: classNames('usage-card', className) }, passThroughProps(rest)),
        React.createElement(Body, { className: "usage-card-title", weight: "medium", "data-test-selector": TestSelector$1.Title }, measurementTitle(name)),
        React.createElement(Body, { className: "usage-card-amount", "data-test-selector": TestSelector$1.Amount }, "" + measurementUsage(usage, usage > 1000 || units !== MeasurementUnit.None) + measurementUnits(units))));
}

var css_248z$4 = ".app-usage-cards {\n  margin-bottom: 32px;\n  display: flex;\n}\n.app-usage-cards .usage-card:not(:first-of-type) {\n  margin-left: 32px;\n}\n";
styleInject(css_248z$4);

function AppUsage(_a) {
    var cardClassName = _a.cardClassName, className = _a.className, computeTime = _a.computeTime, dataOut = _a.dataOut, requestCount = _a.requestCount, syncTime = _a.syncTime, rest = __rest(_a, ["cardClassName", "className", "computeTime", "dataOut", "requestCount", "syncTime"]);
    return (React.createElement("div", __assign({ className: classNames('app-usage-cards', className) }, passThroughProps(rest)),
        React.createElement(UsageCard, { className: cardClassName, name: MeasurementName.RequestCount, units: MeasurementUnit.None, usage: requestCount }),
        React.createElement(UsageCard, { className: cardClassName, name: MeasurementName.DataOut, units: MeasurementUnit.Gigabytes, usage: dataOut }),
        React.createElement(UsageCard, { className: cardClassName, name: MeasurementName.ComputeTime, units: MeasurementUnit.Hours, usage: computeTime }),
        React.createElement(UsageCard, { className: cardClassName, name: MeasurementName.SyncTime, units: MeasurementUnit.Hours, usage: syncTime })));
}
AppUsage.defaultProps = {
    cardClassName: '',
    className: '',
};

var css_248z$3 = ".tb-splitpanel-container {\n  display: flex;\n  flex-direction: row;\n}\n.tb-splitpanel-is-right {\n  width: 70%;\n  flex-grow: 1;\n}\n.tb-splitpanel-is-left {\n  min-width: 300px;\n  max-width: 30%;\n  margin-right: 20px;\n}\n.tb-splitpanel-rightside-tabs-content-padded {\n  padding: 20px;\n}\n.tb-splitpanel-rightside-header-actions .tb-delete-value-button {\n  margin-left: 5px;\n}\n.tb-splitpanel-debug-content {\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n}\n@media (max-width: 1300px) {\n  .tb-splitpanel-debug-content {\n    flex-direction: column;\n  }\n}\n";
styleInject(css_248z$3);

var SplitPanel = /* #__PURE__ */ (function () {
    var SplitPanel = basicComponent({ left: 'tb-splitpanel-is-left', right: 'tb-splitpanel-is-right' }, 'SplitPanel');
    return SplitPanel;
})();

var SplitPanelContainer = /* #__PURE__ */ (function () {
    var SplitPanelContainer = basicComponent({}, 'SplitPanelContainer', 'tb-splitpanel-container');
    return SplitPanelContainer;
})();

var css_248z$2 = ".tb-status-container-content {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n}\n.tb-status-container-content-message {\n  display: flex;\n  align-items: center;\n  padding-right: 20px;\n}\n.tb-status-container-content-controls {\n  display: flex;\n  justify-content: flex-end;\n  flex-shrink: 0;\n  align-items: center;\n}\n.tb-status-message {\n  font-size: 0.875rem;\n  padding-right: 20px;\n}\n";
styleInject(css_248z$2);

var defaultProps$2 = {
    className: '',
    statusType: '',
    message: '',
    messageAddon: undefined,
    controls: undefined,
};
var StatusContainerAgent = createAgent('status-container', 'statusId');
var lastUniqueId = 0;
var getId = function (prefix) { return prefix + "-" + ++lastUniqueId; };
var StatusAgent = /* #__PURE__ */ (function () {
    var StatusAgent = function (props, _a) {
        var through = _a.through;
        var statusType = props.statusType, statusId = props.statusId, className = props.className, message = props.message, messageAddon = props.messageAddon, controls = props.controls, rest = __rest(props, ["statusType", "statusId", "className", "message", "messageAddon", "controls"]);
        var allClassNames = classNames('tb-status-container-content', className);
        if (!through) {
            return null;
        }
        return message ? (React.createElement(StatusContainerAgent, { statusId: statusId, statusType: statusType, className: classNames },
            React.createElement("div", __assign({ className: allClassNames }, passThroughProps(rest)),
                React.createElement("div", { className: "tb-status-container-content-message" },
                    message && (React.createElement("div", { id: getId(statusId), className: "tb-status-message" }, message)),
                    messageAddon),
                React.createElement("div", { className: "tb-status-container-content-controls" }, controls)))) : null;
    };
    StatusAgent.contextTypes = {
        through: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    };
    StatusAgent.defaultProps = defaultProps$2;
    return StatusAgent;
})();

var css_248z$1 = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-status-alert-close {\n  color: rgba(120, 120, 120, 0.5);\n}\n.tb-status-alert-close:focus,\n.tb-status-alert-close:hover {\n  color: rgba(120, 120, 120, 0.25);\n}\n.tb-status-alert-is-error {\n  color: #db1414;\n  border: 1px solid #fbcccc;\n  background: #fff6f6;\n}\n.tb-status-alert-is-warning {\n  color: #b17b00;\n  border: 1px solid #fee9c3;\n  background: #fffbf5;\n}\n.tb-status-alert-is-info {\n  color: #1b8bc1;\n  border: 1px solid #b4dff3;\n  background: #d9edf7;\n}\n.tb-status-alert-is-success {\n  color: #13aa52;\n  border: 1px solid #98efbb;\n  background: #effef6;\n}\n";
styleInject(css_248z$1);

var defaultProps$1 = {
    className: '',
    message: '',
    warning: false,
    error: false,
    info: false,
    success: false,
    clearable: false,
    onClear: function () { },
};
var StatusAlert = /* #__PURE__ */ (function () {
    // TODO make these mutually exclusive props use "variant" instead
    var StatusAlert = function (_a) {
        var className = _a.className, statusId = _a.statusId, message = _a.message, warning = _a.warning, error = _a.error, info = _a.info, success = _a.success, clearable = _a.clearable, onClear = _a.onClear, rest = __rest(_a, ["className", "statusId", "message", "warning", "error", "info", "success", "clearable", "onClear"]);
        var allClassNames = classNames(className, {
            'tb-status-alert-is-warning': warning,
            'tb-status-alert-is-error': error,
            'tb-status-alert-is-info': info,
            'tb-status-alert-is-success': success,
        });
        return (React.createElement(StatusAgent, __assign({ statusId: statusId, className: allClassNames, message: message, messageAddon: undefined, controls: clearable ? (React.createElement("div", { className: "tb-status-alert-close", onClick: onClear },
                React.createElement(FontAwesome, { name: "times" }))) : undefined }, passThroughProps(rest))));
    };
    StatusAlert.defaultProps = defaultProps$1;
    return StatusAlert;
})();

var css_248z = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-status-banner-close {\n  color: #fff;\n  font-size: 11px;\n  font-weight: bold;\n  text-transform: uppercase;\n  padding-left: 10px;\n}\n.tb-status-banner-close:hover {\n  cursor: pointer;\n}\n.tb-status-banner-close:focus:not([disabled]),\n.tb-status-banner-close:hover:not([disabled]) {\n  color: #fff;\n}\n.tb-status-banner-plain-text-button {\n  color: #fff;\n  font-size: 11px;\n  font-weight: bold;\n  text-transform: uppercase;\n  border: none;\n  background: none;\n  text-decoration: underline;\n  margin-right: 20px;\n}\n.tb-status-banner-help {\n  color: #fff;\n  font-size: 11px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.tb-status-banner-is-warning {\n  color: #fff;\n  background-color: #fdb100;\n}\n.tb-status-banner-is-info {\n  color: #fff;\n  background-color: #43b1e5;\n}\n.tb-status-banner-is-error {\n  color: #fff;\n  background-color: #ef4c4c;\n}\n.tb-status-banner-is-success {\n  color: #fff;\n  background-color: #13aa52;\n}\n.tb-status-banner-control-button-container {\n  flex-shrink: 0;\n}\n";
styleInject(css_248z);

var defaultProps = {
    actionLabel: '',
    className: '',
    clearable: false,
    dismissable: false,
    displayTimeMillis: 0,
    error: false,
    helpUrl: '',
    info: false,
    message: '',
    secondaryActionLabel: '',
    success: false,
    warning: false,
    disabled: false,
    action: function () { },
    onClear: function () { },
    onHelp: function () { },
    secondaryAction: function () { },
};
var TestSelector;
(function (TestSelector) {
    TestSelector["HelpLink"] = "help-link";
    TestSelector["ActionButton"] = "action-button";
    TestSelector["SecondaryActionButton"] = "secondary-action-button";
    TestSelector["DismissButton"] = "dismiss-button";
})(TestSelector || (TestSelector = {}));
var StatusBanner = /* #__PURE__ */ (function () {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(StatusBanner, _super);
            function StatusBanner() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.timeoutID = null;
                _this.state = {
                    isOpen: true,
                };
                return _this;
            }
            StatusBanner.prototype.componentDidMount = function () {
                var _this = this;
                var displayTimeMillis = this.props.displayTimeMillis;
                if (displayTimeMillis) {
                    this.timeoutID = window.setTimeout(function () {
                        _this.setState({ isOpen: false });
                        _this.props.onClear();
                    }, displayTimeMillis);
                }
            };
            StatusBanner.prototype.componentWillUnmount = function () {
                if (this.timeoutID !== null) {
                    clearTimeout(this.timeoutID);
                }
            };
            StatusBanner.prototype.render = function () {
                var _a = this.props, className = _a.className, statusId = _a.statusId, message = _a.message, warning = _a.warning, error = _a.error, info = _a.info, success = _a.success, actionLabel = _a.actionLabel, action = _a.action, secondaryActionLabel = _a.secondaryActionLabel, secondaryAction = _a.secondaryAction, helpUrl = _a.helpUrl, dismissable = _a.dismissable, clearable = _a.clearable, onClear = _a.onClear, onHelp = _a.onHelp, statusType = _a.statusType, disabled = _a.disabled, rest = __rest(_a, ["className", "statusId", "message", "warning", "error", "info", "success", "actionLabel", "action", "secondaryActionLabel", "secondaryAction", "helpUrl", "dismissable", "clearable", "onClear", "onHelp", "statusType", "disabled"]);
                if (!this.state.isOpen) {
                    return null;
                }
                var allClassNames = classNames(className, {
                    'tb-status-banner-is-warning': warning,
                    'tb-status-banner-is-error': error,
                    'tb-status-banner-is-info': info,
                    'tb-status-banner-is-success': success,
                });
                return (React.createElement(StatusAgent, __assign({ statusId: statusId, statusType: statusType, className: allClassNames, message: message, messageAddon: React.createElement("div", { className: "tb-status-banner-control-button-container" },
                        secondaryActionLabel && (React.createElement("button", { type: "button", className: "tb-status-banner-plain-text-button", onClick: secondaryAction, disabled: disabled, "data-test-selector": TestSelector.SecondaryActionButton }, secondaryActionLabel)),
                        actionLabel && (React.createElement(Button, { size: "xsmall", onClick: action, disabled: disabled, "data-test-selector": TestSelector.ActionButton }, actionLabel)),
                        dismissable && (React.createElement(Button, { size: "xsmall", onClick: onClear, disabled: disabled, "data-test-selector": TestSelector.DismissButton }, "dismiss"))), controls: React.createElement(React.Fragment, null,
                        helpUrl && (React.createElement("a", { className: "tb-status-banner-help", "data-test-selector": TestSelector.HelpLink, href: helpUrl, onClick: onHelp, target: "_blank", rel: "noopener noreferrer" },
                            React.createElement(FontAwesome, { name: "question-circle" }),
                            " Need Help?")),
                        clearable && (React.createElement("div", { className: "tb-status-banner-close", onClick: onClear }, "\u00D7"))) }, passThroughProps(rest))));
            };
            return StatusBanner;
        }(React.Component)),
        _a.defaultProps = defaultProps,
        _a;
})();

var statusContainerThroughArea = throughArea('status-container');
var StatusContainerComponent = function (_a) {
    var filter = _a.filter;
    return function (props) {
        var values = Object.values(props);
        if (filter) {
            values = values.filter(filter);
        }
        return (React.createElement("div", { className: "tb-status-container" }, values.map(function (item) { return (React.createElement(React.Fragment, { key: item.statusId }, item.children)); })));
    };
};
var buildStatusContainer = function (statusContainerProps) {
    var StatusContainerArea = statusContainerThroughArea(StatusContainerComponent(statusContainerProps));
    var StatusContainer = function (props, _a) {
        var through = _a.through;
        if (!through) {
            return null;
        }
        return React.createElement(StatusContainerArea, null);
    };
    StatusContainer.contextTypes = {
        through: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    };
    return StatusContainer;
};
var StatusContainer = buildStatusContainer({});

// Deprecated Components - Use leafygreen equivalents
/**
 * @deprecated please use `@leafygreen-ui/text-input` instead
 */
var InlineTextInputDeprecated = InlineTextInput;
/**
 * @deprecated please use `@leafygreen-ui/confirmation-modal` instead
 */
var ConfirmDeprecated = default_1;
/**
 * @deprecated please use `@leafygreen-ui/confirmation-modal` instead
 */
var ConfirmChecklistDeprecated = default_1$1;
/**
 * @deprecated please use `@leafygreen-ui/select` or `@leafygreen-ui/menu` instead
 */
var DropdownDeprecated = Dropdown;
/**
 * @deprecated please use `@leafygreen-ui/select` or `@leafygreen-ui/menu` instead
 */
var DropdownListItemDeprecated = DropdownListItem;
/**
 * @deprecated please use `@leafygreen-ui/select` or `@leafygreen-ui/menu` instead
 */
var SelectDropdownToggleDeprecated = SelectDropdownToggle;
/**
 * @deprecated please use `@leafygreen-ui/select` or `@leafygreen-ui/menu` instead
 */
var SelectDropdownSummaryToggleDeprecated = SelectDropdownSummaryToggle;
/**
 * @deprecated please use `@leafygreen-ui/table` instead
 */
var TableDeprecated = Table;
/**
 * @deprecated please use `@leafygreen-ui/tabs` instead
 */
var TabDeprecated = Tab;
/**
 * @deprecated please use `@leafygreen-ui/tabs` instead
 */
var TabsDeprecated = Tabs;
/**
 * @deprecated for components that use DisplayItemRow and DisplayItemColumn, please use `@leafygreen-ui/table` instead
 */
var DisplayItemColumnDeprecated = DisplayItemColumn;
/**
 * @deprecated for components that use DisplayItemRow and DisplayItemColumn, please use `@leafygreen-ui/table` instead
 */
var DisplayItemRowDeprecated = DisplayItemRow;

export { ResumeEventConfirm as $, AddDependencyDialog as A, util as B, ClusterNamespaceSelect as C, DateTimeDisplay as D, ErrorBoundary as E, EmptyLogsIcon$1 as F, CreatableSelect as G, HiddenFileInput as H, IndexRow as I, JSONEditorFormRow as J, InstallationStatusToast as K, EditList as L, MaskedInput as M, NamespaceSelectRow as N, EditListItem as O, Panel as P, CronScheduleInput as Q, RichJavascriptEditor as R, SaveStatus as S, Tabs as T, UserIcon$1 as U, EditAuthenticationEvent as V, EditDatabaseEvent as W, EditEventForm as X, EditScheduledEvent as Y, EventFunctionSelector as Z, __rest as _, __assign as a, index as a0, TriggerType as a1, EditEventFormVariant as a2, toTriggerType as a3, FormRow as a4, FormRowButtonFooter as a5, FormRowHeader as a6, FormRowInputGroup as a7, FormRowLabelGroup as a8, FormRowSubmitButtonFooter as a9, SplitPanelContainer as aA, StatusAgent as aB, StatusAlert as aC, StatusBanner as aD, StatusContainer as aE, buildStatusContainer as aF, SaveButton as aa, FunctionEditor as ab, FunctionEditorFormRow as ac, FunctionSelectorRow as ad, NEW_ID as ae, IndexIcon as af, Variant as ag, ItemListLoadingWrapper as ah, LoadingWrapper as ai, useBillingPeriod as aj, UsageTooltip as ak, UsageCard as al, AppUsage as am, measurementTitle as an, measurementUnits as ao, measurementUsage as ap, RichJSONEditor as aq, DEFAULT_RICH_JSON_EDITOR_MIN_LINES as ar, DEFAULT_RICH_JSON_EDITOR_MAX_LINES as as, CLUSTERTYPE_SERVERLESS as at, DataSourceServiceType as au, MongoServiceStatus as av, isCluster as aw, isDataLake as ax, isSelfHostedMongoService as ay, SplitPanel as az, Tab as b, __extends as c, ArchiveUploadModal$1 as d, Collapsible as e, ConfirmChecklistDeprecated as f, ConfirmDeprecated as g, DisplayItemRowDeprecated as h, DisplayItemColumnDeprecated as i, DropdownDeprecated as j, DropdownListItemDeprecated as k, InlineTextInputDeprecated as l, makeDOMEvent as m, loadable as n, index$1 as o, passThroughProps as p, SelectDropdownSummaryToggleDeprecated as q, SelectDropdownToggleDeprecated as r, styleInject as s, Spinner as t, SpinnerCircle as u, StateIndicator as v, TabDeprecated as w, TableDeprecated as x, TabsDeprecated as y, TextInputFormRow as z };
//# sourceMappingURL=index-7f1490f0.js.map
